const $1L = { hi: 0, lo: 1 };
const $2305843009213693952L = { hi: 536870912, lo: 0 };
const $5955668970331000884L = { hi: 1386662239, lo: -1067102156 };
const $1784059615882449851L = { hi: 415383748, lo: -1362422853 };
const $8982663654677661702L = { hi: 2091439360, lo: 1910491142 };
const $1380349269358112757L = { hi: 321387608, lo: -636522507 };
const $7286864317269821294L = { hi: 1696605309, lo: 894846830 };
const $2135987035920910082L = { hi: 497323236, lo: 1760020226 };
const $7005857020398200553L = { hi: 1631178199, lo: 1745020649 };
const $1652639921975621497L = { hi: 384785216, lo: -1023641735 };
const $_481418970354774919L = { hi: -112089089, lo: 1138658425 };
const $1278668206209430417L = { hi: 297713141, lo: 2024993681 };
const $8928596168509315048L = { hi: 2078850792, lo: -689350680 };
const $1978643211784836272L = { hi: 460688772, lo: -1884531536 };
const $_8371072500651252758L = { hi: -1949042199, lo: -1717296150 };
const $1530901034580419511L = { hi: 356440673, lo: 1081189303 };
const $597001226353042382L = { hi: 139000179, lo: -885070898 };
const $1184477304306571148L = { hi: 275782613, lo: 666146700 };
const $1527430471115325346L = { hi: 355632619, lo: -1175470174 };
const $1832889850782397517L = { hi: 426752923, lo: -1269975987 };
const $_5913534206540532074L = { hi: -1376851976, lo: 1812444822 };
const $1418129833677084982L = { hi: 330184081, lo: -172697290 };
const $5577825024675947042L = { hi: 1298688590, lo: -1357372894 };
const $2194449627517475473L = { hi: 510935119, lo: 1034607249 };
const $_7439769533505684065L = { hi: -1732206330, lo: -526467681 };
const $1697873161311732311L = { hi: 395316900, lo: -39337385 };
const $_8133250842069730034L = { hi: -1893670029, lo: 1900641550 };
const $1313665730009899186L = { hi: 305861637, lo: 1993875634 };
const $_5745727253942878843L = { hi: -1337781375, lo: 880033157 };
const $2032799256770390445L = { hi: 473297959, lo: 1601841581 };
const $0L = { hi: 0, lo: 0 };
const $1152921504606846976L = { hi: 268435456, lo: 0 };
const $1490116119384765625L = { hi: 346944695, lo: 839070905 };
const $1032610780636961552L = { hi: 240423432, lo: -1290085616 };
const $1925929944387235853L = { hi: 448415508, lo: -1786957811 };
const $7910200175544436838L = { hi: 1841736998, lo: 1301219430 };
const $1244603055572228341L = { hi: 289781730, lo: -2051041035 };
const $_1504838264676837686L = { hi: -350372462, lo: 1032165066 };
const $1608611746708759036L = { hi: 374534108, lo: 1612227068 };
const $_5421850118411349444L = { hi: -1262372853, lo: 581866044 };
const $2079081953128979843L = { hi: 484073989, lo: 1529716099 };
const $6607496772837067824L = { hi: 1538427726, lo: -1887548368 };
const $1343575221513417750L = { hi: 312825483, lo: -1621953514 };
const $_1113817083813899013L = { hi: -259330749, lo: 1988285691 };
const $1736530273035216783L = { hi: 404317461, lo: 838461327 };
const $_5409364890226003632L = { hi: -1259465910, lo: -644091568 };
const $2244412773384604712L = { hi: 522568070, lo: -1494201304 };
const $1605989338741628675L = { hi: 373923531, lo: 1891786499 };
const $1450417759929778918L = { hi: 337701700, lo: -1668791578 };
const $_8816519005292960336L = { hi: -2052755795, lo: 906519984 };
const $1874621017369538693L = { hi: 436469218, lo: 348844165 };
const $665883850346957067L = { hi: 155038165, lo: 2040105227 };
const $1211445438634777304L = { hi: 282061621, lo: 983030488 };
const $_3514853404985837908L = { hi: -818365581, lo: 1581201068 };
const $1565756531257009982L = { hi: 364556100, lo: -95262914 };
const $5L = { hi: 0, lo: 5 };
const $25L = { hi: 0, lo: 25 };
const $125L = { hi: 0, lo: 125 };
const $625L = { hi: 0, lo: 625 };
const $3125L = { hi: 0, lo: 3125 };
const $15625L = { hi: 0, lo: 15625 };
const $78125L = { hi: 0, lo: 78125 };
const $390625L = { hi: 0, lo: 390625 };
const $1953125L = { hi: 0, lo: 1953125 };
const $9765625L = { hi: 0, lo: 9765625 };
const $48828125L = { hi: 0, lo: 48828125 };
const $244140625L = { hi: 0, lo: 244140625 };
const $1220703125L = { hi: 0, lo: 1220703125 };
const $6103515625L = { hi: 1, lo: 1808548329 };
const $30517578125L = { hi: 7, lo: 452807053 };
const $152587890625L = { hi: 35, lo: -2030932031 };
const $762939453125L = { hi: 177, lo: -1564725563 };
const $3814697265625L = { hi: 888, lo: 766306777 };
const $19073486328125L = { hi: 4440, lo: -463433411 };
const $95367431640625L = { hi: 22204, lo: 1977800241 };
const $476837158203125L = { hi: 111022, lo: 1299066613 };
const $2384185791015625L = { hi: 555111, lo: -2094601527 };
const $11920928955078125L = { hi: 2775557, lo: -1883073043 };
const $59604644775390625L = { hi: 13877787, lo: -825430623 };
const $298023223876953125L = { hi: 69388939, lo: 167814181 };
const $_1L = { hi: -1, lo: -1 };
const $1000000000000000000L = { hi: 232830643, lo: -1486618624 };
const $10L = { hi: 0, lo: 10 };
const $100L = { hi: 0, lo: 100 };
const $1000L = { hi: 0, lo: 1000 };
const $10000L = { hi: 0, lo: 10000 };
const $100000L = { hi: 0, lo: 100000 };
const $1000000L = { hi: 0, lo: 1000000 };
const $10000000L = { hi: 0, lo: 10000000 };
const $100000000L = { hi: 0, lo: 100000000 };
const $1000000000L = { hi: 0, lo: 1000000000 };
const $10000000000L = { hi: 2, lo: 1410065408 };
const $100000000000L = { hi: 23, lo: 1215752192 };
const $1000000000000L = { hi: 232, lo: -727379968 };
const $10000000000000L = { hi: 2328, lo: 1316134912 };
const $100000000000000L = { hi: 23283, lo: 276447232 };
const $1000000000000000L = { hi: 232830, lo: -1530494976 };
const $22L = { hi: 0, lo: 22 };
const $37L = { hi: 0, lo: 37 };
const $_22L = { hi: -1, lo: -22 };
const $_4503599627370496L = { hi: -1048576, lo: 0 };
const $9221120237041090561L = { hi: 2146959360, lo: 1 };
const $9218868437227405312L = { hi: 2146435072, lo: 0 };
const $2L = { hi: 0, lo: 2 };
class $PanicError extends Error {}
function $panic() {
  throw new $PanicError();
}
function $bound_check(arr, index) {
  if (index < 0 || index >= arr.length) throw new Error("Index out of bounds");
}
function $make_array_len_and_init(a, b) {
  const arr = new Array(a);
  arr.fill(b);
  return arr;
}
function Result$Err$0$(param0) {
  this._0 = param0;
}
Result$Err$0$.prototype.$tag = 0;
function Result$Ok$0$(param0) {
  this._0 = param0;
}
Result$Ok$0$.prototype.$tag = 1;
function Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(param0) {
  this._0 = param0;
}
Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError.prototype.$tag = 2;
const Error$moonbitlang$47$core$47$builtin$46$CreatingViewError$46$IndexOutOfBounds = { $tag: 1 };
const Error$moonbitlang$47$core$47$builtin$46$CreatingViewError$46$InvalidIndex = { $tag: 0 };
const moonbitlang$core$builtin$$int_to_string_js = (x, radix) => {
  return x.toString(radix);
};
const moonbitlang$core$builtin$$uint_to_string_js = (x, radix) => {
  return (x >>> 0).toString(radix);
};
const moonbitlang$core$builtin$$uint64_to_string_js = (num, radix) => {
  return (BigInt(num.hi >>> 0) << 32n | BigInt(num.lo >>> 0)).toString(radix);
};
function $makebytes(a, b) {
  const arr = new Uint8Array(a);
  if (b !== 0) {
    arr.fill(b);
  }
  return arr;
}
const moonbitlang$core$builtin$$JSArray$push = (arr, val) => { arr.push(val); };
const $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Continue$1$ = { $tag: 0 };
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Break$1$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Break$1$.prototype.$tag = 1;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Return$1$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Return$1$.prototype.$tag = 2;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Error$1$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Error$1$.prototype.$tag = 3;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$JumpOuter$1$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$JumpOuter$1$.prototype.$tag = 4;
const $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Continue$2$ = { $tag: 0 };
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Break$2$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Break$2$.prototype.$tag = 1;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Return$2$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Return$2$.prototype.$tag = 2;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Error$2$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$Error$2$.prototype.$tag = 3;
function $64$moonbitlang$47$core$47$builtin$46$ForeachResult$JumpOuter$2$(param0) {
  this._0 = param0;
}
$64$moonbitlang$47$core$47$builtin$46$ForeachResult$JumpOuter$2$.prototype.$tag = 4;
const moonbitlang$core$builtin$$MyInt64$convert_to_double_u = (a) => (a.hi >>> 0) * 4294967296.0 + (a.lo >>> 0);
const moonbitlang$core$builtin$$MyInt64$reinterpret_as_double = function f(a) {
  let view = f._view;
  if (view === undefined) {
    view = f._view = new DataView(new ArrayBuffer(8));
  }
  view.setUint32(0, a.hi);
  view.setUint32(4, a.lo);
  return view.getFloat64(0);
};
const moonbitlang$core$builtin$$try_init_wasm_helper = function() {
  try {
    return new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
  } catch (e) {
    return undefined;
  }
};
const moonbitlang$core$builtin$$MyInt64$div_bigint = (a, b) => {
  const aVal = (BigInt(a.hi) << 32n) | BigInt(a.lo >>> 0);
  const bVal = (BigInt(b.hi) << 32n) | BigInt(b.lo >>> 0);
  const result = aVal / bVal;
  const lo = Number(result & 0xFFFFFFFFn);
  const hi = Number((result >> 32n) & 0xFFFFFFFFn);
  return { hi: hi | 0, lo: lo | 0 };
};
const moonbitlang$core$builtin$$MyInt64$div_u_bigint = (a, b) => {
  const aVal = (BigInt(a.hi >>> 0) << 32n) | BigInt(a.lo >>> 0);
  const bVal = (BigInt(b.hi >>> 0) << 32n) | BigInt(b.lo >>> 0);
  const result = aVal / bVal;
  const lo = Number(result & 0xFFFFFFFFn);
  const hi = Number((result >> 32n) & 0xFFFFFFFFn);
  return { hi: hi | 0, lo: lo | 0 };
};
const moonbitlang$core$builtin$$MyInt64$mod_u_bigint = (a, b) => {
  const aVal = (BigInt(a.hi >>> 0) << 32n) | BigInt(a.lo >>> 0);
  const bVal = (BigInt(b.hi >>> 0) << 32n) | BigInt(b.lo >>> 0);
  const result = aVal % bVal;
  const lo = Number(result & 0xFFFFFFFFn);
  const hi = Number((result >> 32n) & 0xFFFFFFFFn);
  return { hi: hi | 0, lo: lo | 0 };
};
const moonbitlang$core$builtin$$MyInt64$compare = (a, b) => {
  const ahi = a.hi;
  const bhi = b.hi;
  if (ahi < bhi) {
    return -1;
  }
  if (ahi > bhi) {
    return 1;
  }
  const alo = a.lo >>> 0;
  const blo = b.lo >>> 0;
  if (alo < blo) {
    return -1;
  }
  if (alo > blo) {
    return 1;
  }
  return 0;
};
const moonbitlang$core$builtin$$MyInt64$compare_u = (a, b) => {
  const ahi = a.hi >>> 0;
  const bhi = b.hi >>> 0;
  if (ahi < bhi) {
    return -1;
  }
  if (ahi > bhi) {
    return 1;
  }
  const alo = a.lo >>> 0;
  const blo = b.lo >>> 0;
  if (alo < blo) {
    return -1;
  }
  if (alo > blo) {
    return 1;
  }
  return 0;
};
const moonbitlang$core$builtin$$MyInt64$reinterpret_double = function f(a) {
  let view = f._view;
  if (view === undefined) {
    view = f._view = new DataView(new ArrayBuffer(8));
  }
  view.setFloat64(0, a);
  const hi = view.getInt32(0);
  const lo = view.getInt32(4);
  return { hi, lo };
};
const $bytes_literal$0 = new Uint8Array();
const $4294967295L = { hi: 0, lo: -1 };
const $10000000000000000L = { hi: 2328306, lo: 1874919424 };
const $4L = { hi: 0, lo: 4 };
function Result$Err$3$(param0) {
  this._0 = param0;
}
Result$Err$3$.prototype.$tag = 0;
function Result$Ok$3$(param0) {
  this._0 = param0;
}
Result$Ok$3$.prototype.$tag = 1;
function Result$Err$4$(param0) {
  this._0 = param0;
}
Result$Err$4$.prototype.$tag = 0;
function Result$Ok$4$(param0) {
  this._0 = param0;
}
Result$Ok$4$.prototype.$tag = 1;
function Result$Err$5$(param0) {
  this._0 = param0;
}
Result$Err$5$.prototype.$tag = 0;
function Result$Ok$5$(param0) {
  this._0 = param0;
}
Result$Ok$5$.prototype.$tag = 1;
function Result$Err$6$(param0) {
  this._0 = param0;
}
Result$Err$6$.prototype.$tag = 0;
function Result$Ok$6$(param0) {
  this._0 = param0;
}
Result$Ok$6$.prototype.$tag = 1;
function Result$Err$7$(param0) {
  this._0 = param0;
}
Result$Err$7$.prototype.$tag = 0;
function Result$Ok$7$(param0) {
  this._0 = param0;
}
Result$Ok$7$.prototype.$tag = 1;
const $65536L = { hi: 0, lo: 65536 };
const Option$None$8$ = { $tag: 0 };
function Option$Some$8$(param0) {
  this._0 = param0;
}
Option$Some$8$.prototype.$tag = 1;
const $bytes_literal$1 = new Uint8Array([74,119,119,68,97,116,97,46]);
function $64$horideicom$47$jww_parser$47$core$46$Entity$Line(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Line.prototype.$tag = 0;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Arc(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Arc.prototype.$tag = 1;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Point(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Point.prototype.$tag = 2;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Text(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Text.prototype.$tag = 3;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Solid(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Solid.prototype.$tag = 4;
function $64$horideicom$47$jww_parser$47$core$46$Entity$ArcSolid(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$ArcSolid.prototype.$tag = 5;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Block(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Block.prototype.$tag = 6;
function $64$horideicom$47$jww_parser$47$core$46$Entity$Image(param0) {
  this._0 = param0;
}
$64$horideicom$47$jww_parser$47$core$46$Entity$Image.prototype.$tag = 7;
function SvgElement$Text(param0) {
  this._0 = param0;
}
SvgElement$Text.prototype.$tag = 0;
function SvgElement$ElementNode(param0) {
  this._0 = param0;
}
SvgElement$ElementNode.prototype.$tag = 1;
const LineType$Solid = { $tag: 0 };
function LineType$Custom(param0) {
  this._0 = param0;
}
LineType$Custom.prototype.$tag = 4;
const $$$64$moonbitlang$47$core$47$builtin$46$StringBuilder$36$as$36$64$moonbitlang$47$core$47$builtin$46$Logger = { method_0: moonbitlang$core$builtin$$Logger$write_string$0$, method_1: moonbitlang$core$builtin$$Logger$write_substring$1$, method_2: moonbitlang$core$builtin$$Logger$write_view$0$, method_3: moonbitlang$core$builtin$$Logger$write_char$0$ };
const moonbitlang$core$builtin$$parse$46$42$bind$124$5354 = ":";
const moonbitlang$core$builtin$$parse$46$42$bind$124$5393 = ":";
const moonbitlang$core$builtin$$parse$46$42$bind$124$5387 = "-";
const moonbitlang$core$builtin$$parse$46$42$bind$124$5374 = ":";
const moonbitlang$core$builtin$$parse$46$42$bind$124$5368 = ":";
const moonbitlang$core$builtin$$wasm_helper_cache = { tried: false, exports: undefined };
const moonbitlang$core$builtin$$output$46$42$bind$124$8198 = "/";
const moonbitlang$core$builtin$$output$46$42$bind$124$8192 = "/";
const moonbitlang$core$builtin$$boyer_moore_horspool_find$46$constr$47$110 = 0;
const moonbitlang$core$builtin$$brute_force_find$46$constr$47$124 = 0;
const moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_INV_SPLIT2 = [$1L, $2305843009213693952L, $5955668970331000884L, $1784059615882449851L, $8982663654677661702L, $1380349269358112757L, $7286864317269821294L, $2135987035920910082L, $7005857020398200553L, $1652639921975621497L, $_481418970354774919L, $1278668206209430417L, $8928596168509315048L, $1978643211784836272L, $_8371072500651252758L, $1530901034580419511L, $597001226353042382L, $1184477304306571148L, $1527430471115325346L, $1832889850782397517L, $_5913534206540532074L, $1418129833677084982L, $5577825024675947042L, $2194449627517475473L, $_7439769533505684065L, $1697873161311732311L, $_8133250842069730034L, $1313665730009899186L, $_5745727253942878843L, $2032799256770390445L];
const moonbitlang$core$double$internal$ryu$$gPOW5_INV_OFFSETS = [1414808916, 67458373, 268701696, 4195348, 1073807360, 1091917141, 1108, 65604, 1073741824, 1140850753, 1346716752, 1431634004, 1365595476, 1073758208, 16777217, 66816, 1364284433, 89478484, 0];
const moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_SPLIT2 = [$0L, $1152921504606846976L, $0L, $1490116119384765625L, $1032610780636961552L, $1925929944387235853L, $7910200175544436838L, $1244603055572228341L, $_1504838264676837686L, $1608611746708759036L, $_5421850118411349444L, $2079081953128979843L, $6607496772837067824L, $1343575221513417750L, $_1113817083813899013L, $1736530273035216783L, $_5409364890226003632L, $2244412773384604712L, $1605989338741628675L, $1450417759929778918L, $_8816519005292960336L, $1874621017369538693L, $665883850346957067L, $1211445438634777304L, $_3514853404985837908L, $1565756531257009982L];
const moonbitlang$core$double$internal$ryu$$gPOW5_OFFSETS = [0, 0, 0, 0, 1073741824, 1500076437, 1431590229, 1448432917, 1091896580, 1079333904, 1146442053, 1146111296, 1163220304, 1073758208, -1773927360, 1431721317, 1413824581, 1075134801, 1431671125, 1363170645, 261];
const moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_TABLE = [$1L, $5L, $25L, $125L, $625L, $3125L, $15625L, $78125L, $390625L, $1953125L, $9765625L, $48828125L, $244140625L, $1220703125L, $6103515625L, $30517578125L, $152587890625L, $762939453125L, $3814697265625L, $19073486328125L, $95367431640625L, $476837158203125L, $2384185791015625L, $11920928955078125L, $59604644775390625L, $298023223876953125L];
const moonbitlang$core$double$internal$ryu$$ryu_to_string$46$record$47$979 = { mantissa: $0L, exponent: 0 };
const moonbitlang$core$uint64$$max_value = $_1L;
const moonbitlang$core$strconv$$range_err_str = "value out of range";
const moonbitlang$core$strconv$$syntax_err_str = "invalid syntax";
const moonbitlang$core$strconv$$min_19digit_int = $1000000000000000000L;
const moonbitlang$core$strconv$$parse_scientific$46$exp_num$124$306 = $0L;
const moonbitlang$core$strconv$$parse_number$46$exp_number$124$287 = $0L;
const moonbitlang$core$strconv$$double_info = { mantissa_bits: 52, exponent_bits: 11, bias: -1023 };
const moonbitlang$core$strconv$$powtab = [1, 3, 6, 9, 13, 16, 19, 23, 26, 29, 33, 36, 39, 43, 46, 49, 53, 56, 59];
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$994 = { _0: 0, _1: "" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$995 = { _0: 1, _1: "5" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$996 = { _0: 1, _1: "25" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$997 = { _0: 1, _1: "125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$998 = { _0: 2, _1: "625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$999 = { _0: 2, _1: "3125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1000 = { _0: 2, _1: "15625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1001 = { _0: 3, _1: "78125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1002 = { _0: 3, _1: "390625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1003 = { _0: 3, _1: "1953125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1004 = { _0: 4, _1: "9765625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1005 = { _0: 4, _1: "48828125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1006 = { _0: 4, _1: "244140625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1007 = { _0: 4, _1: "1220703125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1008 = { _0: 5, _1: "6103515625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1009 = { _0: 5, _1: "30517578125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1010 = { _0: 5, _1: "152587890625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1011 = { _0: 6, _1: "762939453125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1012 = { _0: 6, _1: "3814697265625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1013 = { _0: 6, _1: "19073486328125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1014 = { _0: 7, _1: "95367431640625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1015 = { _0: 7, _1: "476837158203125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1016 = { _0: 7, _1: "2384185791015625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1017 = { _0: 7, _1: "11920928955078125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1018 = { _0: 8, _1: "59604644775390625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1019 = { _0: 8, _1: "298023223876953125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1020 = { _0: 8, _1: "1490116119384765625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1021 = { _0: 9, _1: "7450580596923828125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1022 = { _0: 9, _1: "37252902984619140625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1023 = { _0: 9, _1: "186264514923095703125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1024 = { _0: 10, _1: "931322574615478515625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1025 = { _0: 10, _1: "4656612873077392578125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1026 = { _0: 10, _1: "23283064365386962890625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1027 = { _0: 10, _1: "116415321826934814453125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1028 = { _0: 11, _1: "582076609134674072265625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1029 = { _0: 11, _1: "2910383045673370361328125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1030 = { _0: 11, _1: "14551915228366851806640625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1031 = { _0: 12, _1: "72759576141834259033203125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1032 = { _0: 12, _1: "363797880709171295166015625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1033 = { _0: 12, _1: "1818989403545856475830078125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1034 = { _0: 13, _1: "9094947017729282379150390625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1035 = { _0: 13, _1: "45474735088646411895751953125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1036 = { _0: 13, _1: "227373675443232059478759765625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1037 = { _0: 13, _1: "1136868377216160297393798828125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1038 = { _0: 14, _1: "5684341886080801486968994140625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1039 = { _0: 14, _1: "28421709430404007434844970703125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1040 = { _0: 14, _1: "142108547152020037174224853515625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1041 = { _0: 15, _1: "710542735760100185871124267578125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1042 = { _0: 15, _1: "3552713678800500929355621337890625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1043 = { _0: 15, _1: "17763568394002504646778106689453125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1044 = { _0: 16, _1: "88817841970012523233890533447265625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1045 = { _0: 16, _1: "444089209850062616169452667236328125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1046 = { _0: 16, _1: "2220446049250313080847263336181640625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1047 = { _0: 16, _1: "11102230246251565404236316680908203125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1048 = { _0: 17, _1: "55511151231257827021181583404541015625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1049 = { _0: 17, _1: "277555756156289135105907917022705078125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1050 = { _0: 17, _1: "1387778780781445675529539585113525390625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1051 = { _0: 18, _1: "6938893903907228377647697925567626953125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1052 = { _0: 18, _1: "34694469519536141888238489627838134765625" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1053 = { _0: 18, _1: "173472347597680709441192448139190673828125" };
const moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1054 = { _0: 19, _1: "867361737988403547205962240695953369140625" };
const moonbitlang$core$strconv$$left_shift_cheats = [moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$994, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$995, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$996, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$997, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$998, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$999, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1000, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1001, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1002, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1003, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1004, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1005, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1006, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1007, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1008, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1009, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1010, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1011, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1012, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1013, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1014, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1015, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1016, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1017, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1018, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1019, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1020, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1021, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1022, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1023, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1024, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1025, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1026, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1027, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1028, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1029, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1030, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1031, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1032, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1033, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1034, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1035, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1036, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1037, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1038, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1039, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1040, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1041, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1042, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1043, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1044, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1045, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1046, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1047, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1048, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1049, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1050, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1051, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1052, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1053, moonbitlang$core$strconv$$left_shift_cheats$46$tuple$47$1054];
const moonbitlang$core$strconv$$int_pow10 = [$1L, $10L, $100L, $1000L, $10000L, $100000L, $1000000L, $10000000L, $100000000L, $1000000000L, $10000000000L, $100000000000L, $1000000000000L, $10000000000000L, $100000000000000L, $1000000000000000L];
const moonbitlang$core$strconv$$max_exponent_fast_path = $22L;
const moonbitlang$core$strconv$$table = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1e+12, 1e+13, 1e+14, 1e+15, 1e+16, 1e+17, 1e+18, 1e+19, 1e+20, 1e+21, 1e+22, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const moonbitlang$core$strconv$$max_exponent_disguised_fast_path = $37L;
const moonbitlang$core$strconv$$min_exponent_fast_path = $_22L;
const moonbitlang$core$strconv$$checked_mul$46$constr$47$1452 = $0L;
const horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$983 = "Printer_";
const horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$984 = "Draw_";
const horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$985 = "View_";
const horideicom$jww_parser$core$$normalize_image_path$46$42$bind$124$989 = "%temp%";
const horideicom$jww_parser$core$$default$46$record$47$1502 = { state: 2, protect: 0, name: "" };
const horideicom$jww_parser$core$$default$46$record$47$1506 = { printer_paper_size: "", draw_bmp_touka: "", view_direct2d: "", printer_bmp_zentai: "", printer_orientation: "", printer_d2d_bmp: "" };
const horideicom$jww_parser$core$$default$46$record$47$1507 = { sunpou1: 0, sunpou2: 0, sunpou3: 0, sunpou4: 0, sunpou5: 0, dummy: 0, max_line_width: 0 };
const horideicom$jww_parser$core$$default$46$record$47$1508 = { origin_x: 0, origin_y: 0, scale: 1, rotation_setting: 0 };
const horideicom$jww_parser$core$$parse$46$constr$47$1879 = 8;
const horideicom$svg_jww$$escape_xml$46$42$bind$124$786 = "&";
const horideicom$svg_jww$$escape_xml$46$42$bind$124$787 = "&amp;";
const horideicom$svg_jww$$escape_xml$46$42$bind$124$788 = "<";
const horideicom$svg_jww$$escape_xml$46$42$bind$124$789 = "&lt;";
const horideicom$svg_jww$$escape_xml$46$42$bind$124$790 = ">";
const horideicom$svg_jww$$escape_xml$46$42$bind$124$791 = "&gt;";
const horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$792 = "\"";
const horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$793 = "&quot;";
const horideicom$svg_jww$$join_attributes$46$42$bind$124$798 = " ";
const horideicom$svg_jww$$join_children$46$42$bind$124$805 = "";
const horideicom$svg_jww$$line_type_to_dasharray$46$42$bind$124$816 = ",";
const horideicom$svg_jww$$fill_none$46$tuple$47$1920 = { _0: "fill", _1: "none" };
const horideicom$svg_jww$$stroke_none$46$tuple$47$1935 = { _0: "stroke", _1: "none" };
const horideicom$svg_jww$$calculate_bounds$46$record$47$2033 = { min_x: 0, min_y: 0, max_x: 400, max_y: 300 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2173 = { _0: 1189, _1: 841 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2174 = { _0: 841, _1: 594 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2175 = { _0: 594, _1: 420 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2176 = { _0: 420, _1: 297 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2177 = { _0: 297, _1: 210 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2178 = { _0: 1682, _1: 1189 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2179 = { _0: 2378, _1: 1682 };
const horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2180 = { _0: 297, _1: 210 };
const horideicom$svg_jww$$render_jww_document_with_debug$46$record$47$2421 = { lines: 0, arcs: 0, texts: 0, points: 0, solids: 0, blocks: 0, images: 0 };
const horideicom$svg_jww$$render_jww_document$46$debug$47$2436 = { show_bounds: false, show_axes: false, show_print_area: false };
const moonbitlang$core$double$$neg_infinity = moonbitlang$core$int64$$Int64$reinterpret_as_double($_4503599627370496L);
const moonbitlang$core$double$$not_a_number = moonbitlang$core$int64$$Int64$reinterpret_as_double($9221120237041090561L);
const moonbitlang$core$double$$infinity = moonbitlang$core$int64$$Int64$reinterpret_as_double($9218868437227405312L);
const moonbitlang$core$strconv$$max_mantissa_fast_path = moonbitlang$core$builtin$$Shl$shl$2$($2L, 52);
function moonbitlang$core$abort$$abort$3$(msg) {
  return $panic();
}
function moonbitlang$core$abort$$abort$4$(msg) {
  return $panic();
}
function moonbitlang$core$abort$$abort$5$(msg) {
  return $panic();
}
function moonbitlang$core$abort$$abort$6$(msg) {
  return $panic();
}
function moonbitlang$core$abort$$abort$7$(msg) {
  $panic();
}
function moonbitlang$core$abort$$abort$8$(msg) {
  return $panic();
}
function moonbitlang$core$abort$$abort$9$(msg) {
  return $panic();
}
function moonbitlang$core$builtin$$abort$3$(string, loc) {
  return moonbitlang$core$abort$$abort$3$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$4$(string, loc) {
  return moonbitlang$core$abort$$abort$4$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$5$(string, loc) {
  return moonbitlang$core$abort$$abort$5$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$6$(string, loc) {
  return moonbitlang$core$abort$$abort$6$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$7$(string, loc) {
  moonbitlang$core$abort$$abort$7$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$8$(string, loc) {
  return moonbitlang$core$abort$$abort$8$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$builtin$$abort$9$(string, loc) {
  return moonbitlang$core$abort$$abort$9$(`${string}\n  at ${moonbitlang$core$builtin$$Show$to_string$10$(loc)}\n`);
}
function moonbitlang$core$array$$FixedArray$unsafe_blit$11$(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp = len - 1 | 0;
    while (true) {
      const i = _tmp;
      if (i >= 0) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function moonbitlang$core$array$$FixedArray$unsafe_blit$12$(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp = len - 1 | 0;
    while (true) {
      const i = _tmp;
      if (i >= 0) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function moonbitlang$core$array$$FixedArray$unsafe_blit$13$(dst, dst_offset, src, src_offset, len) {
  if (dst === src && dst_offset < src_offset) {
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i + 1 | 0;
        continue;
      } else {
        return;
      }
    }
  } else {
    let _tmp = len - 1 | 0;
    while (true) {
      const i = _tmp;
      if (i >= 0) {
        const _tmp$2 = dst_offset + i | 0;
        const _tmp$3 = src_offset + i | 0;
        $bound_check(src, _tmp$3);
        $bound_check(dst, _tmp$2);
        dst[_tmp$2] = src[_tmp$3];
        _tmp = i - 1 | 0;
        continue;
      } else {
        return;
      }
    }
  }
}
function moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$14$(dst, dst_offset, src, src_offset, len) {
  moonbitlang$core$array$$FixedArray$unsafe_blit$11$(dst, dst_offset, src, src_offset, len);
}
function moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$15$(dst, dst_offset, src, src_offset, len) {
  moonbitlang$core$array$$FixedArray$unsafe_blit$12$(dst, dst_offset, src, src_offset, len);
}
function moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$16$(dst, dst_offset, src, src_offset, len) {
  moonbitlang$core$array$$FixedArray$unsafe_blit$13$(dst, dst_offset, src, src_offset, len);
}
function moonbitlang$core$builtin$$StringBuilder$new$46$inner(size_hint) {
  return { val: "" };
}
function moonbitlang$core$builtin$$Logger$write_char$0$(self, ch) {
  const _bind = self;
  _bind.val = `${_bind.val}${String.fromCodePoint(ch)}`;
}
function moonbitlang$core$builtin$$code_point_of_surrogate_pair(leading, trailing) {
  return (((Math.imul(leading - 55296 | 0, 1024) | 0) + trailing | 0) - 56320 | 0) + 65536 | 0;
}
function moonbitlang$core$string$$String$unsafe_char_at(self, index) {
  const c1 = self.charCodeAt(index);
  if (55296 <= c1 && c1 <= 56319) {
    const _tmp = index + 1 | 0;
    const c2 = self.charCodeAt(_tmp);
    return moonbitlang$core$builtin$$code_point_of_surrogate_pair(c1, c2);
  } else {
    return c1;
  }
}
function moonbitlang$core$builtin$$op_notequal$17$(x, y) {
  return !moonbitlang$core$builtin$$Eq$equal$17$(x, y);
}
function moonbitlang$core$builtin$$op_notequal$2$(x, y) {
  return !moonbitlang$core$builtin$$Eq$equal$2$(x, y);
}
function moonbitlang$core$array$$Array$at$18$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$19$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$20$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$21$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$4$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$22$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$array$$Array$at$23$(self, index) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    return self[index];
  } else {
    return $panic();
  }
}
function moonbitlang$core$builtin$$boyer_moore_horspool_find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const skip_table = $make_array_len_and_init(256, needle_len);
      const _end4418 = needle_len - 1 | 0;
      let _tmp = 0;
      while (true) {
        const i = _tmp;
        if (i < _end4418) {
          const _tmp$2 = needle.str;
          const _tmp$3 = needle.start + i | 0;
          const _tmp$4 = _tmp$2.charCodeAt(_tmp$3) & 255;
          $bound_check(skip_table, _tmp$4);
          skip_table[_tmp$4] = (needle_len - 1 | 0) - i | 0;
          _tmp = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$2 = 0;
      while (true) {
        const i = _tmp$2;
        if (i <= (haystack_len - needle_len | 0)) {
          const _end4424 = needle_len - 1 | 0;
          let _tmp$3 = 0;
          while (true) {
            const j = _tmp$3;
            if (j <= _end4424) {
              const _p = i + j | 0;
              const _tmp$4 = haystack.str;
              const _tmp$5 = haystack.start + _p | 0;
              const _tmp$6 = _tmp$4.charCodeAt(_tmp$5);
              const _tmp$7 = needle.str;
              const _tmp$8 = needle.start + j | 0;
              if (_tmp$6 !== _tmp$7.charCodeAt(_tmp$8)) {
                break;
              }
              _tmp$3 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          const _p = (i + needle_len | 0) - 1 | 0;
          const _tmp$4 = haystack.str;
          const _tmp$5 = haystack.start + _p | 0;
          const _tmp$6 = _tmp$4.charCodeAt(_tmp$5) & 255;
          $bound_check(skip_table, _tmp$6);
          _tmp$2 = i + skip_table[_tmp$6] | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return moonbitlang$core$builtin$$boyer_moore_horspool_find$46$constr$47$110;
  }
}
function moonbitlang$core$builtin$$brute_force_find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const _p = 0;
      const _tmp = needle.str;
      const _tmp$2 = needle.start + _p | 0;
      const needle_first = _tmp.charCodeAt(_tmp$2);
      const forward_len = haystack_len - needle_len | 0;
      let i = 0;
      while (true) {
        if (i <= forward_len) {
          while (true) {
            let _tmp$3;
            if (i <= forward_len) {
              const _p$2 = i;
              const _tmp$4 = haystack.str;
              const _tmp$5 = haystack.start + _p$2 | 0;
              _tmp$3 = _tmp$4.charCodeAt(_tmp$5) !== needle_first;
            } else {
              _tmp$3 = false;
            }
            if (_tmp$3) {
              i = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (i <= forward_len) {
            let _tmp$3 = 1;
            while (true) {
              const j = _tmp$3;
              if (j < needle_len) {
                const _p$2 = i + j | 0;
                const _tmp$4 = haystack.str;
                const _tmp$5 = haystack.start + _p$2 | 0;
                const _tmp$6 = _tmp$4.charCodeAt(_tmp$5);
                const _tmp$7 = needle.str;
                const _tmp$8 = needle.start + j | 0;
                if (_tmp$6 !== _tmp$7.charCodeAt(_tmp$8)) {
                  break;
                }
                _tmp$3 = j + 1 | 0;
                continue;
              } else {
                return i;
              }
            }
            i = i + 1 | 0;
          }
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return moonbitlang$core$builtin$$brute_force_find$46$constr$47$124;
  }
}
function moonbitlang$core$string$$StringView$find(self, str) {
  return (str.end - str.start | 0) <= 4 ? moonbitlang$core$builtin$$brute_force_find(self, str) : moonbitlang$core$builtin$$boyer_moore_horspool_find(self, str);
}
function moonbitlang$core$builtin$$boyer_moore_horspool_rev_find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const skip_table = $make_array_len_and_init(256, needle_len);
      let _tmp = needle_len - 1 | 0;
      while (true) {
        const i = _tmp;
        if (i > 0) {
          const _tmp$2 = needle.str;
          const _tmp$3 = needle.start + i | 0;
          const _tmp$4 = _tmp$2.charCodeAt(_tmp$3) & 255;
          $bound_check(skip_table, _tmp$4);
          skip_table[_tmp$4] = i;
          _tmp = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      let _tmp$2 = haystack_len - needle_len | 0;
      while (true) {
        const i = _tmp$2;
        if (i >= 0) {
          let _tmp$3 = 0;
          while (true) {
            const j = _tmp$3;
            if (j < needle_len) {
              const _p = i + j | 0;
              const _tmp$4 = haystack.str;
              const _tmp$5 = haystack.start + _p | 0;
              const _tmp$6 = _tmp$4.charCodeAt(_tmp$5);
              const _tmp$7 = needle.str;
              const _tmp$8 = needle.start + j | 0;
              if (_tmp$6 !== _tmp$7.charCodeAt(_tmp$8)) {
                break;
              }
              _tmp$3 = j + 1 | 0;
              continue;
            } else {
              return i;
            }
          }
          const _tmp$4 = haystack.str;
          const _tmp$5 = haystack.start + i | 0;
          const _tmp$6 = _tmp$4.charCodeAt(_tmp$5) & 255;
          $bound_check(skip_table, _tmp$6);
          _tmp$2 = i - skip_table[_tmp$6] | 0;
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return haystack_len;
  }
}
function moonbitlang$core$builtin$$brute_force_rev_find(haystack, needle) {
  const haystack_len = haystack.end - haystack.start | 0;
  const needle_len = needle.end - needle.start | 0;
  if (needle_len > 0) {
    if (haystack_len >= needle_len) {
      const _p = 0;
      const _tmp = needle.str;
      const _tmp$2 = needle.start + _p | 0;
      const needle_first = _tmp.charCodeAt(_tmp$2);
      let i = haystack_len - needle_len | 0;
      while (true) {
        if (i >= 0) {
          while (true) {
            let _tmp$3;
            if (i >= 0) {
              const _p$2 = i;
              const _tmp$4 = haystack.str;
              const _tmp$5 = haystack.start + _p$2 | 0;
              _tmp$3 = _tmp$4.charCodeAt(_tmp$5) !== needle_first;
            } else {
              _tmp$3 = false;
            }
            if (_tmp$3) {
              i = i - 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (i >= 0) {
            let _tmp$3 = 1;
            while (true) {
              const j = _tmp$3;
              if (j < needle_len) {
                const _p$2 = i + j | 0;
                const _tmp$4 = haystack.str;
                const _tmp$5 = haystack.start + _p$2 | 0;
                const _tmp$6 = _tmp$4.charCodeAt(_tmp$5);
                const _tmp$7 = needle.str;
                const _tmp$8 = needle.start + j | 0;
                if (_tmp$6 !== _tmp$7.charCodeAt(_tmp$8)) {
                  break;
                }
                _tmp$3 = j + 1 | 0;
                continue;
              } else {
                return i;
              }
            }
            i = i - 1 | 0;
          }
          continue;
        } else {
          break;
        }
      }
      return undefined;
    } else {
      return undefined;
    }
  } else {
    return haystack_len;
  }
}
function moonbitlang$core$string$$StringView$rev_find(self, str) {
  return (str.end - str.start | 0) <= 4 ? moonbitlang$core$builtin$$brute_force_rev_find(self, str) : moonbitlang$core$builtin$$boyer_moore_horspool_rev_find(self, str);
}
function moonbitlang$core$string$$StringView$view$46$inner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.end - self.start | 0;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= (self.end - self.start | 0)) ? { str: self.str, start: self.start + start_offset | 0, end: self.start + end_offset$2 | 0 } : moonbitlang$core$builtin$$abort$6$("Invalid index for View", "@moonbitlang/core/builtin:stringview.mbt:111:5-111:36");
}
function moonbitlang$core$builtin$$parse$46$parse_loc$124$1093(view) {
  const _bind = moonbitlang$core$string$$StringView$find(view, { str: moonbitlang$core$builtin$$parse$46$42$bind$124$5354, start: 0, end: moonbitlang$core$builtin$$parse$46$42$bind$124$5354.length });
  if (_bind === undefined) {
    return undefined;
  } else {
    const _Some = _bind;
    const _i = _Some;
    return _i > 0 && (_i + 1 | 0) < (view.end - view.start | 0) ? { _0: moonbitlang$core$string$$StringView$view$46$inner(view, 0, _i), _1: moonbitlang$core$string$$StringView$view$46$inner(view, _i + 1 | 0, undefined) } : undefined;
  }
}
function moonbitlang$core$builtin$$SourceLocRepr$parse(repr) {
  _L: {
    if (moonbitlang$core$string$$String$char_length_ge$46$inner(repr, 1, 0, repr.length)) {
      const _x = repr.charCodeAt(0);
      if (_x === 64) {
        const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(repr, 1, 0, repr.length);
        let _tmp;
        if (_bind === undefined) {
          _tmp = repr.length;
        } else {
          const _Some = _bind;
          _tmp = _Some;
        }
        const _x$2 = { str: repr, start: _tmp, end: repr.length };
        const _bind$2 = moonbitlang$core$string$$StringView$find(_x$2, { str: moonbitlang$core$builtin$$parse$46$42$bind$124$5393, start: 0, end: moonbitlang$core$builtin$$parse$46$42$bind$124$5393.length });
        if (_bind$2 === undefined) {
          return $panic();
        } else {
          const _Some = _bind$2;
          const _pkg_end = _Some;
          const pkg = moonbitlang$core$string$$StringView$view$46$inner(_x$2, 0, _pkg_end);
          const _bind$3 = moonbitlang$core$string$$StringView$rev_find(_x$2, { str: moonbitlang$core$builtin$$parse$46$42$bind$124$5387, start: 0, end: moonbitlang$core$builtin$$parse$46$42$bind$124$5387.length });
          if (_bind$3 === undefined) {
            return $panic();
          } else {
            const _Some$2 = _bind$3;
            const _start_loc_end = _Some$2;
            if ((_start_loc_end + 1 | 0) < (_x$2.end - _x$2.start | 0)) {
              const end_loc = moonbitlang$core$string$$StringView$view$46$inner(_x$2, _start_loc_end + 1 | 0, undefined);
              const _bind$4 = moonbitlang$core$builtin$$parse$46$parse_loc$124$1093(end_loc);
              if (_bind$4 === undefined) {
                return $panic();
              } else {
                const _Some$3 = _bind$4;
                const _x$3 = _Some$3;
                const _end_line = _x$3._0;
                const _end_column = _x$3._1;
                const rest = moonbitlang$core$string$$StringView$view$46$inner(_x$2, 0, _start_loc_end);
                _L$2: {
                  const _bind$5 = moonbitlang$core$string$$StringView$rev_find(rest, { str: moonbitlang$core$builtin$$parse$46$42$bind$124$5374, start: 0, end: moonbitlang$core$builtin$$parse$46$42$bind$124$5374.length });
                  if (_bind$5 === undefined) {
                    break _L$2;
                  } else {
                    const _Some$4 = _bind$5;
                    const _start_line_end = _Some$4;
                    const _bind$6 = moonbitlang$core$string$$StringView$rev_find(moonbitlang$core$string$$StringView$view$46$inner(rest, 0, _start_line_end), { str: moonbitlang$core$builtin$$parse$46$42$bind$124$5368, start: 0, end: moonbitlang$core$builtin$$parse$46$42$bind$124$5368.length });
                    if (_bind$6 === undefined) {
                      break _L$2;
                    } else {
                      const _Some$5 = _bind$6;
                      const _filename_end = _Some$5;
                      if ((_filename_end + 1 | 0) < (rest.end - rest.start | 0)) {
                        const start_loc = moonbitlang$core$string$$StringView$view$46$inner(rest, _filename_end + 1 | 0, undefined);
                        const _bind$7 = moonbitlang$core$builtin$$parse$46$parse_loc$124$1093(start_loc);
                        if (_bind$7 === undefined) {
                          return $panic();
                        } else {
                          const _Some$6 = _bind$7;
                          const _x$4 = _Some$6;
                          const _start_line = _x$4._0;
                          const _start_column = _x$4._1;
                          if (_filename_end > (_pkg_end + 1 | 0)) {
                            const filename = moonbitlang$core$string$$StringView$view$46$inner(rest, _pkg_end + 1 | 0, _filename_end);
                            return { pkg: pkg, filename: filename, start_line: _start_line, start_column: _start_column, end_line: _end_line, end_column: _end_column };
                          } else {
                            return $panic();
                          }
                        }
                      } else {
                        return $panic();
                      }
                    }
                  }
                }
                return $panic();
              }
            } else {
              return $panic();
            }
          }
        }
      } else {
        break _L;
      }
    } else {
      break _L;
    }
  }
  return $panic();
}
function moonbitlang$core$builtin$$Logger$write_string$0$(self, str) {
  const _bind = self;
  _bind.val = `${_bind.val}${str}`;
}
function moonbitlang$core$builtin$$MyInt64$from_int(value) {
  return { hi: value >> 31 & -1, lo: value | 0 };
}
function moonbitlang$core$int$$Int$to_int64(self) {
  return moonbitlang$core$builtin$$MyInt64$from_int(self);
}
function moonbitlang$core$builtin$$Compare$op_lt$24$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$25$(x, y) < 0;
}
function moonbitlang$core$builtin$$Compare$op_lt$26$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$2$(x, y) < 0;
}
function moonbitlang$core$builtin$$Compare$op_gt$26$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$2$(x, y) > 0;
}
function moonbitlang$core$builtin$$Compare$op_gt$24$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$25$(x, y) > 0;
}
function moonbitlang$core$builtin$$Compare$op_le$26$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$2$(x, y) <= 0;
}
function moonbitlang$core$builtin$$Compare$op_le$24$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$25$(x, y) <= 0;
}
function moonbitlang$core$builtin$$Compare$op_ge$26$(x, y) {
  return moonbitlang$core$builtin$$Compare$compare$2$(x, y) >= 0;
}
function moonbitlang$core$string$$String$sub$46$inner(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  if (start$2 >= 0 && (start$2 <= end$2 && end$2 <= len)) {
    let _tmp;
    if (start$2 < len) {
      const _p = self.charCodeAt(start$2);
      _tmp = 56320 <= _p && _p <= 57343;
    } else {
      _tmp = false;
    }
    if (_tmp) {
      return new Result$Err$0$(Error$moonbitlang$47$core$47$builtin$46$CreatingViewError$46$InvalidIndex);
    }
    let _tmp$2;
    if (end$2 < len) {
      const _p = self.charCodeAt(end$2);
      _tmp$2 = 56320 <= _p && _p <= 57343;
    } else {
      _tmp$2 = false;
    }
    if (_tmp$2) {
      return new Result$Err$0$(Error$moonbitlang$47$core$47$builtin$46$CreatingViewError$46$InvalidIndex);
    }
    return new Result$Ok$0$({ str: self, start: start$2, end: end$2 });
  } else {
    return new Result$Err$0$(Error$moonbitlang$47$core$47$builtin$46$CreatingViewError$46$IndexOutOfBounds);
  }
}
function moonbitlang$core$builtin$$Logger$write_substring$1$(self, value, start, len) {
  let _tmp;
  let _try_err;
  _L: {
    _L$2: {
      const _bind = moonbitlang$core$string$$String$sub$46$inner(value, start, start + len | 0);
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _tmp = _ok._0;
      } else {
        const _err = _bind;
        const _tmp$2 = _err._0;
        _try_err = _tmp$2;
        break _L$2;
      }
      break _L;
    }
    _tmp = $panic();
  }
  moonbitlang$core$builtin$$Logger$write_view$0$(self, _tmp);
}
function moonbitlang$core$builtin$$Show$to_string$27$(self) {
  const logger = moonbitlang$core$builtin$$StringBuilder$new$46$inner(0);
  moonbitlang$core$builtin$$Show$output$9$(self, { self: logger, method_table: $$$64$moonbitlang$47$core$47$builtin$46$StringBuilder$36$as$36$64$moonbitlang$47$core$47$builtin$46$Logger });
  return logger.val;
}
function moonbitlang$core$builtin$$Show$to_string$10$(self) {
  const logger = moonbitlang$core$builtin$$StringBuilder$new$46$inner(0);
  moonbitlang$core$builtin$$Show$output$28$(self, { self: logger, method_table: $$$64$moonbitlang$47$core$47$builtin$46$StringBuilder$36$as$36$64$moonbitlang$47$core$47$builtin$46$Logger });
  return logger.val;
}
function moonbitlang$core$builtin$$Show$to_string$26$(self) {
  const logger = moonbitlang$core$builtin$$StringBuilder$new$46$inner(0);
  moonbitlang$core$builtin$$Show$output$2$(self, { self: logger, method_table: $$$64$moonbitlang$47$core$47$builtin$46$StringBuilder$36$as$36$64$moonbitlang$47$core$47$builtin$46$Logger });
  return logger.val;
}
function moonbitlang$core$int$$Int$to_string$46$inner(self, radix) {
  return moonbitlang$core$builtin$$int_to_string_js(self, radix);
}
function moonbitlang$core$uint$$UInt$to_string$46$inner(self, radix) {
  return moonbitlang$core$builtin$$uint_to_string_js(self, radix);
}
function moonbitlang$core$uint64$$UInt64$to_string$46$inner(self, radix) {
  return moonbitlang$core$builtin$$uint64_to_string_js(self, radix);
}
function moonbitlang$core$uint16$$UInt16$to_string$46$inner(self, radix) {
  return moonbitlang$core$int$$Int$to_string$46$inner(self, radix);
}
function moonbitlang$core$builtin$$Show$to_string$6$(self) {
  return self.str.substring(self.start, self.end);
}
function moonbitlang$core$builtin$$Iterator$next$23$(self) {
  const _func = self;
  return _func();
}
function moonbitlang$core$builtin$$Iterator$iter$23$(self) {
  return (yield_) => {
    while (true) {
      const _bind = moonbitlang$core$builtin$$Iterator$next$23$(self);
      if (_bind === -1) {
        return 1;
      } else {
        const _Some = _bind;
        const _x = _Some;
        const _bind$2 = yield_(_x);
        if (_bind$2 === 1) {
        } else {
          return 0;
        }
        continue;
      }
    }
  };
}
function moonbitlang$core$string$$StringView$iterator(self) {
  const start = self.start;
  const end = self.end;
  const index = { val: start };
  const _p = () => {
    if (index.val < end) {
      const _tmp = self.str;
      const _tmp$2 = index.val;
      const c1 = _tmp.charCodeAt(_tmp$2);
      if (55296 <= c1 && c1 <= 56319 && (index.val + 1 | 0) < self.end) {
        const _tmp$3 = self.str;
        const _tmp$4 = index.val + 1 | 0;
        const c2 = _tmp$3.charCodeAt(_tmp$4);
        if (56320 <= c2 && c2 <= 57343) {
          index.val = index.val + 2 | 0;
          return moonbitlang$core$builtin$$code_point_of_surrogate_pair(c1, c2);
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  };
  return _p;
}
function moonbitlang$core$string$$StringView$iter(self) {
  return moonbitlang$core$builtin$$Iterator$iter$23$(moonbitlang$core$string$$StringView$iterator(self));
}
function moonbitlang$core$string$$String$view$46$inner(self, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return start_offset >= 0 && (start_offset <= end_offset$2 && end_offset$2 <= self.length) ? { str: self, start: start_offset, end: end_offset$2 } : moonbitlang$core$builtin$$abort$6$("Invalid index for View", "@moonbitlang/core/builtin:stringview.mbt:374:5-374:36");
}
function moonbitlang$core$string$$String$from_array(chars) {
  const buf = moonbitlang$core$builtin$$StringBuilder$new$46$inner(Math.imul(chars.end - chars.start | 0, 4) | 0);
  const _len = chars.end - chars.start | 0;
  let _tmp = 0;
  while (true) {
    const _i = _tmp;
    if (_i < _len) {
      const c = chars.buf[chars.start + _i | 0];
      moonbitlang$core$builtin$$Logger$write_char$0$(buf, c);
      _tmp = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function moonbitlang$core$string$$String$char_length_eq$46$inner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp = start_offset;
  let _tmp$2 = 0;
  while (true) {
    const index = _tmp;
    const count = _tmp$2;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (55296 <= c1 && c1 <= 56319 && (index + 1 | 0) < end_offset$2) {
        const _tmp$3 = index + 1 | 0;
        const c2 = self.charCodeAt(_tmp$3);
        if (56320 <= c2 && c2 <= 57343) {
          _tmp = index + 2 | 0;
          _tmp$2 = count + 1 | 0;
          continue;
        } else {
          moonbitlang$core$builtin$$abort$7$("invalid surrogate pair", "@moonbitlang/core/builtin:string.mbt:463:9-463:40");
        }
      }
      _tmp = index + 1 | 0;
      _tmp$2 = count + 1 | 0;
      continue;
    } else {
      return count === len && index === end_offset$2;
    }
  }
}
function moonbitlang$core$string$$String$char_length_ge$46$inner(self, len, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  let _tmp = start_offset;
  let _tmp$2 = 0;
  while (true) {
    const index = _tmp;
    const count = _tmp$2;
    if (index < end_offset$2 && count < len) {
      const c1 = self.charCodeAt(index);
      if (55296 <= c1 && c1 <= 56319 && (index + 1 | 0) < end_offset$2) {
        const _tmp$3 = index + 1 | 0;
        const c2 = self.charCodeAt(_tmp$3);
        if (56320 <= c2 && c2 <= 57343) {
          _tmp = index + 2 | 0;
          _tmp$2 = count + 1 | 0;
          continue;
        } else {
          moonbitlang$core$builtin$$abort$7$("invalid surrogate pair", "@moonbitlang/core/builtin:string.mbt:491:9-491:40");
        }
      }
      _tmp = index + 1 | 0;
      _tmp$2 = count + 1 | 0;
      continue;
    } else {
      return count >= len;
    }
  }
}
function moonbitlang$core$string$$String$offset_of_nth_char_backward(self, n, start_offset, end_offset) {
  let char_count = 0;
  let utf16_offset = end_offset;
  while (true) {
    if ((utf16_offset - 1 | 0) >= start_offset && char_count < n) {
      const _tmp = utf16_offset - 1 | 0;
      const c = self.charCodeAt(_tmp);
      if (56320 <= c && c <= 57343) {
        utf16_offset = utf16_offset - 2 | 0;
      } else {
        utf16_offset = utf16_offset - 1 | 0;
      }
      char_count = char_count + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return char_count < n || utf16_offset < start_offset ? undefined : utf16_offset;
}
function moonbitlang$core$string$$String$offset_of_nth_char_forward(self, n, start_offset, end_offset) {
  if (start_offset >= 0 && start_offset <= end_offset) {
    let utf16_offset = start_offset;
    let char_count = 0;
    while (true) {
      if (utf16_offset < end_offset && char_count < n) {
        const _tmp = utf16_offset;
        const c = self.charCodeAt(_tmp);
        if (55296 <= c && c <= 56319) {
          utf16_offset = utf16_offset + 2 | 0;
        } else {
          utf16_offset = utf16_offset + 1 | 0;
        }
        char_count = char_count + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return char_count < n || utf16_offset >= end_offset ? undefined : utf16_offset;
  } else {
    return moonbitlang$core$builtin$$abort$8$("Invalid start index", "@moonbitlang/core/builtin:string.mbt:366:5-366:33");
  }
}
function moonbitlang$core$string$$String$offset_of_nth_char$46$inner(self, i, start_offset, end_offset) {
  let end_offset$2;
  if (end_offset === undefined) {
    end_offset$2 = self.length;
  } else {
    const _Some = end_offset;
    end_offset$2 = _Some;
  }
  return i >= 0 ? moonbitlang$core$string$$String$offset_of_nth_char_forward(self, i, start_offset, end_offset$2) : moonbitlang$core$string$$String$offset_of_nth_char_backward(self, -i | 0, start_offset, end_offset$2);
}
function moonbitlang$core$builtin$$StringBuilder$write_iter(self, iter) {
  iter((ch) => {
    moonbitlang$core$builtin$$Logger$write_char$0$(self, ch);
    return 1;
  });
}
function moonbitlang$core$builtin$$Logger$write_view$0$(self, str) {
  const _bind = self;
  _bind.val = `${_bind.val}${moonbitlang$core$builtin$$Show$to_string$6$(str)}`;
}
function moonbitlang$core$string$$String$find(self, str) {
  return moonbitlang$core$string$$StringView$find({ str: self, start: 0, end: self.length }, str);
}
function moonbitlang$core$string$$StringView$has_prefix(self, str) {
  const _bind = moonbitlang$core$string$$StringView$find(self, str);
  if (_bind === undefined) {
    return false;
  } else {
    const _Some = _bind;
    const _i = _Some;
    return _i === 0;
  }
}
function moonbitlang$core$string$$String$has_prefix(self, str) {
  return moonbitlang$core$string$$StringView$has_prefix({ str: self, start: 0, end: self.length }, str);
}
function moonbitlang$core$array$$Array$new$46$inner$18$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$20$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$22$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$29$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$30$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$21$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$19$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$new$46$inner$23$(capacity) {
  return [];
}
function moonbitlang$core$array$$Array$push$20$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$18$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$19$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$21$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$22$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$29$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$30$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$array$$Array$push$23$(self, value) {
  moonbitlang$core$builtin$$JSArray$push(self, value);
}
function moonbitlang$core$string$$StringView$is_empty(self) {
  return (self.end - self.start | 0) === 0;
}
function moonbitlang$core$string$$String$iterator(self) {
  const len = self.length;
  const index = { val: 0 };
  const _p = () => {
    if (index.val < len) {
      const _tmp = index.val;
      const c1 = self.charCodeAt(_tmp);
      if (55296 <= c1 && c1 <= 56319 && (index.val + 1 | 0) < len) {
        const _tmp$2 = index.val + 1 | 0;
        const c2 = self.charCodeAt(_tmp$2);
        if (56320 <= c2 && c2 <= 57343) {
          const c = moonbitlang$core$builtin$$code_point_of_surrogate_pair(c1, c2);
          index.val = index.val + 2 | 0;
          return c;
        }
      }
      index.val = index.val + 1 | 0;
      return c1;
    } else {
      return -1;
    }
  };
  return _p;
}
function moonbitlang$core$string$$String$iter(self) {
  return moonbitlang$core$builtin$$Iterator$iter$23$(moonbitlang$core$string$$String$iterator(self));
}
function moonbitlang$core$builtin$$Show$to_string$23$(self) {
  return String.fromCodePoint(self);
}
function moonbitlang$core$builtin$$Iter$each$31$(self, f) {
  const _foreach_result = { val: $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Continue$2$ };
  self((a) => {
    f(a);
    return 1;
  });
  const _tmp = _foreach_result.val;
  switch (_tmp.$tag) {
    case 0: {
      return;
    }
    case 1: {
      const _break = _tmp;
      _break._0;
      return;
    }
    case 2: {
      const _return = _tmp;
      return _return._0;
    }
    case 3: {
      $panic();
      return;
    }
    default: {
      $panic();
      return;
    }
  }
}
function moonbitlang$core$builtin$$Iter$collect$23$(self) {
  const result = [];
  moonbitlang$core$builtin$$Iter$each$31$(self, (e) => {
    moonbitlang$core$array$$Array$push$23$(result, e);
  });
  return result;
}
function moonbitlang$core$string$$String$replace(self, old, new_) {
  const _bind = moonbitlang$core$string$$String$find(self, old);
  if (_bind === undefined) {
    return self;
  } else {
    const _Some = _bind;
    const _end = _Some;
    const _self = moonbitlang$core$builtin$$StringBuilder$new$46$inner(0);
    moonbitlang$core$builtin$$StringBuilder$write_iter(_self, moonbitlang$core$string$$StringView$iter(moonbitlang$core$string$$String$view$46$inner(self, 0, _end)));
    moonbitlang$core$builtin$$StringBuilder$write_iter(_self, moonbitlang$core$string$$StringView$iter(new_));
    moonbitlang$core$builtin$$StringBuilder$write_iter(_self, moonbitlang$core$string$$StringView$iter(moonbitlang$core$string$$String$view$46$inner(self, _end + (old.end - old.start | 0) | 0, undefined)));
    const _p = _self;
    return _p.val;
  }
}
function moonbitlang$core$builtin$$ToStringView$to_string_view$19$(self) {
  return { str: self, start: 0, end: self.length };
}
function moonbitlang$core$string$$String$to_array(self) {
  const _p = moonbitlang$core$string$$String$iter(self);
  const _p$2 = moonbitlang$core$array$$Array$new$46$inner$23$(self.length);
  const _p$3 = { val: _p$2 };
  const _p$4 = { val: $64$moonbitlang$47$core$47$builtin$46$ForeachResult$Continue$1$ };
  _p((_p$5) => {
    const _p$6 = _p$3.val;
    moonbitlang$core$array$$Array$push$23$(_p$6, _p$5);
    _p$3.val = _p$6;
    return 1;
  });
  const _tmp = _p$4.val;
  switch (_tmp.$tag) {
    case 0: {
      break;
    }
    case 1: {
      const _p$5 = _tmp;
      _p$5._0;
      break;
    }
    case 2: {
      const _p$6 = _tmp;
      return _p$6._0;
    }
    case 3: {
      $panic();
      break;
    }
    default: {
      $panic();
    }
  }
  return _p$3.val;
}
function moonbitlang$core$builtin$$Show$output$9$(self, logger) {
  logger.method_table.method_0(logger.self, moonbitlang$core$int$$Int$to_string$46$inner(self, 10));
}
function moonbitlang$core$builtin$$Show$output$2$(self, logger) {
  logger.method_table.method_0(logger.self, moonbitlang$core$uint64$$UInt64$to_string$46$inner(self, 10));
}
function moonbitlang$core$array$$ArrayView$iterator$23$(self) {
  const i = { val: 0 };
  const _p = () => {
    if (i.val < (self.end - self.start | 0)) {
      const elem = self.buf[self.start + i.val | 0];
      i.val = i.val + 1 | 0;
      return elem;
    } else {
      return -1;
    }
  };
  return _p;
}
function moonbitlang$core$array$$ArrayView$iter$23$(self) {
  return moonbitlang$core$builtin$$Iterator$iter$23$(moonbitlang$core$array$$ArrayView$iterator$23$(self));
}
function moonbitlang$core$array$$ArrayView$at$4$(self, index) {
  if (index >= 0 && index < (self.end - self.start | 0)) {
    const _tmp = self.buf;
    const _tmp$2 = self.start + index | 0;
    $bound_check(_tmp, _tmp$2);
    return _tmp[_tmp$2];
  } else {
    return moonbitlang$core$builtin$$abort$4$(`index out of bounds: the len is from 0 to ${moonbitlang$core$builtin$$Show$to_string$27$(self.end - self.start | 0)} but the index is ${moonbitlang$core$builtin$$Show$to_string$27$(index)}`, "@moonbitlang/core/builtin:arrayview.mbt:101:5-103:6");
  }
}
function moonbitlang$core$builtin$$MyInt64$extend_i32_u(value) {
  return { hi: 0, lo: value };
}
function moonbitlang$core$uint64$$UInt64$extend_uint(value) {
  return moonbitlang$core$builtin$$MyInt64$extend_i32_u(value);
}
function moonbitlang$core$uint$$UInt$to_uint64(self) {
  return moonbitlang$core$uint64$$UInt64$extend_uint(self);
}
function moonbitlang$core$double$$Double$convert_uint64(value) {
  return moonbitlang$core$builtin$$MyInt64$convert_to_double_u(value);
}
function moonbitlang$core$int64$$Int64$reinterpret_as_double(self) {
  return moonbitlang$core$builtin$$MyInt64$reinterpret_as_double(self);
}
function moonbitlang$core$uint64$$UInt64$to_int(self) {
  const _p = self;
  return _p.lo;
}
function moonbitlang$core$uint64$$UInt64$to_byte(self) {
  return moonbitlang$core$uint64$$UInt64$to_int(self) & 255;
}
function moonbitlang$core$byte$$Byte$to_int64(self) {
  return moonbitlang$core$int$$Int$to_int64(self);
}
function moonbitlang$core$builtin$$Neg$neg$32$(self) {
  return self.lo === 0 ? { hi: ~self.hi + 1 | 0, lo: 0 } : { hi: ~self.hi, lo: ~self.lo + 1 | 0 };
}
function moonbitlang$core$builtin$$MyInt64$add_hi_lo(self, bhi, blo) {
  const _ahi = self.hi;
  const _alo = self.lo;
  const lo = _alo + blo | 0;
  const s = lo >> 31;
  const as_ = _alo >> 31;
  const bs = blo >> 31;
  const c = (as_ & bs | ~s & (as_ ^ bs)) & 1;
  const hi = (_ahi + bhi | 0) + c | 0;
  return { hi: hi, lo: lo };
}
function moonbitlang$core$builtin$$Add$add$32$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$add_hi_lo(self, other.hi, other.lo);
}
function moonbitlang$core$builtin$$Sub$sub$32$(self, other) {
  return other.lo === 0 ? { hi: self.hi - other.hi | 0, lo: self.lo } : moonbitlang$core$builtin$$MyInt64$add_hi_lo(self, ~other.hi, ~other.lo + 1 | 0);
}
function moonbitlang$core$builtin$$Mul$mul$32$(self, other) {
  const _ahi = self.hi;
  const _alo = self.lo;
  const _bhi = other.hi;
  const _blo = other.lo;
  const ahi = _ahi;
  const alo = _alo;
  const bhi = _bhi;
  const blo = _blo;
  const a48 = ahi >>> 16 | 0;
  const a32 = ahi & 65535;
  const a16 = alo >>> 16 | 0;
  const a00 = alo & 65535;
  const b48 = bhi >>> 16 | 0;
  const b32 = bhi & 65535;
  const b16 = blo >>> 16 | 0;
  const b00 = blo & 65535;
  const c00 = Math.imul(a00, b00) | 0;
  const c16 = c00 >>> 16 | 0;
  const c00$2 = c00 & 65535;
  const c16$2 = (c16 >>> 0) + ((Math.imul(a16, b00) | 0) >>> 0) | 0;
  const c32 = c16$2 >>> 16 | 0;
  const c16$3 = c16$2 & 65535;
  const c16$4 = (c16$3 >>> 0) + ((Math.imul(a00, b16) | 0) >>> 0) | 0;
  const c32$2 = (c32 >>> 0) + ((c16$4 >>> 16 | 0) >>> 0) | 0;
  const c16$5 = c16$4 & 65535;
  const c32$3 = (c32$2 >>> 0) + ((Math.imul(a32, b00) | 0) >>> 0) | 0;
  const c48 = c32$3 >>> 16 | 0;
  const c32$4 = c32$3 & 65535;
  const c32$5 = (c32$4 >>> 0) + ((Math.imul(a16, b16) | 0) >>> 0) | 0;
  const c48$2 = (c48 >>> 0) + ((c32$5 >>> 16 | 0) >>> 0) | 0;
  const c32$6 = c32$5 & 65535;
  const c32$7 = (c32$6 >>> 0) + ((Math.imul(a00, b32) | 0) >>> 0) | 0;
  const c48$3 = (c48$2 >>> 0) + ((c32$7 >>> 16 | 0) >>> 0) | 0;
  const c32$8 = c32$7 & 65535;
  const c48$4 = (((((((c48$3 >>> 0) + ((Math.imul(a48, b00) | 0) >>> 0) | 0) >>> 0) + ((Math.imul(a32, b16) | 0) >>> 0) | 0) >>> 0) + ((Math.imul(a16, b32) | 0) >>> 0) | 0) >>> 0) + ((Math.imul(a00, b48) | 0) >>> 0) | 0;
  const c48$5 = c48$4 & 65535;
  return { hi: c48$5 << 16 | c32$8, lo: c16$5 << 16 | c00$2 };
}
function moonbitlang$core$builtin$$try_get_int64_wasm_helper() {
  if (moonbitlang$core$builtin$$wasm_helper_cache.tried) {
    const _bind = moonbitlang$core$builtin$$wasm_helper_cache.exports;
    return !(_bind === undefined);
  }
  moonbitlang$core$builtin$$wasm_helper_cache.tried = true;
  moonbitlang$core$builtin$$wasm_helper_cache.exports = moonbitlang$core$builtin$$try_init_wasm_helper();
  const _bind = moonbitlang$core$builtin$$wasm_helper_cache.exports;
  return !(_bind === undefined);
}
function moonbitlang$core$builtin$$Div$div$32$(self, other) {
  if (!(other.hi === 0 && other.lo === 0)) {
    if (!moonbitlang$core$builtin$$try_get_int64_wasm_helper()) {
      return moonbitlang$core$builtin$$MyInt64$div_bigint(self, other);
    }
    const _bind = moonbitlang$core$builtin$$wasm_helper_cache.exports;
    if (_bind === undefined) {
      return $panic();
    } else {
      const _Some = _bind;
      const _exports = _Some;
      const _ahi = self.hi;
      const _alo = self.lo;
      const _bhi = other.hi;
      const _blo = other.lo;
      const _func = _exports.div_s;
      const lo = _func(_alo, _ahi, _blo, _bhi);
      const _func$2 = _exports.get_high;
      const hi = _func$2();
      return { hi: hi, lo: lo };
    }
  } else {
    return $panic();
  }
}
function moonbitlang$core$builtin$$MyInt64$div_u(self, other) {
  if (!(other.hi === 0 && other.lo === 0)) {
    if (!moonbitlang$core$builtin$$try_get_int64_wasm_helper()) {
      return moonbitlang$core$builtin$$MyInt64$div_u_bigint(self, other);
    }
    const _bind = moonbitlang$core$builtin$$wasm_helper_cache.exports;
    if (_bind === undefined) {
      return $panic();
    } else {
      const _Some = _bind;
      const _exports = _Some;
      const _ahi = self.hi;
      const _alo = self.lo;
      const _bhi = other.hi;
      const _blo = other.lo;
      const _func = _exports.div_u;
      const lo = _func(_alo, _ahi, _blo, _bhi);
      const _func$2 = _exports.get_high;
      const hi = _func$2();
      return { hi: hi, lo: lo };
    }
  } else {
    return $panic();
  }
}
function moonbitlang$core$builtin$$MyInt64$mod_u(self, other) {
  if (!(other.hi === 0 && other.lo === 0)) {
    if (!moonbitlang$core$builtin$$try_get_int64_wasm_helper()) {
      return moonbitlang$core$builtin$$MyInt64$mod_u_bigint(self, other);
    }
    const _bind = moonbitlang$core$builtin$$wasm_helper_cache.exports;
    if (_bind === undefined) {
      return $panic();
    } else {
      const _Some = _bind;
      const _exports = _Some;
      const _ahi = self.hi;
      const _alo = self.lo;
      const _bhi = other.hi;
      const _blo = other.lo;
      const _func = _exports.rem_u;
      const lo = _func(_alo, _ahi, _blo, _bhi);
      const _func$2 = _exports.get_high;
      const hi = _func$2();
      return { hi: hi, lo: lo };
    }
  } else {
    return $panic();
  }
}
function moonbitlang$core$builtin$$MyInt64$land(self, other) {
  return { hi: self.hi & other.hi, lo: self.lo & other.lo };
}
function moonbitlang$core$builtin$$MyInt64$lor(self, other) {
  return { hi: self.hi | other.hi, lo: self.lo | other.lo };
}
function moonbitlang$core$builtin$$MyInt64$lsl(self, shift) {
  const shift$2 = shift & 63;
  if (shift$2 === 0) {
    return self;
  } else {
    if (shift$2 < 32) {
      const _hi = self.hi;
      const _lo = self.lo;
      const hi = _hi;
      const lo = _lo;
      const hi$2 = hi << shift$2 | (lo >>> (32 - shift$2 | 0) | 0);
      const lo$2 = lo << shift$2;
      return { hi: hi$2, lo: lo$2 };
    } else {
      return { hi: self.lo << (shift$2 - 32 | 0), lo: 0 };
    }
  }
}
function moonbitlang$core$builtin$$MyInt64$lsr(self, shift) {
  const shift$2 = shift & 63;
  return shift$2 === 0 ? self : shift$2 < 32 ? { hi: self.hi >>> shift$2 | 0, lo: self.lo >>> shift$2 | self.hi << (32 - shift$2 | 0) } : { hi: 0, lo: self.hi >>> (shift$2 - 32 | 0) | 0 };
}
function moonbitlang$core$builtin$$MyInt64$asr(self, shift) {
  const shift$2 = shift & 63;
  return shift$2 === 0 ? self : shift$2 < 32 ? { hi: self.hi >> shift$2, lo: self.lo >>> shift$2 | self.hi << (32 - shift$2 | 0) } : { hi: self.hi >> 31, lo: self.hi >> (shift$2 - 32 | 0) };
}
function moonbitlang$core$builtin$$Neg$neg$25$(self) {
  return moonbitlang$core$builtin$$Neg$neg$32$(self);
}
function moonbitlang$core$builtin$$Add$add$25$(self, other) {
  return moonbitlang$core$builtin$$Add$add$32$(self, other);
}
function moonbitlang$core$builtin$$Sub$sub$25$(self, other) {
  return moonbitlang$core$builtin$$Sub$sub$32$(self, other);
}
function moonbitlang$core$builtin$$Mul$mul$25$(self, other) {
  return moonbitlang$core$builtin$$Mul$mul$32$(self, other);
}
function moonbitlang$core$builtin$$Div$div$25$(self, other) {
  return moonbitlang$core$builtin$$Div$div$32$(self, other);
}
function moonbitlang$core$builtin$$BitAnd$land$25$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$land(self, other);
}
function moonbitlang$core$builtin$$BitOr$lor$25$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$lor(self, other);
}
function moonbitlang$core$builtin$$Shr$shr$25$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$asr(self, other);
}
function moonbitlang$core$builtin$$Shl$shl$25$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$lsl(self, other);
}
function moonbitlang$core$builtin$$Eq$equal$25$(self, other) {
  const _p = self;
  const _p$2 = other;
  return _p.hi === _p$2.hi && _p.lo === _p$2.lo;
}
function moonbitlang$core$builtin$$Compare$compare$25$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$compare(self, other);
}
function moonbitlang$core$int64$$Int64$to_int(self) {
  const _p = self;
  return _p.lo;
}
function moonbitlang$core$uint64$$UInt64$reinterpret_as_double(self) {
  return moonbitlang$core$builtin$$MyInt64$reinterpret_as_double(self);
}
function moonbitlang$core$double$$Double$reinterpret_as_uint64(self) {
  return moonbitlang$core$builtin$$MyInt64$reinterpret_double(self);
}
function moonbitlang$core$builtin$$Add$add$2$(self, other) {
  return moonbitlang$core$builtin$$Add$add$32$(self, other);
}
function moonbitlang$core$builtin$$Sub$sub$2$(self, other) {
  return moonbitlang$core$builtin$$Sub$sub$32$(self, other);
}
function moonbitlang$core$builtin$$Mul$mul$2$(self, other) {
  return moonbitlang$core$builtin$$Mul$mul$32$(self, other);
}
function moonbitlang$core$builtin$$Div$div$2$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$div_u(self, other);
}
function moonbitlang$core$builtin$$Mod$mod$2$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$mod_u(self, other);
}
function moonbitlang$core$builtin$$Compare$compare$2$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$compare_u(self, other);
}
function moonbitlang$core$builtin$$Eq$equal$2$(self, other) {
  const _p = self;
  const _p$2 = other;
  return _p.hi === _p$2.hi && _p.lo === _p$2.lo;
}
function moonbitlang$core$builtin$$BitAnd$land$2$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$land(self, other);
}
function moonbitlang$core$builtin$$BitOr$lor$2$(self, other) {
  return moonbitlang$core$builtin$$MyInt64$lor(self, other);
}
function moonbitlang$core$builtin$$Shl$shl$2$(self, shift) {
  return moonbitlang$core$builtin$$MyInt64$lsl(self, shift);
}
function moonbitlang$core$builtin$$Shr$shr$2$(self, shift) {
  return moonbitlang$core$builtin$$MyInt64$lsr(self, shift);
}
function moonbitlang$core$uint64$$UInt64$clz(self) {
  const _p = self;
  return _p.hi !== 0 ? Math.clz32(_p.hi) : 32 + Math.clz32(_p.lo) | 0;
}
function moonbitlang$core$bytes$$Bytes$makei$33$(length, value) {
  if (length <= 0) {
    return $bytes_literal$0;
  }
  const arr = $makebytes(length, value(0));
  let _tmp = 1;
  while (true) {
    const i = _tmp;
    if (i < length) {
      $bound_check(arr, i);
      arr[i] = value(i);
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function moonbitlang$core$byte$$Byte$to_uint64(self) {
  return moonbitlang$core$uint$$UInt$to_uint64(self);
}
function moonbitlang$core$builtin$$Eq$equal$17$(self, other) {
  if (self.length !== other.length) {
    return false;
  } else {
    const len = self.length;
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < len) {
        $bound_check(self, i);
        const _tmp$2 = self[i];
        $bound_check(other, i);
        if (_tmp$2 !== other[i]) {
          return false;
        }
        _tmp = i + 1 | 0;
        continue;
      } else {
        return true;
      }
    }
  }
}
function moonbitlang$core$bytes$$Bytes$from_array(arr) {
  return moonbitlang$core$bytes$$Bytes$makei$33$(arr.end - arr.start | 0, (i) => moonbitlang$core$array$$ArrayView$at$4$(arr, i));
}
function moonbitlang$core$array$$Array$make$4$(len, elem) {
  const arr = new Array(len);
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < len) {
      arr[i] = elem;
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return arr;
}
function moonbitlang$core$array$$Array$set$4$(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function moonbitlang$core$array$$Array$set$19$(self, index, value) {
  const len = self.length;
  if (index >= 0 && index < len) {
    $bound_check(self, index);
    self[index] = value;
    return;
  } else {
    $panic();
    return;
  }
}
function moonbitlang$core$bytes$$Bytes$to_array(self) {
  const len = self.length;
  const rv = moonbitlang$core$array$$Array$make$4$(len, 48);
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < len) {
      $bound_check(self, i);
      moonbitlang$core$array$$Array$set$4$(rv, i, self[i]);
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return rv;
}
function moonbitlang$core$builtin$$Show$output$34$(self, logger) {
  const pkg = self.pkg;
  const _bind = moonbitlang$core$string$$StringView$find(pkg, { str: moonbitlang$core$builtin$$output$46$42$bind$124$8198, start: 0, end: moonbitlang$core$builtin$$output$46$42$bind$124$8198.length });
  let _bind$2;
  if (_bind === undefined) {
    _bind$2 = { _0: pkg, _1: undefined };
  } else {
    const _Some = _bind;
    const _first_slash = _Some;
    const _bind$3 = moonbitlang$core$string$$StringView$find(moonbitlang$core$string$$StringView$view$46$inner(pkg, _first_slash + 1 | 0, undefined), { str: moonbitlang$core$builtin$$output$46$42$bind$124$8192, start: 0, end: moonbitlang$core$builtin$$output$46$42$bind$124$8192.length });
    if (_bind$3 === undefined) {
      _bind$2 = { _0: pkg, _1: undefined };
    } else {
      const _Some$2 = _bind$3;
      const _second_slash = _Some$2;
      const module_name_end = (_first_slash + 1 | 0) + _second_slash | 0;
      _bind$2 = { _0: moonbitlang$core$string$$StringView$view$46$inner(pkg, 0, module_name_end), _1: moonbitlang$core$string$$StringView$view$46$inner(pkg, module_name_end + 1 | 0, undefined) };
    }
  }
  const _module_name = _bind$2._0;
  const _package_name = _bind$2._1;
  if (_package_name === undefined) {
  } else {
    const _Some = _package_name;
    const _pkg_name = _Some;
    logger.method_table.method_2(logger.self, _pkg_name);
    logger.method_table.method_3(logger.self, 47);
  }
  logger.method_table.method_2(logger.self, self.filename);
  logger.method_table.method_3(logger.self, 58);
  logger.method_table.method_2(logger.self, self.start_line);
  logger.method_table.method_3(logger.self, 58);
  logger.method_table.method_2(logger.self, self.start_column);
  logger.method_table.method_3(logger.self, 45);
  logger.method_table.method_2(logger.self, self.end_line);
  logger.method_table.method_3(logger.self, 58);
  logger.method_table.method_2(logger.self, self.end_column);
  logger.method_table.method_3(logger.self, 64);
  logger.method_table.method_2(logger.self, _module_name);
}
function moonbitlang$core$builtin$$Show$output$28$(self, logger) {
  moonbitlang$core$builtin$$Show$output$34$(moonbitlang$core$builtin$$SourceLocRepr$parse(self), logger);
}
function moonbitlang$core$array$$Array$sub$46$inner$4$(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  return start$2 >= 0 && (start$2 <= end$2 && end$2 <= len) ? { buf: self, start: start$2, end: end$2 } : moonbitlang$core$builtin$$abort$3$("View index out of bounds", "@moonbitlang/core/builtin:arrayview.mbt:200:5-200:38");
}
function moonbitlang$core$array$$Array$sub$46$inner$23$(self, start, end) {
  const len = self.length;
  let end$2;
  if (end === undefined) {
    end$2 = len;
  } else {
    const _Some = end;
    const _end = _Some;
    end$2 = _end < 0 ? len + _end | 0 : _end;
  }
  const start$2 = start < 0 ? len + start | 0 : start;
  return start$2 >= 0 && (start$2 <= end$2 && end$2 <= len) ? { buf: self, start: start$2, end: end$2 } : moonbitlang$core$builtin$$abort$5$("View index out of bounds", "@moonbitlang/core/builtin:arrayview.mbt:200:5-200:38");
}
function moonbitlang$core$array$$ArrayView$join$19$(self, separator) {
  if ((self.end - self.start | 0) === 0) {
    return "";
  } else {
    const _hd = self.buf[self.start];
    const _bind = self.buf;
    const _bind$2 = 1 + self.start | 0;
    const _bind$3 = self.end;
    const _x = { buf: _bind, start: _bind$2, end: _bind$3 };
    const hd = moonbitlang$core$builtin$$ToStringView$to_string_view$19$(_hd);
    let size_hint = hd.end - hd.start | 0;
    const _len = _x.end - _x.start | 0;
    let _tmp = 0;
    while (true) {
      const _i = _tmp;
      if (_i < _len) {
        const s = _bind[_bind$2 + _i | 0];
        const _tmp$2 = size_hint;
        const _p = moonbitlang$core$builtin$$ToStringView$to_string_view$19$(s);
        size_hint = _tmp$2 + ((_p.end - _p.start | 0) + (separator.end - separator.start | 0) | 0) | 0;
        _tmp = _i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    size_hint = size_hint << 1;
    const buf = moonbitlang$core$builtin$$StringBuilder$new$46$inner(size_hint);
    moonbitlang$core$builtin$$Logger$write_view$0$(buf, hd);
    if (moonbitlang$core$string$$String$char_length_eq$46$inner(separator.str, 0, separator.start, separator.end)) {
      const _len$2 = _x.end - _x.start | 0;
      let _tmp$2 = 0;
      while (true) {
        const _i = _tmp$2;
        if (_i < _len$2) {
          const s = _bind[_bind$2 + _i | 0];
          const s$2 = moonbitlang$core$builtin$$ToStringView$to_string_view$19$(s);
          moonbitlang$core$builtin$$Logger$write_view$0$(buf, s$2);
          _tmp$2 = _i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      const _len$2 = _x.end - _x.start | 0;
      let _tmp$2 = 0;
      while (true) {
        const _i = _tmp$2;
        if (_i < _len$2) {
          const s = _bind[_bind$2 + _i | 0];
          const s$2 = moonbitlang$core$builtin$$ToStringView$to_string_view$19$(s);
          moonbitlang$core$builtin$$Logger$write_view$0$(buf, separator);
          moonbitlang$core$builtin$$Logger$write_view$0$(buf, s$2);
          _tmp$2 = _i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    }
    return buf.val;
  }
}
function moonbitlang$core$builtin$$Add$add$35$(self, other) {
  const result = new Array(self.length + other.length | 0);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$14$(result, 0, self, 0, self.length);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$14$(result, self.length, other, 0, other.length);
  return result;
}
function moonbitlang$core$builtin$$Add$add$36$(self, other) {
  const result = new Array(self.length + other.length | 0);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$15$(result, 0, self, 0, self.length);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$15$(result, self.length, other, 0, other.length);
  return result;
}
function moonbitlang$core$builtin$$Add$add$37$(self, other) {
  const result = new Array(self.length + other.length | 0);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$16$(result, 0, self, 0, self.length);
  moonbitlang$core$builtin$$UninitializedArray$unsafe_blit$16$(result, self.length, other, 0, other.length);
  return result;
}
function moonbitlang$core$array$$Array$from_iter$23$(iter) {
  return moonbitlang$core$builtin$$Iter$collect$23$(iter);
}
function moonbitlang$core$array$$Array$join$19$(self, separator) {
  return moonbitlang$core$array$$ArrayView$join$19$({ buf: self, start: 0, end: self.length }, separator);
}
function moonbitlang$core$double$internal$ryu$$copy_special_str(sign, exponent, mantissa) {
  if (mantissa) {
    return "NaN";
  }
  const s = sign ? "-" : "";
  if (exponent) {
    return `${s}Infinity`;
  }
  return `${s}0.0`;
}
function moonbitlang$core$double$internal$ryu$$string_from_bytes(bytes, from, to) {
  const buf = moonbitlang$core$builtin$$StringBuilder$new$46$inner(bytes.length);
  let _tmp = from;
  while (true) {
    const i = _tmp;
    if (i < to) {
      $bound_check(bytes, i);
      const _p = bytes[i];
      moonbitlang$core$builtin$$Logger$write_char$0$(buf, _p);
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return buf.val;
}
function moonbitlang$core$double$internal$ryu$$umul128(a, b) {
  const aLo = moonbitlang$core$builtin$$BitAnd$land$2$(a, $4294967295L);
  const aHi = moonbitlang$core$builtin$$Shr$shr$2$(a, 32);
  const bLo = moonbitlang$core$builtin$$BitAnd$land$2$(b, $4294967295L);
  const bHi = moonbitlang$core$builtin$$Shr$shr$2$(b, 32);
  const x = moonbitlang$core$builtin$$Mul$mul$2$(aLo, bLo);
  const y = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(aHi, bLo), moonbitlang$core$builtin$$Shr$shr$2$(x, 32));
  const z = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(aLo, bHi), moonbitlang$core$builtin$$BitAnd$land$2$(y, $4294967295L));
  const w = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(aHi, bHi), moonbitlang$core$builtin$$Shr$shr$2$(y, 32)), moonbitlang$core$builtin$$Shr$shr$2$(z, 32));
  const lo = moonbitlang$core$builtin$$Mul$mul$2$(a, b);
  return { _0: lo, _1: w };
}
function moonbitlang$core$double$internal$ryu$$shiftright128(lo, hi, dist) {
  return moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$Shl$shl$2$(hi, 64 - dist | 0), moonbitlang$core$builtin$$Shr$shr$2$(lo, dist));
}
function moonbitlang$core$double$internal$ryu$$pow5Factor(value) {
  if (moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$Mod$mod$2$(value, $5L), $0L)) {
    return 0;
  }
  if (moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$Mod$mod$2$(value, $25L), $0L)) {
    return 1;
  }
  if (moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$Mod$mod$2$(value, $125L), $0L)) {
    return 2;
  }
  if (moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$Mod$mod$2$(value, $625L), $0L)) {
    return 3;
  }
  let count = 4;
  let value$2 = moonbitlang$core$builtin$$Div$div$2$(value, $625L);
  while (true) {
    if (moonbitlang$core$builtin$$Compare$op_gt$26$(value$2, $0L)) {
      if (moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$Mod$mod$2$(value$2, $5L), $0L)) {
        return count;
      }
      value$2 = moonbitlang$core$builtin$$Div$div$2$(value$2, $5L);
      count = count + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return moonbitlang$core$builtin$$abort$9$(`IllegalArgumentException ${moonbitlang$core$builtin$$Show$to_string$26$(value$2)}`, "@moonbitlang/core/double/internal/ryu:ryu.mbt:116:3-116:45");
}
function moonbitlang$core$double$internal$ryu$$multipleOfPowerOf5(value, p) {
  return moonbitlang$core$double$internal$ryu$$pow5Factor(value) >= p;
}
function moonbitlang$core$double$internal$ryu$$multipleOfPowerOf2(value, p) {
  return moonbitlang$core$builtin$$Eq$equal$2$(moonbitlang$core$builtin$$BitAnd$land$2$(value, moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, p), $1L)), $0L);
}
function moonbitlang$core$double$internal$ryu$$mulShiftAll64(m, mul, j, mmShift) {
  const _mul0 = mul._0;
  const _mul1 = mul._1;
  const m$2 = moonbitlang$core$builtin$$Shl$shl$2$(m, 1);
  const _bind = moonbitlang$core$double$internal$ryu$$umul128(m$2, _mul0);
  const _lo = _bind._0;
  const _tmp = _bind._1;
  const _bind$2 = moonbitlang$core$double$internal$ryu$$umul128(m$2, _mul1);
  const _lo2 = _bind$2._0;
  const _hi2 = _bind$2._1;
  const mid = moonbitlang$core$builtin$$Add$add$2$(_tmp, _lo2);
  const hi = moonbitlang$core$builtin$$Add$add$2$(_hi2, moonbitlang$core$builtin$$Compare$op_lt$26$(mid, _tmp) ? $1L : $0L);
  const lo2 = moonbitlang$core$builtin$$Add$add$2$(_lo, _mul0);
  const mid2 = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Add$add$2$(mid, _mul1), moonbitlang$core$builtin$$Compare$op_lt$26$(lo2, _lo) ? $1L : $0L);
  const hi2 = moonbitlang$core$builtin$$Add$add$2$(hi, moonbitlang$core$builtin$$Compare$op_lt$26$(mid2, mid) ? $1L : $0L);
  const vp = moonbitlang$core$double$internal$ryu$$shiftright128(mid2, hi2, (j - 64 | 0) - 1 | 0);
  let vm = $0L;
  if (mmShift) {
    const lo3 = moonbitlang$core$builtin$$Sub$sub$2$(_lo, _mul0);
    const mid3 = moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Sub$sub$2$(mid, _mul1), moonbitlang$core$builtin$$Compare$op_lt$26$(_lo, lo3) ? $1L : $0L);
    const hi3 = moonbitlang$core$builtin$$Sub$sub$2$(hi, moonbitlang$core$builtin$$Compare$op_lt$26$(mid, mid3) ? $1L : $0L);
    vm = moonbitlang$core$double$internal$ryu$$shiftright128(mid3, hi3, (j - 64 | 0) - 1 | 0);
  } else {
    const lo3 = moonbitlang$core$builtin$$Add$add$2$(_lo, _lo);
    const mid3 = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Add$add$2$(mid, mid), moonbitlang$core$builtin$$Compare$op_lt$26$(lo3, _lo) ? $1L : $0L);
    const hi3 = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Add$add$2$(hi, hi), moonbitlang$core$builtin$$Compare$op_lt$26$(mid3, mid) ? $1L : $0L);
    const lo4 = moonbitlang$core$builtin$$Sub$sub$2$(lo3, _mul0);
    const mid4 = moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Sub$sub$2$(mid3, _mul1), moonbitlang$core$builtin$$Compare$op_lt$26$(lo3, lo4) ? $1L : $0L);
    const hi4 = moonbitlang$core$builtin$$Sub$sub$2$(hi3, moonbitlang$core$builtin$$Compare$op_lt$26$(mid3, mid4) ? $1L : $0L);
    vm = moonbitlang$core$double$internal$ryu$$shiftright128(mid4, hi4, j - 64 | 0);
  }
  const vr = moonbitlang$core$double$internal$ryu$$shiftright128(mid, hi, (j - 64 | 0) - 1 | 0);
  return { _0: vr, _1: vp, _2: vm };
}
function moonbitlang$core$double$internal$ryu$$double_computePow5(i) {
  const base = i / 26 | 0;
  const base2 = Math.imul(base, 26) | 0;
  const offset = i - base2 | 0;
  const _p = Math.imul(base, 2) | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_SPLIT2, _p);
  const mul0 = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_SPLIT2[_p];
  const _p$2 = (Math.imul(base, 2) | 0) + 1 | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_SPLIT2, _p$2);
  const mul1 = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_SPLIT2[_p$2];
  if (offset === 0) {
    return { _0: mul0, _1: mul1 };
  }
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_TABLE, offset);
  const m = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_TABLE[offset];
  const _bind = moonbitlang$core$double$internal$ryu$$umul128(m, mul1);
  const _low1 = _bind._0;
  const _high1 = _bind._1;
  const _bind$2 = moonbitlang$core$double$internal$ryu$$umul128(m, mul0);
  const _low0 = _bind$2._0;
  const _high0 = _bind$2._1;
  const sum = moonbitlang$core$builtin$$Add$add$2$(_high0, _low1);
  let high1 = _high1;
  if (moonbitlang$core$builtin$$Compare$op_lt$26$(sum, _high0)) {
    high1 = moonbitlang$core$builtin$$Add$add$2$(high1, $1L);
  }
  const delta = (((Math.imul(i, 1217359) | 0) >>> 19 | 0) + 1 | 0) - (((Math.imul(base2, 1217359) | 0) >>> 19 | 0) + 1 | 0) | 0;
  const _tmp = moonbitlang$core$double$internal$ryu$$shiftright128(_low0, sum, delta);
  const _p$3 = i / 16 | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gPOW5_OFFSETS, _p$3);
  const a = moonbitlang$core$builtin$$Add$add$2$(_tmp, moonbitlang$core$uint$$UInt$to_uint64(moonbitlang$core$double$internal$ryu$$gPOW5_OFFSETS[_p$3] >>> (i % 16 << 1) & 3));
  const b = moonbitlang$core$double$internal$ryu$$shiftright128(sum, high1, delta);
  return { _0: a, _1: b };
}
function moonbitlang$core$double$internal$ryu$$double_computeInvPow5(i) {
  const base = ((i + 26 | 0) - 1 | 0) / 26 | 0;
  const base2 = Math.imul(base, 26) | 0;
  const offset = base2 - i | 0;
  const _p = Math.imul(base, 2) | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_INV_SPLIT2, _p);
  const mul0 = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_INV_SPLIT2[_p];
  const _p$2 = (Math.imul(base, 2) | 0) + 1 | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_INV_SPLIT2, _p$2);
  const mul1 = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_INV_SPLIT2[_p$2];
  if (offset === 0) {
    return { _0: mul0, _1: mul1 };
  }
  $bound_check(moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_TABLE, offset);
  const m = moonbitlang$core$double$internal$ryu$$gDOUBLE_POW5_TABLE[offset];
  const _bind = moonbitlang$core$double$internal$ryu$$umul128(m, mul1);
  const _low1 = _bind._0;
  const _high1 = _bind._1;
  const _bind$2 = moonbitlang$core$double$internal$ryu$$umul128(m, mul0);
  const _low0 = _bind$2._0;
  const _high0 = _bind$2._1;
  const sum = moonbitlang$core$builtin$$Add$add$2$(_high0, _low1);
  let high1 = _high1;
  if (moonbitlang$core$builtin$$Compare$op_lt$26$(sum, _high0)) {
    high1 = moonbitlang$core$builtin$$Add$add$2$(high1, $1L);
  }
  const delta = (((Math.imul(base2, 1217359) | 0) >>> 19 | 0) + 1 | 0) - (((Math.imul(i, 1217359) | 0) >>> 19 | 0) + 1 | 0) | 0;
  const _tmp = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$double$internal$ryu$$shiftright128(_low0, sum, delta), $1L);
  const _p$3 = i / 16 | 0;
  $bound_check(moonbitlang$core$double$internal$ryu$$gPOW5_INV_OFFSETS, _p$3);
  const a = moonbitlang$core$builtin$$Add$add$2$(_tmp, moonbitlang$core$uint$$UInt$to_uint64(moonbitlang$core$double$internal$ryu$$gPOW5_INV_OFFSETS[_p$3] >>> (i % 16 << 1) & 3));
  const b = moonbitlang$core$double$internal$ryu$$shiftright128(sum, high1, delta);
  return { _0: a, _1: b };
}
function moonbitlang$core$double$internal$ryu$$decimal_length17(v) {
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10000000000000000L)) {
    return 17;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $1000000000000000L)) {
    return 16;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $100000000000000L)) {
    return 15;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10000000000000L)) {
    return 14;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $1000000000000L)) {
    return 13;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $100000000000L)) {
    return 12;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10000000000L)) {
    return 11;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $1000000000L)) {
    return 10;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $100000000L)) {
    return 9;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10000000L)) {
    return 8;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $1000000L)) {
    return 7;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $100000L)) {
    return 6;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10000L)) {
    return 5;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $1000L)) {
    return 4;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $100L)) {
    return 3;
  }
  if (moonbitlang$core$builtin$$Compare$op_ge$26$(v, $10L)) {
    return 2;
  }
  return 1;
}
function moonbitlang$core$double$internal$ryu$$d2d(ieeeMantissa, ieeeExponent) {
  let e2 = 0;
  let m2 = $0L;
  if (ieeeExponent === 0) {
    e2 = -1076;
    m2 = ieeeMantissa;
  } else {
    e2 = ((ieeeExponent - 1023 | 0) - 52 | 0) - 2 | 0;
    m2 = moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, 52), ieeeMantissa);
  }
  const even = moonbitlang$core$builtin$$Eq$equal$2$(moonbitlang$core$builtin$$BitAnd$land$2$(m2, $1L), $0L);
  const mv = moonbitlang$core$builtin$$Mul$mul$2$($4L, m2);
  const mmShift = moonbitlang$core$builtin$$op_notequal$2$(ieeeMantissa, $0L) || ieeeExponent >>> 0 <= 1 >>> 0;
  let vr = $0L;
  let vp = $0L;
  let vm = $0L;
  let e10 = 0;
  let vmIsTrailingZeros = false;
  let vrIsTrailingZeros = false;
  if (e2 >= 0) {
    const _p = e2;
    const _tmp = (Math.imul(_p, 78913) | 0) >>> 18 | 0;
    const _p$2 = e2 > 3;
    const q = _tmp - (_p$2 ? 1 : 0) | 0;
    e10 = q;
    const k = (125 + (((Math.imul(q, 1217359) | 0) >>> 19 | 0) + 1 | 0) | 0) - 1 | 0;
    const i = ((-e2 | 0) + q | 0) + k | 0;
    const pow5 = moonbitlang$core$double$internal$ryu$$double_computeInvPow5(q);
    const _bind = moonbitlang$core$double$internal$ryu$$mulShiftAll64(m2, pow5, i, mmShift);
    const _vrOut = _bind._0;
    const _vpOut = _bind._1;
    const _vmOut = _bind._2;
    vr = _vrOut;
    vp = _vpOut;
    vm = _vmOut;
    if (q <= 21) {
      const mvMod5 = moonbitlang$core$uint64$$UInt64$to_int(mv) - (Math.imul(5, moonbitlang$core$uint64$$UInt64$to_int(moonbitlang$core$builtin$$Div$div$2$(mv, $5L))) | 0) | 0;
      if (mvMod5 === 0) {
        vrIsTrailingZeros = moonbitlang$core$double$internal$ryu$$multipleOfPowerOf5(mv, q);
      } else {
        if (even) {
          vmIsTrailingZeros = moonbitlang$core$double$internal$ryu$$multipleOfPowerOf5(moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Sub$sub$2$(mv, $1L), mmShift ? $1L : $0L), q);
        } else {
          const _tmp$2 = vp;
          const _p$3 = moonbitlang$core$double$internal$ryu$$multipleOfPowerOf5(moonbitlang$core$builtin$$Add$add$2$(mv, $2L), q);
          vp = moonbitlang$core$builtin$$Sub$sub$2$(_tmp$2, _p$3 ? $1L : $0L);
        }
      }
    }
  } else {
    const _p = -e2 | 0;
    const _tmp = (Math.imul(_p, 732923) | 0) >>> 20 | 0;
    const _p$2 = (-e2 | 0) > 1;
    const q = _tmp - (_p$2 ? 1 : 0) | 0;
    e10 = q + e2 | 0;
    const i = (-e2 | 0) - q | 0;
    const k = (((Math.imul(i, 1217359) | 0) >>> 19 | 0) + 1 | 0) - 125 | 0;
    const j = q - k | 0;
    const pow5 = moonbitlang$core$double$internal$ryu$$double_computePow5(i);
    const _bind = moonbitlang$core$double$internal$ryu$$mulShiftAll64(m2, pow5, j, mmShift);
    const _vrOut = _bind._0;
    const _vpOut = _bind._1;
    const _vmOut = _bind._2;
    vr = _vrOut;
    vp = _vpOut;
    vm = _vmOut;
    if (q <= 1) {
      vrIsTrailingZeros = true;
      if (even) {
        vmIsTrailingZeros = (mmShift ? 1 : 0) === 1;
      } else {
        vp = moonbitlang$core$builtin$$Sub$sub$2$(vp, $1L);
      }
    } else {
      if (q < 63) {
        vrIsTrailingZeros = moonbitlang$core$double$internal$ryu$$multipleOfPowerOf2(mv, q);
      }
    }
  }
  let removed = 0;
  let lastRemovedDigit = 0;
  let output = $0L;
  if (vmIsTrailingZeros || vrIsTrailingZeros) {
    while (true) {
      const vpDiv10 = moonbitlang$core$builtin$$Div$div$2$(vp, $10L);
      const vmDiv10 = moonbitlang$core$builtin$$Div$div$2$(vm, $10L);
      if (moonbitlang$core$builtin$$Compare$op_le$26$(vpDiv10, vmDiv10)) {
        break;
      }
      const vmMod10 = moonbitlang$core$uint64$$UInt64$to_int(vm) - (Math.imul(10, moonbitlang$core$uint64$$UInt64$to_int(vmDiv10)) | 0) | 0;
      const vrDiv10 = moonbitlang$core$builtin$$Div$div$2$(vr, $10L);
      const vrMod10 = moonbitlang$core$uint64$$UInt64$to_int(vr) - (Math.imul(10, moonbitlang$core$uint64$$UInt64$to_int(vrDiv10)) | 0) | 0;
      vmIsTrailingZeros = vmIsTrailingZeros && vmMod10 === 0;
      vrIsTrailingZeros = vrIsTrailingZeros && lastRemovedDigit === 0;
      lastRemovedDigit = vrMod10;
      vr = vrDiv10;
      vp = vpDiv10;
      vm = vmDiv10;
      removed = removed + 1 | 0;
      continue;
    }
    if (vmIsTrailingZeros) {
      while (true) {
        const vmDiv10 = moonbitlang$core$builtin$$Div$div$2$(vm, $10L);
        const vmMod10 = moonbitlang$core$uint64$$UInt64$to_int(vm) - (Math.imul(10, moonbitlang$core$uint64$$UInt64$to_int(vmDiv10)) | 0) | 0;
        if (vmMod10 !== 0) {
          break;
        }
        const vpDiv10 = moonbitlang$core$builtin$$Div$div$2$(vp, $10L);
        const vrDiv10 = moonbitlang$core$builtin$$Div$div$2$(vr, $10L);
        const vrMod10 = moonbitlang$core$uint64$$UInt64$to_int(vr) - (Math.imul(10, moonbitlang$core$uint64$$UInt64$to_int(vrDiv10)) | 0) | 0;
        vrIsTrailingZeros = vrIsTrailingZeros && lastRemovedDigit === 0;
        lastRemovedDigit = vrMod10;
        vr = vrDiv10;
        vp = vpDiv10;
        vm = vmDiv10;
        removed = removed + 1 | 0;
        continue;
      }
    }
    if (vrIsTrailingZeros && (lastRemovedDigit === 5 && moonbitlang$core$builtin$$Eq$equal$2$(moonbitlang$core$builtin$$Mod$mod$2$(vr, $2L), $0L))) {
      lastRemovedDigit = 4;
    }
    const _tmp = vr;
    const _p = moonbitlang$core$builtin$$Eq$equal$2$(vr, vm) && (!even || !vmIsTrailingZeros) || lastRemovedDigit >= 5;
    output = moonbitlang$core$builtin$$Add$add$2$(_tmp, _p ? $1L : $0L);
  } else {
    let roundUp = false;
    const vpDiv100 = moonbitlang$core$builtin$$Div$div$2$(vp, $100L);
    const vmDiv100 = moonbitlang$core$builtin$$Div$div$2$(vm, $100L);
    if (moonbitlang$core$builtin$$Compare$op_gt$26$(vpDiv100, vmDiv100)) {
      const vrDiv100 = moonbitlang$core$builtin$$Div$div$2$(vr, $100L);
      const vrMod100 = moonbitlang$core$uint64$$UInt64$to_int(vr) - (Math.imul(100, moonbitlang$core$uint64$$UInt64$to_int(vrDiv100)) | 0) | 0;
      roundUp = vrMod100 >= 50;
      vr = vrDiv100;
      vp = vpDiv100;
      vm = vmDiv100;
      removed = removed + 2 | 0;
    }
    while (true) {
      const vpDiv10 = moonbitlang$core$builtin$$Div$div$2$(vp, $10L);
      const vmDiv10 = moonbitlang$core$builtin$$Div$div$2$(vm, $10L);
      if (moonbitlang$core$builtin$$Compare$op_le$26$(vpDiv10, vmDiv10)) {
        break;
      }
      const vrDiv10 = moonbitlang$core$builtin$$Div$div$2$(vr, $10L);
      const vrMod10 = moonbitlang$core$uint64$$UInt64$to_int(vr) - (Math.imul(10, moonbitlang$core$uint64$$UInt64$to_int(vrDiv10)) | 0) | 0;
      roundUp = vrMod10 >= 5;
      vr = vrDiv10;
      vp = vpDiv10;
      vm = vmDiv10;
      removed = removed + 1 | 0;
      continue;
    }
    const _tmp = vr;
    const _p = moonbitlang$core$builtin$$Eq$equal$2$(vr, vm) || roundUp;
    output = moonbitlang$core$builtin$$Add$add$2$(_tmp, _p ? $1L : $0L);
  }
  const exp = e10 + removed | 0;
  return { mantissa: output, exponent: exp };
}
function moonbitlang$core$double$internal$ryu$$to_chars(v, sign) {
  const result = $makebytes(25, 0);
  let index = 0;
  if (sign) {
    const _tmp = index;
    $bound_check(result, _tmp);
    result[_tmp] = 45;
    index = index + 1 | 0;
  }
  let output = v.mantissa;
  const olength = moonbitlang$core$double$internal$ryu$$decimal_length17(output);
  let exp = (v.exponent + olength | 0) - 1 | 0;
  const scientificNotation = !(exp >= -6 && exp < 21);
  if (scientificNotation) {
    const _end41 = olength - 1 | 0;
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < _end41) {
        const c = moonbitlang$core$builtin$$Mod$mod$2$(output, $10L);
        output = moonbitlang$core$builtin$$Div$div$2$(output, $10L);
        const _tmp$2 = (index + olength | 0) - i | 0;
        $bound_check(result, _tmp$2);
        result[_tmp$2] = (48 + moonbitlang$core$uint64$$UInt64$to_int(c) | 0) & 255;
        _tmp = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const _tmp$2 = index;
    $bound_check(result, _tmp$2);
    result[_tmp$2] = (48 + (moonbitlang$core$uint64$$UInt64$to_int(output) % 10 | 0) | 0) & 255;
    if (olength > 1) {
      const _tmp$3 = index + 1 | 0;
      $bound_check(result, _tmp$3);
      result[_tmp$3] = 46;
    } else {
      index = index - 1 | 0;
    }
    index = index + (olength + 1 | 0) | 0;
    const _tmp$3 = index;
    $bound_check(result, _tmp$3);
    result[_tmp$3] = 101;
    index = index + 1 | 0;
    if (exp < 0) {
      const _tmp$4 = index;
      $bound_check(result, _tmp$4);
      result[_tmp$4] = 45;
      index = index + 1 | 0;
      exp = -exp | 0;
    } else {
      const _tmp$4 = index;
      $bound_check(result, _tmp$4);
      result[_tmp$4] = 43;
      index = index + 1 | 0;
    }
    if (exp >= 100) {
      const a = exp / 100 | 0;
      const b = (exp / 10 | 0) % 10 | 0;
      const c = exp % 10 | 0;
      const _tmp$4 = index;
      $bound_check(result, _tmp$4);
      result[_tmp$4] = (48 + a | 0) & 255;
      const _tmp$5 = index + 1 | 0;
      $bound_check(result, _tmp$5);
      result[_tmp$5] = (48 + b | 0) & 255;
      const _tmp$6 = index + 2 | 0;
      $bound_check(result, _tmp$6);
      result[_tmp$6] = (48 + c | 0) & 255;
      index = index + 3 | 0;
    } else {
      if (exp >= 10) {
        const a = exp / 10 | 0;
        const b = exp % 10 | 0;
        const _tmp$4 = index;
        $bound_check(result, _tmp$4);
        result[_tmp$4] = (48 + a | 0) & 255;
        const _tmp$5 = index + 1 | 0;
        $bound_check(result, _tmp$5);
        result[_tmp$5] = (48 + b | 0) & 255;
        index = index + 2 | 0;
      } else {
        const _tmp$4 = index;
        $bound_check(result, _tmp$4);
        result[_tmp$4] = (48 + exp | 0) & 255;
        index = index + 1 | 0;
      }
    }
    return moonbitlang$core$double$internal$ryu$$string_from_bytes(result, 0, index);
  } else {
    if (exp < 0) {
      const _tmp = index;
      $bound_check(result, _tmp);
      result[_tmp] = 48;
      index = index + 1 | 0;
      const _tmp$2 = index;
      $bound_check(result, _tmp$2);
      result[_tmp$2] = 46;
      index = index + 1 | 0;
      let _tmp$3 = -1;
      while (true) {
        const i = _tmp$3;
        if (i > exp) {
          const _tmp$4 = index;
          $bound_check(result, _tmp$4);
          result[_tmp$4] = 48;
          index = index + 1 | 0;
          _tmp$3 = i - 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const current = index;
      let _tmp$4 = 0;
      while (true) {
        const i = _tmp$4;
        if (i < olength) {
          const _tmp$5 = ((current + olength | 0) - i | 0) - 1 | 0;
          $bound_check(result, _tmp$5);
          result[_tmp$5] = (48 + moonbitlang$core$uint64$$UInt64$to_int(moonbitlang$core$builtin$$Mod$mod$2$(output, $10L)) | 0) & 255;
          output = moonbitlang$core$builtin$$Div$div$2$(output, $10L);
          index = index + 1 | 0;
          _tmp$4 = i + 1 | 0;
          continue;
        } else {
          break;
        }
      }
    } else {
      if ((exp + 1 | 0) >= olength) {
        let _tmp = 0;
        while (true) {
          const i = _tmp;
          if (i < olength) {
            const _tmp$2 = ((index + olength | 0) - i | 0) - 1 | 0;
            $bound_check(result, _tmp$2);
            result[_tmp$2] = (48 + moonbitlang$core$uint64$$UInt64$to_int(moonbitlang$core$builtin$$Mod$mod$2$(output, $10L)) | 0) & 255;
            output = moonbitlang$core$builtin$$Div$div$2$(output, $10L);
            _tmp = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        index = index + olength | 0;
        const _end64 = exp + 1 | 0;
        let _tmp$2 = olength;
        while (true) {
          const i = _tmp$2;
          if (i < _end64) {
            const _tmp$3 = index;
            $bound_check(result, _tmp$3);
            result[_tmp$3] = 48;
            index = index + 1 | 0;
            _tmp$2 = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
      } else {
        let current = index + 1 | 0;
        let _tmp = 0;
        while (true) {
          const i = _tmp;
          if (i < olength) {
            if (((olength - i | 0) - 1 | 0) === exp) {
              const _tmp$2 = ((current + olength | 0) - i | 0) - 1 | 0;
              $bound_check(result, _tmp$2);
              result[_tmp$2] = 46;
              current = current - 1 | 0;
            }
            const _tmp$2 = ((current + olength | 0) - i | 0) - 1 | 0;
            $bound_check(result, _tmp$2);
            result[_tmp$2] = (48 + moonbitlang$core$uint64$$UInt64$to_int(moonbitlang$core$builtin$$Mod$mod$2$(output, $10L)) | 0) & 255;
            output = moonbitlang$core$builtin$$Div$div$2$(output, $10L);
            _tmp = i + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        index = index + (olength + 1 | 0) | 0;
      }
    }
    return moonbitlang$core$double$internal$ryu$$string_from_bytes(result, 0, index);
  }
}
function moonbitlang$core$double$internal$ryu$$d2d_small_int(ieeeMantissa, ieeeExponent) {
  const m2 = moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, 52), ieeeMantissa);
  const e2 = (ieeeExponent - 1023 | 0) - 52 | 0;
  if (e2 > 0) {
    return undefined;
  }
  if (e2 < -52) {
    return undefined;
  }
  const mask = moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, -e2 | 0), $1L);
  const fraction = moonbitlang$core$builtin$$BitAnd$land$2$(m2, mask);
  if (moonbitlang$core$builtin$$op_notequal$2$(fraction, $0L)) {
    return undefined;
  }
  return { mantissa: moonbitlang$core$builtin$$Shr$shr$2$(m2, -e2 | 0), exponent: 0 };
}
function moonbitlang$core$double$internal$ryu$$ryu_to_string(val) {
  if (val === 0) {
    return "0";
  }
  const bits = moonbitlang$core$double$$Double$reinterpret_as_uint64(val);
  const ieeeSign = moonbitlang$core$builtin$$op_notequal$2$(moonbitlang$core$builtin$$BitAnd$land$2$(moonbitlang$core$builtin$$Shr$shr$2$(bits, 63), $1L), $0L);
  const ieeeMantissa = moonbitlang$core$builtin$$BitAnd$land$2$(bits, moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, 52), $1L));
  const ieeeExponent = moonbitlang$core$uint64$$UInt64$to_int(moonbitlang$core$builtin$$BitAnd$land$2$(moonbitlang$core$builtin$$Shr$shr$2$(bits, 52), moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, 11), $1L)));
  if (ieeeExponent === 2047 || ieeeExponent === 0 && moonbitlang$core$builtin$$Eq$equal$2$(ieeeMantissa, $0L)) {
    return moonbitlang$core$double$internal$ryu$$copy_special_str(ieeeSign, ieeeExponent !== 0, moonbitlang$core$builtin$$op_notequal$2$(ieeeMantissa, $0L));
  }
  let v = moonbitlang$core$double$internal$ryu$$ryu_to_string$46$record$47$979;
  const small = moonbitlang$core$double$internal$ryu$$d2d_small_int(ieeeMantissa, ieeeExponent);
  if (small === undefined) {
    v = moonbitlang$core$double$internal$ryu$$d2d(ieeeMantissa, ieeeExponent);
  } else {
    const _Some = small;
    const _f = _Some;
    let x = _f;
    while (true) {
      const q = moonbitlang$core$builtin$$Div$div$2$(x.mantissa, $10L);
      const r = moonbitlang$core$builtin$$Sub$sub$2$(x.mantissa, moonbitlang$core$builtin$$Mul$mul$2$($10L, q));
      if (moonbitlang$core$builtin$$op_notequal$2$(r, $0L)) {
        break;
      }
      x = { mantissa: q, exponent: x.exponent + 1 | 0 };
      continue;
    }
    v = x;
  }
  return moonbitlang$core$double$internal$ryu$$to_chars(v, ieeeSign);
}
function moonbitlang$core$double$$Double$to_string(self) {
  return moonbitlang$core$double$internal$ryu$$ryu_to_string(self);
}
function moonbitlang$core$strconv$$range_err$7$() {
  return new Result$Err$3$(new Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(moonbitlang$core$strconv$$range_err_str));
}
function moonbitlang$core$strconv$$syntax_err$38$() {
  return new Result$Err$4$(new Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(moonbitlang$core$strconv$$syntax_err_str));
}
function moonbitlang$core$strconv$$syntax_err$39$() {
  return new Result$Err$5$(new Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(moonbitlang$core$strconv$$syntax_err_str));
}
function moonbitlang$core$strconv$$syntax_err$6$() {
  return new Result$Err$6$(new Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(moonbitlang$core$strconv$$syntax_err_str));
}
function moonbitlang$core$strconv$$syntax_err$40$() {
  return new Result$Err$7$(new Error$moonbitlang$47$core$47$strconv$46$StrConvError$46$StrConvError(moonbitlang$core$strconv$$syntax_err_str));
}
function moonbitlang$core$strconv$$check_underscore(str) {
  let rest;
  if (moonbitlang$core$string$$String$char_length_ge$46$inner(str.str, 1, str.start, str.end)) {
    const _x = moonbitlang$core$string$$String$unsafe_char_at(str.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 0, str.start, str.end));
    switch (_x) {
      case 43: {
        const _tmp = str.str;
        const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 1, str.start, str.end);
        let _tmp$2;
        if (_bind === undefined) {
          _tmp$2 = str.end;
        } else {
          const _Some = _bind;
          _tmp$2 = _Some;
        }
        const _tmp$3 = _tmp$2;
        const _x$2 = { str: _tmp, start: _tmp$3, end: str.end };
        rest = _x$2;
        break;
      }
      case 45: {
        const _tmp$4 = str.str;
        const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 1, str.start, str.end);
        let _tmp$5;
        if (_bind$2 === undefined) {
          _tmp$5 = str.end;
        } else {
          const _Some = _bind$2;
          _tmp$5 = _Some;
        }
        const _tmp$6 = _tmp$5;
        const _x$3 = { str: _tmp$4, start: _tmp$6, end: str.end };
        rest = _x$3;
        break;
      }
      default: {
        rest = str;
      }
    }
  } else {
    rest = str;
  }
  let _bind;
  let rest$2;
  _L: {
    _L$2: {
      let rest$3;
      _L$3: {
        _L$4: {
          let rest$4;
          _L$5: {
            _L$6: {
              let rest$5;
              _L$7: {
                if (moonbitlang$core$string$$String$char_length_ge$46$inner(rest.str, 2, rest.start, rest.end)) {
                  const _x = moonbitlang$core$string$$String$unsafe_char_at(rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 0, rest.start, rest.end));
                  if (_x === 48) {
                    const _x$2 = moonbitlang$core$string$$String$unsafe_char_at(rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 1, rest.start, rest.end));
                    switch (_x$2) {
                      case 120: {
                        const _tmp = rest.str;
                        const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$2;
                        if (_bind$2 === undefined) {
                          _tmp$2 = rest.end;
                        } else {
                          const _Some = _bind$2;
                          _tmp$2 = _Some;
                        }
                        const _tmp$3 = _tmp$2;
                        const _x$3 = { str: _tmp, start: _tmp$3, end: rest.end };
                        rest$5 = _x$3;
                        break _L$7;
                      }
                      case 88: {
                        const _tmp$4 = rest.str;
                        const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$5;
                        if (_bind$3 === undefined) {
                          _tmp$5 = rest.end;
                        } else {
                          const _Some = _bind$3;
                          _tmp$5 = _Some;
                        }
                        const _tmp$6 = _tmp$5;
                        const _x$4 = { str: _tmp$4, start: _tmp$6, end: rest.end };
                        rest$5 = _x$4;
                        break _L$7;
                      }
                      case 111: {
                        const _tmp$7 = rest.str;
                        const _bind$4 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$8;
                        if (_bind$4 === undefined) {
                          _tmp$8 = rest.end;
                        } else {
                          const _Some = _bind$4;
                          _tmp$8 = _Some;
                        }
                        const _tmp$9 = _tmp$8;
                        const _x$5 = { str: _tmp$7, start: _tmp$9, end: rest.end };
                        rest$4 = _x$5;
                        break _L$6;
                      }
                      case 79: {
                        const _tmp$10 = rest.str;
                        const _bind$5 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$11;
                        if (_bind$5 === undefined) {
                          _tmp$11 = rest.end;
                        } else {
                          const _Some = _bind$5;
                          _tmp$11 = _Some;
                        }
                        const _tmp$12 = _tmp$11;
                        const _x$6 = { str: _tmp$10, start: _tmp$12, end: rest.end };
                        rest$4 = _x$6;
                        break _L$6;
                      }
                      case 98: {
                        const _tmp$13 = rest.str;
                        const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$14;
                        if (_bind$6 === undefined) {
                          _tmp$14 = rest.end;
                        } else {
                          const _Some = _bind$6;
                          _tmp$14 = _Some;
                        }
                        const _tmp$15 = _tmp$14;
                        const _x$7 = { str: _tmp$13, start: _tmp$15, end: rest.end };
                        rest$3 = _x$7;
                        break _L$4;
                      }
                      case 66: {
                        const _tmp$16 = rest.str;
                        const _bind$7 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 2, rest.start, rest.end);
                        let _tmp$17;
                        if (_bind$7 === undefined) {
                          _tmp$17 = rest.end;
                        } else {
                          const _Some = _bind$7;
                          _tmp$17 = _Some;
                        }
                        const _tmp$18 = _tmp$17;
                        const _x$8 = { str: _tmp$16, start: _tmp$18, end: rest.end };
                        rest$3 = _x$8;
                        break _L$4;
                      }
                      default: {
                        rest$2 = rest;
                        break _L$2;
                      }
                    }
                  } else {
                    rest$2 = rest;
                    break _L$2;
                  }
                } else {
                  rest$2 = rest;
                  break _L$2;
                }
              }
              _bind = { _0: rest$5, _1: true, _2: true };
              break _L$5;
            }
            _bind = { _0: rest$4, _1: true, _2: false };
          }
          break _L$3;
        }
        _bind = { _0: rest$3, _1: true, _2: false };
      }
      break _L;
    }
    _bind = { _0: rest$2, _1: false, _2: false };
  }
  const _rest = _bind._0;
  const _allow_underscore = _bind._1;
  const _hex = _bind._2;
  let _tmp = _rest;
  let _tmp$2 = _allow_underscore;
  let _tmp$3 = false;
  while (true) {
    const _param_0 = _tmp;
    const _param_1 = _tmp$2;
    const _param_2 = _tmp$3;
    let rest$3;
    let c;
    let follow_underscore;
    _L$2: {
      if (moonbitlang$core$string$$String$char_length_eq$46$inner(_param_0.str, 0, _param_0.start, _param_0.end)) {
        return true;
      } else {
        if (moonbitlang$core$string$$String$char_length_eq$46$inner(_param_0.str, 1, _param_0.start, _param_0.end)) {
          const _x = moonbitlang$core$string$$String$unsafe_char_at(_param_0.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_0.str, 0, _param_0.start, _param_0.end));
          if (_x === 95) {
            return false;
          } else {
            const _tmp$4 = _param_0.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_0.str, 1, _param_0.start, _param_0.end);
            let _tmp$5;
            if (_bind$2 === undefined) {
              _tmp$5 = _param_0.end;
            } else {
              const _Some = _bind$2;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$2 = { str: _tmp$4, start: _tmp$6, end: _param_0.end };
            rest$3 = _x$2;
            c = _x;
            follow_underscore = _param_2;
            break _L$2;
          }
        } else {
          const _x = moonbitlang$core$string$$String$unsafe_char_at(_param_0.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_0.str, 0, _param_0.start, _param_0.end));
          if (_x === 95) {
            if (_param_1 === false) {
              return false;
            } else {
              const _tmp$4 = _param_0.str;
              const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_0.str, 1, _param_0.start, _param_0.end);
              let _tmp$5;
              if (_bind$2 === undefined) {
                _tmp$5 = _param_0.end;
              } else {
                const _Some = _bind$2;
                _tmp$5 = _Some;
              }
              const _tmp$6 = _tmp$5;
              const _x$2 = { str: _tmp$4, start: _tmp$6, end: _param_0.end };
              _tmp = _x$2;
              _tmp$2 = false;
              _tmp$3 = true;
              continue;
            }
          } else {
            const _tmp$4 = _param_0.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_0.str, 1, _param_0.start, _param_0.end);
            let _tmp$5;
            if (_bind$2 === undefined) {
              _tmp$5 = _param_0.end;
            } else {
              const _Some = _bind$2;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$2 = { str: _tmp$4, start: _tmp$6, end: _param_0.end };
            rest$3 = _x$2;
            c = _x;
            follow_underscore = _param_2;
            break _L$2;
          }
        }
      }
    }
    if (c >= 48 && c <= 57 ? true : _hex && (c >= 97 && c <= 102 ? true : c >= 65 && c <= 70)) {
      _tmp = rest$3;
      _tmp$2 = true;
      _tmp$3 = false;
      continue;
    } else {
      if (follow_underscore) {
        return false;
      } else {
        _tmp = rest$3;
        _tmp$2 = false;
        _tmp$3 = false;
        continue;
      }
    }
  }
}
function moonbitlang$core$strconv$$Decimal$new_priv() {
  return { digits: $makebytes(800, 0), digits_num: 0, decimal_point: 0, negative: false, truncated: false };
}
function moonbitlang$core$strconv$$Decimal$trim(self) {
  while (true) {
    let _tmp;
    if (self.digits_num > 0) {
      const _tmp$2 = self.digits;
      const _tmp$3 = self.digits_num - 1 | 0;
      $bound_check(_tmp$2, _tmp$3);
      const _p = _tmp$2[_tmp$3];
      const _p$2 = 0;
      _tmp = _p === _p$2;
    } else {
      _tmp = false;
    }
    if (_tmp) {
      self.digits_num = self.digits_num - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (self.digits_num === 0) {
    self.decimal_point = 0;
    return;
  } else {
    return;
  }
}
function moonbitlang$core$strconv$$parse_decimal_from_view(str) {
  const d = moonbitlang$core$strconv$$Decimal$new_priv();
  let has_dp = false;
  let has_digits = false;
  let rest;
  _L: {
    _L$2: {
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(str.str, 1, str.start, str.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(str.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 0, str.start, str.end));
        switch (_x) {
          case 45: {
            const _tmp = str.str;
            const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 1, str.start, str.end);
            let _tmp$2;
            if (_bind === undefined) {
              _tmp$2 = str.end;
            } else {
              const _Some = _bind;
              _tmp$2 = _Some;
            }
            const _tmp$3 = _tmp$2;
            const _x$2 = { str: _tmp, start: _tmp$3, end: str.end };
            d.negative = true;
            rest = _x$2;
            break;
          }
          case 43: {
            const _tmp$4 = str.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(str.str, 1, str.start, str.end);
            let _tmp$5;
            if (_bind$2 === undefined) {
              _tmp$5 = str.end;
            } else {
              const _Some = _bind$2;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            rest = { str: _tmp$4, start: _tmp$6, end: str.end };
            break;
          }
          default: {
            break _L$2;
          }
        }
      } else {
        break _L$2;
      }
      break _L;
    }
    rest = str;
  }
  let rest$2;
  let _tmp = rest;
  while (true) {
    const _param = _tmp;
    if (moonbitlang$core$string$$String$char_length_ge$46$inner(_param.str, 1, _param.start, _param.end)) {
      const _x = moonbitlang$core$string$$String$unsafe_char_at(_param.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 0, _param.start, _param.end));
      if (_x === 95) {
        const _tmp$2 = _param.str;
        const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
        let _tmp$3;
        if (_bind === undefined) {
          _tmp$3 = _param.end;
        } else {
          const _Some = _bind;
          _tmp$3 = _Some;
        }
        const _tmp$4 = _tmp$3;
        const _x$2 = { str: _tmp$2, start: _tmp$4, end: _param.end };
        _tmp = _x$2;
        continue;
      } else {
        if (_x === 46) {
          const _tmp$2 = _param.str;
          const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
          let _tmp$3;
          if (_bind === undefined) {
            _tmp$3 = _param.end;
          } else {
            const _Some = _bind;
            _tmp$3 = _Some;
          }
          const _tmp$4 = _tmp$3;
          const _x$2 = { str: _tmp$2, start: _tmp$4, end: _param.end };
          if (!has_dp) {
            has_dp = true;
            d.decimal_point = d.digits_num;
            _tmp = _x$2;
            continue;
          } else {
            const _bind$2 = moonbitlang$core$strconv$$syntax_err$6$();
            if (_bind$2.$tag === 1) {
              const _ok = _bind$2;
              rest$2 = _ok._0;
              break;
            } else {
              return _bind$2;
            }
          }
        } else {
          if (_x >= 48 && _x <= 57) {
            const _tmp$2 = _param.str;
            const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = _param.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            const _tmp$4 = _tmp$3;
            const _x$2 = { str: _tmp$2, start: _tmp$4, end: _param.end };
            has_digits = true;
            if (_x === 48 && d.digits_num === 0) {
              d.decimal_point = d.decimal_point - 1 | 0;
              _tmp = _x$2;
              continue;
            }
            if (d.digits_num < d.digits.length) {
              const _tmp$5 = d.digits;
              const _tmp$6 = d.digits_num;
              $bound_check(_tmp$5, _tmp$6);
              _tmp$5[_tmp$6] = (_x - 48 | 0) & 255;
              d.digits_num = d.digits_num + 1 | 0;
            } else {
              if (_x !== 48) {
                d.truncated = true;
              }
            }
            _tmp = _x$2;
            continue;
          } else {
            rest$2 = _param;
            break;
          }
        }
      }
    } else {
      rest$2 = _param;
      break;
    }
  }
  if (has_digits) {
    if (!has_dp) {
      d.decimal_point = d.digits_num;
    }
    let rest$3;
    let rest$4;
    _L$2: {
      _L$3: {
        if (moonbitlang$core$string$$String$char_length_ge$46$inner(rest$2.str, 1, rest$2.start, rest$2.end)) {
          const _x = moonbitlang$core$string$$String$unsafe_char_at(rest$2.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$2.str, 0, rest$2.start, rest$2.end));
          switch (_x) {
            case 101: {
              const _tmp$2 = rest$2.str;
              const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$3;
              if (_bind === undefined) {
                _tmp$3 = rest$2.end;
              } else {
                const _Some = _bind;
                _tmp$3 = _Some;
              }
              const _tmp$4 = _tmp$3;
              const _x$2 = { str: _tmp$2, start: _tmp$4, end: rest$2.end };
              rest$4 = _x$2;
              break _L$3;
            }
            case 69: {
              const _tmp$5 = rest$2.str;
              const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$2.str, 1, rest$2.start, rest$2.end);
              let _tmp$6;
              if (_bind$2 === undefined) {
                _tmp$6 = rest$2.end;
              } else {
                const _Some = _bind$2;
                _tmp$6 = _Some;
              }
              const _tmp$7 = _tmp$6;
              const _x$3 = { str: _tmp$5, start: _tmp$7, end: rest$2.end };
              rest$4 = _x$3;
              break _L$3;
            }
            default: {
              rest$3 = rest$2;
            }
          }
        } else {
          rest$3 = rest$2;
        }
        break _L$2;
      }
      let exp_sign = 1;
      let rest$5;
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(rest$4.str, 1, rest$4.start, rest$4.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(rest$4.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$4.str, 0, rest$4.start, rest$4.end));
        switch (_x) {
          case 43: {
            const _tmp$2 = rest$4.str;
            const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = rest$4.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            const _tmp$4 = _tmp$3;
            rest$5 = { str: _tmp$2, start: _tmp$4, end: rest$4.end };
            break;
          }
          case 45: {
            const _tmp$5 = rest$4.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$4.str, 1, rest$4.start, rest$4.end);
            let _tmp$6;
            if (_bind$2 === undefined) {
              _tmp$6 = rest$4.end;
            } else {
              const _Some = _bind$2;
              _tmp$6 = _Some;
            }
            const _tmp$7 = _tmp$6;
            const _x$2 = { str: _tmp$5, start: _tmp$7, end: rest$4.end };
            exp_sign = -1;
            rest$5 = _x$2;
            break;
          }
          default: {
            rest$5 = rest$4;
          }
        }
      } else {
        rest$5 = rest$4;
      }
      _L$4: {
        _L$5: {
          if (moonbitlang$core$string$$String$char_length_ge$46$inner(rest$5.str, 1, rest$5.start, rest$5.end)) {
            const _x = moonbitlang$core$string$$String$unsafe_char_at(rest$5.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$5.str, 0, rest$5.start, rest$5.end));
            if (_x >= 48 && _x <= 57) {
              let exp = 0;
              let rest$6;
              let _tmp$2 = rest$5;
              while (true) {
                const _param = _tmp$2;
                if (moonbitlang$core$string$$String$char_length_ge$46$inner(_param.str, 1, _param.start, _param.end)) {
                  const _x$2 = moonbitlang$core$string$$String$unsafe_char_at(_param.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 0, _param.start, _param.end));
                  if (_x$2 === 95) {
                    const _tmp$3 = _param.str;
                    const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
                    let _tmp$4;
                    if (_bind === undefined) {
                      _tmp$4 = _param.end;
                    } else {
                      const _Some = _bind;
                      _tmp$4 = _Some;
                    }
                    const _tmp$5 = _tmp$4;
                    const _x$3 = { str: _tmp$3, start: _tmp$5, end: _param.end };
                    _tmp$2 = _x$3;
                    continue;
                  } else {
                    if (_x$2 >= 48 && _x$2 <= 57) {
                      const _tmp$3 = _param.str;
                      const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
                      let _tmp$4;
                      if (_bind === undefined) {
                        _tmp$4 = _param.end;
                      } else {
                        const _Some = _bind;
                        _tmp$4 = _Some;
                      }
                      const _tmp$5 = _tmp$4;
                      const _x$3 = { str: _tmp$3, start: _tmp$5, end: _param.end };
                      exp = (Math.imul(exp, 10) | 0) + (_x$2 - 48 | 0) | 0;
                      _tmp$2 = _x$3;
                      continue;
                    } else {
                      rest$6 = _param;
                      break;
                    }
                  }
                } else {
                  rest$6 = _param;
                  break;
                }
              }
              d.decimal_point = d.decimal_point + (Math.imul(exp_sign, exp) | 0) | 0;
              rest$3 = rest$6;
            } else {
              break _L$5;
            }
          } else {
            break _L$5;
          }
          break _L$4;
        }
        const _bind = moonbitlang$core$strconv$$syntax_err$6$();
        if (_bind.$tag === 1) {
          const _ok = _bind;
          rest$3 = _ok._0;
        } else {
          return _bind;
        }
      }
    }
    if (moonbitlang$core$string$$String$char_length_eq$46$inner(rest$3.str, 0, rest$3.start, rest$3.end)) {
      moonbitlang$core$strconv$$Decimal$trim(d);
      return new Result$Ok$7$(d);
    } else {
      return moonbitlang$core$strconv$$syntax_err$40$();
    }
  } else {
    return moonbitlang$core$strconv$$syntax_err$40$();
  }
}
function moonbitlang$core$strconv$$parse_decimal_priv(str) {
  return moonbitlang$core$strconv$$parse_decimal_from_view(str);
}
function moonbitlang$core$strconv$$parse_inf_nan(rest) {
  let _bind;
  let rest$2;
  _L: {
    _L$2: {
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(rest.str, 1, rest.start, rest.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 0, rest.start, rest.end));
        switch (_x) {
          case 45: {
            const _tmp = rest.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 1, rest.start, rest.end);
            let _tmp$2;
            if (_bind$2 === undefined) {
              _tmp$2 = rest.end;
            } else {
              const _Some = _bind$2;
              _tmp$2 = _Some;
            }
            const _tmp$3 = _tmp$2;
            const _x$2 = { str: _tmp, start: _tmp$3, end: rest.end };
            _bind = { _0: false, _1: _x$2 };
            break;
          }
          case 43: {
            const _tmp$4 = rest.str;
            const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest.str, 1, rest.start, rest.end);
            let _tmp$5;
            if (_bind$3 === undefined) {
              _tmp$5 = rest.end;
            } else {
              const _Some = _bind$3;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$3 = { str: _tmp$4, start: _tmp$6, end: rest.end };
            rest$2 = _x$3;
            break _L$2;
          }
          default: {
            rest$2 = rest;
            break _L$2;
          }
        }
      } else {
        rest$2 = rest;
        break _L$2;
      }
      break _L;
    }
    _bind = { _0: true, _1: rest$2 };
  }
  const _pos = _bind._0;
  const _rest = _bind._1;
  _L$2: {
    let rest$3;
    _L$3: {
      _L$4: {
        if (moonbitlang$core$string$$String$char_length_eq$46$inner(_rest.str, 3, _rest.start, _rest.end)) {
          const _x = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 0, _rest.start, _rest.end));
          switch (_x) {
            case 110: {
              const _x$2 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
              switch (_x$2) {
                case 97: {
                  const _x$3 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$3) {
                    case 110: {
                      break _L$4;
                    }
                    case 78: {
                      break _L$4;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                case 65: {
                  const _x$4 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$4) {
                    case 110: {
                      break _L$4;
                    }
                    case 78: {
                      break _L$4;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                default: {
                  break _L$2;
                }
              }
            }
            case 78: {
              const _x$5 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
              switch (_x$5) {
                case 97: {
                  const _x$6 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$6) {
                    case 110: {
                      break _L$4;
                    }
                    case 78: {
                      break _L$4;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                case 65: {
                  const _x$7 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$7) {
                    case 110: {
                      break _L$4;
                    }
                    case 78: {
                      break _L$4;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                default: {
                  break _L$2;
                }
              }
            }
            case 105: {
              const _x$8 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
              switch (_x$8) {
                case 110: {
                  const _x$9 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$9) {
                    case 102: {
                      const _tmp = _rest.str;
                      const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$2;
                      if (_bind$2 === undefined) {
                        _tmp$2 = _rest.end;
                      } else {
                        const _Some = _bind$2;
                        _tmp$2 = _Some;
                      }
                      const _tmp$3 = _tmp$2;
                      const _x$10 = { str: _tmp, start: _tmp$3, end: _rest.end };
                      rest$3 = _x$10;
                      break _L$3;
                    }
                    case 70: {
                      const _tmp$4 = _rest.str;
                      const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$5;
                      if (_bind$3 === undefined) {
                        _tmp$5 = _rest.end;
                      } else {
                        const _Some = _bind$3;
                        _tmp$5 = _Some;
                      }
                      const _tmp$6 = _tmp$5;
                      const _x$11 = { str: _tmp$4, start: _tmp$6, end: _rest.end };
                      rest$3 = _x$11;
                      break _L$3;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                case 78: {
                  const _x$12 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$12) {
                    case 102: {
                      const _tmp$7 = _rest.str;
                      const _bind$4 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$8;
                      if (_bind$4 === undefined) {
                        _tmp$8 = _rest.end;
                      } else {
                        const _Some = _bind$4;
                        _tmp$8 = _Some;
                      }
                      const _tmp$9 = _tmp$8;
                      const _x$13 = { str: _tmp$7, start: _tmp$9, end: _rest.end };
                      rest$3 = _x$13;
                      break _L$3;
                    }
                    case 70: {
                      const _tmp$10 = _rest.str;
                      const _bind$5 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$11;
                      if (_bind$5 === undefined) {
                        _tmp$11 = _rest.end;
                      } else {
                        const _Some = _bind$5;
                        _tmp$11 = _Some;
                      }
                      const _tmp$12 = _tmp$11;
                      const _x$14 = { str: _tmp$10, start: _tmp$12, end: _rest.end };
                      rest$3 = _x$14;
                      break _L$3;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                default: {
                  break _L$2;
                }
              }
            }
            case 73: {
              const _x$15 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
              switch (_x$15) {
                case 110: {
                  const _x$16 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$16) {
                    case 102: {
                      const _tmp$13 = _rest.str;
                      const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$14;
                      if (_bind$6 === undefined) {
                        _tmp$14 = _rest.end;
                      } else {
                        const _Some = _bind$6;
                        _tmp$14 = _Some;
                      }
                      const _tmp$15 = _tmp$14;
                      const _x$17 = { str: _tmp$13, start: _tmp$15, end: _rest.end };
                      rest$3 = _x$17;
                      break _L$3;
                    }
                    case 70: {
                      const _tmp$16 = _rest.str;
                      const _bind$7 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$17;
                      if (_bind$7 === undefined) {
                        _tmp$17 = _rest.end;
                      } else {
                        const _Some = _bind$7;
                        _tmp$17 = _Some;
                      }
                      const _tmp$18 = _tmp$17;
                      const _x$18 = { str: _tmp$16, start: _tmp$18, end: _rest.end };
                      rest$3 = _x$18;
                      break _L$3;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                case 78: {
                  const _x$19 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                  switch (_x$19) {
                    case 102: {
                      const _tmp$19 = _rest.str;
                      const _bind$8 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$20;
                      if (_bind$8 === undefined) {
                        _tmp$20 = _rest.end;
                      } else {
                        const _Some = _bind$8;
                        _tmp$20 = _Some;
                      }
                      const _tmp$21 = _tmp$20;
                      const _x$20 = { str: _tmp$19, start: _tmp$21, end: _rest.end };
                      rest$3 = _x$20;
                      break _L$3;
                    }
                    case 70: {
                      const _tmp$22 = _rest.str;
                      const _bind$9 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                      let _tmp$23;
                      if (_bind$9 === undefined) {
                        _tmp$23 = _rest.end;
                      } else {
                        const _Some = _bind$9;
                        _tmp$23 = _Some;
                      }
                      const _tmp$24 = _tmp$23;
                      const _x$21 = { str: _tmp$22, start: _tmp$24, end: _rest.end };
                      rest$3 = _x$21;
                      break _L$3;
                    }
                    default: {
                      break _L$2;
                    }
                  }
                }
                default: {
                  break _L$2;
                }
              }
            }
            default: {
              break _L$2;
            }
          }
        } else {
          if (moonbitlang$core$string$$String$char_length_ge$46$inner(_rest.str, 3, _rest.start, _rest.end)) {
            const _x = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 0, _rest.start, _rest.end));
            switch (_x) {
              case 105: {
                const _x$2 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
                switch (_x$2) {
                  case 110: {
                    const _x$3 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                    switch (_x$3) {
                      case 102: {
                        const _tmp = _rest.str;
                        const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$2;
                        if (_bind$2 === undefined) {
                          _tmp$2 = _rest.end;
                        } else {
                          const _Some = _bind$2;
                          _tmp$2 = _Some;
                        }
                        const _tmp$3 = _tmp$2;
                        const _x$4 = { str: _tmp, start: _tmp$3, end: _rest.end };
                        rest$3 = _x$4;
                        break _L$3;
                      }
                      case 70: {
                        const _tmp$4 = _rest.str;
                        const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$5;
                        if (_bind$3 === undefined) {
                          _tmp$5 = _rest.end;
                        } else {
                          const _Some = _bind$3;
                          _tmp$5 = _Some;
                        }
                        const _tmp$6 = _tmp$5;
                        const _x$5 = { str: _tmp$4, start: _tmp$6, end: _rest.end };
                        rest$3 = _x$5;
                        break _L$3;
                      }
                      default: {
                        break _L$2;
                      }
                    }
                  }
                  case 78: {
                    const _x$6 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                    switch (_x$6) {
                      case 102: {
                        const _tmp$7 = _rest.str;
                        const _bind$4 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$8;
                        if (_bind$4 === undefined) {
                          _tmp$8 = _rest.end;
                        } else {
                          const _Some = _bind$4;
                          _tmp$8 = _Some;
                        }
                        const _tmp$9 = _tmp$8;
                        const _x$7 = { str: _tmp$7, start: _tmp$9, end: _rest.end };
                        rest$3 = _x$7;
                        break _L$3;
                      }
                      case 70: {
                        const _tmp$10 = _rest.str;
                        const _bind$5 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$11;
                        if (_bind$5 === undefined) {
                          _tmp$11 = _rest.end;
                        } else {
                          const _Some = _bind$5;
                          _tmp$11 = _Some;
                        }
                        const _tmp$12 = _tmp$11;
                        const _x$8 = { str: _tmp$10, start: _tmp$12, end: _rest.end };
                        rest$3 = _x$8;
                        break _L$3;
                      }
                      default: {
                        break _L$2;
                      }
                    }
                  }
                  default: {
                    break _L$2;
                  }
                }
              }
              case 73: {
                const _x$9 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 1, _rest.start, _rest.end));
                switch (_x$9) {
                  case 110: {
                    const _x$10 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                    switch (_x$10) {
                      case 102: {
                        const _tmp$13 = _rest.str;
                        const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$14;
                        if (_bind$6 === undefined) {
                          _tmp$14 = _rest.end;
                        } else {
                          const _Some = _bind$6;
                          _tmp$14 = _Some;
                        }
                        const _tmp$15 = _tmp$14;
                        const _x$11 = { str: _tmp$13, start: _tmp$15, end: _rest.end };
                        rest$3 = _x$11;
                        break _L$3;
                      }
                      case 70: {
                        const _tmp$16 = _rest.str;
                        const _bind$7 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$17;
                        if (_bind$7 === undefined) {
                          _tmp$17 = _rest.end;
                        } else {
                          const _Some = _bind$7;
                          _tmp$17 = _Some;
                        }
                        const _tmp$18 = _tmp$17;
                        const _x$12 = { str: _tmp$16, start: _tmp$18, end: _rest.end };
                        rest$3 = _x$12;
                        break _L$3;
                      }
                      default: {
                        break _L$2;
                      }
                    }
                  }
                  case 78: {
                    const _x$13 = moonbitlang$core$string$$String$unsafe_char_at(_rest.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 2, _rest.start, _rest.end));
                    switch (_x$13) {
                      case 102: {
                        const _tmp$19 = _rest.str;
                        const _bind$8 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$20;
                        if (_bind$8 === undefined) {
                          _tmp$20 = _rest.end;
                        } else {
                          const _Some = _bind$8;
                          _tmp$20 = _Some;
                        }
                        const _tmp$21 = _tmp$20;
                        const _x$14 = { str: _tmp$19, start: _tmp$21, end: _rest.end };
                        rest$3 = _x$14;
                        break _L$3;
                      }
                      case 70: {
                        const _tmp$22 = _rest.str;
                        const _bind$9 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_rest.str, 3, _rest.start, _rest.end);
                        let _tmp$23;
                        if (_bind$9 === undefined) {
                          _tmp$23 = _rest.end;
                        } else {
                          const _Some = _bind$9;
                          _tmp$23 = _Some;
                        }
                        const _tmp$24 = _tmp$23;
                        const _x$15 = { str: _tmp$22, start: _tmp$24, end: _rest.end };
                        rest$3 = _x$15;
                        break _L$3;
                      }
                      default: {
                        break _L$2;
                      }
                    }
                  }
                  default: {
                    break _L$2;
                  }
                }
              }
              default: {
                break _L$2;
              }
            }
          } else {
            break _L$2;
          }
        }
      }
      return new Result$Ok$4$(moonbitlang$core$double$$not_a_number);
    }
    _L$4: {
      _L$5: {
        if (moonbitlang$core$string$$String$char_length_eq$46$inner(rest$3.str, 0, rest$3.start, rest$3.end)) {
          break _L$5;
        } else {
          if (moonbitlang$core$string$$String$char_length_eq$46$inner(rest$3.str, 5, rest$3.start, rest$3.end)) {
            const _x = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 0, rest$3.start, rest$3.end));
            switch (_x) {
              case 105: {
                const _x$2 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 1, rest$3.start, rest$3.end));
                switch (_x$2) {
                  case 110: {
                    const _x$3 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 2, rest$3.start, rest$3.end));
                    switch (_x$3) {
                      case 105: {
                        const _x$4 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$4) {
                          case 116: {
                            const _x$5 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$5) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$6 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$6) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      case 73: {
                        const _x$7 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$7) {
                          case 116: {
                            const _x$8 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$8) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$9 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$9) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      default: {
                        break _L$4;
                      }
                    }
                  }
                  case 78: {
                    const _x$10 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 2, rest$3.start, rest$3.end));
                    switch (_x$10) {
                      case 105: {
                        const _x$11 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$11) {
                          case 116: {
                            const _x$12 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$12) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$13 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$13) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      case 73: {
                        const _x$14 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$14) {
                          case 116: {
                            const _x$15 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$15) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$16 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$16) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      default: {
                        break _L$4;
                      }
                    }
                  }
                  default: {
                    break _L$4;
                  }
                }
              }
              case 73: {
                const _x$17 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 1, rest$3.start, rest$3.end));
                switch (_x$17) {
                  case 110: {
                    const _x$18 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 2, rest$3.start, rest$3.end));
                    switch (_x$18) {
                      case 105: {
                        const _x$19 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$19) {
                          case 116: {
                            const _x$20 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$20) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$21 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$21) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      case 73: {
                        const _x$22 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$22) {
                          case 116: {
                            const _x$23 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$23) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$24 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$24) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      default: {
                        break _L$4;
                      }
                    }
                  }
                  case 78: {
                    const _x$25 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 2, rest$3.start, rest$3.end));
                    switch (_x$25) {
                      case 105: {
                        const _x$26 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$26) {
                          case 116: {
                            const _x$27 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$27) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$28 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$28) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      case 73: {
                        const _x$29 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 3, rest$3.start, rest$3.end));
                        switch (_x$29) {
                          case 116: {
                            const _x$30 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$30) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          case 84: {
                            const _x$31 = moonbitlang$core$string$$String$unsafe_char_at(rest$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(rest$3.str, 4, rest$3.start, rest$3.end));
                            switch (_x$31) {
                              case 121: {
                                break _L$5;
                              }
                              case 89: {
                                break _L$5;
                              }
                              default: {
                                break _L$4;
                              }
                            }
                          }
                          default: {
                            break _L$4;
                          }
                        }
                      }
                      default: {
                        break _L$4;
                      }
                    }
                  }
                  default: {
                    break _L$4;
                  }
                }
              }
              default: {
                break _L$4;
              }
            }
          } else {
            break _L$4;
          }
        }
      }
      return _pos ? new Result$Ok$4$(moonbitlang$core$double$$infinity) : new Result$Ok$4$(moonbitlang$core$double$$neg_infinity);
    }
    return moonbitlang$core$strconv$$syntax_err$38$();
  }
  return moonbitlang$core$strconv$$syntax_err$38$();
}
function $moonbitlang$core$strconv$$moonbitlang$core$string$$StringView$fold_digits$2$(self, init, f) {
  let ret = init;
  let len = 0;
  let str = self;
  while (true) {
    const _bind = str;
    if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind.str, 1, _bind.start, _bind.end)) {
      const _ch = moonbitlang$core$string$$String$unsafe_char_at(_bind.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 0, _bind.start, _bind.end));
      const _tmp = _bind.str;
      const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 1, _bind.start, _bind.end);
      let _tmp$2;
      if (_bind$2 === undefined) {
        _tmp$2 = _bind.end;
      } else {
        const _Some = _bind$2;
        _tmp$2 = _Some;
      }
      const _tmp$3 = _tmp$2;
      const _x = { str: _tmp, start: _tmp$3, end: _bind.end };
      if (_ch >= 48 && _ch <= 57) {
        len = len + 1 | 0;
        ret = f(_ch - 48 | 0, ret);
      } else {
        if (_ch !== 95) {
          break;
        }
      }
      str = _x;
      continue;
    } else {
      break;
    }
  }
  return { _0: str, _1: ret, _2: len };
}
function $moonbitlang$core$strconv$$moonbitlang$core$string$$StringView$fold_digits$25$(self, init, f) {
  let ret = init;
  let len = 0;
  let str = self;
  while (true) {
    const _bind = str;
    if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind.str, 1, _bind.start, _bind.end)) {
      const _ch = moonbitlang$core$string$$String$unsafe_char_at(_bind.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 0, _bind.start, _bind.end));
      const _tmp = _bind.str;
      const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 1, _bind.start, _bind.end);
      let _tmp$2;
      if (_bind$2 === undefined) {
        _tmp$2 = _bind.end;
      } else {
        const _Some = _bind$2;
        _tmp$2 = _Some;
      }
      const _tmp$3 = _tmp$2;
      const _x = { str: _tmp, start: _tmp$3, end: _bind.end };
      if (_ch >= 48 && _ch <= 57) {
        len = len + 1 | 0;
        ret = f(_ch - 48 | 0, ret);
      } else {
        if (_ch !== 95) {
          break;
        }
      }
      str = _x;
      continue;
    } else {
      break;
    }
  }
  return { _0: str, _1: ret, _2: len };
}
function moonbitlang$core$strconv$$parse_digits(s, x) {
  return $moonbitlang$core$strconv$$moonbitlang$core$string$$StringView$fold_digits$2$(s, x, (digit, acc) => moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(acc, $10L), moonbitlang$core$uint64$$UInt64$extend_uint(digit)));
}
function moonbitlang$core$strconv$$parse_scientific(s) {
  let s$2 = s;
  let neg_exp = false;
  let rest;
  let ch;
  _L: {
    _L$2: {
      const _bind = s$2;
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind.str, 1, _bind.start, _bind.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(_bind.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 0, _bind.start, _bind.end));
        switch (_x) {
          case 43: {
            const _tmp = _bind.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 1, _bind.start, _bind.end);
            let _tmp$2;
            if (_bind$2 === undefined) {
              _tmp$2 = _bind.end;
            } else {
              const _Some = _bind$2;
              _tmp$2 = _Some;
            }
            const _tmp$3 = _tmp$2;
            const _x$2 = { str: _tmp, start: _tmp$3, end: _bind.end };
            rest = _x$2;
            ch = _x;
            break _L$2;
          }
          case 45: {
            const _tmp$4 = _bind.str;
            const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 1, _bind.start, _bind.end);
            let _tmp$5;
            if (_bind$3 === undefined) {
              _tmp$5 = _bind.end;
            } else {
              const _Some = _bind$3;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$3 = { str: _tmp$4, start: _tmp$6, end: _bind.end };
            rest = _x$3;
            ch = _x;
            break _L$2;
          }
        }
      }
      break _L;
    }
    neg_exp = ch === 45;
    s$2 = rest;
  }
  _L$2: {
    const _bind = s$2;
    if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind.str, 1, _bind.start, _bind.end)) {
      const _x = moonbitlang$core$string$$String$unsafe_char_at(_bind.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind.str, 0, _bind.start, _bind.end));
      if (_x >= 48 && _x <= 57) {
        const _bind$2 = $moonbitlang$core$strconv$$moonbitlang$core$string$$StringView$fold_digits$25$(s$2, moonbitlang$core$strconv$$parse_scientific$46$exp_num$124$306, (digit, exp_num) => moonbitlang$core$builtin$$Compare$op_lt$24$(exp_num, $65536L) ? moonbitlang$core$builtin$$Add$add$25$(moonbitlang$core$builtin$$Mul$mul$25$($10L, exp_num), moonbitlang$core$int$$Int$to_int64(digit)) : exp_num);
        const _s = _bind$2._0;
        const _exp_num = _bind$2._1;
        return neg_exp ? { _0: _s, _1: moonbitlang$core$builtin$$Neg$neg$25$(_exp_num) } : { _0: _s, _1: _exp_num };
      } else {
        break _L$2;
      }
    } else {
      break _L$2;
    }
  }
  return undefined;
}
function moonbitlang$core$strconv$$try_parse_19digits(s, x) {
  let x$2 = x;
  let len = 0;
  let _tmp = s;
  while (true) {
    const _param = _tmp;
    let s$2;
    _L: {
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(_param.str, 1, _param.start, _param.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(_param.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 0, _param.start, _param.end));
        if (_x >= 48 && _x <= 57) {
          const _tmp$2 = _param.str;
          const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
          let _tmp$3;
          if (_bind === undefined) {
            _tmp$3 = _param.end;
          } else {
            const _Some = _bind;
            _tmp$3 = _Some;
          }
          const _tmp$4 = _tmp$3;
          const _x$2 = { str: _tmp$2, start: _tmp$4, end: _param.end };
          if (moonbitlang$core$builtin$$Compare$op_lt$26$(x$2, moonbitlang$core$strconv$$min_19digit_int)) {
            len = len + 1 | 0;
            x$2 = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(x$2, $10L), moonbitlang$core$uint64$$UInt64$extend_uint(_x - 48 | 0));
            _tmp = _x$2;
            continue;
          } else {
            s$2 = _param;
            break _L;
          }
        } else {
          if (_x === 95) {
            const _tmp$2 = _param.str;
            const _bind = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param.str, 1, _param.start, _param.end);
            let _tmp$3;
            if (_bind === undefined) {
              _tmp$3 = _param.end;
            } else {
              const _Some = _bind;
              _tmp$3 = _Some;
            }
            const _tmp$4 = _tmp$3;
            const _x$2 = { str: _tmp$2, start: _tmp$4, end: _param.end };
            _tmp = _x$2;
            continue;
          } else {
            s$2 = _param;
            break _L;
          }
        }
      } else {
        s$2 = _param;
        break _L;
      }
    }
    return { _0: s$2, _1: x$2, _2: len };
  }
}
function moonbitlang$core$strconv$$parse_number(s) {
  let _bind;
  let rest;
  _L: {
    _L$2: {
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(s.str, 1, s.start, s.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(s.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(s.str, 0, s.start, s.end));
        switch (_x) {
          case 45: {
            const _tmp = s.str;
            const _bind$2 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(s.str, 1, s.start, s.end);
            let _tmp$2;
            if (_bind$2 === undefined) {
              _tmp$2 = s.end;
            } else {
              const _Some = _bind$2;
              _tmp$2 = _Some;
            }
            const _tmp$3 = _tmp$2;
            const _x$2 = { str: _tmp, start: _tmp$3, end: s.end };
            _bind = { _0: _x$2, _1: true };
            break;
          }
          case 43: {
            const _tmp$4 = s.str;
            const _bind$3 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(s.str, 1, s.start, s.end);
            let _tmp$5;
            if (_bind$3 === undefined) {
              _tmp$5 = s.end;
            } else {
              const _Some = _bind$3;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$3 = { str: _tmp$4, start: _tmp$6, end: s.end };
            rest = _x$3;
            break _L$2;
          }
          default: {
            rest = s;
            break _L$2;
          }
        }
      } else {
        rest = s;
        break _L$2;
      }
      break _L;
    }
    _bind = { _0: rest, _1: false };
  }
  const _s = _bind._0;
  const _negative = _bind._1;
  if (moonbitlang$core$string$$StringView$is_empty(_s)) {
    return new Result$Ok$5$(undefined);
  }
  const _bind$2 = moonbitlang$core$strconv$$parse_digits(_s, $0L);
  const _s$2 = _bind$2._0;
  const _mantissa = _bind$2._1;
  const _consumed = _bind$2._2;
  let mantissa = _mantissa;
  let s$2 = _s$2;
  let n_digits = _consumed;
  let n_after_dot = 0;
  let exponent = $0L;
  const _bind$3 = s$2;
  if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind$3.str, 1, _bind$3.start, _bind$3.end)) {
    const _x = moonbitlang$core$string$$String$unsafe_char_at(_bind$3.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind$3.str, 0, _bind$3.start, _bind$3.end));
    if (_x === 46) {
      const _tmp = _bind$3.str;
      const _bind$4 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind$3.str, 1, _bind$3.start, _bind$3.end);
      let _tmp$2;
      if (_bind$4 === undefined) {
        _tmp$2 = _bind$3.end;
      } else {
        const _Some = _bind$4;
        _tmp$2 = _Some;
      }
      const _tmp$3 = _tmp$2;
      const _x$2 = { str: _tmp, start: _tmp$3, end: _bind$3.end };
      s$2 = _x$2;
      const _bind$5 = moonbitlang$core$strconv$$parse_digits(s$2, mantissa);
      const _new_s = _bind$5._0;
      const _new_mantissa = _bind$5._1;
      const _consumed_digit = _bind$5._2;
      s$2 = _new_s;
      mantissa = _new_mantissa;
      n_after_dot = _consumed_digit;
      exponent = moonbitlang$core$builtin$$Neg$neg$25$(moonbitlang$core$int$$Int$to_int64(n_after_dot));
    }
  }
  n_digits = n_digits + n_after_dot | 0;
  if (n_digits === 0) {
    return new Result$Ok$5$(undefined);
  }
  let rest$2;
  _L$2: {
    _L$3: {
      const _bind$4 = s$2;
      if (moonbitlang$core$string$$String$char_length_ge$46$inner(_bind$4.str, 1, _bind$4.start, _bind$4.end)) {
        const _x = moonbitlang$core$string$$String$unsafe_char_at(_bind$4.str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind$4.str, 0, _bind$4.start, _bind$4.end));
        switch (_x) {
          case 101: {
            const _tmp = _bind$4.str;
            const _bind$5 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$2;
            if (_bind$5 === undefined) {
              _tmp$2 = _bind$4.end;
            } else {
              const _Some = _bind$5;
              _tmp$2 = _Some;
            }
            const _tmp$3 = _tmp$2;
            const _x$2 = { str: _tmp, start: _tmp$3, end: _bind$4.end };
            rest$2 = _x$2;
            break _L$3;
          }
          case 69: {
            const _tmp$4 = _bind$4.str;
            const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_bind$4.str, 1, _bind$4.start, _bind$4.end);
            let _tmp$5;
            if (_bind$6 === undefined) {
              _tmp$5 = _bind$4.end;
            } else {
              const _Some = _bind$6;
              _tmp$5 = _Some;
            }
            const _tmp$6 = _tmp$5;
            const _x$3 = { str: _tmp$4, start: _tmp$6, end: _bind$4.end };
            rest$2 = _x$3;
            break _L$3;
          }
        }
      }
      break _L$2;
    }
    const _bind$4 = moonbitlang$core$strconv$$parse_scientific(rest$2);
    let _bind$5;
    if (_bind$4 === undefined) {
      return new Result$Ok$5$(undefined);
    } else {
      const _Some = _bind$4;
      _bind$5 = _Some;
    }
    const _new_s = _bind$5._0;
    const _exp_number = _bind$5._1;
    s$2 = _new_s;
    exponent = moonbitlang$core$builtin$$Add$add$25$(exponent, _exp_number);
  }
  const _bind$4 = s$2;
  if (moonbitlang$core$string$$String$char_length_eq$46$inner(_bind$4.str, 0, _bind$4.start, _bind$4.end)) {
    if (n_digits <= 19) {
      return new Result$Ok$5$({ exponent: exponent, mantissa: mantissa, negative: _negative, many_digits: false });
    }
    n_digits = n_digits - 19 | 0;
    let many_digits = false;
    let _tmp = s.str;
    let _tmp$2 = s.start;
    let _tmp$3 = s.end;
    _L$3: while (true) {
      const _param_str = _tmp;
      const _param_start = _tmp$2;
      const _param_end = _tmp$3;
      let rest$3;
      let ch;
      _L$4: {
        if (moonbitlang$core$string$$String$char_length_ge$46$inner(_param_str, 1, _param_start, _param_end)) {
          const _x = moonbitlang$core$string$$String$unsafe_char_at(_param_str, moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_str, 0, _param_start, _param_end));
          switch (_x) {
            case 48: {
              const _bind$5 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_str, 1, _param_start, _param_end);
              let _tmp$4;
              if (_bind$5 === undefined) {
                _tmp$4 = _param_end;
              } else {
                const _Some = _bind$5;
                _tmp$4 = _Some;
              }
              const _x$2 = { str: _param_str, start: _tmp$4, end: _param_end };
              rest$3 = _x$2;
              ch = _x;
              break _L$4;
            }
            case 46: {
              const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_param_str, 1, _param_start, _param_end);
              let _tmp$5;
              if (_bind$6 === undefined) {
                _tmp$5 = _param_end;
              } else {
                const _Some = _bind$6;
                _tmp$5 = _Some;
              }
              const _x$3 = { str: _param_str, start: _tmp$5, end: _param_end };
              rest$3 = _x$3;
              ch = _x;
              break _L$4;
            }
            default: {
              break _L$3;
            }
          }
        } else {
          break;
        }
      }
      n_digits = n_digits - ((ch - 46 | 0) / 2 | 0) | 0;
      _tmp = rest$3.str;
      _tmp$2 = rest$3.start;
      _tmp$3 = rest$3.end;
      continue;
    }
    let mantissa$2 = mantissa;
    if (n_digits > 0) {
      many_digits = true;
      mantissa$2 = $0L;
      const _bind$5 = moonbitlang$core$strconv$$try_parse_19digits(s, mantissa$2);
      const _s$3 = _bind$5._0;
      const _new_mantissa = _bind$5._1;
      const _consumed_digit = _bind$5._2;
      mantissa$2 = _new_mantissa;
      let _tmp$4;
      if (moonbitlang$core$builtin$$Compare$op_ge$26$(mantissa$2, moonbitlang$core$strconv$$min_19digit_int)) {
        _tmp$4 = _consumed_digit;
      } else {
        if (moonbitlang$core$string$$String$char_length_ge$46$inner(_s$3.str, 1, _s$3.start, _s$3.end)) {
          const _tmp$5 = _s$3.str;
          const _bind$6 = moonbitlang$core$string$$String$offset_of_nth_char$46$inner(_s$3.str, 1, _s$3.start, _s$3.end);
          let _tmp$6;
          if (_bind$6 === undefined) {
            _tmp$6 = _s$3.end;
          } else {
            const _Some = _bind$6;
            _tmp$6 = _Some;
          }
          const _tmp$7 = _tmp$6;
          const _x = { str: _tmp$5, start: _tmp$7, end: _s$3.end };
          const _bind$7 = moonbitlang$core$strconv$$try_parse_19digits(_x, mantissa$2);
          const _new_mantissa$2 = _bind$7._1;
          const _consumed_digit$2 = _bind$7._2;
          mantissa$2 = _new_mantissa$2;
          _tmp$4 = _consumed_digit$2;
        } else {
          return new Result$Ok$5$(undefined);
        }
      }
      exponent = moonbitlang$core$int$$Int$to_int64(_tmp$4);
      exponent = moonbitlang$core$builtin$$Add$add$25$(exponent, moonbitlang$core$strconv$$parse_number$46$exp_number$124$287);
    }
    return new Result$Ok$5$({ exponent: exponent, mantissa: mantissa$2, negative: _negative, many_digits: many_digits });
  } else {
    return moonbitlang$core$strconv$$syntax_err$39$();
  }
}
function moonbitlang$core$strconv$$assemble_bits(mantissa, exponent, negative) {
  const biased_exp = exponent - moonbitlang$core$strconv$$double_info.bias | 0;
  let bits = moonbitlang$core$builtin$$BitAnd$land$25$(mantissa, moonbitlang$core$builtin$$Sub$sub$25$(moonbitlang$core$builtin$$Shl$shl$25$($1L, moonbitlang$core$strconv$$double_info.mantissa_bits), $1L));
  const exp_bits = moonbitlang$core$int$$Int$to_int64(biased_exp & ((1 << moonbitlang$core$strconv$$double_info.exponent_bits) - 1 | 0));
  bits = moonbitlang$core$builtin$$BitOr$lor$25$(bits, moonbitlang$core$builtin$$Shl$shl$25$(exp_bits, moonbitlang$core$strconv$$double_info.mantissa_bits));
  if (negative) {
    bits = moonbitlang$core$builtin$$BitOr$lor$25$(bits, moonbitlang$core$builtin$$Shl$shl$25$(moonbitlang$core$builtin$$Shl$shl$25$($1L, moonbitlang$core$strconv$$double_info.mantissa_bits), moonbitlang$core$strconv$$double_info.exponent_bits));
  }
  return bits;
}
function moonbitlang$core$strconv$$Decimal$should_round_up(self, d) {
  if (d < 0 || d >= self.digits_num) {
    return false;
  }
  let _tmp;
  const _tmp$2 = self.digits;
  $bound_check(_tmp$2, d);
  if (_tmp$2[d] === 5) {
    _tmp = (d + 1 | 0) === self.digits_num;
  } else {
    _tmp = false;
  }
  if (_tmp) {
    if (self.truncated) {
      return true;
    }
    let _tmp$3;
    if (d > 0) {
      const _tmp$4 = self.digits;
      const _tmp$5 = d - 1 | 0;
      $bound_check(_tmp$4, _tmp$5);
      _tmp$3 = (_tmp$4[_tmp$5] % 2 | 0) !== 0;
    } else {
      _tmp$3 = false;
    }
    return _tmp$3;
  }
  const _tmp$3 = self.digits;
  $bound_check(_tmp$3, d);
  return _tmp$3[d] >= 5;
}
function moonbitlang$core$strconv$$Decimal$rounded_integer(self) {
  if (self.decimal_point > 20) {
    return $_1L;
  }
  let n = $0L;
  let i = 0;
  while (true) {
    if (i < self.decimal_point && i < self.digits_num) {
      const _tmp = moonbitlang$core$builtin$$Mul$mul$25$(n, $10L);
      const _tmp$2 = self.digits;
      const _tmp$3 = i;
      $bound_check(_tmp$2, _tmp$3);
      n = moonbitlang$core$builtin$$Add$add$25$(_tmp, moonbitlang$core$byte$$Byte$to_int64(_tmp$2[_tmp$3]));
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (i < self.decimal_point) {
      n = moonbitlang$core$builtin$$Mul$mul$25$(n, $10L);
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  if (moonbitlang$core$strconv$$Decimal$should_round_up(self, self.decimal_point)) {
    n = moonbitlang$core$builtin$$Add$add$25$(n, $1L);
  }
  return n;
}
function moonbitlang$core$strconv$$Decimal$new_digits(self, s) {
  $bound_check(moonbitlang$core$strconv$$left_shift_cheats, s);
  const new_digits = moonbitlang$core$strconv$$left_shift_cheats[s]._0;
  $bound_check(moonbitlang$core$strconv$$left_shift_cheats, s);
  const cheat_num = moonbitlang$core$strconv$$left_shift_cheats[s]._1;
  let less = false;
  const _end73 = cheat_num.length;
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < _end73) {
      if (i >= self.digits_num) {
        less = true;
        break;
      }
      const d = cheat_num.charCodeAt(i) - 48 | 0;
      const _tmp$2 = self.digits;
      $bound_check(_tmp$2, i);
      if (_tmp$2[i] !== d) {
        const _tmp$3 = self.digits;
        $bound_check(_tmp$3, i);
        less = _tmp$3[i] < d;
        break;
      }
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return less ? new_digits - 1 | 0 : new_digits;
}
function moonbitlang$core$strconv$$Decimal$left_shift(self, s) {
  const new_digits = moonbitlang$core$strconv$$Decimal$new_digits(self, s);
  let read_index = self.digits_num;
  let write_index = self.digits_num + new_digits | 0;
  let acc = $0L;
  read_index = read_index - 1 | 0;
  while (true) {
    if (read_index >= 0) {
      const _tmp = self.digits;
      const _tmp$2 = read_index;
      $bound_check(_tmp, _tmp$2);
      const d = moonbitlang$core$byte$$Byte$to_int64(_tmp[_tmp$2]);
      acc = moonbitlang$core$builtin$$Add$add$25$(acc, moonbitlang$core$builtin$$Shl$shl$25$(d, s));
      const quo = moonbitlang$core$builtin$$Div$div$25$(acc, $10L);
      const rem = moonbitlang$core$int64$$Int64$to_int(moonbitlang$core$builtin$$Sub$sub$25$(acc, moonbitlang$core$builtin$$Mul$mul$25$(quo, $10L)));
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp$3 = self.digits;
        const _tmp$4 = write_index;
        $bound_check(_tmp$3, _tmp$4);
        _tmp$3[_tmp$4] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      read_index = read_index - 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (moonbitlang$core$builtin$$Compare$op_gt$24$(acc, $0L)) {
      const quo = moonbitlang$core$builtin$$Div$div$25$(acc, $10L);
      const rem = moonbitlang$core$int64$$Int64$to_int(moonbitlang$core$builtin$$Sub$sub$25$(acc, moonbitlang$core$builtin$$Mul$mul$25$($10L, quo)));
      write_index = write_index - 1 | 0;
      if (write_index < self.digits.length) {
        const _tmp = self.digits;
        const _tmp$2 = write_index;
        $bound_check(_tmp, _tmp$2);
        _tmp[_tmp$2] = rem & 255;
      } else {
        if (rem !== 0) {
          self.truncated = true;
        }
      }
      acc = quo;
      continue;
    } else {
      break;
    }
  }
  self.digits_num = self.digits_num + new_digits | 0;
  if (self.digits_num > self.digits.length) {
    self.digits_num = self.digits.length;
  }
  self.decimal_point = self.decimal_point + new_digits | 0;
  moonbitlang$core$strconv$$Decimal$trim(self);
}
function moonbitlang$core$strconv$$Decimal$right_shift(self, s) {
  let read_index = 0;
  let write_index = 0;
  let acc = $0L;
  while (true) {
    if (moonbitlang$core$builtin$$Eq$equal$2$(moonbitlang$core$builtin$$Shr$shr$2$(acc, s), $0L)) {
      if (read_index >= self.digits_num) {
        while (true) {
          if (moonbitlang$core$builtin$$Eq$equal$2$(moonbitlang$core$builtin$$Shr$shr$2$(acc, s), $0L)) {
            acc = moonbitlang$core$builtin$$Mul$mul$2$(acc, $10L);
            read_index = read_index + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        break;
      }
      const _tmp = self.digits;
      const _tmp$2 = read_index;
      $bound_check(_tmp, _tmp$2);
      const d = _tmp[_tmp$2];
      acc = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(acc, $10L), moonbitlang$core$byte$$Byte$to_int64(d));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  self.decimal_point = self.decimal_point - (read_index - 1 | 0) | 0;
  const mask = moonbitlang$core$builtin$$Sub$sub$2$(moonbitlang$core$builtin$$Shl$shl$2$($1L, s), $1L);
  while (true) {
    if (read_index < self.digits_num) {
      const out = moonbitlang$core$builtin$$Shr$shr$2$(acc, s);
      const _tmp = self.digits;
      const _tmp$2 = write_index;
      $bound_check(_tmp, _tmp$2);
      _tmp[_tmp$2] = moonbitlang$core$uint64$$UInt64$to_byte(out);
      write_index = write_index + 1 | 0;
      acc = moonbitlang$core$builtin$$BitAnd$land$2$(acc, mask);
      const _tmp$3 = self.digits;
      const _tmp$4 = read_index;
      $bound_check(_tmp$3, _tmp$4);
      const d = _tmp$3[_tmp$4];
      acc = moonbitlang$core$builtin$$Add$add$2$(moonbitlang$core$builtin$$Mul$mul$2$(acc, $10L), moonbitlang$core$byte$$Byte$to_int64(d));
      read_index = read_index + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    if (moonbitlang$core$builtin$$Compare$op_gt$26$(acc, $0L)) {
      const out = moonbitlang$core$builtin$$Shr$shr$2$(acc, s);
      if (write_index < self.digits.length) {
        const _tmp = self.digits;
        const _tmp$2 = write_index;
        $bound_check(_tmp, _tmp$2);
        _tmp[_tmp$2] = moonbitlang$core$uint64$$UInt64$to_byte(out);
        write_index = write_index + 1 | 0;
      } else {
        if (moonbitlang$core$builtin$$Compare$op_gt$26$(out, $0L)) {
          self.truncated = true;
        }
      }
      acc = moonbitlang$core$builtin$$BitAnd$land$2$(acc, mask);
      acc = moonbitlang$core$builtin$$Mul$mul$2$(acc, $10L);
      continue;
    } else {
      break;
    }
  }
  self.digits_num = write_index;
  moonbitlang$core$strconv$$Decimal$trim(self);
}
function moonbitlang$core$strconv$$Decimal$shift_priv(self, s) {
  if (self.digits_num === 0) {
    return undefined;
  }
  let s$2 = s;
  if (s$2 > 0) {
    while (true) {
      if (s$2 > 59) {
        moonbitlang$core$strconv$$Decimal$left_shift(self, 59);
        s$2 = s$2 - 59 | 0;
        continue;
      } else {
        break;
      }
    }
    moonbitlang$core$strconv$$Decimal$left_shift(self, s$2);
  }
  if (s$2 < 0) {
    while (true) {
      if (s$2 < -59) {
        moonbitlang$core$strconv$$Decimal$right_shift(self, 59);
        s$2 = s$2 + 59 | 0;
        continue;
      } else {
        break;
      }
    }
    moonbitlang$core$strconv$$Decimal$right_shift(self, -s$2 | 0);
    return;
  } else {
    return;
  }
}
function moonbitlang$core$strconv$$Decimal$to_double_priv(self) {
  let exponent = 0;
  let mantissa = $0L;
  if (self.digits_num === 0 || self.decimal_point < -330) {
    mantissa = $0L;
    exponent = moonbitlang$core$strconv$$double_info.bias;
    const bits = moonbitlang$core$strconv$$assemble_bits(mantissa, exponent, self.negative);
    return new Result$Ok$4$(moonbitlang$core$int64$$Int64$reinterpret_as_double(bits));
  }
  if (self.decimal_point > 310) {
    const _bind = moonbitlang$core$strconv$$range_err$7$();
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _ok._0;
    } else {
      return _bind;
    }
  }
  while (true) {
    if (self.decimal_point > 0) {
      let n = 0;
      if (self.decimal_point >= moonbitlang$core$strconv$$powtab.length) {
        n = 60;
      } else {
        const _p = self.decimal_point;
        $bound_check(moonbitlang$core$strconv$$powtab, _p);
        n = moonbitlang$core$strconv$$powtab[_p];
      }
      moonbitlang$core$strconv$$Decimal$shift_priv(self, -n | 0);
      exponent = exponent + n | 0;
      continue;
    } else {
      break;
    }
  }
  while (true) {
    let _tmp;
    if (self.decimal_point < 0) {
      _tmp = true;
    } else {
      let _tmp$2;
      if (self.decimal_point === 0) {
        const _tmp$3 = self.digits;
        $bound_check(_tmp$3, 0);
        _tmp$2 = _tmp$3[0] < 5;
      } else {
        _tmp$2 = false;
      }
      _tmp = _tmp$2;
    }
    if (_tmp) {
      let n = 0;
      if ((-self.decimal_point | 0) >= moonbitlang$core$strconv$$powtab.length) {
        n = 60;
      } else {
        const _p = -self.decimal_point | 0;
        $bound_check(moonbitlang$core$strconv$$powtab, _p);
        n = moonbitlang$core$strconv$$powtab[_p];
      }
      moonbitlang$core$strconv$$Decimal$shift_priv(self, n);
      exponent = exponent - n | 0;
      continue;
    } else {
      break;
    }
  }
  exponent = exponent - 1 | 0;
  if (exponent < (moonbitlang$core$strconv$$double_info.bias + 1 | 0)) {
    const n = (moonbitlang$core$strconv$$double_info.bias + 1 | 0) - exponent | 0;
    moonbitlang$core$strconv$$Decimal$shift_priv(self, -n | 0);
    exponent = exponent + n | 0;
  }
  if ((exponent - moonbitlang$core$strconv$$double_info.bias | 0) >= ((1 << moonbitlang$core$strconv$$double_info.exponent_bits) - 1 | 0)) {
    const _bind = moonbitlang$core$strconv$$range_err$7$();
    if (_bind.$tag === 1) {
      const _ok = _bind;
      _ok._0;
    } else {
      return _bind;
    }
  }
  moonbitlang$core$strconv$$Decimal$shift_priv(self, moonbitlang$core$strconv$$double_info.mantissa_bits + 1 | 0);
  mantissa = moonbitlang$core$strconv$$Decimal$rounded_integer(self);
  if (moonbitlang$core$builtin$$Eq$equal$25$(mantissa, moonbitlang$core$builtin$$Shl$shl$25$($2L, moonbitlang$core$strconv$$double_info.mantissa_bits))) {
    mantissa = moonbitlang$core$builtin$$Shr$shr$25$(mantissa, 1);
    exponent = exponent + 1 | 0;
    if ((exponent - moonbitlang$core$strconv$$double_info.bias | 0) >= ((1 << moonbitlang$core$strconv$$double_info.exponent_bits) - 1 | 0)) {
      const _bind = moonbitlang$core$strconv$$range_err$7$();
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _ok._0;
      } else {
        return _bind;
      }
    }
  }
  if (moonbitlang$core$builtin$$Eq$equal$25$(moonbitlang$core$builtin$$BitAnd$land$25$(mantissa, moonbitlang$core$builtin$$Shl$shl$25$($1L, moonbitlang$core$strconv$$double_info.mantissa_bits)), $0L)) {
    exponent = moonbitlang$core$strconv$$double_info.bias;
  }
  const bits = moonbitlang$core$strconv$$assemble_bits(mantissa, exponent, self.negative);
  return new Result$Ok$4$(moonbitlang$core$int64$$Int64$reinterpret_as_double(bits));
}
function moonbitlang$core$strconv$$checked_mul(a, b) {
  if (moonbitlang$core$builtin$$Eq$equal$2$(a, $0L) || moonbitlang$core$builtin$$Eq$equal$2$(b, $0L)) {
    return moonbitlang$core$strconv$$checked_mul$46$constr$47$1452;
  }
  if (moonbitlang$core$builtin$$Eq$equal$2$(a, $1L)) {
    return b;
  }
  if (moonbitlang$core$builtin$$Eq$equal$2$(b, $1L)) {
    return a;
  }
  if (moonbitlang$core$uint64$$UInt64$clz(b) === 0 || moonbitlang$core$uint64$$UInt64$clz(a) === 0) {
    return undefined;
  }
  const quotient = moonbitlang$core$builtin$$Div$div$2$(moonbitlang$core$uint64$$max_value, b);
  if (moonbitlang$core$builtin$$Compare$op_gt$26$(a, quotient)) {
    return undefined;
  }
  return moonbitlang$core$builtin$$Mul$mul$2$(a, b);
}
function moonbitlang$core$strconv$$pow10_fast_path(exponent) {
  const _p = exponent & 31;
  $bound_check(moonbitlang$core$strconv$$table, _p);
  return moonbitlang$core$strconv$$table[_p];
}
function moonbitlang$core$strconv$$Number$is_fast_path(self) {
  return moonbitlang$core$builtin$$Compare$op_le$24$(moonbitlang$core$strconv$$min_exponent_fast_path, self.exponent) && (moonbitlang$core$builtin$$Compare$op_le$24$(self.exponent, moonbitlang$core$strconv$$max_exponent_disguised_fast_path) && (moonbitlang$core$builtin$$Compare$op_le$26$(self.mantissa, moonbitlang$core$strconv$$max_mantissa_fast_path) && !self.many_digits));
}
function moonbitlang$core$strconv$$Number$try_fast_path(self) {
  if (moonbitlang$core$strconv$$Number$is_fast_path(self)) {
    let value;
    if (moonbitlang$core$builtin$$Compare$op_le$24$(self.exponent, moonbitlang$core$strconv$$max_exponent_fast_path)) {
      const value$2 = moonbitlang$core$double$$Double$convert_uint64(self.mantissa);
      value = moonbitlang$core$builtin$$Compare$op_lt$24$(self.exponent, $0L) ? value$2 / moonbitlang$core$strconv$$pow10_fast_path(-moonbitlang$core$int64$$Int64$to_int(self.exponent) | 0) : value$2 * moonbitlang$core$strconv$$pow10_fast_path(moonbitlang$core$int64$$Int64$to_int(self.exponent));
    } else {
      const shift = moonbitlang$core$builtin$$Sub$sub$25$(self.exponent, moonbitlang$core$strconv$$max_exponent_fast_path);
      const _tmp = self.mantissa;
      const _p = moonbitlang$core$int64$$Int64$to_int(shift);
      $bound_check(moonbitlang$core$strconv$$int_pow10, _p);
      const _bind = moonbitlang$core$strconv$$checked_mul(_tmp, moonbitlang$core$strconv$$int_pow10[_p]);
      let mantissa;
      if (_bind === undefined) {
        return Option$None$8$;
      } else {
        const _Some = _bind;
        mantissa = _Some;
      }
      if (moonbitlang$core$builtin$$Compare$op_gt$26$(mantissa, moonbitlang$core$strconv$$max_mantissa_fast_path)) {
        return Option$None$8$;
      }
      value = moonbitlang$core$double$$Double$convert_uint64(mantissa) * moonbitlang$core$strconv$$pow10_fast_path(moonbitlang$core$int64$$Int64$to_int(moonbitlang$core$strconv$$max_exponent_fast_path));
    }
    if (self.negative) {
      value = -value;
    }
    return new Option$Some$8$(value);
  } else {
    return Option$None$8$;
  }
}
function moonbitlang$core$strconv$$parse_double(str) {
  if ((str.end - str.start | 0) > 0) {
    if (moonbitlang$core$strconv$$check_underscore(str)) {
      const _bind = moonbitlang$core$strconv$$parse_number(str);
      let _bind$2;
      if (_bind.$tag === 1) {
        const _ok = _bind;
        _bind$2 = _ok._0;
      } else {
        return _bind;
      }
      if (_bind$2 === undefined) {
        return moonbitlang$core$strconv$$parse_inf_nan(str);
      } else {
        const _Some = _bind$2;
        const _num = _Some;
        const _bind$3 = moonbitlang$core$strconv$$Number$try_fast_path(_num);
        if (_bind$3.$tag === 1) {
          const _Some$2 = _bind$3;
          const _value = _Some$2._0;
          return new Result$Ok$4$(_value);
        } else {
          const _bind$4 = moonbitlang$core$strconv$$parse_decimal_priv(str);
          let _tmp;
          if (_bind$4.$tag === 1) {
            const _ok = _bind$4;
            _tmp = _ok._0;
          } else {
            return _bind$4;
          }
          return moonbitlang$core$strconv$$Decimal$to_double_priv(_tmp);
        }
      }
    } else {
      return moonbitlang$core$strconv$$syntax_err$38$();
    }
  } else {
    return moonbitlang$core$strconv$$syntax_err$38$();
  }
}
function moonbitlang$core$math$$sin(_tmp) {
  return Math.sin(_tmp);
}
function moonbitlang$core$math$$cos(_tmp) {
  return Math.cos(_tmp);
}
function horideicom$encoding_sjis$$decode_jis_x_0208(code) {
  switch (code) {
    case 33088: {
      return 12288;
    }
    case 33089: {
      return 12289;
    }
    case 33090: {
      return 12290;
    }
    case 33091: {
      return 65292;
    }
    case 33092: {
      return 65294;
    }
    case 33093: {
      return 12539;
    }
    case 33094: {
      return 65306;
    }
    case 33095: {
      return 65307;
    }
    case 33096: {
      return 65311;
    }
    case 33097: {
      return 65281;
    }
    case 33098: {
      return 12443;
    }
    case 33099: {
      return 12444;
    }
    case 33100: {
      return 180;
    }
    case 33101: {
      return 65344;
    }
    case 33102: {
      return 168;
    }
    case 33103: {
      return 65342;
    }
    case 33104: {
      return 65507;
    }
    case 33105: {
      return 65343;
    }
    case 33106: {
      return 12541;
    }
    case 33107: {
      return 12542;
    }
    case 33108: {
      return 12445;
    }
    case 33109: {
      return 12446;
    }
    case 33110: {
      return 12291;
    }
    case 33111: {
      return 20189;
    }
    case 33112: {
      return 12293;
    }
    case 33113: {
      return 12294;
    }
    case 33114: {
      return 12295;
    }
    case 33115: {
      return 12540;
    }
    case 33116: {
      return 8213;
    }
    case 33117: {
      return 8208;
    }
    case 33118: {
      return 65295;
    }
    case 33119: {
      return 65340;
    }
    case 33120: {
      return 12316;
    }
    case 33121: {
      return 8214;
    }
    case 33122: {
      return 65372;
    }
    case 33123: {
      return 8230;
    }
    case 33124: {
      return 8229;
    }
    case 33125: {
      return 8216;
    }
    case 33126: {
      return 8217;
    }
    case 33127: {
      return 8220;
    }
    case 33128: {
      return 8221;
    }
    case 33129: {
      return 65288;
    }
    case 33130: {
      return 65289;
    }
    case 33131: {
      return 12308;
    }
    case 33132: {
      return 12309;
    }
    case 33133: {
      return 65339;
    }
    case 33134: {
      return 65341;
    }
    case 33135: {
      return 65371;
    }
    case 33136: {
      return 65373;
    }
    case 33137: {
      return 12296;
    }
    case 33138: {
      return 12297;
    }
    case 33139: {
      return 12298;
    }
    case 33140: {
      return 12299;
    }
    case 33141: {
      return 12300;
    }
    case 33142: {
      return 12301;
    }
    case 33143: {
      return 12302;
    }
    case 33144: {
      return 12303;
    }
    case 33145: {
      return 12304;
    }
    case 33146: {
      return 12305;
    }
    case 33147: {
      return 65291;
    }
    case 33148: {
      return 8722;
    }
    case 33149: {
      return 177;
    }
    case 33150: {
      return 215;
    }
    case 33152: {
      return 247;
    }
    case 33153: {
      return 65309;
    }
    case 33154: {
      return 8800;
    }
    case 33155: {
      return 65308;
    }
    case 33156: {
      return 65310;
    }
    case 33157: {
      return 8806;
    }
    case 33158: {
      return 8807;
    }
    case 33159: {
      return 8734;
    }
    case 33160: {
      return 8756;
    }
    case 33161: {
      return 9794;
    }
    case 33162: {
      return 9792;
    }
    case 33163: {
      return 176;
    }
    case 33164: {
      return 8242;
    }
    case 33165: {
      return 8243;
    }
    case 33166: {
      return 8451;
    }
    case 33167: {
      return 65509;
    }
    case 33168: {
      return 65284;
    }
    case 33169: {
      return 162;
    }
    case 33170: {
      return 163;
    }
    case 33171: {
      return 65285;
    }
    case 33172: {
      return 65283;
    }
    case 33173: {
      return 65286;
    }
    case 33174: {
      return 65290;
    }
    case 33175: {
      return 65312;
    }
    case 33176: {
      return 167;
    }
    case 33177: {
      return 9734;
    }
    case 33178: {
      return 9733;
    }
    case 33179: {
      return 9675;
    }
    case 33180: {
      return 9679;
    }
    case 33181: {
      return 9678;
    }
    case 33182: {
      return 9671;
    }
    case 33183: {
      return 9670;
    }
    case 33184: {
      return 9633;
    }
    case 33185: {
      return 9632;
    }
    case 33186: {
      return 9651;
    }
    case 33187: {
      return 9650;
    }
    case 33188: {
      return 9661;
    }
    case 33189: {
      return 9660;
    }
    case 33190: {
      return 8251;
    }
    case 33191: {
      return 12306;
    }
    case 33192: {
      return 8594;
    }
    case 33193: {
      return 8592;
    }
    case 33194: {
      return 8593;
    }
    case 33195: {
      return 8595;
    }
    case 33196: {
      return 12307;
    }
    case 33208: {
      return 8712;
    }
    case 33209: {
      return 8715;
    }
    case 33210: {
      return 8838;
    }
    case 33211: {
      return 8839;
    }
    case 33212: {
      return 8834;
    }
    case 33213: {
      return 8835;
    }
    case 33214: {
      return 8746;
    }
    case 33215: {
      return 8745;
    }
    case 33224: {
      return 8743;
    }
    case 33225: {
      return 8744;
    }
    case 33226: {
      return 172;
    }
    case 33227: {
      return 8658;
    }
    case 33228: {
      return 8660;
    }
    case 33229: {
      return 8704;
    }
    case 33230: {
      return 8707;
    }
    case 33242: {
      return 8736;
    }
    case 33243: {
      return 8869;
    }
    case 33244: {
      return 8978;
    }
    case 33245: {
      return 8706;
    }
    case 33246: {
      return 8711;
    }
    case 33247: {
      return 8801;
    }
    case 33248: {
      return 8786;
    }
    case 33249: {
      return 8810;
    }
    case 33250: {
      return 8811;
    }
    case 33251: {
      return 8730;
    }
    case 33252: {
      return 8765;
    }
    case 33253: {
      return 8733;
    }
    case 33254: {
      return 8757;
    }
    case 33255: {
      return 8747;
    }
    case 33256: {
      return 8748;
    }
    case 33264: {
      return 8491;
    }
    case 33265: {
      return 8240;
    }
    case 33266: {
      return 9839;
    }
    case 33267: {
      return 9837;
    }
    case 33268: {
      return 9834;
    }
    case 33269: {
      return 8224;
    }
    case 33270: {
      return 8225;
    }
    case 33271: {
      return 182;
    }
    case 33276: {
      return 9711;
    }
    case 33359: {
      return 65296;
    }
    case 33360: {
      return 65297;
    }
    case 33361: {
      return 65298;
    }
    case 33362: {
      return 65299;
    }
    case 33363: {
      return 65300;
    }
    case 33364: {
      return 65301;
    }
    case 33365: {
      return 65302;
    }
    case 33366: {
      return 65303;
    }
    case 33367: {
      return 65304;
    }
    case 33368: {
      return 65305;
    }
    case 33376: {
      return 65313;
    }
    case 33377: {
      return 65314;
    }
    case 33378: {
      return 65315;
    }
    case 33379: {
      return 65316;
    }
    case 33380: {
      return 65317;
    }
    case 33381: {
      return 65318;
    }
    case 33382: {
      return 65319;
    }
    case 33383: {
      return 65320;
    }
    case 33384: {
      return 65321;
    }
    case 33385: {
      return 65322;
    }
    case 33386: {
      return 65323;
    }
    case 33387: {
      return 65324;
    }
    case 33388: {
      return 65325;
    }
    case 33389: {
      return 65326;
    }
    case 33390: {
      return 65327;
    }
    case 33391: {
      return 65328;
    }
    case 33392: {
      return 65329;
    }
    case 33393: {
      return 65330;
    }
    case 33394: {
      return 65331;
    }
    case 33395: {
      return 65332;
    }
    case 33396: {
      return 65333;
    }
    case 33397: {
      return 65334;
    }
    case 33398: {
      return 65335;
    }
    case 33399: {
      return 65336;
    }
    case 33400: {
      return 65337;
    }
    case 33401: {
      return 65338;
    }
    case 33409: {
      return 65345;
    }
    case 33410: {
      return 65346;
    }
    case 33411: {
      return 65347;
    }
    case 33412: {
      return 65348;
    }
    case 33413: {
      return 65349;
    }
    case 33414: {
      return 65350;
    }
    case 33415: {
      return 65351;
    }
    case 33416: {
      return 65352;
    }
    case 33417: {
      return 65353;
    }
    case 33418: {
      return 65354;
    }
    case 33419: {
      return 65355;
    }
    case 33420: {
      return 65356;
    }
    case 33421: {
      return 65357;
    }
    case 33422: {
      return 65358;
    }
    case 33423: {
      return 65359;
    }
    case 33424: {
      return 65360;
    }
    case 33425: {
      return 65361;
    }
    case 33426: {
      return 65362;
    }
    case 33427: {
      return 65363;
    }
    case 33428: {
      return 65364;
    }
    case 33429: {
      return 65365;
    }
    case 33430: {
      return 65366;
    }
    case 33431: {
      return 65367;
    }
    case 33432: {
      return 65368;
    }
    case 33433: {
      return 65369;
    }
    case 33434: {
      return 65370;
    }
    case 33439: {
      return 12353;
    }
    case 33440: {
      return 12354;
    }
    case 33441: {
      return 12355;
    }
    case 33442: {
      return 12356;
    }
    case 33443: {
      return 12357;
    }
    case 33444: {
      return 12358;
    }
    case 33445: {
      return 12359;
    }
    case 33446: {
      return 12360;
    }
    case 33447: {
      return 12361;
    }
    case 33448: {
      return 12362;
    }
    case 33449: {
      return 12363;
    }
    case 33450: {
      return 12364;
    }
    case 33451: {
      return 12365;
    }
    case 33452: {
      return 12366;
    }
    case 33453: {
      return 12367;
    }
    case 33454: {
      return 12368;
    }
    case 33455: {
      return 12369;
    }
    case 33456: {
      return 12370;
    }
    case 33457: {
      return 12371;
    }
    case 33458: {
      return 12372;
    }
    case 33459: {
      return 12373;
    }
    case 33460: {
      return 12374;
    }
    case 33461: {
      return 12375;
    }
    case 33462: {
      return 12376;
    }
    case 33463: {
      return 12377;
    }
    case 33464: {
      return 12378;
    }
    case 33465: {
      return 12379;
    }
    case 33466: {
      return 12380;
    }
    case 33467: {
      return 12381;
    }
    case 33468: {
      return 12382;
    }
    case 33469: {
      return 12383;
    }
    case 33470: {
      return 12384;
    }
    case 33471: {
      return 12385;
    }
    case 33472: {
      return 12386;
    }
    case 33473: {
      return 12387;
    }
    case 33474: {
      return 12388;
    }
    case 33475: {
      return 12389;
    }
    case 33476: {
      return 12390;
    }
    case 33477: {
      return 12391;
    }
    case 33478: {
      return 12392;
    }
    case 33479: {
      return 12393;
    }
    case 33480: {
      return 12394;
    }
    case 33481: {
      return 12395;
    }
    case 33482: {
      return 12396;
    }
    case 33483: {
      return 12397;
    }
    case 33484: {
      return 12398;
    }
    case 33485: {
      return 12399;
    }
    case 33486: {
      return 12400;
    }
    case 33487: {
      return 12401;
    }
    case 33488: {
      return 12402;
    }
    case 33489: {
      return 12403;
    }
    case 33490: {
      return 12404;
    }
    case 33491: {
      return 12405;
    }
    case 33492: {
      return 12406;
    }
    case 33493: {
      return 12407;
    }
    case 33494: {
      return 12408;
    }
    case 33495: {
      return 12409;
    }
    case 33496: {
      return 12410;
    }
    case 33497: {
      return 12411;
    }
    case 33498: {
      return 12412;
    }
    case 33499: {
      return 12413;
    }
    case 33500: {
      return 12414;
    }
    case 33501: {
      return 12415;
    }
    case 33502: {
      return 12416;
    }
    case 33503: {
      return 12417;
    }
    case 33504: {
      return 12418;
    }
    case 33505: {
      return 12419;
    }
    case 33506: {
      return 12420;
    }
    case 33507: {
      return 12421;
    }
    case 33508: {
      return 12422;
    }
    case 33509: {
      return 12423;
    }
    case 33510: {
      return 12424;
    }
    case 33511: {
      return 12425;
    }
    case 33512: {
      return 12426;
    }
    case 33513: {
      return 12427;
    }
    case 33514: {
      return 12428;
    }
    case 33515: {
      return 12429;
    }
    case 33516: {
      return 12430;
    }
    case 33517: {
      return 12431;
    }
    case 33518: {
      return 12432;
    }
    case 33519: {
      return 12433;
    }
    case 33520: {
      return 12434;
    }
    case 33521: {
      return 12435;
    }
    case 33600: {
      return 12449;
    }
    case 33601: {
      return 12450;
    }
    case 33602: {
      return 12451;
    }
    case 33603: {
      return 12452;
    }
    case 33604: {
      return 12453;
    }
    case 33605: {
      return 12454;
    }
    case 33606: {
      return 12455;
    }
    case 33607: {
      return 12456;
    }
    case 33608: {
      return 12457;
    }
    case 33609: {
      return 12458;
    }
    case 33610: {
      return 12459;
    }
    case 33611: {
      return 12460;
    }
    case 33612: {
      return 12461;
    }
    case 33613: {
      return 12462;
    }
    case 33614: {
      return 12463;
    }
    case 33615: {
      return 12464;
    }
    case 33616: {
      return 12465;
    }
    case 33617: {
      return 12466;
    }
    case 33618: {
      return 12467;
    }
    case 33619: {
      return 12468;
    }
    case 33620: {
      return 12469;
    }
    case 33621: {
      return 12470;
    }
    case 33622: {
      return 12471;
    }
    case 33623: {
      return 12472;
    }
    case 33624: {
      return 12473;
    }
    case 33625: {
      return 12474;
    }
    case 33626: {
      return 12475;
    }
    case 33627: {
      return 12476;
    }
    case 33628: {
      return 12477;
    }
    case 33629: {
      return 12478;
    }
    case 33630: {
      return 12479;
    }
    case 33631: {
      return 12480;
    }
    case 33632: {
      return 12481;
    }
    case 33633: {
      return 12482;
    }
    case 33634: {
      return 12483;
    }
    case 33635: {
      return 12484;
    }
    case 33636: {
      return 12485;
    }
    case 33637: {
      return 12486;
    }
    case 33638: {
      return 12487;
    }
    case 33639: {
      return 12488;
    }
    case 33640: {
      return 12489;
    }
    case 33641: {
      return 12490;
    }
    case 33642: {
      return 12491;
    }
    case 33643: {
      return 12492;
    }
    case 33644: {
      return 12493;
    }
    case 33645: {
      return 12494;
    }
    case 33646: {
      return 12495;
    }
    case 33647: {
      return 12496;
    }
    case 33648: {
      return 12497;
    }
    case 33649: {
      return 12498;
    }
    case 33650: {
      return 12499;
    }
    case 33651: {
      return 12500;
    }
    case 33652: {
      return 12501;
    }
    case 33653: {
      return 12502;
    }
    case 33654: {
      return 12503;
    }
    case 33655: {
      return 12504;
    }
    case 33656: {
      return 12505;
    }
    case 33657: {
      return 12506;
    }
    case 33658: {
      return 12507;
    }
    case 33659: {
      return 12508;
    }
    case 33660: {
      return 12509;
    }
    case 33661: {
      return 12510;
    }
    case 33662: {
      return 12511;
    }
    case 33664: {
      return 12512;
    }
    case 33665: {
      return 12513;
    }
    case 33666: {
      return 12514;
    }
    case 33667: {
      return 12515;
    }
    case 33668: {
      return 12516;
    }
    case 33669: {
      return 12517;
    }
    case 33670: {
      return 12518;
    }
    case 33671: {
      return 12519;
    }
    case 33672: {
      return 12520;
    }
    case 33673: {
      return 12521;
    }
    case 33674: {
      return 12522;
    }
    case 33675: {
      return 12523;
    }
    case 33676: {
      return 12524;
    }
    case 33677: {
      return 12525;
    }
    case 33678: {
      return 12526;
    }
    case 33679: {
      return 12527;
    }
    case 33680: {
      return 12528;
    }
    case 33681: {
      return 12529;
    }
    case 33682: {
      return 12530;
    }
    case 33683: {
      return 12531;
    }
    case 33684: {
      return 12532;
    }
    case 33685: {
      return 12533;
    }
    case 33686: {
      return 12534;
    }
    case 33695: {
      return 913;
    }
    case 33696: {
      return 914;
    }
    case 33697: {
      return 915;
    }
    case 33698: {
      return 916;
    }
    case 33699: {
      return 917;
    }
    case 33700: {
      return 918;
    }
    case 33701: {
      return 919;
    }
    case 33702: {
      return 920;
    }
    case 33703: {
      return 921;
    }
    case 33704: {
      return 922;
    }
    case 33705: {
      return 923;
    }
    case 33706: {
      return 924;
    }
    case 33707: {
      return 925;
    }
    case 33708: {
      return 926;
    }
    case 33709: {
      return 927;
    }
    case 33710: {
      return 928;
    }
    case 33711: {
      return 929;
    }
    case 33712: {
      return 931;
    }
    case 33713: {
      return 932;
    }
    case 33714: {
      return 933;
    }
    case 33715: {
      return 934;
    }
    case 33716: {
      return 935;
    }
    case 33717: {
      return 936;
    }
    case 33718: {
      return 937;
    }
    case 33727: {
      return 945;
    }
    case 33728: {
      return 946;
    }
    case 33729: {
      return 947;
    }
    case 33730: {
      return 948;
    }
    case 33731: {
      return 949;
    }
    case 33732: {
      return 950;
    }
    case 33733: {
      return 951;
    }
    case 33734: {
      return 952;
    }
    case 33735: {
      return 953;
    }
    case 33736: {
      return 954;
    }
    case 33737: {
      return 955;
    }
    case 33738: {
      return 956;
    }
    case 33739: {
      return 957;
    }
    case 33740: {
      return 958;
    }
    case 33741: {
      return 959;
    }
    case 33742: {
      return 960;
    }
    case 33743: {
      return 961;
    }
    case 33744: {
      return 963;
    }
    case 33745: {
      return 964;
    }
    case 33746: {
      return 965;
    }
    case 33747: {
      return 966;
    }
    case 33748: {
      return 967;
    }
    case 33749: {
      return 968;
    }
    case 33750: {
      return 969;
    }
    case 33856: {
      return 1040;
    }
    case 33857: {
      return 1041;
    }
    case 33858: {
      return 1042;
    }
    case 33859: {
      return 1043;
    }
    case 33860: {
      return 1044;
    }
    case 33861: {
      return 1045;
    }
    case 33862: {
      return 1025;
    }
    case 33863: {
      return 1046;
    }
    case 33864: {
      return 1047;
    }
    case 33865: {
      return 1048;
    }
    case 33866: {
      return 1049;
    }
    case 33867: {
      return 1050;
    }
    case 33868: {
      return 1051;
    }
    case 33869: {
      return 1052;
    }
    case 33870: {
      return 1053;
    }
    case 33871: {
      return 1054;
    }
    case 33872: {
      return 1055;
    }
    case 33873: {
      return 1056;
    }
    case 33874: {
      return 1057;
    }
    case 33875: {
      return 1058;
    }
    case 33876: {
      return 1059;
    }
    case 33877: {
      return 1060;
    }
    case 33878: {
      return 1061;
    }
    case 33879: {
      return 1062;
    }
    case 33880: {
      return 1063;
    }
    case 33881: {
      return 1064;
    }
    case 33882: {
      return 1065;
    }
    case 33883: {
      return 1066;
    }
    case 33884: {
      return 1067;
    }
    case 33885: {
      return 1068;
    }
    case 33886: {
      return 1069;
    }
    case 33887: {
      return 1070;
    }
    case 33888: {
      return 1071;
    }
    case 33904: {
      return 1072;
    }
    case 33905: {
      return 1073;
    }
    case 33906: {
      return 1074;
    }
    case 33907: {
      return 1075;
    }
    case 33908: {
      return 1076;
    }
    case 33909: {
      return 1077;
    }
    case 33910: {
      return 1105;
    }
    case 33911: {
      return 1078;
    }
    case 33912: {
      return 1079;
    }
    case 33913: {
      return 1080;
    }
    case 33914: {
      return 1081;
    }
    case 33915: {
      return 1082;
    }
    case 33916: {
      return 1083;
    }
    case 33917: {
      return 1084;
    }
    case 33918: {
      return 1085;
    }
    case 33920: {
      return 1086;
    }
    case 33921: {
      return 1087;
    }
    case 33922: {
      return 1088;
    }
    case 33923: {
      return 1089;
    }
    case 33924: {
      return 1090;
    }
    case 33925: {
      return 1091;
    }
    case 33926: {
      return 1092;
    }
    case 33927: {
      return 1093;
    }
    case 33928: {
      return 1094;
    }
    case 33929: {
      return 1095;
    }
    case 33930: {
      return 1096;
    }
    case 33931: {
      return 1097;
    }
    case 33932: {
      return 1098;
    }
    case 33933: {
      return 1099;
    }
    case 33934: {
      return 1100;
    }
    case 33935: {
      return 1101;
    }
    case 33936: {
      return 1102;
    }
    case 33937: {
      return 1103;
    }
    case 33951: {
      return 9472;
    }
    case 33952: {
      return 9474;
    }
    case 33953: {
      return 9484;
    }
    case 33954: {
      return 9488;
    }
    case 33955: {
      return 9496;
    }
    case 33956: {
      return 9492;
    }
    case 33957: {
      return 9500;
    }
    case 33958: {
      return 9516;
    }
    case 33959: {
      return 9508;
    }
    case 33960: {
      return 9524;
    }
    case 33961: {
      return 9532;
    }
    case 33962: {
      return 9473;
    }
    case 33963: {
      return 9475;
    }
    case 33964: {
      return 9487;
    }
    case 33965: {
      return 9491;
    }
    case 33966: {
      return 9499;
    }
    case 33967: {
      return 9495;
    }
    case 33968: {
      return 9507;
    }
    case 33969: {
      return 9523;
    }
    case 33970: {
      return 9515;
    }
    case 33971: {
      return 9531;
    }
    case 33972: {
      return 9547;
    }
    case 33973: {
      return 9504;
    }
    case 33974: {
      return 9519;
    }
    case 33975: {
      return 9512;
    }
    case 33976: {
      return 9527;
    }
    case 33977: {
      return 9535;
    }
    case 33978: {
      return 9501;
    }
    case 33979: {
      return 9520;
    }
    case 33980: {
      return 9509;
    }
    case 33981: {
      return 9528;
    }
    case 33982: {
      return 9538;
    }
    case 34975: {
      return 20124;
    }
    case 34976: {
      return 21782;
    }
    case 34977: {
      return 23043;
    }
    case 34978: {
      return 38463;
    }
    case 34979: {
      return 21696;
    }
    case 34980: {
      return 24859;
    }
    case 34981: {
      return 25384;
    }
    case 34982: {
      return 23030;
    }
    case 34983: {
      return 36898;
    }
    case 34984: {
      return 33909;
    }
    case 34985: {
      return 33564;
    }
    case 34986: {
      return 31312;
    }
    case 34987: {
      return 24746;
    }
    case 34988: {
      return 25569;
    }
    case 34989: {
      return 28197;
    }
    case 34990: {
      return 26093;
    }
    case 34991: {
      return 33894;
    }
    case 34992: {
      return 33446;
    }
    case 34993: {
      return 39925;
    }
    case 34994: {
      return 26771;
    }
    case 34995: {
      return 22311;
    }
    case 34996: {
      return 26017;
    }
    case 34997: {
      return 25201;
    }
    case 34998: {
      return 23451;
    }
    case 34999: {
      return 22992;
    }
    case 35000: {
      return 34427;
    }
    case 35001: {
      return 39156;
    }
    case 35002: {
      return 32098;
    }
    case 35003: {
      return 32190;
    }
    case 35004: {
      return 39822;
    }
    case 35005: {
      return 25110;
    }
    case 35006: {
      return 31903;
    }
    case 35007: {
      return 34999;
    }
    case 35008: {
      return 23433;
    }
    case 35009: {
      return 24245;
    }
    case 35010: {
      return 25353;
    }
    case 35011: {
      return 26263;
    }
    case 35012: {
      return 26696;
    }
    case 35013: {
      return 38343;
    }
    case 35014: {
      return 38797;
    }
    case 35015: {
      return 26447;
    }
    case 35016: {
      return 20197;
    }
    case 35017: {
      return 20234;
    }
    case 35018: {
      return 20301;
    }
    case 35019: {
      return 20381;
    }
    case 35020: {
      return 20553;
    }
    case 35021: {
      return 22258;
    }
    case 35022: {
      return 22839;
    }
    case 35023: {
      return 22996;
    }
    case 35024: {
      return 23041;
    }
    case 35025: {
      return 23561;
    }
    case 35026: {
      return 24799;
    }
    case 35027: {
      return 24847;
    }
    case 35028: {
      return 24944;
    }
    case 35029: {
      return 26131;
    }
    case 35030: {
      return 26885;
    }
    case 35031: {
      return 28858;
    }
    case 35032: {
      return 30031;
    }
    case 35033: {
      return 30064;
    }
    case 35034: {
      return 31227;
    }
    case 35035: {
      return 32173;
    }
    case 35036: {
      return 32239;
    }
    case 35037: {
      return 32963;
    }
    case 35038: {
      return 33806;
    }
    case 35039: {
      return 34915;
    }
    case 35040: {
      return 35586;
    }
    case 35041: {
      return 36949;
    }
    case 35042: {
      return 36986;
    }
    case 35043: {
      return 21307;
    }
    case 35044: {
      return 20117;
    }
    case 35045: {
      return 20133;
    }
    case 35046: {
      return 22495;
    }
    case 35047: {
      return 32946;
    }
    case 35048: {
      return 37057;
    }
    case 35049: {
      return 30959;
    }
    case 35050: {
      return 19968;
    }
    case 35051: {
      return 22769;
    }
    case 35052: {
      return 28322;
    }
    case 35053: {
      return 36920;
    }
    case 35054: {
      return 31282;
    }
    case 35055: {
      return 33576;
    }
    case 35056: {
      return 33419;
    }
    case 35057: {
      return 39983;
    }
    case 35058: {
      return 20801;
    }
    case 35059: {
      return 21360;
    }
    case 35060: {
      return 21693;
    }
    case 35061: {
      return 21729;
    }
    case 35062: {
      return 22240;
    }
    case 35063: {
      return 23035;
    }
    case 35064: {
      return 24341;
    }
    case 35065: {
      return 39154;
    }
    case 35066: {
      return 28139;
    }
    case 35067: {
      return 32996;
    }
    case 35068: {
      return 34093;
    }
    case 35136: {
      return 38498;
    }
    case 35137: {
      return 38512;
    }
    case 35138: {
      return 38560;
    }
    case 35139: {
      return 38907;
    }
    case 35140: {
      return 21515;
    }
    case 35141: {
      return 21491;
    }
    case 35142: {
      return 23431;
    }
    case 35143: {
      return 28879;
    }
    case 35144: {
      return 32701;
    }
    case 35145: {
      return 36802;
    }
    case 35146: {
      return 38632;
    }
    case 35147: {
      return 21359;
    }
    case 35148: {
      return 40284;
    }
    case 35149: {
      return 31418;
    }
    case 35150: {
      return 19985;
    }
    case 35151: {
      return 30867;
    }
    case 35152: {
      return 33276;
    }
    case 35153: {
      return 28198;
    }
    case 35154: {
      return 22040;
    }
    case 35155: {
      return 21764;
    }
    case 35156: {
      return 27421;
    }
    case 35157: {
      return 34074;
    }
    case 35158: {
      return 39995;
    }
    case 35159: {
      return 23013;
    }
    case 35160: {
      return 21417;
    }
    case 35161: {
      return 28006;
    }
    case 35162: {
      return 29916;
    }
    case 35163: {
      return 38287;
    }
    case 35164: {
      return 22082;
    }
    case 35165: {
      return 20113;
    }
    case 35166: {
      return 36939;
    }
    case 35167: {
      return 38642;
    }
    case 35168: {
      return 33615;
    }
    case 35169: {
      return 39180;
    }
    case 35170: {
      return 21473;
    }
    case 35171: {
      return 21942;
    }
    case 35172: {
      return 23344;
    }
    case 35173: {
      return 24433;
    }
    case 35174: {
      return 26144;
    }
    case 35175: {
      return 26355;
    }
    case 35176: {
      return 26628;
    }
    case 35177: {
      return 27704;
    }
    case 35178: {
      return 27891;
    }
    case 35179: {
      return 27945;
    }
    case 35180: {
      return 29787;
    }
    case 35181: {
      return 30408;
    }
    case 35182: {
      return 31310;
    }
    case 35183: {
      return 38964;
    }
    case 35184: {
      return 33521;
    }
    case 35185: {
      return 34907;
    }
    case 35186: {
      return 35424;
    }
    case 35187: {
      return 37613;
    }
    case 35188: {
      return 28082;
    }
    case 35189: {
      return 30123;
    }
    case 35190: {
      return 30410;
    }
    case 35191: {
      return 39365;
    }
    case 35192: {
      return 24742;
    }
    case 35193: {
      return 35585;
    }
    case 35194: {
      return 36234;
    }
    case 35195: {
      return 38322;
    }
    case 35196: {
      return 27022;
    }
    case 35197: {
      return 21421;
    }
    case 35198: {
      return 20870;
    }
    case 35200: {
      return 22290;
    }
    case 35201: {
      return 22576;
    }
    case 35202: {
      return 22852;
    }
    case 35203: {
      return 23476;
    }
    case 35204: {
      return 24310;
    }
    case 35205: {
      return 24616;
    }
    case 35206: {
      return 25513;
    }
    case 35207: {
      return 25588;
    }
    case 35208: {
      return 27839;
    }
    case 35209: {
      return 28436;
    }
    case 35210: {
      return 28814;
    }
    case 35211: {
      return 28948;
    }
    case 35212: {
      return 29017;
    }
    case 35213: {
      return 29141;
    }
    case 35214: {
      return 29503;
    }
    case 35215: {
      return 32257;
    }
    case 35216: {
      return 33398;
    }
    case 35217: {
      return 33489;
    }
    case 35218: {
      return 34199;
    }
    case 35219: {
      return 36960;
    }
    case 35220: {
      return 37467;
    }
    case 35221: {
      return 40219;
    }
    case 35222: {
      return 22633;
    }
    case 35223: {
      return 26044;
    }
    case 35224: {
      return 27738;
    }
    case 35225: {
      return 29989;
    }
    case 35226: {
      return 20985;
    }
    case 35227: {
      return 22830;
    }
    case 35228: {
      return 22885;
    }
    case 35229: {
      return 24448;
    }
    case 35230: {
      return 24540;
    }
    case 35231: {
      return 25276;
    }
    case 35232: {
      return 26106;
    }
    case 35233: {
      return 27178;
    }
    case 35234: {
      return 27431;
    }
    case 35235: {
      return 27572;
    }
    case 35236: {
      return 29579;
    }
    case 35237: {
      return 32705;
    }
    case 35238: {
      return 35158;
    }
    case 35239: {
      return 40236;
    }
    case 35240: {
      return 40206;
    }
    case 35241: {
      return 40644;
    }
    case 35242: {
      return 23713;
    }
    case 35243: {
      return 27798;
    }
    case 35244: {
      return 33659;
    }
    case 35245: {
      return 20740;
    }
    case 35246: {
      return 23627;
    }
    case 35247: {
      return 25014;
    }
    case 35248: {
      return 33222;
    }
    case 35249: {
      return 26742;
    }
    case 35250: {
      return 29281;
    }
    case 35251: {
      return 20057;
    }
    case 35252: {
      return 20474;
    }
    case 35253: {
      return 21368;
    }
    case 35254: {
      return 24681;
    }
    case 35255: {
      return 28201;
    }
    case 35256: {
      return 31311;
    }
    case 35257: {
      return 38899;
    }
    case 35258: {
      return 19979;
    }
    case 35259: {
      return 21270;
    }
    case 35260: {
      return 20206;
    }
    case 35261: {
      return 20309;
    }
    case 35262: {
      return 20285;
    }
    case 35263: {
      return 20385;
    }
    case 35264: {
      return 20339;
    }
    case 35265: {
      return 21152;
    }
    case 35266: {
      return 21487;
    }
    case 35267: {
      return 22025;
    }
    case 35268: {
      return 22799;
    }
    case 35269: {
      return 23233;
    }
    case 35270: {
      return 23478;
    }
    case 35271: {
      return 23521;
    }
    case 35272: {
      return 31185;
    }
    case 35273: {
      return 26247;
    }
    case 35274: {
      return 26524;
    }
    case 35275: {
      return 26550;
    }
    case 35276: {
      return 27468;
    }
    case 35277: {
      return 27827;
    }
    case 35278: {
      return 28779;
    }
    case 35279: {
      return 29634;
    }
    case 35280: {
      return 31117;
    }
    case 35281: {
      return 31166;
    }
    case 35282: {
      return 31292;
    }
    case 35283: {
      return 31623;
    }
    case 35284: {
      return 33457;
    }
    case 35285: {
      return 33499;
    }
    case 35286: {
      return 33540;
    }
    case 35287: {
      return 33655;
    }
    case 35288: {
      return 33775;
    }
    case 35289: {
      return 33747;
    }
    case 35290: {
      return 34662;
    }
    case 35291: {
      return 35506;
    }
    case 35292: {
      return 22057;
    }
    case 35293: {
      return 36008;
    }
    case 35294: {
      return 36838;
    }
    case 35295: {
      return 36942;
    }
    case 35296: {
      return 38686;
    }
    case 35297: {
      return 34442;
    }
    case 35298: {
      return 20420;
    }
    case 35299: {
      return 23784;
    }
    case 35300: {
      return 25105;
    }
    case 35301: {
      return 29273;
    }
    case 35302: {
      return 30011;
    }
    case 35303: {
      return 33253;
    }
    case 35304: {
      return 33469;
    }
    case 35305: {
      return 34558;
    }
    case 35306: {
      return 36032;
    }
    case 35307: {
      return 38597;
    }
    case 35308: {
      return 39187;
    }
    case 35309: {
      return 39381;
    }
    case 35310: {
      return 20171;
    }
    case 35311: {
      return 20250;
    }
    case 35312: {
      return 35299;
    }
    case 35313: {
      return 22238;
    }
    case 35314: {
      return 22602;
    }
    case 35315: {
      return 22730;
    }
    case 35316: {
      return 24315;
    }
    case 35317: {
      return 24555;
    }
    case 35318: {
      return 24618;
    }
    case 35319: {
      return 24724;
    }
    case 35320: {
      return 24674;
    }
    case 35321: {
      return 25040;
    }
    case 35322: {
      return 25106;
    }
    case 35323: {
      return 25296;
    }
    case 35324: {
      return 25913;
    }
    case 35392: {
      return 39745;
    }
    case 35393: {
      return 26214;
    }
    case 35394: {
      return 26800;
    }
    case 35395: {
      return 28023;
    }
    case 35396: {
      return 28784;
    }
    case 35397: {
      return 30028;
    }
    case 35398: {
      return 30342;
    }
    case 35399: {
      return 32117;
    }
    case 35400: {
      return 33445;
    }
    case 35401: {
      return 34809;
    }
    case 35402: {
      return 38283;
    }
    case 35403: {
      return 38542;
    }
    case 35404: {
      return 35997;
    }
    case 35405: {
      return 20977;
    }
    case 35406: {
      return 21182;
    }
    case 35407: {
      return 22806;
    }
    case 35408: {
      return 21683;
    }
    case 35409: {
      return 23475;
    }
    case 35410: {
      return 23830;
    }
    case 35411: {
      return 24936;
    }
    case 35412: {
      return 27010;
    }
    case 35413: {
      return 28079;
    }
    case 35414: {
      return 30861;
    }
    case 35415: {
      return 33995;
    }
    case 35416: {
      return 34903;
    }
    case 35417: {
      return 35442;
    }
    case 35418: {
      return 37799;
    }
    case 35419: {
      return 39608;
    }
    case 35420: {
      return 28012;
    }
    case 35421: {
      return 39336;
    }
    case 35422: {
      return 34521;
    }
    case 35423: {
      return 22435;
    }
    case 35424: {
      return 26623;
    }
    case 35425: {
      return 34510;
    }
    case 35426: {
      return 37390;
    }
    case 35427: {
      return 21123;
    }
    case 35428: {
      return 22151;
    }
    case 35429: {
      return 21508;
    }
    case 35430: {
      return 24275;
    }
    case 35431: {
      return 25313;
    }
    case 35432: {
      return 25785;
    }
    case 35433: {
      return 26684;
    }
    case 35434: {
      return 26680;
    }
    case 35435: {
      return 27579;
    }
    case 35436: {
      return 29554;
    }
    case 35437: {
      return 30906;
    }
    case 35438: {
      return 31339;
    }
    case 35439: {
      return 35226;
    }
    case 35440: {
      return 35282;
    }
    case 35441: {
      return 36203;
    }
    case 35442: {
      return 36611;
    }
    case 35443: {
      return 37101;
    }
    case 35444: {
      return 38307;
    }
    case 35445: {
      return 38548;
    }
    case 35446: {
      return 38761;
    }
    case 35447: {
      return 23398;
    }
    case 35448: {
      return 23731;
    }
    case 35449: {
      return 27005;
    }
    case 35450: {
      return 38989;
    }
    case 35451: {
      return 38990;
    }
    case 35452: {
      return 25499;
    }
    case 35453: {
      return 31520;
    }
    case 35454: {
      return 27179;
    }
    case 35456: {
      return 27263;
    }
    case 35457: {
      return 26806;
    }
    case 35458: {
      return 39949;
    }
    case 35459: {
      return 28511;
    }
    case 35460: {
      return 21106;
    }
    case 35461: {
      return 21917;
    }
    case 35462: {
      return 24688;
    }
    case 35463: {
      return 25324;
    }
    case 35464: {
      return 27963;
    }
    case 35465: {
      return 28167;
    }
    case 35466: {
      return 28369;
    }
    case 35467: {
      return 33883;
    }
    case 35468: {
      return 35088;
    }
    case 35469: {
      return 36676;
    }
    case 35470: {
      return 19988;
    }
    case 35471: {
      return 39993;
    }
    case 35472: {
      return 21494;
    }
    case 35473: {
      return 26907;
    }
    case 35474: {
      return 27194;
    }
    case 35475: {
      return 38788;
    }
    case 35476: {
      return 26666;
    }
    case 35477: {
      return 20828;
    }
    case 35478: {
      return 31427;
    }
    case 35479: {
      return 33970;
    }
    case 35480: {
      return 37340;
    }
    case 35481: {
      return 37772;
    }
    case 35482: {
      return 22107;
    }
    case 35483: {
      return 40232;
    }
    case 35484: {
      return 26658;
    }
    case 35485: {
      return 33541;
    }
    case 35486: {
      return 33841;
    }
    case 35487: {
      return 31909;
    }
    case 35488: {
      return 21000;
    }
    case 35489: {
      return 33477;
    }
    case 35490: {
      return 29926;
    }
    case 35491: {
      return 20094;
    }
    case 35492: {
      return 20355;
    }
    case 35493: {
      return 20896;
    }
    case 35494: {
      return 23506;
    }
    case 35495: {
      return 21002;
    }
    case 35496: {
      return 21208;
    }
    case 35497: {
      return 21223;
    }
    case 35498: {
      return 24059;
    }
    case 35499: {
      return 21914;
    }
    case 35500: {
      return 22570;
    }
    case 35501: {
      return 23014;
    }
    case 35502: {
      return 23436;
    }
    case 35503: {
      return 23448;
    }
    case 35504: {
      return 23515;
    }
    case 35505: {
      return 24178;
    }
    case 35506: {
      return 24185;
    }
    case 35507: {
      return 24739;
    }
    case 35508: {
      return 24863;
    }
    case 35509: {
      return 24931;
    }
    case 35510: {
      return 25022;
    }
    case 35511: {
      return 25563;
    }
    case 35512: {
      return 25954;
    }
    case 35513: {
      return 26577;
    }
    case 35514: {
      return 26707;
    }
    case 35515: {
      return 26874;
    }
    case 35516: {
      return 27454;
    }
    case 35517: {
      return 27475;
    }
    case 35518: {
      return 27735;
    }
    case 35519: {
      return 28450;
    }
    case 35520: {
      return 28567;
    }
    case 35521: {
      return 28485;
    }
    case 35522: {
      return 29872;
    }
    case 35523: {
      return 29976;
    }
    case 35524: {
      return 30435;
    }
    case 35525: {
      return 30475;
    }
    case 35526: {
      return 31487;
    }
    case 35527: {
      return 31649;
    }
    case 35528: {
      return 31777;
    }
    case 35529: {
      return 32233;
    }
    case 35530: {
      return 32566;
    }
    case 35531: {
      return 32752;
    }
    case 35532: {
      return 32925;
    }
    case 35533: {
      return 33382;
    }
    case 35534: {
      return 33694;
    }
    case 35535: {
      return 35251;
    }
    case 35536: {
      return 35532;
    }
    case 35537: {
      return 36011;
    }
    case 35538: {
      return 36996;
    }
    case 35539: {
      return 37969;
    }
    case 35540: {
      return 38291;
    }
    case 35541: {
      return 38289;
    }
    case 35542: {
      return 38306;
    }
    case 35543: {
      return 38501;
    }
    case 35544: {
      return 38867;
    }
    case 35545: {
      return 39208;
    }
    case 35546: {
      return 33304;
    }
    case 35547: {
      return 20024;
    }
    case 35548: {
      return 21547;
    }
    case 35549: {
      return 23736;
    }
    case 35550: {
      return 24012;
    }
    case 35551: {
      return 29609;
    }
    case 35552: {
      return 30284;
    }
    case 35553: {
      return 30524;
    }
    case 35554: {
      return 23721;
    }
    case 35555: {
      return 32747;
    }
    case 35556: {
      return 36107;
    }
    case 35557: {
      return 38593;
    }
    case 35558: {
      return 38929;
    }
    case 35559: {
      return 38996;
    }
    case 35560: {
      return 39000;
    }
    case 35561: {
      return 20225;
    }
    case 35562: {
      return 20238;
    }
    case 35563: {
      return 21361;
    }
    case 35564: {
      return 21916;
    }
    case 35565: {
      return 22120;
    }
    case 35566: {
      return 22522;
    }
    case 35567: {
      return 22855;
    }
    case 35568: {
      return 23305;
    }
    case 35569: {
      return 23492;
    }
    case 35570: {
      return 23696;
    }
    case 35571: {
      return 24076;
    }
    case 35572: {
      return 24190;
    }
    case 35573: {
      return 24524;
    }
    case 35574: {
      return 25582;
    }
    case 35575: {
      return 26426;
    }
    case 35576: {
      return 26071;
    }
    case 35577: {
      return 26082;
    }
    case 35578: {
      return 26399;
    }
    case 35579: {
      return 26827;
    }
    case 35580: {
      return 26820;
    }
    case 35648: {
      return 27231;
    }
    case 35649: {
      return 24112;
    }
    case 35650: {
      return 27589;
    }
    case 35651: {
      return 27671;
    }
    case 35652: {
      return 27773;
    }
    case 35653: {
      return 30079;
    }
    case 35654: {
      return 31048;
    }
    case 35655: {
      return 23395;
    }
    case 35656: {
      return 31232;
    }
    case 35657: {
      return 32000;
    }
    case 35658: {
      return 24509;
    }
    case 35659: {
      return 35215;
    }
    case 35660: {
      return 35352;
    }
    case 35661: {
      return 36020;
    }
    case 35662: {
      return 36215;
    }
    case 35663: {
      return 36556;
    }
    case 35664: {
      return 36637;
    }
    case 35665: {
      return 39138;
    }
    case 35666: {
      return 39438;
    }
    case 35667: {
      return 39740;
    }
    case 35668: {
      return 20096;
    }
    case 35669: {
      return 20605;
    }
    case 35670: {
      return 20736;
    }
    case 35671: {
      return 22931;
    }
    case 35672: {
      return 23452;
    }
    case 35673: {
      return 25135;
    }
    case 35674: {
      return 25216;
    }
    case 35675: {
      return 25836;
    }
    case 35676: {
      return 27450;
    }
    case 35677: {
      return 29344;
    }
    case 35678: {
      return 30097;
    }
    case 35679: {
      return 31047;
    }
    case 35680: {
      return 32681;
    }
    case 35681: {
      return 34811;
    }
    case 35682: {
      return 35516;
    }
    case 35683: {
      return 35696;
    }
    case 35684: {
      return 25516;
    }
    case 35685: {
      return 33738;
    }
    case 35686: {
      return 38816;
    }
    case 35687: {
      return 21513;
    }
    case 35688: {
      return 21507;
    }
    case 35689: {
      return 21931;
    }
    case 35690: {
      return 26708;
    }
    case 35691: {
      return 27224;
    }
    case 35692: {
      return 35440;
    }
    case 35693: {
      return 30759;
    }
    case 35694: {
      return 26485;
    }
    case 35695: {
      return 40653;
    }
    case 35696: {
      return 21364;
    }
    case 35697: {
      return 23458;
    }
    case 35698: {
      return 33050;
    }
    case 35699: {
      return 34384;
    }
    case 35700: {
      return 36870;
    }
    case 35701: {
      return 19992;
    }
    case 35702: {
      return 20037;
    }
    case 35703: {
      return 20167;
    }
    case 35704: {
      return 20241;
    }
    case 35705: {
      return 21450;
    }
    case 35706: {
      return 21560;
    }
    case 35707: {
      return 23470;
    }
    case 35708: {
      return 24339;
    }
    case 35709: {
      return 24613;
    }
    case 35710: {
      return 25937;
    }
    case 35712: {
      return 26429;
    }
    case 35713: {
      return 27714;
    }
    case 35714: {
      return 27762;
    }
    case 35715: {
      return 27875;
    }
    case 35716: {
      return 28792;
    }
    case 35717: {
      return 29699;
    }
    case 35718: {
      return 31350;
    }
    case 35719: {
      return 31406;
    }
    case 35720: {
      return 31496;
    }
    case 35721: {
      return 32026;
    }
    case 35722: {
      return 31998;
    }
    case 35723: {
      return 32102;
    }
    case 35724: {
      return 26087;
    }
    case 35725: {
      return 29275;
    }
    case 35726: {
      return 21435;
    }
    case 35727: {
      return 23621;
    }
    case 35728: {
      return 24040;
    }
    case 35729: {
      return 25298;
    }
    case 35730: {
      return 25312;
    }
    case 35731: {
      return 25369;
    }
    case 35732: {
      return 28192;
    }
    case 35733: {
      return 34394;
    }
    case 35734: {
      return 35377;
    }
    case 35735: {
      return 36317;
    }
    case 35736: {
      return 37624;
    }
    case 35737: {
      return 28417;
    }
    case 35738: {
      return 31142;
    }
    case 35739: {
      return 39770;
    }
    case 35740: {
      return 20136;
    }
    case 35741: {
      return 20139;
    }
    case 35742: {
      return 20140;
    }
    case 35743: {
      return 20379;
    }
    case 35744: {
      return 20384;
    }
    case 35745: {
      return 20689;
    }
    case 35746: {
      return 20807;
    }
    case 35747: {
      return 31478;
    }
    case 35748: {
      return 20849;
    }
    case 35749: {
      return 20982;
    }
    case 35750: {
      return 21332;
    }
    case 35751: {
      return 21281;
    }
    case 35752: {
      return 21375;
    }
    case 35753: {
      return 21483;
    }
    case 35754: {
      return 21932;
    }
    case 35755: {
      return 22659;
    }
    case 35756: {
      return 23777;
    }
    case 35757: {
      return 24375;
    }
    case 35758: {
      return 24394;
    }
    case 35759: {
      return 24623;
    }
    case 35760: {
      return 24656;
    }
    case 35761: {
      return 24685;
    }
    case 35762: {
      return 25375;
    }
    case 35763: {
      return 25945;
    }
    case 35764: {
      return 27211;
    }
    case 35765: {
      return 27841;
    }
    case 35766: {
      return 29378;
    }
    case 35767: {
      return 29421;
    }
    case 35768: {
      return 30703;
    }
    case 35769: {
      return 33016;
    }
    case 35770: {
      return 33029;
    }
    case 35771: {
      return 33288;
    }
    case 35772: {
      return 34126;
    }
    case 35773: {
      return 37111;
    }
    case 35774: {
      return 37857;
    }
    case 35775: {
      return 38911;
    }
    case 35776: {
      return 39255;
    }
    case 35777: {
      return 39514;
    }
    case 35778: {
      return 20208;
    }
    case 35779: {
      return 20957;
    }
    case 35780: {
      return 23597;
    }
    case 35781: {
      return 26241;
    }
    case 35782: {
      return 26989;
    }
    case 35783: {
      return 23616;
    }
    case 35784: {
      return 26354;
    }
    case 35785: {
      return 26997;
    }
    case 35786: {
      return 29577;
    }
    case 35787: {
      return 26704;
    }
    case 35788: {
      return 31873;
    }
    case 35789: {
      return 20677;
    }
    case 35790: {
      return 21220;
    }
    case 35791: {
      return 22343;
    }
    case 35792: {
      return 24062;
    }
    case 35793: {
      return 37670;
    }
    case 35794: {
      return 26020;
    }
    case 35795: {
      return 27427;
    }
    case 35796: {
      return 27453;
    }
    case 35797: {
      return 29748;
    }
    case 35798: {
      return 31105;
    }
    case 35799: {
      return 31165;
    }
    case 35800: {
      return 31563;
    }
    case 35801: {
      return 32202;
    }
    case 35802: {
      return 33465;
    }
    case 35803: {
      return 33740;
    }
    case 35804: {
      return 34943;
    }
    case 35805: {
      return 35167;
    }
    case 35806: {
      return 35641;
    }
    case 35807: {
      return 36817;
    }
    case 35808: {
      return 37329;
    }
    case 35809: {
      return 21535;
    }
    case 35810: {
      return 37504;
    }
    case 35811: {
      return 20061;
    }
    case 35812: {
      return 20534;
    }
    case 35813: {
      return 21477;
    }
    case 35814: {
      return 21306;
    }
    case 35815: {
      return 29399;
    }
    case 35816: {
      return 29590;
    }
    case 35817: {
      return 30697;
    }
    case 35818: {
      return 33510;
    }
    case 35819: {
      return 36527;
    }
    case 35820: {
      return 39366;
    }
    case 35821: {
      return 39368;
    }
    case 35822: {
      return 39378;
    }
    case 35823: {
      return 20855;
    }
    case 35824: {
      return 24858;
    }
    case 35825: {
      return 34398;
    }
    case 35826: {
      return 21936;
    }
    case 35827: {
      return 31354;
    }
    case 35828: {
      return 20598;
    }
    case 35829: {
      return 23507;
    }
    case 35830: {
      return 36935;
    }
    case 35831: {
      return 38533;
    }
    case 35832: {
      return 20018;
    }
    case 35833: {
      return 27355;
    }
    case 35834: {
      return 37351;
    }
    case 35835: {
      return 23633;
    }
    case 35836: {
      return 23624;
    }
    case 35904: {
      return 25496;
    }
    case 35905: {
      return 31391;
    }
    case 35906: {
      return 27795;
    }
    case 35907: {
      return 38772;
    }
    case 35908: {
      return 36705;
    }
    case 35909: {
      return 31402;
    }
    case 35910: {
      return 29066;
    }
    case 35911: {
      return 38536;
    }
    case 35912: {
      return 31874;
    }
    case 35913: {
      return 26647;
    }
    case 35914: {
      return 32368;
    }
    case 35915: {
      return 26705;
    }
    case 35916: {
      return 37740;
    }
    case 35917: {
      return 21234;
    }
    case 35918: {
      return 21531;
    }
    case 35919: {
      return 34219;
    }
    case 35920: {
      return 35347;
    }
    case 35921: {
      return 32676;
    }
    case 35922: {
      return 36557;
    }
    case 35923: {
      return 37089;
    }
    case 35924: {
      return 21350;
    }
    case 35925: {
      return 34952;
    }
    case 35926: {
      return 31041;
    }
    case 35927: {
      return 20418;
    }
    case 35928: {
      return 20670;
    }
    case 35929: {
      return 21009;
    }
    case 35930: {
      return 20804;
    }
    case 35931: {
      return 21843;
    }
    case 35932: {
      return 22317;
    }
    case 35933: {
      return 29674;
    }
    case 35934: {
      return 22411;
    }
    case 35935: {
      return 22865;
    }
    case 35936: {
      return 24418;
    }
    case 35937: {
      return 24452;
    }
    case 35938: {
      return 24693;
    }
    case 35939: {
      return 24950;
    }
    case 35940: {
      return 24935;
    }
    case 35941: {
      return 25001;
    }
    case 35942: {
      return 25522;
    }
    case 35943: {
      return 25658;
    }
    case 35944: {
      return 25964;
    }
    case 35945: {
      return 26223;
    }
    case 35946: {
      return 26690;
    }
    case 35947: {
      return 28179;
    }
    case 35948: {
      return 30054;
    }
    case 35949: {
      return 31293;
    }
    case 35950: {
      return 31995;
    }
    case 35951: {
      return 32076;
    }
    case 35952: {
      return 32153;
    }
    case 35953: {
      return 32331;
    }
    case 35954: {
      return 32619;
    }
    case 35955: {
      return 33550;
    }
    case 35956: {
      return 33610;
    }
    case 35957: {
      return 34509;
    }
    case 35958: {
      return 35336;
    }
    case 35959: {
      return 35427;
    }
    case 35960: {
      return 35686;
    }
    case 35961: {
      return 36605;
    }
    case 35962: {
      return 38938;
    }
    case 35963: {
      return 40335;
    }
    case 35964: {
      return 33464;
    }
    case 35965: {
      return 36814;
    }
    case 35966: {
      return 39912;
    }
    case 35968: {
      return 21127;
    }
    case 35969: {
      return 25119;
    }
    case 35970: {
      return 25731;
    }
    case 35971: {
      return 28608;
    }
    case 35972: {
      return 38553;
    }
    case 35973: {
      return 26689;
    }
    case 35974: {
      return 20625;
    }
    case 35975: {
      return 27424;
    }
    case 35976: {
      return 27770;
    }
    case 35977: {
      return 28500;
    }
    case 35978: {
      return 31348;
    }
    case 35979: {
      return 32080;
    }
    case 35980: {
      return 34880;
    }
    case 35981: {
      return 35363;
    }
    case 35982: {
      return 26376;
    }
    case 35983: {
      return 20214;
    }
    case 35984: {
      return 20537;
    }
    case 35985: {
      return 20518;
    }
    case 35986: {
      return 20581;
    }
    case 35987: {
      return 20860;
    }
    case 35988: {
      return 21048;
    }
    case 35989: {
      return 21091;
    }
    case 35990: {
      return 21927;
    }
    case 35991: {
      return 22287;
    }
    case 35992: {
      return 22533;
    }
    case 35993: {
      return 23244;
    }
    case 35994: {
      return 24314;
    }
    case 35995: {
      return 25010;
    }
    case 35996: {
      return 25080;
    }
    case 35997: {
      return 25331;
    }
    case 35998: {
      return 25458;
    }
    case 35999: {
      return 26908;
    }
    case 36000: {
      return 27177;
    }
    case 36001: {
      return 29309;
    }
    case 36002: {
      return 29356;
    }
    case 36003: {
      return 29486;
    }
    case 36004: {
      return 30740;
    }
    case 36005: {
      return 30831;
    }
    case 36006: {
      return 32121;
    }
    case 36007: {
      return 30476;
    }
    case 36008: {
      return 32937;
    }
    case 36009: {
      return 35211;
    }
    case 36010: {
      return 35609;
    }
    case 36011: {
      return 36066;
    }
    case 36012: {
      return 36562;
    }
    case 36013: {
      return 36963;
    }
    case 36014: {
      return 37749;
    }
    case 36015: {
      return 38522;
    }
    case 36016: {
      return 38997;
    }
    case 36017: {
      return 39443;
    }
    case 36018: {
      return 40568;
    }
    case 36019: {
      return 20803;
    }
    case 36020: {
      return 21407;
    }
    case 36021: {
      return 21427;
    }
    case 36022: {
      return 24187;
    }
    case 36023: {
      return 24358;
    }
    case 36024: {
      return 28187;
    }
    case 36025: {
      return 28304;
    }
    case 36026: {
      return 29572;
    }
    case 36027: {
      return 29694;
    }
    case 36028: {
      return 32067;
    }
    case 36029: {
      return 33335;
    }
    case 36030: {
      return 35328;
    }
    case 36031: {
      return 35578;
    }
    case 36032: {
      return 38480;
    }
    case 36033: {
      return 20046;
    }
    case 36034: {
      return 20491;
    }
    case 36035: {
      return 21476;
    }
    case 36036: {
      return 21628;
    }
    case 36037: {
      return 22266;
    }
    case 36038: {
      return 22993;
    }
    case 36039: {
      return 23396;
    }
    case 36040: {
      return 24049;
    }
    case 36041: {
      return 24235;
    }
    case 36042: {
      return 24359;
    }
    case 36043: {
      return 25144;
    }
    case 36044: {
      return 25925;
    }
    case 36045: {
      return 26543;
    }
    case 36046: {
      return 28246;
    }
    case 36047: {
      return 29392;
    }
    case 36048: {
      return 31946;
    }
    case 36049: {
      return 34996;
    }
    case 36050: {
      return 32929;
    }
    case 36051: {
      return 32993;
    }
    case 36052: {
      return 33776;
    }
    case 36053: {
      return 34382;
    }
    case 36054: {
      return 35463;
    }
    case 36055: {
      return 36328;
    }
    case 36056: {
      return 37431;
    }
    case 36057: {
      return 38599;
    }
    case 36058: {
      return 39015;
    }
    case 36059: {
      return 40723;
    }
    case 36060: {
      return 20116;
    }
    case 36061: {
      return 20114;
    }
    case 36062: {
      return 20237;
    }
    case 36063: {
      return 21320;
    }
    case 36064: {
      return 21577;
    }
    case 36065: {
      return 21566;
    }
    case 36066: {
      return 23087;
    }
    case 36067: {
      return 24460;
    }
    case 36068: {
      return 24481;
    }
    case 36069: {
      return 24735;
    }
    case 36070: {
      return 26791;
    }
    case 36071: {
      return 27278;
    }
    case 36072: {
      return 29786;
    }
    case 36073: {
      return 30849;
    }
    case 36074: {
      return 35486;
    }
    case 36075: {
      return 35492;
    }
    case 36076: {
      return 35703;
    }
    case 36077: {
      return 37264;
    }
    case 36078: {
      return 20062;
    }
    case 36079: {
      return 39881;
    }
    case 36080: {
      return 20132;
    }
    case 36081: {
      return 20348;
    }
    case 36082: {
      return 20399;
    }
    case 36083: {
      return 20505;
    }
    case 36084: {
      return 20502;
    }
    case 36085: {
      return 20809;
    }
    case 36086: {
      return 20844;
    }
    case 36087: {
      return 21151;
    }
    case 36088: {
      return 21177;
    }
    case 36089: {
      return 21246;
    }
    case 36090: {
      return 21402;
    }
    case 36091: {
      return 21475;
    }
    case 36092: {
      return 21521;
    }
    case 36160: {
      return 21518;
    }
    case 36161: {
      return 21897;
    }
    case 36162: {
      return 22353;
    }
    case 36163: {
      return 22434;
    }
    case 36164: {
      return 22909;
    }
    case 36165: {
      return 23380;
    }
    case 36166: {
      return 23389;
    }
    case 36167: {
      return 23439;
    }
    case 36168: {
      return 24037;
    }
    case 36169: {
      return 24039;
    }
    case 36170: {
      return 24055;
    }
    case 36171: {
      return 24184;
    }
    case 36172: {
      return 24195;
    }
    case 36173: {
      return 24218;
    }
    case 36174: {
      return 24247;
    }
    case 36175: {
      return 24344;
    }
    case 36176: {
      return 24658;
    }
    case 36177: {
      return 24908;
    }
    case 36178: {
      return 25239;
    }
    case 36179: {
      return 25304;
    }
    case 36180: {
      return 25511;
    }
    case 36181: {
      return 25915;
    }
    case 36182: {
      return 26114;
    }
    case 36183: {
      return 26179;
    }
    case 36184: {
      return 26356;
    }
    case 36185: {
      return 26477;
    }
    case 36186: {
      return 26657;
    }
    case 36187: {
      return 26775;
    }
    case 36188: {
      return 27083;
    }
    case 36189: {
      return 27743;
    }
    case 36190: {
      return 27946;
    }
    case 36191: {
      return 28009;
    }
    case 36192: {
      return 28207;
    }
    case 36193: {
      return 28317;
    }
    case 36194: {
      return 30002;
    }
    case 36195: {
      return 30343;
    }
    case 36196: {
      return 30828;
    }
    case 36197: {
      return 31295;
    }
    case 36198: {
      return 31968;
    }
    case 36199: {
      return 32005;
    }
    case 36200: {
      return 32024;
    }
    case 36201: {
      return 32094;
    }
    case 36202: {
      return 32177;
    }
    case 36203: {
      return 32789;
    }
    case 36204: {
      return 32771;
    }
    case 36205: {
      return 32943;
    }
    case 36206: {
      return 32945;
    }
    case 36207: {
      return 33108;
    }
    case 36208: {
      return 33167;
    }
    case 36209: {
      return 33322;
    }
    case 36210: {
      return 33618;
    }
    case 36211: {
      return 34892;
    }
    case 36212: {
      return 34913;
    }
    case 36213: {
      return 35611;
    }
    case 36214: {
      return 36002;
    }
    case 36215: {
      return 36092;
    }
    case 36216: {
      return 37066;
    }
    case 36217: {
      return 37237;
    }
    case 36218: {
      return 37489;
    }
    case 36219: {
      return 30783;
    }
    case 36220: {
      return 37628;
    }
    case 36221: {
      return 38308;
    }
    case 36222: {
      return 38477;
    }
    case 36224: {
      return 38917;
    }
    case 36225: {
      return 39321;
    }
    case 36226: {
      return 39640;
    }
    case 36227: {
      return 40251;
    }
    case 36228: {
      return 21083;
    }
    case 36229: {
      return 21163;
    }
    case 36230: {
      return 21495;
    }
    case 36231: {
      return 21512;
    }
    case 36232: {
      return 22741;
    }
    case 36233: {
      return 25335;
    }
    case 36234: {
      return 28640;
    }
    case 36235: {
      return 35946;
    }
    case 36236: {
      return 36703;
    }
    case 36237: {
      return 40633;
    }
    case 36238: {
      return 20811;
    }
    case 36239: {
      return 21051;
    }
    case 36240: {
      return 21578;
    }
    case 36241: {
      return 22269;
    }
    case 36242: {
      return 31296;
    }
    case 36243: {
      return 37239;
    }
    case 36244: {
      return 40288;
    }
    case 36245: {
      return 40658;
    }
    case 36246: {
      return 29508;
    }
    case 36247: {
      return 28425;
    }
    case 36248: {
      return 33136;
    }
    case 36249: {
      return 29969;
    }
    case 36250: {
      return 24573;
    }
    case 36251: {
      return 24794;
    }
    case 36252: {
      return 39592;
    }
    case 36253: {
      return 29403;
    }
    case 36254: {
      return 36796;
    }
    case 36255: {
      return 27492;
    }
    case 36256: {
      return 38915;
    }
    case 36257: {
      return 20170;
    }
    case 36258: {
      return 22256;
    }
    case 36259: {
      return 22372;
    }
    case 36260: {
      return 22718;
    }
    case 36261: {
      return 23130;
    }
    case 36262: {
      return 24680;
    }
    case 36263: {
      return 25031;
    }
    case 36264: {
      return 26127;
    }
    case 36265: {
      return 26118;
    }
    case 36266: {
      return 26681;
    }
    case 36267: {
      return 26801;
    }
    case 36268: {
      return 28151;
    }
    case 36269: {
      return 30165;
    }
    case 36270: {
      return 32058;
    }
    case 36271: {
      return 33390;
    }
    case 36272: {
      return 39746;
    }
    case 36273: {
      return 20123;
    }
    case 36274: {
      return 20304;
    }
    case 36275: {
      return 21449;
    }
    case 36276: {
      return 21766;
    }
    case 36277: {
      return 23919;
    }
    case 36278: {
      return 24038;
    }
    case 36279: {
      return 24046;
    }
    case 36280: {
      return 26619;
    }
    case 36281: {
      return 27801;
    }
    case 36282: {
      return 29811;
    }
    case 36283: {
      return 30722;
    }
    case 36284: {
      return 35408;
    }
    case 36285: {
      return 37782;
    }
    case 36286: {
      return 35039;
    }
    case 36287: {
      return 22352;
    }
    case 36288: {
      return 24231;
    }
    case 36289: {
      return 25387;
    }
    case 36290: {
      return 20661;
    }
    case 36291: {
      return 20652;
    }
    case 36292: {
      return 20877;
    }
    case 36293: {
      return 26368;
    }
    case 36294: {
      return 21705;
    }
    case 36295: {
      return 22622;
    }
    case 36296: {
      return 22971;
    }
    case 36297: {
      return 23472;
    }
    case 36298: {
      return 24425;
    }
    case 36299: {
      return 25165;
    }
    case 36300: {
      return 25505;
    }
    case 36301: {
      return 26685;
    }
    case 36302: {
      return 27507;
    }
    case 36303: {
      return 28168;
    }
    case 36304: {
      return 28797;
    }
    case 36305: {
      return 37319;
    }
    case 36306: {
      return 29312;
    }
    case 36307: {
      return 30741;
    }
    case 36308: {
      return 30758;
    }
    case 36309: {
      return 31085;
    }
    case 36310: {
      return 25998;
    }
    case 36311: {
      return 32048;
    }
    case 36312: {
      return 33756;
    }
    case 36313: {
      return 35009;
    }
    case 36314: {
      return 36617;
    }
    case 36315: {
      return 38555;
    }
    case 36316: {
      return 21092;
    }
    case 36317: {
      return 22312;
    }
    case 36318: {
      return 26448;
    }
    case 36319: {
      return 32618;
    }
    case 36320: {
      return 36001;
    }
    case 36321: {
      return 20916;
    }
    case 36322: {
      return 22338;
    }
    case 36323: {
      return 38442;
    }
    case 36324: {
      return 22586;
    }
    case 36325: {
      return 27018;
    }
    case 36326: {
      return 32948;
    }
    case 36327: {
      return 21682;
    }
    case 36328: {
      return 23822;
    }
    case 36329: {
      return 22524;
    }
    case 36330: {
      return 30869;
    }
    case 36331: {
      return 40442;
    }
    case 36332: {
      return 20316;
    }
    case 36333: {
      return 21066;
    }
    case 36334: {
      return 21643;
    }
    case 36335: {
      return 25662;
    }
    case 36336: {
      return 26152;
    }
    case 36337: {
      return 26388;
    }
    case 36338: {
      return 26613;
    }
    case 36339: {
      return 31364;
    }
    case 36340: {
      return 31574;
    }
    case 36341: {
      return 32034;
    }
    case 36342: {
      return 37679;
    }
    case 36343: {
      return 26716;
    }
    case 36344: {
      return 39853;
    }
    case 36345: {
      return 31545;
    }
    case 36346: {
      return 21273;
    }
    case 36347: {
      return 20874;
    }
    case 36348: {
      return 21047;
    }
    case 36416: {
      return 23519;
    }
    case 36417: {
      return 25334;
    }
    case 36418: {
      return 25774;
    }
    case 36419: {
      return 25830;
    }
    case 36420: {
      return 26413;
    }
    case 36421: {
      return 27578;
    }
    case 36422: {
      return 34217;
    }
    case 36423: {
      return 38609;
    }
    case 36424: {
      return 30352;
    }
    case 36425: {
      return 39894;
    }
    case 36426: {
      return 25420;
    }
    case 36427: {
      return 37638;
    }
    case 36428: {
      return 39851;
    }
    case 36429: {
      return 30399;
    }
    case 36430: {
      return 26194;
    }
    case 36431: {
      return 19977;
    }
    case 36432: {
      return 20632;
    }
    case 36433: {
      return 21442;
    }
    case 36434: {
      return 23665;
    }
    case 36435: {
      return 24808;
    }
    case 36436: {
      return 25746;
    }
    case 36437: {
      return 25955;
    }
    case 36438: {
      return 26719;
    }
    case 36439: {
      return 29158;
    }
    case 36440: {
      return 29642;
    }
    case 36441: {
      return 29987;
    }
    case 36442: {
      return 31639;
    }
    case 36443: {
      return 32386;
    }
    case 36444: {
      return 34453;
    }
    case 36445: {
      return 35715;
    }
    case 36446: {
      return 36059;
    }
    case 36447: {
      return 37240;
    }
    case 36448: {
      return 39184;
    }
    case 36449: {
      return 26028;
    }
    case 36450: {
      return 26283;
    }
    case 36451: {
      return 27531;
    }
    case 36452: {
      return 20181;
    }
    case 36453: {
      return 20180;
    }
    case 36454: {
      return 20282;
    }
    case 36455: {
      return 20351;
    }
    case 36456: {
      return 21050;
    }
    case 36457: {
      return 21496;
    }
    case 36458: {
      return 21490;
    }
    case 36459: {
      return 21987;
    }
    case 36460: {
      return 22235;
    }
    case 36461: {
      return 22763;
    }
    case 36462: {
      return 22987;
    }
    case 36463: {
      return 22985;
    }
    case 36464: {
      return 23039;
    }
    case 36465: {
      return 23376;
    }
    case 36466: {
      return 23629;
    }
    case 36467: {
      return 24066;
    }
    case 36468: {
      return 24107;
    }
    case 36469: {
      return 24535;
    }
    case 36470: {
      return 24605;
    }
    case 36471: {
      return 25351;
    }
    case 36472: {
      return 25903;
    }
    case 36473: {
      return 23388;
    }
    case 36474: {
      return 26031;
    }
    case 36475: {
      return 26045;
    }
    case 36476: {
      return 26088;
    }
    case 36477: {
      return 26525;
    }
    case 36478: {
      return 27490;
    }
    case 36480: {
      return 27515;
    }
    case 36481: {
      return 27663;
    }
    case 36482: {
      return 29509;
    }
    case 36483: {
      return 31049;
    }
    case 36484: {
      return 31169;
    }
    case 36485: {
      return 31992;
    }
    case 36486: {
      return 32025;
    }
    case 36487: {
      return 32043;
    }
    case 36488: {
      return 32930;
    }
    case 36489: {
      return 33026;
    }
    case 36490: {
      return 33267;
    }
    case 36491: {
      return 35222;
    }
    case 36492: {
      return 35422;
    }
    case 36493: {
      return 35433;
    }
    case 36494: {
      return 35430;
    }
    case 36495: {
      return 35468;
    }
    case 36496: {
      return 35566;
    }
    case 36497: {
      return 36039;
    }
    case 36498: {
      return 36060;
    }
    case 36499: {
      return 38604;
    }
    case 36500: {
      return 39164;
    }
    case 36501: {
      return 27503;
    }
    case 36502: {
      return 20107;
    }
    case 36503: {
      return 20284;
    }
    case 36504: {
      return 20365;
    }
    case 36505: {
      return 20816;
    }
    case 36506: {
      return 23383;
    }
    case 36507: {
      return 23546;
    }
    case 36508: {
      return 24904;
    }
    case 36509: {
      return 25345;
    }
    case 36510: {
      return 26178;
    }
    case 36511: {
      return 27425;
    }
    case 36512: {
      return 28363;
    }
    case 36513: {
      return 27835;
    }
    case 36514: {
      return 29246;
    }
    case 36515: {
      return 29885;
    }
    case 36516: {
      return 30164;
    }
    case 36517: {
      return 30913;
    }
    case 36518: {
      return 31034;
    }
    case 36519: {
      return 32780;
    }
    case 36520: {
      return 32819;
    }
    case 36521: {
      return 33258;
    }
    case 36522: {
      return 33940;
    }
    case 36523: {
      return 36766;
    }
    case 36524: {
      return 27728;
    }
    case 36525: {
      return 40575;
    }
    case 36526: {
      return 24335;
    }
    case 36527: {
      return 35672;
    }
    case 36528: {
      return 40235;
    }
    case 36529: {
      return 31482;
    }
    case 36530: {
      return 36600;
    }
    case 36531: {
      return 23437;
    }
    case 36532: {
      return 38635;
    }
    case 36533: {
      return 19971;
    }
    case 36534: {
      return 21489;
    }
    case 36535: {
      return 22519;
    }
    case 36536: {
      return 22833;
    }
    case 36537: {
      return 23241;
    }
    case 36538: {
      return 23460;
    }
    case 36539: {
      return 24713;
    }
    case 36540: {
      return 28287;
    }
    case 36541: {
      return 28422;
    }
    case 36542: {
      return 30142;
    }
    case 36543: {
      return 36074;
    }
    case 36544: {
      return 23455;
    }
    case 36545: {
      return 34048;
    }
    case 36546: {
      return 31712;
    }
    case 36547: {
      return 20594;
    }
    case 36548: {
      return 26612;
    }
    case 36549: {
      return 33437;
    }
    case 36550: {
      return 23649;
    }
    case 36551: {
      return 34122;
    }
    case 36552: {
      return 32286;
    }
    case 36553: {
      return 33294;
    }
    case 36554: {
      return 20889;
    }
    case 36555: {
      return 23556;
    }
    case 36556: {
      return 25448;
    }
    case 36557: {
      return 36198;
    }
    case 36558: {
      return 26012;
    }
    case 36559: {
      return 29038;
    }
    case 36560: {
      return 31038;
    }
    case 36561: {
      return 32023;
    }
    case 36562: {
      return 32773;
    }
    case 36563: {
      return 35613;
    }
    case 36564: {
      return 36554;
    }
    case 36565: {
      return 36974;
    }
    case 36566: {
      return 34503;
    }
    case 36567: {
      return 37034;
    }
    case 36568: {
      return 20511;
    }
    case 36569: {
      return 21242;
    }
    case 36570: {
      return 23610;
    }
    case 36571: {
      return 26451;
    }
    case 36572: {
      return 28796;
    }
    case 36573: {
      return 29237;
    }
    case 36574: {
      return 37196;
    }
    case 36575: {
      return 37320;
    }
    case 36576: {
      return 37675;
    }
    case 36577: {
      return 33509;
    }
    case 36578: {
      return 23490;
    }
    case 36579: {
      return 24369;
    }
    case 36580: {
      return 24825;
    }
    case 36581: {
      return 20027;
    }
    case 36582: {
      return 21462;
    }
    case 36583: {
      return 23432;
    }
    case 36584: {
      return 25163;
    }
    case 36585: {
      return 26417;
    }
    case 36586: {
      return 27530;
    }
    case 36587: {
      return 29417;
    }
    case 36588: {
      return 29664;
    }
    case 36589: {
      return 31278;
    }
    case 36590: {
      return 33131;
    }
    case 36591: {
      return 36259;
    }
    case 36592: {
      return 37202;
    }
    case 36593: {
      return 39318;
    }
    case 36594: {
      return 20754;
    }
    case 36595: {
      return 21463;
    }
    case 36596: {
      return 21610;
    }
    case 36597: {
      return 23551;
    }
    case 36598: {
      return 25480;
    }
    case 36599: {
      return 27193;
    }
    case 36600: {
      return 32172;
    }
    case 36601: {
      return 38656;
    }
    case 36602: {
      return 22234;
    }
    case 36603: {
      return 21454;
    }
    case 36604: {
      return 21608;
    }
    case 36672: {
      return 23447;
    }
    case 36673: {
      return 23601;
    }
    case 36674: {
      return 24030;
    }
    case 36675: {
      return 20462;
    }
    case 36676: {
      return 24833;
    }
    case 36677: {
      return 25342;
    }
    case 36678: {
      return 27954;
    }
    case 36679: {
      return 31168;
    }
    case 36680: {
      return 31179;
    }
    case 36681: {
      return 32066;
    }
    case 36682: {
      return 32333;
    }
    case 36683: {
      return 32722;
    }
    case 36684: {
      return 33261;
    }
    case 36685: {
      return 33311;
    }
    case 36686: {
      return 33936;
    }
    case 36687: {
      return 34886;
    }
    case 36688: {
      return 35186;
    }
    case 36689: {
      return 35728;
    }
    case 36690: {
      return 36468;
    }
    case 36691: {
      return 36655;
    }
    case 36692: {
      return 36913;
    }
    case 36693: {
      return 37195;
    }
    case 36694: {
      return 37228;
    }
    case 36695: {
      return 38598;
    }
    case 36696: {
      return 37276;
    }
    case 36697: {
      return 20160;
    }
    case 36698: {
      return 20303;
    }
    case 36699: {
      return 20805;
    }
    case 36700: {
      return 21313;
    }
    case 36701: {
      return 24467;
    }
    case 36702: {
      return 25102;
    }
    case 36703: {
      return 26580;
    }
    case 36704: {
      return 27713;
    }
    case 36705: {
      return 28171;
    }
    case 36706: {
      return 29539;
    }
    case 36707: {
      return 32294;
    }
    case 36708: {
      return 37325;
    }
    case 36709: {
      return 37507;
    }
    case 36710: {
      return 21460;
    }
    case 36711: {
      return 22809;
    }
    case 36712: {
      return 23487;
    }
    case 36713: {
      return 28113;
    }
    case 36714: {
      return 31069;
    }
    case 36715: {
      return 32302;
    }
    case 36716: {
      return 31899;
    }
    case 36717: {
      return 22654;
    }
    case 36718: {
      return 29087;
    }
    case 36719: {
      return 20986;
    }
    case 36720: {
      return 34899;
    }
    case 36721: {
      return 36848;
    }
    case 36722: {
      return 20426;
    }
    case 36723: {
      return 23803;
    }
    case 36724: {
      return 26149;
    }
    case 36725: {
      return 30636;
    }
    case 36726: {
      return 31459;
    }
    case 36727: {
      return 33308;
    }
    case 36728: {
      return 39423;
    }
    case 36729: {
      return 20934;
    }
    case 36730: {
      return 24490;
    }
    case 36731: {
      return 26092;
    }
    case 36732: {
      return 26991;
    }
    case 36733: {
      return 27529;
    }
    case 36734: {
      return 28147;
    }
    case 36736: {
      return 28310;
    }
    case 36737: {
      return 28516;
    }
    case 36738: {
      return 30462;
    }
    case 36739: {
      return 32020;
    }
    case 36740: {
      return 24033;
    }
    case 36741: {
      return 36981;
    }
    case 36742: {
      return 37255;
    }
    case 36743: {
      return 38918;
    }
    case 36744: {
      return 20966;
    }
    case 36745: {
      return 21021;
    }
    case 36746: {
      return 25152;
    }
    case 36747: {
      return 26257;
    }
    case 36748: {
      return 26329;
    }
    case 36749: {
      return 28186;
    }
    case 36750: {
      return 24246;
    }
    case 36751: {
      return 32210;
    }
    case 36752: {
      return 32626;
    }
    case 36753: {
      return 26360;
    }
    case 36754: {
      return 34223;
    }
    case 36755: {
      return 34295;
    }
    case 36756: {
      return 35576;
    }
    case 36757: {
      return 21161;
    }
    case 36758: {
      return 21465;
    }
    case 36759: {
      return 22899;
    }
    case 36760: {
      return 24207;
    }
    case 36761: {
      return 24464;
    }
    case 36762: {
      return 24661;
    }
    case 36763: {
      return 37604;
    }
    case 36764: {
      return 38500;
    }
    case 36765: {
      return 20663;
    }
    case 36766: {
      return 20767;
    }
    case 36767: {
      return 21213;
    }
    case 36768: {
      return 21280;
    }
    case 36769: {
      return 21319;
    }
    case 36770: {
      return 21484;
    }
    case 36771: {
      return 21736;
    }
    case 36772: {
      return 21830;
    }
    case 36773: {
      return 21809;
    }
    case 36774: {
      return 22039;
    }
    case 36775: {
      return 22888;
    }
    case 36776: {
      return 22974;
    }
    case 36777: {
      return 23100;
    }
    case 36778: {
      return 23477;
    }
    case 36779: {
      return 23558;
    }
    case 36780: {
      return 23567;
    }
    case 36781: {
      return 23569;
    }
    case 36782: {
      return 23578;
    }
    case 36783: {
      return 24196;
    }
    case 36784: {
      return 24202;
    }
    case 36785: {
      return 24288;
    }
    case 36786: {
      return 24432;
    }
    case 36787: {
      return 25215;
    }
    case 36788: {
      return 25220;
    }
    case 36789: {
      return 25307;
    }
    case 36790: {
      return 25484;
    }
    case 36791: {
      return 25463;
    }
    case 36792: {
      return 26119;
    }
    case 36793: {
      return 26124;
    }
    case 36794: {
      return 26157;
    }
    case 36795: {
      return 26230;
    }
    case 36796: {
      return 26494;
    }
    case 36797: {
      return 26786;
    }
    case 36798: {
      return 27167;
    }
    case 36799: {
      return 27189;
    }
    case 36800: {
      return 27836;
    }
    case 36801: {
      return 28040;
    }
    case 36802: {
      return 28169;
    }
    case 36803: {
      return 28248;
    }
    case 36804: {
      return 28988;
    }
    case 36805: {
      return 28966;
    }
    case 36806: {
      return 29031;
    }
    case 36807: {
      return 30151;
    }
    case 36808: {
      return 30465;
    }
    case 36809: {
      return 30813;
    }
    case 36810: {
      return 30977;
    }
    case 36811: {
      return 31077;
    }
    case 36812: {
      return 31216;
    }
    case 36813: {
      return 31456;
    }
    case 36814: {
      return 31505;
    }
    case 36815: {
      return 31911;
    }
    case 36816: {
      return 32057;
    }
    case 36817: {
      return 32918;
    }
    case 36818: {
      return 33750;
    }
    case 36819: {
      return 33931;
    }
    case 36820: {
      return 34121;
    }
    case 36821: {
      return 34909;
    }
    case 36822: {
      return 35059;
    }
    case 36823: {
      return 35359;
    }
    case 36824: {
      return 35388;
    }
    case 36825: {
      return 35412;
    }
    case 36826: {
      return 35443;
    }
    case 36827: {
      return 35937;
    }
    case 36828: {
      return 36062;
    }
    case 36829: {
      return 37284;
    }
    case 36830: {
      return 37478;
    }
    case 36831: {
      return 37758;
    }
    case 36832: {
      return 37912;
    }
    case 36833: {
      return 38556;
    }
    case 36834: {
      return 38808;
    }
    case 36835: {
      return 19978;
    }
    case 36836: {
      return 19976;
    }
    case 36837: {
      return 19998;
    }
    case 36838: {
      return 20055;
    }
    case 36839: {
      return 20887;
    }
    case 36840: {
      return 21104;
    }
    case 36841: {
      return 22478;
    }
    case 36842: {
      return 22580;
    }
    case 36843: {
      return 22732;
    }
    case 36844: {
      return 23330;
    }
    case 36845: {
      return 24120;
    }
    case 36846: {
      return 24773;
    }
    case 36847: {
      return 25854;
    }
    case 36848: {
      return 26465;
    }
    case 36849: {
      return 26454;
    }
    case 36850: {
      return 27972;
    }
    case 36851: {
      return 29366;
    }
    case 36852: {
      return 30067;
    }
    case 36853: {
      return 31331;
    }
    case 36854: {
      return 33976;
    }
    case 36855: {
      return 35698;
    }
    case 36856: {
      return 37304;
    }
    case 36857: {
      return 37664;
    }
    case 36858: {
      return 22065;
    }
    case 36859: {
      return 22516;
    }
    case 36860: {
      return 39166;
    }
    case 36928: {
      return 25325;
    }
    case 36929: {
      return 26893;
    }
    case 36930: {
      return 27542;
    }
    case 36931: {
      return 29165;
    }
    case 36932: {
      return 32340;
    }
    case 36933: {
      return 32887;
    }
    case 36934: {
      return 33394;
    }
    case 36935: {
      return 35302;
    }
    case 36936: {
      return 39135;
    }
    case 36937: {
      return 34645;
    }
    case 36938: {
      return 36785;
    }
    case 36939: {
      return 23611;
    }
    case 36940: {
      return 20280;
    }
    case 36941: {
      return 20449;
    }
    case 36942: {
      return 20405;
    }
    case 36943: {
      return 21767;
    }
    case 36944: {
      return 23072;
    }
    case 36945: {
      return 23517;
    }
    case 36946: {
      return 23529;
    }
    case 36947: {
      return 24515;
    }
    case 36948: {
      return 24910;
    }
    case 36949: {
      return 25391;
    }
    case 36950: {
      return 26032;
    }
    case 36951: {
      return 26187;
    }
    case 36952: {
      return 26862;
    }
    case 36953: {
      return 27035;
    }
    case 36954: {
      return 28024;
    }
    case 36955: {
      return 28145;
    }
    case 36956: {
      return 30003;
    }
    case 36957: {
      return 30137;
    }
    case 36958: {
      return 30495;
    }
    case 36959: {
      return 31070;
    }
    case 36960: {
      return 31206;
    }
    case 36961: {
      return 32051;
    }
    case 36962: {
      return 33251;
    }
    case 36963: {
      return 33455;
    }
    case 36964: {
      return 34218;
    }
    case 36965: {
      return 35242;
    }
    case 36966: {
      return 35386;
    }
    case 36967: {
      return 36523;
    }
    case 36968: {
      return 36763;
    }
    case 36969: {
      return 36914;
    }
    case 36970: {
      return 37341;
    }
    case 36971: {
      return 38663;
    }
    case 36972: {
      return 20154;
    }
    case 36973: {
      return 20161;
    }
    case 36974: {
      return 20995;
    }
    case 36975: {
      return 22645;
    }
    case 36976: {
      return 22764;
    }
    case 36977: {
      return 23563;
    }
    case 36978: {
      return 29978;
    }
    case 36979: {
      return 23613;
    }
    case 36980: {
      return 33102;
    }
    case 36981: {
      return 35338;
    }
    case 36982: {
      return 36805;
    }
    case 36983: {
      return 38499;
    }
    case 36984: {
      return 38765;
    }
    case 36985: {
      return 31525;
    }
    case 36986: {
      return 35535;
    }
    case 36987: {
      return 38920;
    }
    case 36988: {
      return 37218;
    }
    case 36989: {
      return 22259;
    }
    case 36990: {
      return 21416;
    }
    case 36992: {
      return 36887;
    }
    case 36993: {
      return 21561;
    }
    case 36994: {
      return 22402;
    }
    case 36995: {
      return 24101;
    }
    case 36996: {
      return 25512;
    }
    case 36997: {
      return 27700;
    }
    case 36998: {
      return 28810;
    }
    case 36999: {
      return 30561;
    }
    case 37000: {
      return 31883;
    }
    case 37001: {
      return 32736;
    }
    case 37002: {
      return 34928;
    }
    case 37003: {
      return 36930;
    }
    case 37004: {
      return 37204;
    }
    case 37005: {
      return 37648;
    }
    case 37006: {
      return 37656;
    }
    case 37007: {
      return 38543;
    }
    case 37008: {
      return 29790;
    }
    case 37009: {
      return 39620;
    }
    case 37010: {
      return 23815;
    }
    case 37011: {
      return 23913;
    }
    case 37012: {
      return 25968;
    }
    case 37013: {
      return 26530;
    }
    case 37014: {
      return 36264;
    }
    case 37015: {
      return 38619;
    }
    case 37016: {
      return 25454;
    }
    case 37017: {
      return 26441;
    }
    case 37018: {
      return 26905;
    }
    case 37019: {
      return 33733;
    }
    case 37020: {
      return 38935;
    }
    case 37021: {
      return 38592;
    }
    case 37022: {
      return 35070;
    }
    case 37023: {
      return 28548;
    }
    case 37024: {
      return 25722;
    }
    case 37025: {
      return 23544;
    }
    case 37026: {
      return 19990;
    }
    case 37027: {
      return 28716;
    }
    case 37028: {
      return 30045;
    }
    case 37029: {
      return 26159;
    }
    case 37030: {
      return 20932;
    }
    case 37031: {
      return 21046;
    }
    case 37032: {
      return 21218;
    }
    case 37033: {
      return 22995;
    }
    case 37034: {
      return 24449;
    }
    case 37035: {
      return 24615;
    }
    case 37036: {
      return 25104;
    }
    case 37037: {
      return 25919;
    }
    case 37038: {
      return 25972;
    }
    case 37039: {
      return 26143;
    }
    case 37040: {
      return 26228;
    }
    case 37041: {
      return 26866;
    }
    case 37042: {
      return 26646;
    }
    case 37043: {
      return 27491;
    }
    case 37044: {
      return 28165;
    }
    case 37045: {
      return 29298;
    }
    case 37046: {
      return 29983;
    }
    case 37047: {
      return 30427;
    }
    case 37048: {
      return 31934;
    }
    case 37049: {
      return 32854;
    }
    case 37050: {
      return 22768;
    }
    case 37051: {
      return 35069;
    }
    case 37052: {
      return 35199;
    }
    case 37053: {
      return 35488;
    }
    case 37054: {
      return 35475;
    }
    case 37055: {
      return 35531;
    }
    case 37056: {
      return 36893;
    }
    case 37057: {
      return 37266;
    }
    case 37058: {
      return 38738;
    }
    case 37059: {
      return 38745;
    }
    case 37060: {
      return 25993;
    }
    case 37061: {
      return 31246;
    }
    case 37062: {
      return 33030;
    }
    case 37063: {
      return 38587;
    }
    case 37064: {
      return 24109;
    }
    case 37065: {
      return 24796;
    }
    case 37066: {
      return 25114;
    }
    case 37067: {
      return 26021;
    }
    case 37068: {
      return 26132;
    }
    case 37069: {
      return 26512;
    }
    case 37070: {
      return 30707;
    }
    case 37071: {
      return 31309;
    }
    case 37072: {
      return 31821;
    }
    case 37073: {
      return 32318;
    }
    case 37074: {
      return 33034;
    }
    case 37075: {
      return 36012;
    }
    case 37076: {
      return 36196;
    }
    case 37077: {
      return 36321;
    }
    case 37078: {
      return 36447;
    }
    case 37079: {
      return 30889;
    }
    case 37080: {
      return 20999;
    }
    case 37081: {
      return 25305;
    }
    case 37082: {
      return 25509;
    }
    case 37083: {
      return 25666;
    }
    case 37084: {
      return 25240;
    }
    case 37085: {
      return 35373;
    }
    case 37086: {
      return 31363;
    }
    case 37087: {
      return 31680;
    }
    case 37088: {
      return 35500;
    }
    case 37089: {
      return 38634;
    }
    case 37090: {
      return 32118;
    }
    case 37091: {
      return 33292;
    }
    case 37092: {
      return 34633;
    }
    case 37093: {
      return 20185;
    }
    case 37094: {
      return 20808;
    }
    case 37095: {
      return 21315;
    }
    case 37096: {
      return 21344;
    }
    case 37097: {
      return 23459;
    }
    case 37098: {
      return 23554;
    }
    case 37099: {
      return 23574;
    }
    case 37100: {
      return 24029;
    }
    case 37101: {
      return 25126;
    }
    case 37102: {
      return 25159;
    }
    case 37103: {
      return 25776;
    }
    case 37104: {
      return 26643;
    }
    case 37105: {
      return 26676;
    }
    case 37106: {
      return 27849;
    }
    case 37107: {
      return 27973;
    }
    case 37108: {
      return 27927;
    }
    case 37109: {
      return 26579;
    }
    case 37110: {
      return 28508;
    }
    case 37111: {
      return 29006;
    }
    case 37112: {
      return 29053;
    }
    case 37113: {
      return 26059;
    }
    case 37114: {
      return 31359;
    }
    case 37115: {
      return 31661;
    }
    case 37116: {
      return 32218;
    }
    case 37184: {
      return 32330;
    }
    case 37185: {
      return 32680;
    }
    case 37186: {
      return 33146;
    }
    case 37187: {
      return 33307;
    }
    case 37188: {
      return 33337;
    }
    case 37189: {
      return 34214;
    }
    case 37190: {
      return 35438;
    }
    case 37191: {
      return 36046;
    }
    case 37192: {
      return 36341;
    }
    case 37193: {
      return 36984;
    }
    case 37194: {
      return 36983;
    }
    case 37195: {
      return 37549;
    }
    case 37196: {
      return 37521;
    }
    case 37197: {
      return 38275;
    }
    case 37198: {
      return 39854;
    }
    case 37199: {
      return 21069;
    }
    case 37200: {
      return 21892;
    }
    case 37201: {
      return 28472;
    }
    case 37202: {
      return 28982;
    }
    case 37203: {
      return 20840;
    }
    case 37204: {
      return 31109;
    }
    case 37205: {
      return 32341;
    }
    case 37206: {
      return 33203;
    }
    case 37207: {
      return 31950;
    }
    case 37208: {
      return 22092;
    }
    case 37209: {
      return 22609;
    }
    case 37210: {
      return 23720;
    }
    case 37211: {
      return 25514;
    }
    case 37212: {
      return 26366;
    }
    case 37213: {
      return 26365;
    }
    case 37214: {
      return 26970;
    }
    case 37215: {
      return 29401;
    }
    case 37216: {
      return 30095;
    }
    case 37217: {
      return 30094;
    }
    case 37218: {
      return 30990;
    }
    case 37219: {
      return 31062;
    }
    case 37220: {
      return 31199;
    }
    case 37221: {
      return 31895;
    }
    case 37222: {
      return 32032;
    }
    case 37223: {
      return 32068;
    }
    case 37224: {
      return 34311;
    }
    case 37225: {
      return 35380;
    }
    case 37226: {
      return 38459;
    }
    case 37227: {
      return 36961;
    }
    case 37228: {
      return 40736;
    }
    case 37229: {
      return 20711;
    }
    case 37230: {
      return 21109;
    }
    case 37231: {
      return 21452;
    }
    case 37232: {
      return 21474;
    }
    case 37233: {
      return 20489;
    }
    case 37234: {
      return 21930;
    }
    case 37235: {
      return 22766;
    }
    case 37236: {
      return 22863;
    }
    case 37237: {
      return 29245;
    }
    case 37238: {
      return 23435;
    }
    case 37239: {
      return 23652;
    }
    case 37240: {
      return 21277;
    }
    case 37241: {
      return 24803;
    }
    case 37242: {
      return 24819;
    }
    case 37243: {
      return 25436;
    }
    case 37244: {
      return 25475;
    }
    case 37245: {
      return 25407;
    }
    case 37246: {
      return 25531;
    }
    case 37248: {
      return 25805;
    }
    case 37249: {
      return 26089;
    }
    case 37250: {
      return 26361;
    }
    case 37251: {
      return 24035;
    }
    case 37252: {
      return 27085;
    }
    case 37253: {
      return 27133;
    }
    case 37254: {
      return 28437;
    }
    case 37255: {
      return 29157;
    }
    case 37256: {
      return 20105;
    }
    case 37257: {
      return 30185;
    }
    case 37258: {
      return 30456;
    }
    case 37259: {
      return 31379;
    }
    case 37260: {
      return 31967;
    }
    case 37261: {
      return 32207;
    }
    case 37262: {
      return 32156;
    }
    case 37263: {
      return 32865;
    }
    case 37264: {
      return 33609;
    }
    case 37265: {
      return 33624;
    }
    case 37266: {
      return 33900;
    }
    case 37267: {
      return 33980;
    }
    case 37268: {
      return 34299;
    }
    case 37269: {
      return 35013;
    }
    case 37270: {
      return 36208;
    }
    case 37271: {
      return 36865;
    }
    case 37272: {
      return 36973;
    }
    case 37273: {
      return 37783;
    }
    case 37274: {
      return 38684;
    }
    case 37275: {
      return 39442;
    }
    case 37276: {
      return 20687;
    }
    case 37277: {
      return 22679;
    }
    case 37278: {
      return 24974;
    }
    case 37279: {
      return 33235;
    }
    case 37280: {
      return 34101;
    }
    case 37281: {
      return 36104;
    }
    case 37282: {
      return 36896;
    }
    case 37283: {
      return 20419;
    }
    case 37284: {
      return 20596;
    }
    case 37285: {
      return 21063;
    }
    case 37286: {
      return 21363;
    }
    case 37287: {
      return 24687;
    }
    case 37288: {
      return 25417;
    }
    case 37289: {
      return 26463;
    }
    case 37290: {
      return 28204;
    }
    case 37291: {
      return 36275;
    }
    case 37292: {
      return 36895;
    }
    case 37293: {
      return 20439;
    }
    case 37294: {
      return 23646;
    }
    case 37295: {
      return 36042;
    }
    case 37296: {
      return 26063;
    }
    case 37297: {
      return 32154;
    }
    case 37298: {
      return 21330;
    }
    case 37299: {
      return 34966;
    }
    case 37300: {
      return 20854;
    }
    case 37301: {
      return 25539;
    }
    case 37302: {
      return 23384;
    }
    case 37303: {
      return 23403;
    }
    case 37304: {
      return 23562;
    }
    case 37305: {
      return 25613;
    }
    case 37306: {
      return 26449;
    }
    case 37307: {
      return 36956;
    }
    case 37308: {
      return 20182;
    }
    case 37309: {
      return 22810;
    }
    case 37310: {
      return 22826;
    }
    case 37311: {
      return 27760;
    }
    case 37312: {
      return 35409;
    }
    case 37313: {
      return 21822;
    }
    case 37314: {
      return 22549;
    }
    case 37315: {
      return 22949;
    }
    case 37316: {
      return 24816;
    }
    case 37317: {
      return 25171;
    }
    case 37318: {
      return 26561;
    }
    case 37319: {
      return 33333;
    }
    case 37320: {
      return 26965;
    }
    case 37321: {
      return 38464;
    }
    case 37322: {
      return 39364;
    }
    case 37323: {
      return 39464;
    }
    case 37324: {
      return 20307;
    }
    case 37325: {
      return 22534;
    }
    case 37326: {
      return 23550;
    }
    case 37327: {
      return 32784;
    }
    case 37328: {
      return 23729;
    }
    case 37329: {
      return 24111;
    }
    case 37330: {
      return 24453;
    }
    case 37331: {
      return 24608;
    }
    case 37332: {
      return 24907;
    }
    case 37333: {
      return 25140;
    }
    case 37334: {
      return 26367;
    }
    case 37335: {
      return 27888;
    }
    case 37336: {
      return 28382;
    }
    case 37337: {
      return 32974;
    }
    case 37338: {
      return 33151;
    }
    case 37339: {
      return 33492;
    }
    case 37340: {
      return 34955;
    }
    case 37341: {
      return 36024;
    }
    case 37342: {
      return 36864;
    }
    case 37343: {
      return 36910;
    }
    case 37344: {
      return 38538;
    }
    case 37345: {
      return 40667;
    }
    case 37346: {
      return 39899;
    }
    case 37347: {
      return 20195;
    }
    case 37348: {
      return 21488;
    }
    case 37349: {
      return 22823;
    }
    case 37350: {
      return 31532;
    }
    case 37351: {
      return 37261;
    }
    case 37352: {
      return 38988;
    }
    case 37353: {
      return 40441;
    }
    case 37354: {
      return 28381;
    }
    case 37355: {
      return 28711;
    }
    case 37356: {
      return 21331;
    }
    case 37357: {
      return 21828;
    }
    case 37358: {
      return 23429;
    }
    case 37359: {
      return 25176;
    }
    case 37360: {
      return 25246;
    }
    case 37361: {
      return 25299;
    }
    case 37362: {
      return 27810;
    }
    case 37363: {
      return 28655;
    }
    case 37364: {
      return 29730;
    }
    case 37365: {
      return 35351;
    }
    case 37366: {
      return 37944;
    }
    case 37367: {
      return 28609;
    }
    case 37368: {
      return 35582;
    }
    case 37369: {
      return 33592;
    }
    case 37370: {
      return 20967;
    }
    case 37371: {
      return 34552;
    }
    case 37372: {
      return 21482;
    }
    case 37440: {
      return 21481;
    }
    case 37441: {
      return 20294;
    }
    case 37442: {
      return 36948;
    }
    case 37443: {
      return 36784;
    }
    case 37444: {
      return 22890;
    }
    case 37445: {
      return 33073;
    }
    case 37446: {
      return 24061;
    }
    case 37447: {
      return 31466;
    }
    case 37448: {
      return 36799;
    }
    case 37449: {
      return 26842;
    }
    case 37450: {
      return 35895;
    }
    case 37451: {
      return 29432;
    }
    case 37452: {
      return 40008;
    }
    case 37453: {
      return 27197;
    }
    case 37454: {
      return 35504;
    }
    case 37455: {
      return 20025;
    }
    case 37456: {
      return 21336;
    }
    case 37457: {
      return 22022;
    }
    case 37458: {
      return 22374;
    }
    case 37459: {
      return 25285;
    }
    case 37460: {
      return 25506;
    }
    case 37461: {
      return 26086;
    }
    case 37462: {
      return 27470;
    }
    case 37463: {
      return 28129;
    }
    case 37464: {
      return 28251;
    }
    case 37465: {
      return 28845;
    }
    case 37466: {
      return 30701;
    }
    case 37467: {
      return 31471;
    }
    case 37468: {
      return 31658;
    }
    case 37469: {
      return 32187;
    }
    case 37470: {
      return 32829;
    }
    case 37471: {
      return 32966;
    }
    case 37472: {
      return 34507;
    }
    case 37473: {
      return 35477;
    }
    case 37474: {
      return 37723;
    }
    case 37475: {
      return 22243;
    }
    case 37476: {
      return 22727;
    }
    case 37477: {
      return 24382;
    }
    case 37478: {
      return 26029;
    }
    case 37479: {
      return 26262;
    }
    case 37480: {
      return 27264;
    }
    case 37481: {
      return 27573;
    }
    case 37482: {
      return 30007;
    }
    case 37483: {
      return 35527;
    }
    case 37484: {
      return 20516;
    }
    case 37485: {
      return 30693;
    }
    case 37486: {
      return 22320;
    }
    case 37487: {
      return 24347;
    }
    case 37488: {
      return 24677;
    }
    case 37489: {
      return 26234;
    }
    case 37490: {
      return 27744;
    }
    case 37491: {
      return 30196;
    }
    case 37492: {
      return 31258;
    }
    case 37493: {
      return 32622;
    }
    case 37494: {
      return 33268;
    }
    case 37495: {
      return 34584;
    }
    case 37496: {
      return 36933;
    }
    case 37497: {
      return 39347;
    }
    case 37498: {
      return 31689;
    }
    case 37499: {
      return 30044;
    }
    case 37500: {
      return 31481;
    }
    case 37501: {
      return 31569;
    }
    case 37502: {
      return 33988;
    }
    case 37504: {
      return 36880;
    }
    case 37505: {
      return 31209;
    }
    case 37506: {
      return 31378;
    }
    case 37507: {
      return 33590;
    }
    case 37508: {
      return 23265;
    }
    case 37509: {
      return 30528;
    }
    case 37510: {
      return 20013;
    }
    case 37511: {
      return 20210;
    }
    case 37512: {
      return 23449;
    }
    case 37513: {
      return 24544;
    }
    case 37514: {
      return 25277;
    }
    case 37515: {
      return 26172;
    }
    case 37516: {
      return 26609;
    }
    case 37517: {
      return 27880;
    }
    case 37518: {
      return 34411;
    }
    case 37519: {
      return 34935;
    }
    case 37520: {
      return 35387;
    }
    case 37521: {
      return 37198;
    }
    case 37522: {
      return 37619;
    }
    case 37523: {
      return 39376;
    }
    case 37524: {
      return 27159;
    }
    case 37525: {
      return 28710;
    }
    case 37526: {
      return 29482;
    }
    case 37527: {
      return 33511;
    }
    case 37528: {
      return 33879;
    }
    case 37529: {
      return 36015;
    }
    case 37530: {
      return 19969;
    }
    case 37531: {
      return 20806;
    }
    case 37532: {
      return 20939;
    }
    case 37533: {
      return 21899;
    }
    case 37534: {
      return 23541;
    }
    case 37535: {
      return 24086;
    }
    case 37536: {
      return 24115;
    }
    case 37537: {
      return 24193;
    }
    case 37538: {
      return 24340;
    }
    case 37539: {
      return 24373;
    }
    case 37540: {
      return 24427;
    }
    case 37541: {
      return 24500;
    }
    case 37542: {
      return 25074;
    }
    case 37543: {
      return 25361;
    }
    case 37544: {
      return 26274;
    }
    case 37545: {
      return 26397;
    }
    case 37546: {
      return 28526;
    }
    case 37547: {
      return 29266;
    }
    case 37548: {
      return 30010;
    }
    case 37549: {
      return 30522;
    }
    case 37550: {
      return 32884;
    }
    case 37551: {
      return 33081;
    }
    case 37552: {
      return 33144;
    }
    case 37553: {
      return 34678;
    }
    case 37554: {
      return 35519;
    }
    case 37555: {
      return 35548;
    }
    case 37556: {
      return 36229;
    }
    case 37557: {
      return 36339;
    }
    case 37558: {
      return 37530;
    }
    case 37559: {
      return 38263;
    }
    case 37560: {
      return 38914;
    }
    case 37561: {
      return 40165;
    }
    case 37562: {
      return 21189;
    }
    case 37563: {
      return 25431;
    }
    case 37564: {
      return 30452;
    }
    case 37565: {
      return 26389;
    }
    case 37566: {
      return 27784;
    }
    case 37567: {
      return 29645;
    }
    case 37568: {
      return 36035;
    }
    case 37569: {
      return 37806;
    }
    case 37570: {
      return 38515;
    }
    case 37571: {
      return 27941;
    }
    case 37572: {
      return 22684;
    }
    case 37573: {
      return 26894;
    }
    case 37574: {
      return 27084;
    }
    case 37575: {
      return 36861;
    }
    case 37576: {
      return 37786;
    }
    case 37577: {
      return 30171;
    }
    case 37578: {
      return 36890;
    }
    case 37579: {
      return 22618;
    }
    case 37580: {
      return 26626;
    }
    case 37581: {
      return 25524;
    }
    case 37582: {
      return 27131;
    }
    case 37583: {
      return 20291;
    }
    case 37584: {
      return 28460;
    }
    case 37585: {
      return 26584;
    }
    case 37586: {
      return 36795;
    }
    case 37587: {
      return 34086;
    }
    case 37588: {
      return 32180;
    }
    case 37589: {
      return 37716;
    }
    case 37590: {
      return 26943;
    }
    case 37591: {
      return 28528;
    }
    case 37592: {
      return 22378;
    }
    case 37593: {
      return 22775;
    }
    case 37594: {
      return 23340;
    }
    case 37595: {
      return 32044;
    }
    case 37596: {
      return 29226;
    }
    case 37597: {
      return 21514;
    }
    case 37598: {
      return 37347;
    }
    case 37599: {
      return 40372;
    }
    case 37600: {
      return 20141;
    }
    case 37601: {
      return 20302;
    }
    case 37602: {
      return 20572;
    }
    case 37603: {
      return 20597;
    }
    case 37604: {
      return 21059;
    }
    case 37605: {
      return 35998;
    }
    case 37606: {
      return 21576;
    }
    case 37607: {
      return 22564;
    }
    case 37608: {
      return 23450;
    }
    case 37609: {
      return 24093;
    }
    case 37610: {
      return 24213;
    }
    case 37611: {
      return 24237;
    }
    case 37612: {
      return 24311;
    }
    case 37613: {
      return 24351;
    }
    case 37614: {
      return 24716;
    }
    case 37615: {
      return 25269;
    }
    case 37616: {
      return 25402;
    }
    case 37617: {
      return 25552;
    }
    case 37618: {
      return 26799;
    }
    case 37619: {
      return 27712;
    }
    case 37620: {
      return 30855;
    }
    case 37621: {
      return 31118;
    }
    case 37622: {
      return 31243;
    }
    case 37623: {
      return 32224;
    }
    case 37624: {
      return 33351;
    }
    case 37625: {
      return 35330;
    }
    case 37626: {
      return 35558;
    }
    case 37627: {
      return 36420;
    }
    case 37628: {
      return 36883;
    }
    case 37696: {
      return 37048;
    }
    case 37697: {
      return 37165;
    }
    case 37698: {
      return 37336;
    }
    case 37699: {
      return 40718;
    }
    case 37700: {
      return 27877;
    }
    case 37701: {
      return 25688;
    }
    case 37702: {
      return 25826;
    }
    case 37703: {
      return 25973;
    }
    case 37704: {
      return 28404;
    }
    case 37705: {
      return 30340;
    }
    case 37706: {
      return 31515;
    }
    case 37707: {
      return 36969;
    }
    case 37708: {
      return 37841;
    }
    case 37709: {
      return 28346;
    }
    case 37710: {
      return 21746;
    }
    case 37711: {
      return 24505;
    }
    case 37712: {
      return 25764;
    }
    case 37713: {
      return 36685;
    }
    case 37714: {
      return 36845;
    }
    case 37715: {
      return 37444;
    }
    case 37716: {
      return 20856;
    }
    case 37717: {
      return 22635;
    }
    case 37718: {
      return 22825;
    }
    case 37719: {
      return 23637;
    }
    case 37720: {
      return 24215;
    }
    case 37721: {
      return 28155;
    }
    case 37722: {
      return 32399;
    }
    case 37723: {
      return 29980;
    }
    case 37724: {
      return 36028;
    }
    case 37725: {
      return 36578;
    }
    case 37726: {
      return 39003;
    }
    case 37727: {
      return 28857;
    }
    case 37728: {
      return 20253;
    }
    case 37729: {
      return 27583;
    }
    case 37730: {
      return 28593;
    }
    case 37731: {
      return 30000;
    }
    case 37732: {
      return 38651;
    }
    case 37733: {
      return 20814;
    }
    case 37734: {
      return 21520;
    }
    case 37735: {
      return 22581;
    }
    case 37736: {
      return 22615;
    }
    case 37737: {
      return 22956;
    }
    case 37738: {
      return 23648;
    }
    case 37739: {
      return 24466;
    }
    case 37740: {
      return 26007;
    }
    case 37741: {
      return 26460;
    }
    case 37742: {
      return 28193;
    }
    case 37743: {
      return 30331;
    }
    case 37744: {
      return 33759;
    }
    case 37745: {
      return 36077;
    }
    case 37746: {
      return 36884;
    }
    case 37747: {
      return 37117;
    }
    case 37748: {
      return 37709;
    }
    case 37749: {
      return 30757;
    }
    case 37750: {
      return 30778;
    }
    case 37751: {
      return 21162;
    }
    case 37752: {
      return 24230;
    }
    case 37753: {
      return 22303;
    }
    case 37754: {
      return 22900;
    }
    case 37755: {
      return 24594;
    }
    case 37756: {
      return 20498;
    }
    case 37757: {
      return 20826;
    }
    case 37758: {
      return 20908;
    }
    case 37760: {
      return 20941;
    }
    case 37761: {
      return 20992;
    }
    case 37762: {
      return 21776;
    }
    case 37763: {
      return 22612;
    }
    case 37764: {
      return 22616;
    }
    case 37765: {
      return 22871;
    }
    case 37766: {
      return 23445;
    }
    case 37767: {
      return 23798;
    }
    case 37768: {
      return 23947;
    }
    case 37769: {
      return 24764;
    }
    case 37770: {
      return 25237;
    }
    case 37771: {
      return 25645;
    }
    case 37772: {
      return 26481;
    }
    case 37773: {
      return 26691;
    }
    case 37774: {
      return 26812;
    }
    case 37775: {
      return 26847;
    }
    case 37776: {
      return 30423;
    }
    case 37777: {
      return 28120;
    }
    case 37778: {
      return 28271;
    }
    case 37779: {
      return 28059;
    }
    case 37780: {
      return 28783;
    }
    case 37781: {
      return 29128;
    }
    case 37782: {
      return 24403;
    }
    case 37783: {
      return 30168;
    }
    case 37784: {
      return 31095;
    }
    case 37785: {
      return 31561;
    }
    case 37786: {
      return 31572;
    }
    case 37787: {
      return 31570;
    }
    case 37788: {
      return 31958;
    }
    case 37789: {
      return 32113;
    }
    case 37790: {
      return 21040;
    }
    case 37791: {
      return 33891;
    }
    case 37792: {
      return 34153;
    }
    case 37793: {
      return 34276;
    }
    case 37794: {
      return 35342;
    }
    case 37795: {
      return 35588;
    }
    case 37796: {
      return 35910;
    }
    case 37797: {
      return 36367;
    }
    case 37798: {
      return 36867;
    }
    case 37799: {
      return 36879;
    }
    case 37800: {
      return 37913;
    }
    case 37801: {
      return 38518;
    }
    case 37802: {
      return 38957;
    }
    case 37803: {
      return 39472;
    }
    case 37804: {
      return 38360;
    }
    case 37805: {
      return 20685;
    }
    case 37806: {
      return 21205;
    }
    case 37807: {
      return 21516;
    }
    case 37808: {
      return 22530;
    }
    case 37809: {
      return 23566;
    }
    case 37810: {
      return 24999;
    }
    case 37811: {
      return 25758;
    }
    case 37812: {
      return 27934;
    }
    case 37813: {
      return 30643;
    }
    case 37814: {
      return 31461;
    }
    case 37815: {
      return 33012;
    }
    case 37816: {
      return 33796;
    }
    case 37817: {
      return 36947;
    }
    case 37818: {
      return 37509;
    }
    case 37819: {
      return 23776;
    }
    case 37820: {
      return 40199;
    }
    case 37821: {
      return 21311;
    }
    case 37822: {
      return 24471;
    }
    case 37823: {
      return 24499;
    }
    case 37824: {
      return 28060;
    }
    case 37825: {
      return 29305;
    }
    case 37826: {
      return 30563;
    }
    case 37827: {
      return 31167;
    }
    case 37828: {
      return 31716;
    }
    case 37829: {
      return 27602;
    }
    case 37830: {
      return 29420;
    }
    case 37831: {
      return 35501;
    }
    case 37832: {
      return 26627;
    }
    case 37833: {
      return 27233;
    }
    case 37834: {
      return 20984;
    }
    case 37835: {
      return 31361;
    }
    case 37836: {
      return 26932;
    }
    case 37837: {
      return 23626;
    }
    case 37838: {
      return 40182;
    }
    case 37839: {
      return 33515;
    }
    case 37840: {
      return 23493;
    }
    case 37841: {
      return 37193;
    }
    case 37842: {
      return 28702;
    }
    case 37843: {
      return 22136;
    }
    case 37844: {
      return 23663;
    }
    case 37845: {
      return 24775;
    }
    case 37846: {
      return 25958;
    }
    case 37847: {
      return 27788;
    }
    case 37848: {
      return 35930;
    }
    case 37849: {
      return 36929;
    }
    case 37850: {
      return 38931;
    }
    case 37851: {
      return 21585;
    }
    case 37852: {
      return 26311;
    }
    case 37853: {
      return 37389;
    }
    case 37854: {
      return 22856;
    }
    case 37855: {
      return 37027;
    }
    case 37856: {
      return 20869;
    }
    case 37857: {
      return 20045;
    }
    case 37858: {
      return 20970;
    }
    case 37859: {
      return 34201;
    }
    case 37860: {
      return 35598;
    }
    case 37861: {
      return 28760;
    }
    case 37862: {
      return 25466;
    }
    case 37863: {
      return 37707;
    }
    case 37864: {
      return 26978;
    }
    case 37865: {
      return 39348;
    }
    case 37866: {
      return 32260;
    }
    case 37867: {
      return 30071;
    }
    case 37868: {
      return 21335;
    }
    case 37869: {
      return 26976;
    }
    case 37870: {
      return 36575;
    }
    case 37871: {
      return 38627;
    }
    case 37872: {
      return 27741;
    }
    case 37873: {
      return 20108;
    }
    case 37874: {
      return 23612;
    }
    case 37875: {
      return 24336;
    }
    case 37876: {
      return 36841;
    }
    case 37877: {
      return 21250;
    }
    case 37878: {
      return 36049;
    }
    case 37879: {
      return 32905;
    }
    case 37880: {
      return 34425;
    }
    case 37881: {
      return 24319;
    }
    case 37882: {
      return 26085;
    }
    case 37883: {
      return 20083;
    }
    case 37884: {
      return 20837;
    }
    case 37952: {
      return 22914;
    }
    case 37953: {
      return 23615;
    }
    case 37954: {
      return 38894;
    }
    case 37955: {
      return 20219;
    }
    case 37956: {
      return 22922;
    }
    case 37957: {
      return 24525;
    }
    case 37958: {
      return 35469;
    }
    case 37959: {
      return 28641;
    }
    case 37960: {
      return 31152;
    }
    case 37961: {
      return 31074;
    }
    case 37962: {
      return 23527;
    }
    case 37963: {
      return 33905;
    }
    case 37964: {
      return 29483;
    }
    case 37965: {
      return 29105;
    }
    case 37966: {
      return 24180;
    }
    case 37967: {
      return 24565;
    }
    case 37968: {
      return 25467;
    }
    case 37969: {
      return 25754;
    }
    case 37970: {
      return 29123;
    }
    case 37971: {
      return 31896;
    }
    case 37972: {
      return 20035;
    }
    case 37973: {
      return 24316;
    }
    case 37974: {
      return 20043;
    }
    case 37975: {
      return 22492;
    }
    case 37976: {
      return 22178;
    }
    case 37977: {
      return 24745;
    }
    case 37978: {
      return 28611;
    }
    case 37979: {
      return 32013;
    }
    case 37980: {
      return 33021;
    }
    case 37981: {
      return 33075;
    }
    case 37982: {
      return 33215;
    }
    case 37983: {
      return 36786;
    }
    case 37984: {
      return 35223;
    }
    case 37985: {
      return 34468;
    }
    case 37986: {
      return 24052;
    }
    case 37987: {
      return 25226;
    }
    case 37988: {
      return 25773;
    }
    case 37989: {
      return 35207;
    }
    case 37990: {
      return 26487;
    }
    case 37991: {
      return 27874;
    }
    case 37992: {
      return 27966;
    }
    case 37993: {
      return 29750;
    }
    case 37994: {
      return 30772;
    }
    case 37995: {
      return 23110;
    }
    case 37996: {
      return 32629;
    }
    case 37997: {
      return 33453;
    }
    case 37998: {
      return 39340;
    }
    case 37999: {
      return 20467;
    }
    case 38000: {
      return 24259;
    }
    case 38001: {
      return 25309;
    }
    case 38002: {
      return 25490;
    }
    case 38003: {
      return 25943;
    }
    case 38004: {
      return 26479;
    }
    case 38005: {
      return 30403;
    }
    case 38006: {
      return 29260;
    }
    case 38007: {
      return 32972;
    }
    case 38008: {
      return 32954;
    }
    case 38009: {
      return 36649;
    }
    case 38010: {
      return 37197;
    }
    case 38011: {
      return 20493;
    }
    case 38012: {
      return 22521;
    }
    case 38013: {
      return 23186;
    }
    case 38014: {
      return 26757;
    }
    case 38016: {
      return 26995;
    }
    case 38017: {
      return 29028;
    }
    case 38018: {
      return 29437;
    }
    case 38019: {
      return 36023;
    }
    case 38020: {
      return 22770;
    }
    case 38021: {
      return 36064;
    }
    case 38022: {
      return 38506;
    }
    case 38023: {
      return 36889;
    }
    case 38024: {
      return 34687;
    }
    case 38025: {
      return 31204;
    }
    case 38026: {
      return 30695;
    }
    case 38027: {
      return 33833;
    }
    case 38028: {
      return 20271;
    }
    case 38029: {
      return 21093;
    }
    case 38030: {
      return 21338;
    }
    case 38031: {
      return 25293;
    }
    case 38032: {
      return 26575;
    }
    case 38033: {
      return 27850;
    }
    case 38034: {
      return 30333;
    }
    case 38035: {
      return 31636;
    }
    case 38036: {
      return 31893;
    }
    case 38037: {
      return 33334;
    }
    case 38038: {
      return 34180;
    }
    case 38039: {
      return 36843;
    }
    case 38040: {
      return 26333;
    }
    case 38041: {
      return 28448;
    }
    case 38042: {
      return 29190;
    }
    case 38043: {
      return 32283;
    }
    case 38044: {
      return 33707;
    }
    case 38045: {
      return 39361;
    }
    case 38046: {
      return 40614;
    }
    case 38047: {
      return 20989;
    }
    case 38048: {
      return 31665;
    }
    case 38049: {
      return 30834;
    }
    case 38050: {
      return 31672;
    }
    case 38051: {
      return 32903;
    }
    case 38052: {
      return 31560;
    }
    case 38053: {
      return 27368;
    }
    case 38054: {
      return 24161;
    }
    case 38055: {
      return 32908;
    }
    case 38056: {
      return 30033;
    }
    case 38057: {
      return 30048;
    }
    case 38058: {
      return 20843;
    }
    case 38059: {
      return 37474;
    }
    case 38060: {
      return 28300;
    }
    case 38061: {
      return 30330;
    }
    case 38062: {
      return 37271;
    }
    case 38063: {
      return 39658;
    }
    case 38064: {
      return 20240;
    }
    case 38065: {
      return 32624;
    }
    case 38066: {
      return 25244;
    }
    case 38067: {
      return 31567;
    }
    case 38068: {
      return 38309;
    }
    case 38069: {
      return 40169;
    }
    case 38070: {
      return 22138;
    }
    case 38071: {
      return 22617;
    }
    case 38072: {
      return 34532;
    }
    case 38073: {
      return 38588;
    }
    case 38074: {
      return 20276;
    }
    case 38075: {
      return 21028;
    }
    case 38076: {
      return 21322;
    }
    case 38077: {
      return 21453;
    }
    case 38078: {
      return 21467;
    }
    case 38079: {
      return 24070;
    }
    case 38080: {
      return 25644;
    }
    case 38081: {
      return 26001;
    }
    case 38082: {
      return 26495;
    }
    case 38083: {
      return 27710;
    }
    case 38084: {
      return 27726;
    }
    case 38085: {
      return 29256;
    }
    case 38086: {
      return 29359;
    }
    case 38087: {
      return 29677;
    }
    case 38088: {
      return 30036;
    }
    case 38089: {
      return 32321;
    }
    case 38090: {
      return 33324;
    }
    case 38091: {
      return 34281;
    }
    case 38092: {
      return 36009;
    }
    case 38093: {
      return 31684;
    }
    case 38094: {
      return 37318;
    }
    case 38095: {
      return 29033;
    }
    case 38096: {
      return 38930;
    }
    case 38097: {
      return 39151;
    }
    case 38098: {
      return 25405;
    }
    case 38099: {
      return 26217;
    }
    case 38100: {
      return 30058;
    }
    case 38101: {
      return 30436;
    }
    case 38102: {
      return 30928;
    }
    case 38103: {
      return 34115;
    }
    case 38104: {
      return 34542;
    }
    case 38105: {
      return 21290;
    }
    case 38106: {
      return 21329;
    }
    case 38107: {
      return 21542;
    }
    case 38108: {
      return 22915;
    }
    case 38109: {
      return 24199;
    }
    case 38110: {
      return 24444;
    }
    case 38111: {
      return 24754;
    }
    case 38112: {
      return 25161;
    }
    case 38113: {
      return 25209;
    }
    case 38114: {
      return 25259;
    }
    case 38115: {
      return 26000;
    }
    case 38116: {
      return 27604;
    }
    case 38117: {
      return 27852;
    }
    case 38118: {
      return 30130;
    }
    case 38119: {
      return 30382;
    }
    case 38120: {
      return 30865;
    }
    case 38121: {
      return 31192;
    }
    case 38122: {
      return 32203;
    }
    case 38123: {
      return 32631;
    }
    case 38124: {
      return 32933;
    }
    case 38125: {
      return 34987;
    }
    case 38126: {
      return 35513;
    }
    case 38127: {
      return 36027;
    }
    case 38128: {
      return 36991;
    }
    case 38129: {
      return 38750;
    }
    case 38130: {
      return 39131;
    }
    case 38131: {
      return 27147;
    }
    case 38132: {
      return 31800;
    }
    case 38133: {
      return 20633;
    }
    case 38134: {
      return 23614;
    }
    case 38135: {
      return 24494;
    }
    case 38136: {
      return 26503;
    }
    case 38137: {
      return 27608;
    }
    case 38138: {
      return 29749;
    }
    case 38139: {
      return 30473;
    }
    case 38140: {
      return 32654;
    }
    case 38208: {
      return 40763;
    }
    case 38209: {
      return 26570;
    }
    case 38210: {
      return 31255;
    }
    case 38211: {
      return 21305;
    }
    case 38212: {
      return 30091;
    }
    case 38213: {
      return 39661;
    }
    case 38214: {
      return 24422;
    }
    case 38215: {
      return 33181;
    }
    case 38216: {
      return 33777;
    }
    case 38217: {
      return 32920;
    }
    case 38218: {
      return 24380;
    }
    case 38219: {
      return 24517;
    }
    case 38220: {
      return 30050;
    }
    case 38221: {
      return 31558;
    }
    case 38222: {
      return 36924;
    }
    case 38223: {
      return 26727;
    }
    case 38224: {
      return 23019;
    }
    case 38225: {
      return 23195;
    }
    case 38226: {
      return 32016;
    }
    case 38227: {
      return 30334;
    }
    case 38228: {
      return 35628;
    }
    case 38229: {
      return 20469;
    }
    case 38230: {
      return 24426;
    }
    case 38231: {
      return 27161;
    }
    case 38232: {
      return 27703;
    }
    case 38233: {
      return 28418;
    }
    case 38234: {
      return 29922;
    }
    case 38235: {
      return 31080;
    }
    case 38236: {
      return 34920;
    }
    case 38237: {
      return 35413;
    }
    case 38238: {
      return 35961;
    }
    case 38239: {
      return 24287;
    }
    case 38240: {
      return 25551;
    }
    case 38241: {
      return 30149;
    }
    case 38242: {
      return 31186;
    }
    case 38243: {
      return 33495;
    }
    case 38244: {
      return 37672;
    }
    case 38245: {
      return 37618;
    }
    case 38246: {
      return 33948;
    }
    case 38247: {
      return 34541;
    }
    case 38248: {
      return 39981;
    }
    case 38249: {
      return 21697;
    }
    case 38250: {
      return 24428;
    }
    case 38251: {
      return 25996;
    }
    case 38252: {
      return 27996;
    }
    case 38253: {
      return 28693;
    }
    case 38254: {
      return 36007;
    }
    case 38255: {
      return 36051;
    }
    case 38256: {
      return 38971;
    }
    case 38257: {
      return 25935;
    }
    case 38258: {
      return 29942;
    }
    case 38259: {
      return 19981;
    }
    case 38260: {
      return 20184;
    }
    case 38261: {
      return 22496;
    }
    case 38262: {
      return 22827;
    }
    case 38263: {
      return 23142;
    }
    case 38264: {
      return 23500;
    }
    case 38265: {
      return 20904;
    }
    case 38266: {
      return 24067;
    }
    case 38267: {
      return 24220;
    }
    case 38268: {
      return 24598;
    }
    case 38269: {
      return 25206;
    }
    case 38270: {
      return 25975;
    }
    case 38272: {
      return 26023;
    }
    case 38273: {
      return 26222;
    }
    case 38274: {
      return 28014;
    }
    case 38275: {
      return 29238;
    }
    case 38276: {
      return 31526;
    }
    case 38277: {
      return 33104;
    }
    case 38278: {
      return 33178;
    }
    case 38279: {
      return 33433;
    }
    case 38280: {
      return 35676;
    }
    case 38281: {
      return 36000;
    }
    case 38282: {
      return 36070;
    }
    case 38283: {
      return 36212;
    }
    case 38284: {
      return 38428;
    }
    case 38285: {
      return 38468;
    }
    case 38286: {
      return 20398;
    }
    case 38287: {
      return 25771;
    }
    case 38288: {
      return 27494;
    }
    case 38289: {
      return 33310;
    }
    case 38290: {
      return 33889;
    }
    case 38291: {
      return 34154;
    }
    case 38292: {
      return 37096;
    }
    case 38293: {
      return 23553;
    }
    case 38294: {
      return 26963;
    }
    case 38295: {
      return 39080;
    }
    case 38296: {
      return 33914;
    }
    case 38297: {
      return 34135;
    }
    case 38298: {
      return 20239;
    }
    case 38299: {
      return 21103;
    }
    case 38300: {
      return 24489;
    }
    case 38301: {
      return 24133;
    }
    case 38302: {
      return 26381;
    }
    case 38303: {
      return 31119;
    }
    case 38304: {
      return 33145;
    }
    case 38305: {
      return 35079;
    }
    case 38306: {
      return 35206;
    }
    case 38307: {
      return 28149;
    }
    case 38308: {
      return 24343;
    }
    case 38309: {
      return 25173;
    }
    case 38310: {
      return 27832;
    }
    case 38311: {
      return 20175;
    }
    case 38312: {
      return 29289;
    }
    case 38313: {
      return 39826;
    }
    case 38314: {
      return 20998;
    }
    case 38315: {
      return 21563;
    }
    case 38316: {
      return 22132;
    }
    case 38317: {
      return 22707;
    }
    case 38318: {
      return 24996;
    }
    case 38319: {
      return 25198;
    }
    case 38320: {
      return 28954;
    }
    case 38321: {
      return 22894;
    }
    case 38322: {
      return 31881;
    }
    case 38323: {
      return 31966;
    }
    case 38324: {
      return 32027;
    }
    case 38325: {
      return 38640;
    }
    case 38326: {
      return 25991;
    }
    case 38327: {
      return 32862;
    }
    case 38328: {
      return 19993;
    }
    case 38329: {
      return 20341;
    }
    case 38330: {
      return 20853;
    }
    case 38331: {
      return 22592;
    }
    case 38332: {
      return 24163;
    }
    case 38333: {
      return 24179;
    }
    case 38334: {
      return 24330;
    }
    case 38335: {
      return 26564;
    }
    case 38336: {
      return 20006;
    }
    case 38337: {
      return 34109;
    }
    case 38338: {
      return 38281;
    }
    case 38339: {
      return 38491;
    }
    case 38340: {
      return 31859;
    }
    case 38341: {
      return 38913;
    }
    case 38342: {
      return 20731;
    }
    case 38343: {
      return 22721;
    }
    case 38344: {
      return 30294;
    }
    case 38345: {
      return 30887;
    }
    case 38346: {
      return 21029;
    }
    case 38347: {
      return 30629;
    }
    case 38348: {
      return 34065;
    }
    case 38349: {
      return 31622;
    }
    case 38350: {
      return 20559;
    }
    case 38351: {
      return 22793;
    }
    case 38352: {
      return 29255;
    }
    case 38353: {
      return 31687;
    }
    case 38354: {
      return 32232;
    }
    case 38355: {
      return 36794;
    }
    case 38356: {
      return 36820;
    }
    case 38357: {
      return 36941;
    }
    case 38358: {
      return 20415;
    }
    case 38359: {
      return 21193;
    }
    case 38360: {
      return 23081;
    }
    case 38361: {
      return 24321;
    }
    case 38362: {
      return 38829;
    }
    case 38363: {
      return 20445;
    }
    case 38364: {
      return 33303;
    }
    case 38365: {
      return 37610;
    }
    case 38366: {
      return 22275;
    }
    case 38367: {
      return 25429;
    }
    case 38368: {
      return 27497;
    }
    case 38369: {
      return 29995;
    }
    case 38370: {
      return 35036;
    }
    case 38371: {
      return 36628;
    }
    case 38372: {
      return 31298;
    }
    case 38373: {
      return 21215;
    }
    case 38374: {
      return 22675;
    }
    case 38375: {
      return 24917;
    }
    case 38376: {
      return 25098;
    }
    case 38377: {
      return 26286;
    }
    case 38378: {
      return 27597;
    }
    case 38379: {
      return 31807;
    }
    case 38380: {
      return 33769;
    }
    case 38381: {
      return 20515;
    }
    case 38382: {
      return 20472;
    }
    case 38383: {
      return 21253;
    }
    case 38384: {
      return 21574;
    }
    case 38385: {
      return 22577;
    }
    case 38386: {
      return 22857;
    }
    case 38387: {
      return 23453;
    }
    case 38388: {
      return 23792;
    }
    case 38389: {
      return 23791;
    }
    case 38390: {
      return 23849;
    }
    case 38391: {
      return 24214;
    }
    case 38392: {
      return 25265;
    }
    case 38393: {
      return 25447;
    }
    case 38394: {
      return 25918;
    }
    case 38395: {
      return 26041;
    }
    case 38396: {
      return 26379;
    }
    case 38464: {
      return 27861;
    }
    case 38465: {
      return 27873;
    }
    case 38466: {
      return 28921;
    }
    case 38467: {
      return 30770;
    }
    case 38468: {
      return 32299;
    }
    case 38469: {
      return 32990;
    }
    case 38470: {
      return 33459;
    }
    case 38471: {
      return 33804;
    }
    case 38472: {
      return 34028;
    }
    case 38473: {
      return 34562;
    }
    case 38474: {
      return 35090;
    }
    case 38475: {
      return 35370;
    }
    case 38476: {
      return 35914;
    }
    case 38477: {
      return 37030;
    }
    case 38478: {
      return 37586;
    }
    case 38479: {
      return 39165;
    }
    case 38480: {
      return 40179;
    }
    case 38481: {
      return 40300;
    }
    case 38482: {
      return 20047;
    }
    case 38483: {
      return 20129;
    }
    case 38484: {
      return 20621;
    }
    case 38485: {
      return 21078;
    }
    case 38486: {
      return 22346;
    }
    case 38487: {
      return 22952;
    }
    case 38488: {
      return 24125;
    }
    case 38489: {
      return 24536;
    }
    case 38490: {
      return 24537;
    }
    case 38491: {
      return 25151;
    }
    case 38492: {
      return 26292;
    }
    case 38493: {
      return 26395;
    }
    case 38494: {
      return 26576;
    }
    case 38495: {
      return 26834;
    }
    case 38496: {
      return 20882;
    }
    case 38497: {
      return 32033;
    }
    case 38498: {
      return 32938;
    }
    case 38499: {
      return 33192;
    }
    case 38500: {
      return 35584;
    }
    case 38501: {
      return 35980;
    }
    case 38502: {
      return 36031;
    }
    case 38503: {
      return 37502;
    }
    case 38504: {
      return 38450;
    }
    case 38505: {
      return 21536;
    }
    case 38506: {
      return 38956;
    }
    case 38507: {
      return 21271;
    }
    case 38508: {
      return 20693;
    }
    case 38509: {
      return 21340;
    }
    case 38510: {
      return 22696;
    }
    case 38511: {
      return 25778;
    }
    case 38512: {
      return 26420;
    }
    case 38513: {
      return 29287;
    }
    case 38514: {
      return 30566;
    }
    case 38515: {
      return 31302;
    }
    case 38516: {
      return 37350;
    }
    case 38517: {
      return 21187;
    }
    case 38518: {
      return 27809;
    }
    case 38519: {
      return 27526;
    }
    case 38520: {
      return 22528;
    }
    case 38521: {
      return 24140;
    }
    case 38522: {
      return 22868;
    }
    case 38523: {
      return 26412;
    }
    case 38524: {
      return 32763;
    }
    case 38525: {
      return 20961;
    }
    case 38526: {
      return 30406;
    }
    case 38528: {
      return 25705;
    }
    case 38529: {
      return 30952;
    }
    case 38530: {
      return 39764;
    }
    case 38531: {
      return 40635;
    }
    case 38532: {
      return 22475;
    }
    case 38533: {
      return 22969;
    }
    case 38534: {
      return 26151;
    }
    case 38535: {
      return 26522;
    }
    case 38536: {
      return 27598;
    }
    case 38537: {
      return 21737;
    }
    case 38538: {
      return 27097;
    }
    case 38539: {
      return 24149;
    }
    case 38540: {
      return 33180;
    }
    case 38541: {
      return 26517;
    }
    case 38542: {
      return 39850;
    }
    case 38543: {
      return 26622;
    }
    case 38544: {
      return 40018;
    }
    case 38545: {
      return 26717;
    }
    case 38546: {
      return 20134;
    }
    case 38547: {
      return 20451;
    }
    case 38548: {
      return 21448;
    }
    case 38549: {
      return 25273;
    }
    case 38550: {
      return 26411;
    }
    case 38551: {
      return 27819;
    }
    case 38552: {
      return 36804;
    }
    case 38553: {
      return 20397;
    }
    case 38554: {
      return 32365;
    }
    case 38555: {
      return 40639;
    }
    case 38556: {
      return 19975;
    }
    case 38557: {
      return 24930;
    }
    case 38558: {
      return 28288;
    }
    case 38559: {
      return 28459;
    }
    case 38560: {
      return 34067;
    }
    case 38561: {
      return 21619;
    }
    case 38562: {
      return 26410;
    }
    case 38563: {
      return 39749;
    }
    case 38564: {
      return 24051;
    }
    case 38565: {
      return 31637;
    }
    case 38566: {
      return 23724;
    }
    case 38567: {
      return 23494;
    }
    case 38568: {
      return 34588;
    }
    case 38569: {
      return 28234;
    }
    case 38570: {
      return 34001;
    }
    case 38571: {
      return 31252;
    }
    case 38572: {
      return 33032;
    }
    case 38573: {
      return 22937;
    }
    case 38574: {
      return 31885;
    }
    case 38575: {
      return 27665;
    }
    case 38576: {
      return 30496;
    }
    case 38577: {
      return 21209;
    }
    case 38578: {
      return 22818;
    }
    case 38579: {
      return 28961;
    }
    case 38580: {
      return 29279;
    }
    case 38581: {
      return 30683;
    }
    case 38582: {
      return 38695;
    }
    case 38583: {
      return 40289;
    }
    case 38584: {
      return 26891;
    }
    case 38585: {
      return 23167;
    }
    case 38586: {
      return 23064;
    }
    case 38587: {
      return 20901;
    }
    case 38588: {
      return 21517;
    }
    case 38589: {
      return 21629;
    }
    case 38590: {
      return 26126;
    }
    case 38591: {
      return 30431;
    }
    case 38592: {
      return 36855;
    }
    case 38593: {
      return 37528;
    }
    case 38594: {
      return 40180;
    }
    case 38595: {
      return 23018;
    }
    case 38596: {
      return 29277;
    }
    case 38597: {
      return 28357;
    }
    case 38598: {
      return 20813;
    }
    case 38599: {
      return 26825;
    }
    case 38600: {
      return 32191;
    }
    case 38601: {
      return 32236;
    }
    case 38602: {
      return 38754;
    }
    case 38603: {
      return 40634;
    }
    case 38604: {
      return 25720;
    }
    case 38605: {
      return 27169;
    }
    case 38606: {
      return 33538;
    }
    case 38607: {
      return 22916;
    }
    case 38608: {
      return 23391;
    }
    case 38609: {
      return 27611;
    }
    case 38610: {
      return 29467;
    }
    case 38611: {
      return 30450;
    }
    case 38612: {
      return 32178;
    }
    case 38613: {
      return 32791;
    }
    case 38614: {
      return 33945;
    }
    case 38615: {
      return 20786;
    }
    case 38616: {
      return 26408;
    }
    case 38617: {
      return 40665;
    }
    case 38618: {
      return 30446;
    }
    case 38619: {
      return 26466;
    }
    case 38620: {
      return 21247;
    }
    case 38621: {
      return 39173;
    }
    case 38622: {
      return 23588;
    }
    case 38623: {
      return 25147;
    }
    case 38624: {
      return 31870;
    }
    case 38625: {
      return 36016;
    }
    case 38626: {
      return 21839;
    }
    case 38627: {
      return 24758;
    }
    case 38628: {
      return 32011;
    }
    case 38629: {
      return 38272;
    }
    case 38630: {
      return 21249;
    }
    case 38631: {
      return 20063;
    }
    case 38632: {
      return 20918;
    }
    case 38633: {
      return 22812;
    }
    case 38634: {
      return 29242;
    }
    case 38635: {
      return 32822;
    }
    case 38636: {
      return 37326;
    }
    case 38637: {
      return 24357;
    }
    case 38638: {
      return 30690;
    }
    case 38639: {
      return 21380;
    }
    case 38640: {
      return 24441;
    }
    case 38641: {
      return 32004;
    }
    case 38642: {
      return 34220;
    }
    case 38643: {
      return 35379;
    }
    case 38644: {
      return 36493;
    }
    case 38645: {
      return 38742;
    }
    case 38646: {
      return 26611;
    }
    case 38647: {
      return 34222;
    }
    case 38648: {
      return 37971;
    }
    case 38649: {
      return 24841;
    }
    case 38650: {
      return 24840;
    }
    case 38651: {
      return 27833;
    }
    case 38652: {
      return 30290;
    }
    case 38720: {
      return 35565;
    }
    case 38721: {
      return 36664;
    }
    case 38722: {
      return 21807;
    }
    case 38723: {
      return 20305;
    }
    case 38724: {
      return 20778;
    }
    case 38725: {
      return 21191;
    }
    case 38726: {
      return 21451;
    }
    case 38727: {
      return 23461;
    }
    case 38728: {
      return 24189;
    }
    case 38729: {
      return 24736;
    }
    case 38730: {
      return 24962;
    }
    case 38731: {
      return 25558;
    }
    case 38732: {
      return 26377;
    }
    case 38733: {
      return 26586;
    }
    case 38734: {
      return 28263;
    }
    case 38735: {
      return 28044;
    }
    case 38736: {
      return 29494;
    }
    case 38737: {
      return 29495;
    }
    case 38738: {
      return 30001;
    }
    case 38739: {
      return 31056;
    }
    case 38740: {
      return 35029;
    }
    case 38741: {
      return 35480;
    }
    case 38742: {
      return 36938;
    }
    case 38743: {
      return 37009;
    }
    case 38744: {
      return 37109;
    }
    case 38745: {
      return 38596;
    }
    case 38746: {
      return 34701;
    }
    case 38747: {
      return 22805;
    }
    case 38748: {
      return 20104;
    }
    case 38749: {
      return 20313;
    }
    case 38750: {
      return 19982;
    }
    case 38751: {
      return 35465;
    }
    case 38752: {
      return 36671;
    }
    case 38753: {
      return 38928;
    }
    case 38754: {
      return 20653;
    }
    case 38755: {
      return 24188;
    }
    case 38756: {
      return 22934;
    }
    case 38757: {
      return 23481;
    }
    case 38758: {
      return 24248;
    }
    case 38759: {
      return 25562;
    }
    case 38760: {
      return 25594;
    }
    case 38761: {
      return 25793;
    }
    case 38762: {
      return 26332;
    }
    case 38763: {
      return 26954;
    }
    case 38764: {
      return 27096;
    }
    case 38765: {
      return 27915;
    }
    case 38766: {
      return 28342;
    }
    case 38767: {
      return 29076;
    }
    case 38768: {
      return 29992;
    }
    case 38769: {
      return 31407;
    }
    case 38770: {
      return 32650;
    }
    case 38771: {
      return 32768;
    }
    case 38772: {
      return 33865;
    }
    case 38773: {
      return 33993;
    }
    case 38774: {
      return 35201;
    }
    case 38775: {
      return 35617;
    }
    case 38776: {
      return 36362;
    }
    case 38777: {
      return 36965;
    }
    case 38778: {
      return 38525;
    }
    case 38779: {
      return 39178;
    }
    case 38780: {
      return 24958;
    }
    case 38781: {
      return 25233;
    }
    case 38782: {
      return 27442;
    }
    case 38784: {
      return 27779;
    }
    case 38785: {
      return 28020;
    }
    case 38786: {
      return 32716;
    }
    case 38787: {
      return 32764;
    }
    case 38788: {
      return 28096;
    }
    case 38789: {
      return 32645;
    }
    case 38790: {
      return 34746;
    }
    case 38791: {
      return 35064;
    }
    case 38792: {
      return 26469;
    }
    case 38793: {
      return 33713;
    }
    case 38794: {
      return 38972;
    }
    case 38795: {
      return 38647;
    }
    case 38796: {
      return 27931;
    }
    case 38797: {
      return 32097;
    }
    case 38798: {
      return 33853;
    }
    case 38799: {
      return 37226;
    }
    case 38800: {
      return 20081;
    }
    case 38801: {
      return 21365;
    }
    case 38802: {
      return 23888;
    }
    case 38803: {
      return 27396;
    }
    case 38804: {
      return 28651;
    }
    case 38805: {
      return 34253;
    }
    case 38806: {
      return 34349;
    }
    case 38807: {
      return 35239;
    }
    case 38808: {
      return 21033;
    }
    case 38809: {
      return 21519;
    }
    case 38810: {
      return 23653;
    }
    case 38811: {
      return 26446;
    }
    case 38812: {
      return 26792;
    }
    case 38813: {
      return 29702;
    }
    case 38814: {
      return 29827;
    }
    case 38815: {
      return 30178;
    }
    case 38816: {
      return 35023;
    }
    case 38817: {
      return 35041;
    }
    case 38818: {
      return 37324;
    }
    case 38819: {
      return 38626;
    }
    case 38820: {
      return 38520;
    }
    case 38821: {
      return 24459;
    }
    case 38822: {
      return 29575;
    }
    case 38823: {
      return 31435;
    }
    case 38824: {
      return 33870;
    }
    case 38825: {
      return 25504;
    }
    case 38826: {
      return 30053;
    }
    case 38827: {
      return 21129;
    }
    case 38828: {
      return 27969;
    }
    case 38829: {
      return 28316;
    }
    case 38830: {
      return 29705;
    }
    case 38831: {
      return 30041;
    }
    case 38832: {
      return 30827;
    }
    case 38833: {
      return 31890;
    }
    case 38834: {
      return 38534;
    }
    case 38835: {
      return 31452;
    }
    case 38836: {
      return 40845;
    }
    case 38837: {
      return 20406;
    }
    case 38838: {
      return 24942;
    }
    case 38839: {
      return 26053;
    }
    case 38840: {
      return 34396;
    }
    case 38841: {
      return 20102;
    }
    case 38842: {
      return 20142;
    }
    case 38843: {
      return 20698;
    }
    case 38844: {
      return 20001;
    }
    case 38845: {
      return 20940;
    }
    case 38846: {
      return 23534;
    }
    case 38847: {
      return 26009;
    }
    case 38848: {
      return 26753;
    }
    case 38849: {
      return 28092;
    }
    case 38850: {
      return 29471;
    }
    case 38851: {
      return 30274;
    }
    case 38852: {
      return 30637;
    }
    case 38853: {
      return 31260;
    }
    case 38854: {
      return 31975;
    }
    case 38855: {
      return 33391;
    }
    case 38856: {
      return 35538;
    }
    case 38857: {
      return 36988;
    }
    case 38858: {
      return 37327;
    }
    case 38859: {
      return 38517;
    }
    case 38860: {
      return 38936;
    }
    case 38861: {
      return 21147;
    }
    case 38862: {
      return 32209;
    }
    case 38863: {
      return 20523;
    }
    case 38864: {
      return 21400;
    }
    case 38865: {
      return 26519;
    }
    case 38866: {
      return 28107;
    }
    case 38867: {
      return 29136;
    }
    case 38868: {
      return 29747;
    }
    case 38869: {
      return 33256;
    }
    case 38870: {
      return 36650;
    }
    case 38871: {
      return 38563;
    }
    case 38872: {
      return 40023;
    }
    case 38873: {
      return 40607;
    }
    case 38874: {
      return 29792;
    }
    case 38875: {
      return 22593;
    }
    case 38876: {
      return 28057;
    }
    case 38877: {
      return 32047;
    }
    case 38878: {
      return 39006;
    }
    case 38879: {
      return 20196;
    }
    case 38880: {
      return 20278;
    }
    case 38881: {
      return 20363;
    }
    case 38882: {
      return 20919;
    }
    case 38883: {
      return 21169;
    }
    case 38884: {
      return 23994;
    }
    case 38885: {
      return 24604;
    }
    case 38886: {
      return 29618;
    }
    case 38887: {
      return 31036;
    }
    case 38888: {
      return 33491;
    }
    case 38889: {
      return 37428;
    }
    case 38890: {
      return 38583;
    }
    case 38891: {
      return 38646;
    }
    case 38892: {
      return 38666;
    }
    case 38893: {
      return 40599;
    }
    case 38894: {
      return 40802;
    }
    case 38895: {
      return 26278;
    }
    case 38896: {
      return 27508;
    }
    case 38897: {
      return 21015;
    }
    case 38898: {
      return 21155;
    }
    case 38899: {
      return 28872;
    }
    case 38900: {
      return 35010;
    }
    case 38901: {
      return 24265;
    }
    case 38902: {
      return 24651;
    }
    case 38903: {
      return 24976;
    }
    case 38904: {
      return 28451;
    }
    case 38905: {
      return 29001;
    }
    case 38906: {
      return 31806;
    }
    case 38907: {
      return 32244;
    }
    case 38908: {
      return 32879;
    }
    case 38976: {
      return 34030;
    }
    case 38977: {
      return 36899;
    }
    case 38978: {
      return 37676;
    }
    case 38979: {
      return 21570;
    }
    case 38980: {
      return 39791;
    }
    case 38981: {
      return 27347;
    }
    case 38982: {
      return 28809;
    }
    case 38983: {
      return 36034;
    }
    case 38984: {
      return 36335;
    }
    case 38985: {
      return 38706;
    }
    case 38986: {
      return 21172;
    }
    case 38987: {
      return 23105;
    }
    case 38988: {
      return 24266;
    }
    case 38989: {
      return 24324;
    }
    case 38990: {
      return 26391;
    }
    case 38991: {
      return 27004;
    }
    case 38992: {
      return 27028;
    }
    case 38993: {
      return 28010;
    }
    case 38994: {
      return 28431;
    }
    case 38995: {
      return 29282;
    }
    case 38996: {
      return 29436;
    }
    case 38997: {
      return 31725;
    }
    case 38998: {
      return 32769;
    }
    case 38999: {
      return 32894;
    }
    case 39000: {
      return 34635;
    }
    case 39001: {
      return 37070;
    }
    case 39002: {
      return 20845;
    }
    case 39003: {
      return 40595;
    }
    case 39004: {
      return 31108;
    }
    case 39005: {
      return 32907;
    }
    case 39006: {
      return 37682;
    }
    case 39007: {
      return 35542;
    }
    case 39008: {
      return 20525;
    }
    case 39009: {
      return 21644;
    }
    case 39010: {
      return 35441;
    }
    case 39011: {
      return 27498;
    }
    case 39012: {
      return 36036;
    }
    case 39013: {
      return 33031;
    }
    case 39014: {
      return 24785;
    }
    case 39015: {
      return 26528;
    }
    case 39016: {
      return 40434;
    }
    case 39017: {
      return 20121;
    }
    case 39018: {
      return 20120;
    }
    case 39019: {
      return 39952;
    }
    case 39020: {
      return 35435;
    }
    case 39021: {
      return 34241;
    }
    case 39022: {
      return 34152;
    }
    case 39023: {
      return 26880;
    }
    case 39024: {
      return 28286;
    }
    case 39025: {
      return 30871;
    }
    case 39026: {
      return 33109;
    }
    case 39071: {
      return 24332;
    }
    case 39072: {
      return 19984;
    }
    case 39073: {
      return 19989;
    }
    case 39074: {
      return 20010;
    }
    case 39075: {
      return 20017;
    }
    case 39076: {
      return 20022;
    }
    case 39077: {
      return 20028;
    }
    case 39078: {
      return 20031;
    }
    case 39079: {
      return 20034;
    }
    case 39080: {
      return 20054;
    }
    case 39081: {
      return 20056;
    }
    case 39082: {
      return 20098;
    }
    case 39083: {
      return 20101;
    }
    case 39084: {
      return 35947;
    }
    case 39085: {
      return 20106;
    }
    case 39086: {
      return 33298;
    }
    case 39087: {
      return 24333;
    }
    case 39088: {
      return 20110;
    }
    case 39089: {
      return 20126;
    }
    case 39090: {
      return 20127;
    }
    case 39091: {
      return 20128;
    }
    case 39092: {
      return 20130;
    }
    case 39093: {
      return 20144;
    }
    case 39094: {
      return 20147;
    }
    case 39095: {
      return 20150;
    }
    case 39096: {
      return 20174;
    }
    case 39097: {
      return 20173;
    }
    case 39098: {
      return 20164;
    }
    case 39099: {
      return 20166;
    }
    case 39100: {
      return 20162;
    }
    case 39101: {
      return 20183;
    }
    case 39102: {
      return 20190;
    }
    case 39103: {
      return 20205;
    }
    case 39104: {
      return 20191;
    }
    case 39105: {
      return 20215;
    }
    case 39106: {
      return 20233;
    }
    case 39107: {
      return 20314;
    }
    case 39108: {
      return 20272;
    }
    case 39109: {
      return 20315;
    }
    case 39110: {
      return 20317;
    }
    case 39111: {
      return 20311;
    }
    case 39112: {
      return 20295;
    }
    case 39113: {
      return 20342;
    }
    case 39114: {
      return 20360;
    }
    case 39115: {
      return 20367;
    }
    case 39116: {
      return 20376;
    }
    case 39117: {
      return 20347;
    }
    case 39118: {
      return 20329;
    }
    case 39119: {
      return 20336;
    }
    case 39120: {
      return 20369;
    }
    case 39121: {
      return 20335;
    }
    case 39122: {
      return 20358;
    }
    case 39123: {
      return 20374;
    }
    case 39124: {
      return 20760;
    }
    case 39125: {
      return 20436;
    }
    case 39126: {
      return 20447;
    }
    case 39127: {
      return 20430;
    }
    case 39128: {
      return 20440;
    }
    case 39129: {
      return 20443;
    }
    case 39130: {
      return 20433;
    }
    case 39131: {
      return 20442;
    }
    case 39132: {
      return 20432;
    }
    case 39133: {
      return 20452;
    }
    case 39134: {
      return 20453;
    }
    case 39135: {
      return 20506;
    }
    case 39136: {
      return 20520;
    }
    case 39137: {
      return 20500;
    }
    case 39138: {
      return 20522;
    }
    case 39139: {
      return 20517;
    }
    case 39140: {
      return 20485;
    }
    case 39141: {
      return 20252;
    }
    case 39142: {
      return 20470;
    }
    case 39143: {
      return 20513;
    }
    case 39144: {
      return 20521;
    }
    case 39145: {
      return 20524;
    }
    case 39146: {
      return 20478;
    }
    case 39147: {
      return 20463;
    }
    case 39148: {
      return 20497;
    }
    case 39149: {
      return 20486;
    }
    case 39150: {
      return 20547;
    }
    case 39151: {
      return 20551;
    }
    case 39152: {
      return 26371;
    }
    case 39153: {
      return 20565;
    }
    case 39154: {
      return 20560;
    }
    case 39155: {
      return 20552;
    }
    case 39156: {
      return 20570;
    }
    case 39157: {
      return 20566;
    }
    case 39158: {
      return 20588;
    }
    case 39159: {
      return 20600;
    }
    case 39160: {
      return 20608;
    }
    case 39161: {
      return 20634;
    }
    case 39162: {
      return 20613;
    }
    case 39163: {
      return 20660;
    }
    case 39164: {
      return 20658;
    }
    case 39232: {
      return 20681;
    }
    case 39233: {
      return 20682;
    }
    case 39234: {
      return 20659;
    }
    case 39235: {
      return 20674;
    }
    case 39236: {
      return 20694;
    }
    case 39237: {
      return 20702;
    }
    case 39238: {
      return 20709;
    }
    case 39239: {
      return 20717;
    }
    case 39240: {
      return 20707;
    }
    case 39241: {
      return 20718;
    }
    case 39242: {
      return 20729;
    }
    case 39243: {
      return 20725;
    }
    case 39244: {
      return 20745;
    }
    case 39245: {
      return 20737;
    }
    case 39246: {
      return 20738;
    }
    case 39247: {
      return 20758;
    }
    case 39248: {
      return 20757;
    }
    case 39249: {
      return 20756;
    }
    case 39250: {
      return 20762;
    }
    case 39251: {
      return 20769;
    }
    case 39252: {
      return 20794;
    }
    case 39253: {
      return 20791;
    }
    case 39254: {
      return 20796;
    }
    case 39255: {
      return 20795;
    }
    case 39256: {
      return 20799;
    }
    case 39257: {
      return 20800;
    }
    case 39258: {
      return 20818;
    }
    case 39259: {
      return 20812;
    }
    case 39260: {
      return 20820;
    }
    case 39261: {
      return 20834;
    }
    case 39262: {
      return 31480;
    }
    case 39263: {
      return 20841;
    }
    case 39264: {
      return 20842;
    }
    case 39265: {
      return 20846;
    }
    case 39266: {
      return 20864;
    }
    case 39267: {
      return 20866;
    }
    case 39268: {
      return 22232;
    }
    case 39269: {
      return 20876;
    }
    case 39270: {
      return 20873;
    }
    case 39271: {
      return 20879;
    }
    case 39272: {
      return 20881;
    }
    case 39273: {
      return 20883;
    }
    case 39274: {
      return 20885;
    }
    case 39275: {
      return 20886;
    }
    case 39276: {
      return 20900;
    }
    case 39277: {
      return 20902;
    }
    case 39278: {
      return 20898;
    }
    case 39279: {
      return 20905;
    }
    case 39280: {
      return 20906;
    }
    case 39281: {
      return 20907;
    }
    case 39282: {
      return 20915;
    }
    case 39283: {
      return 20913;
    }
    case 39284: {
      return 20914;
    }
    case 39285: {
      return 20912;
    }
    case 39286: {
      return 20917;
    }
    case 39287: {
      return 20925;
    }
    case 39288: {
      return 20933;
    }
    case 39289: {
      return 20937;
    }
    case 39290: {
      return 20955;
    }
    case 39291: {
      return 20960;
    }
    case 39292: {
      return 34389;
    }
    case 39293: {
      return 20969;
    }
    case 39294: {
      return 20973;
    }
    case 39296: {
      return 20976;
    }
    case 39297: {
      return 20981;
    }
    case 39298: {
      return 20990;
    }
    case 39299: {
      return 20996;
    }
    case 39300: {
      return 21003;
    }
    case 39301: {
      return 21012;
    }
    case 39302: {
      return 21006;
    }
    case 39303: {
      return 21031;
    }
    case 39304: {
      return 21034;
    }
    case 39305: {
      return 21038;
    }
    case 39306: {
      return 21043;
    }
    case 39307: {
      return 21049;
    }
    case 39308: {
      return 21071;
    }
    case 39309: {
      return 21060;
    }
    case 39310: {
      return 21067;
    }
    case 39311: {
      return 21068;
    }
    case 39312: {
      return 21086;
    }
    case 39313: {
      return 21076;
    }
    case 39314: {
      return 21098;
    }
    case 39315: {
      return 21108;
    }
    case 39316: {
      return 21097;
    }
    case 39317: {
      return 21107;
    }
    case 39318: {
      return 21119;
    }
    case 39319: {
      return 21117;
    }
    case 39320: {
      return 21133;
    }
    case 39321: {
      return 21140;
    }
    case 39322: {
      return 21138;
    }
    case 39323: {
      return 21105;
    }
    case 39324: {
      return 21128;
    }
    case 39325: {
      return 21137;
    }
    case 39326: {
      return 36776;
    }
    case 39327: {
      return 36775;
    }
    case 39328: {
      return 21164;
    }
    case 39329: {
      return 21165;
    }
    case 39330: {
      return 21180;
    }
    case 39331: {
      return 21173;
    }
    case 39332: {
      return 21185;
    }
    case 39333: {
      return 21197;
    }
    case 39334: {
      return 21207;
    }
    case 39335: {
      return 21214;
    }
    case 39336: {
      return 21219;
    }
    case 39337: {
      return 21222;
    }
    case 39338: {
      return 39149;
    }
    case 39339: {
      return 21216;
    }
    case 39340: {
      return 21235;
    }
    case 39341: {
      return 21237;
    }
    case 39342: {
      return 21240;
    }
    case 39343: {
      return 21241;
    }
    case 39344: {
      return 21254;
    }
    case 39345: {
      return 21256;
    }
    case 39346: {
      return 30008;
    }
    case 39347: {
      return 21261;
    }
    case 39348: {
      return 21264;
    }
    case 39349: {
      return 21263;
    }
    case 39350: {
      return 21269;
    }
    case 39351: {
      return 21274;
    }
    case 39352: {
      return 21283;
    }
    case 39353: {
      return 21295;
    }
    case 39354: {
      return 21297;
    }
    case 39355: {
      return 21299;
    }
    case 39356: {
      return 21304;
    }
    case 39357: {
      return 21312;
    }
    case 39358: {
      return 21318;
    }
    case 39359: {
      return 21317;
    }
    case 39360: {
      return 19991;
    }
    case 39361: {
      return 21321;
    }
    case 39362: {
      return 21325;
    }
    case 39363: {
      return 20950;
    }
    case 39364: {
      return 21342;
    }
    case 39365: {
      return 21353;
    }
    case 39366: {
      return 21358;
    }
    case 39367: {
      return 22808;
    }
    case 39368: {
      return 21371;
    }
    case 39369: {
      return 21367;
    }
    case 39370: {
      return 21378;
    }
    case 39371: {
      return 21398;
    }
    case 39372: {
      return 21408;
    }
    case 39373: {
      return 21414;
    }
    case 39374: {
      return 21413;
    }
    case 39375: {
      return 21422;
    }
    case 39376: {
      return 21424;
    }
    case 39377: {
      return 21430;
    }
    case 39378: {
      return 21443;
    }
    case 39379: {
      return 31762;
    }
    case 39380: {
      return 38617;
    }
    case 39381: {
      return 21471;
    }
    case 39382: {
      return 26364;
    }
    case 39383: {
      return 29166;
    }
    case 39384: {
      return 21486;
    }
    case 39385: {
      return 21480;
    }
    case 39386: {
      return 21485;
    }
    case 39387: {
      return 21498;
    }
    case 39388: {
      return 21505;
    }
    case 39389: {
      return 21565;
    }
    case 39390: {
      return 21568;
    }
    case 39391: {
      return 21548;
    }
    case 39392: {
      return 21549;
    }
    case 39393: {
      return 21564;
    }
    case 39394: {
      return 21550;
    }
    case 39395: {
      return 21558;
    }
    case 39396: {
      return 21545;
    }
    case 39397: {
      return 21533;
    }
    case 39398: {
      return 21582;
    }
    case 39399: {
      return 21647;
    }
    case 39400: {
      return 21621;
    }
    case 39401: {
      return 21646;
    }
    case 39402: {
      return 21599;
    }
    case 39403: {
      return 21617;
    }
    case 39404: {
      return 21623;
    }
    case 39405: {
      return 21616;
    }
    case 39406: {
      return 21650;
    }
    case 39407: {
      return 21627;
    }
    case 39408: {
      return 21632;
    }
    case 39409: {
      return 21622;
    }
    case 39410: {
      return 21636;
    }
    case 39411: {
      return 21648;
    }
    case 39412: {
      return 21638;
    }
    case 39413: {
      return 21703;
    }
    case 39414: {
      return 21666;
    }
    case 39415: {
      return 21688;
    }
    case 39416: {
      return 21669;
    }
    case 39417: {
      return 21676;
    }
    case 39418: {
      return 21700;
    }
    case 39419: {
      return 21704;
    }
    case 39420: {
      return 21672;
    }
    case 39488: {
      return 21675;
    }
    case 39489: {
      return 21698;
    }
    case 39490: {
      return 21668;
    }
    case 39491: {
      return 21694;
    }
    case 39492: {
      return 21692;
    }
    case 39493: {
      return 21720;
    }
    case 39494: {
      return 21733;
    }
    case 39495: {
      return 21734;
    }
    case 39496: {
      return 21775;
    }
    case 39497: {
      return 21780;
    }
    case 39498: {
      return 21757;
    }
    case 39499: {
      return 21742;
    }
    case 39500: {
      return 21741;
    }
    case 39501: {
      return 21754;
    }
    case 39502: {
      return 21730;
    }
    case 39503: {
      return 21817;
    }
    case 39504: {
      return 21824;
    }
    case 39505: {
      return 21859;
    }
    case 39506: {
      return 21836;
    }
    case 39507: {
      return 21806;
    }
    case 39508: {
      return 21852;
    }
    case 39509: {
      return 21829;
    }
    case 39510: {
      return 21846;
    }
    case 39511: {
      return 21847;
    }
    case 39512: {
      return 21816;
    }
    case 39513: {
      return 21811;
    }
    case 39514: {
      return 21853;
    }
    case 39515: {
      return 21913;
    }
    case 39516: {
      return 21888;
    }
    case 39517: {
      return 21679;
    }
    case 39518: {
      return 21898;
    }
    case 39519: {
      return 21919;
    }
    case 39520: {
      return 21883;
    }
    case 39521: {
      return 21886;
    }
    case 39522: {
      return 21912;
    }
    case 39523: {
      return 21918;
    }
    case 39524: {
      return 21934;
    }
    case 39525: {
      return 21884;
    }
    case 39526: {
      return 21891;
    }
    case 39527: {
      return 21929;
    }
    case 39528: {
      return 21895;
    }
    case 39529: {
      return 21928;
    }
    case 39530: {
      return 21978;
    }
    case 39531: {
      return 21957;
    }
    case 39532: {
      return 21983;
    }
    case 39533: {
      return 21956;
    }
    case 39534: {
      return 21980;
    }
    case 39535: {
      return 21988;
    }
    case 39536: {
      return 21972;
    }
    case 39537: {
      return 22036;
    }
    case 39538: {
      return 22007;
    }
    case 39539: {
      return 22038;
    }
    case 39540: {
      return 22014;
    }
    case 39541: {
      return 22013;
    }
    case 39542: {
      return 22043;
    }
    case 39543: {
      return 22009;
    }
    case 39544: {
      return 22094;
    }
    case 39545: {
      return 22096;
    }
    case 39546: {
      return 29151;
    }
    case 39547: {
      return 22068;
    }
    case 39548: {
      return 22070;
    }
    case 39549: {
      return 22066;
    }
    case 39550: {
      return 22072;
    }
    case 39552: {
      return 22123;
    }
    case 39553: {
      return 22116;
    }
    case 39554: {
      return 22063;
    }
    case 39555: {
      return 22124;
    }
    case 39556: {
      return 22122;
    }
    case 39557: {
      return 22150;
    }
    case 39558: {
      return 22144;
    }
    case 39559: {
      return 22154;
    }
    case 39560: {
      return 22176;
    }
    case 39561: {
      return 22164;
    }
    case 39562: {
      return 22159;
    }
    case 39563: {
      return 22181;
    }
    case 39564: {
      return 22190;
    }
    case 39565: {
      return 22198;
    }
    case 39566: {
      return 22196;
    }
    case 39567: {
      return 22210;
    }
    case 39568: {
      return 22204;
    }
    case 39569: {
      return 22209;
    }
    case 39570: {
      return 22211;
    }
    case 39571: {
      return 22208;
    }
    case 39572: {
      return 22216;
    }
    case 39573: {
      return 22222;
    }
    case 39574: {
      return 22225;
    }
    case 39575: {
      return 22227;
    }
    case 39576: {
      return 22231;
    }
    case 39577: {
      return 22254;
    }
    case 39578: {
      return 22265;
    }
    case 39579: {
      return 22272;
    }
    case 39580: {
      return 22271;
    }
    case 39581: {
      return 22276;
    }
    case 39582: {
      return 22281;
    }
    case 39583: {
      return 22280;
    }
    case 39584: {
      return 22283;
    }
    case 39585: {
      return 22285;
    }
    case 39586: {
      return 22291;
    }
    case 39587: {
      return 22296;
    }
    case 39588: {
      return 22294;
    }
    case 39589: {
      return 21959;
    }
    case 39590: {
      return 22300;
    }
    case 39591: {
      return 22310;
    }
    case 39592: {
      return 22327;
    }
    case 39593: {
      return 22328;
    }
    case 39594: {
      return 22350;
    }
    case 39595: {
      return 22331;
    }
    case 39596: {
      return 22336;
    }
    case 39597: {
      return 22351;
    }
    case 39598: {
      return 22377;
    }
    case 39599: {
      return 22464;
    }
    case 39600: {
      return 22408;
    }
    case 39601: {
      return 22369;
    }
    case 39602: {
      return 22399;
    }
    case 39603: {
      return 22409;
    }
    case 39604: {
      return 22419;
    }
    case 39605: {
      return 22432;
    }
    case 39606: {
      return 22451;
    }
    case 39607: {
      return 22436;
    }
    case 39608: {
      return 22442;
    }
    case 39609: {
      return 22448;
    }
    case 39610: {
      return 22467;
    }
    case 39611: {
      return 22470;
    }
    case 39612: {
      return 22484;
    }
    case 39613: {
      return 22482;
    }
    case 39614: {
      return 22483;
    }
    case 39615: {
      return 22538;
    }
    case 39616: {
      return 22486;
    }
    case 39617: {
      return 22499;
    }
    case 39618: {
      return 22539;
    }
    case 39619: {
      return 22553;
    }
    case 39620: {
      return 22557;
    }
    case 39621: {
      return 22642;
    }
    case 39622: {
      return 22561;
    }
    case 39623: {
      return 22626;
    }
    case 39624: {
      return 22603;
    }
    case 39625: {
      return 22640;
    }
    case 39626: {
      return 27584;
    }
    case 39627: {
      return 22610;
    }
    case 39628: {
      return 22589;
    }
    case 39629: {
      return 22649;
    }
    case 39630: {
      return 22661;
    }
    case 39631: {
      return 22713;
    }
    case 39632: {
      return 22687;
    }
    case 39633: {
      return 22699;
    }
    case 39634: {
      return 22714;
    }
    case 39635: {
      return 22750;
    }
    case 39636: {
      return 22715;
    }
    case 39637: {
      return 22712;
    }
    case 39638: {
      return 22702;
    }
    case 39639: {
      return 22725;
    }
    case 39640: {
      return 22739;
    }
    case 39641: {
      return 22737;
    }
    case 39642: {
      return 22743;
    }
    case 39643: {
      return 22745;
    }
    case 39644: {
      return 22744;
    }
    case 39645: {
      return 22757;
    }
    case 39646: {
      return 22748;
    }
    case 39647: {
      return 22756;
    }
    case 39648: {
      return 22751;
    }
    case 39649: {
      return 22767;
    }
    case 39650: {
      return 22778;
    }
    case 39651: {
      return 22777;
    }
    case 39652: {
      return 22779;
    }
    case 39653: {
      return 22780;
    }
    case 39654: {
      return 22781;
    }
    case 39655: {
      return 22786;
    }
    case 39656: {
      return 22794;
    }
    case 39657: {
      return 22800;
    }
    case 39658: {
      return 22811;
    }
    case 39659: {
      return 26790;
    }
    case 39660: {
      return 22821;
    }
    case 39661: {
      return 22828;
    }
    case 39662: {
      return 22829;
    }
    case 39663: {
      return 22834;
    }
    case 39664: {
      return 22840;
    }
    case 39665: {
      return 22846;
    }
    case 39666: {
      return 31442;
    }
    case 39667: {
      return 22869;
    }
    case 39668: {
      return 22864;
    }
    case 39669: {
      return 22862;
    }
    case 39670: {
      return 22874;
    }
    case 39671: {
      return 22872;
    }
    case 39672: {
      return 22882;
    }
    case 39673: {
      return 22880;
    }
    case 39674: {
      return 22887;
    }
    case 39675: {
      return 22892;
    }
    case 39676: {
      return 22889;
    }
    case 39744: {
      return 22904;
    }
    case 39745: {
      return 22913;
    }
    case 39746: {
      return 22941;
    }
    case 39747: {
      return 20318;
    }
    case 39748: {
      return 20395;
    }
    case 39749: {
      return 22947;
    }
    case 39750: {
      return 22962;
    }
    case 39751: {
      return 22982;
    }
    case 39752: {
      return 23016;
    }
    case 39753: {
      return 23004;
    }
    case 39754: {
      return 22925;
    }
    case 39755: {
      return 23001;
    }
    case 39756: {
      return 23002;
    }
    case 39757: {
      return 23077;
    }
    case 39758: {
      return 23071;
    }
    case 39759: {
      return 23057;
    }
    case 39760: {
      return 23068;
    }
    case 39761: {
      return 23049;
    }
    case 39762: {
      return 23066;
    }
    case 39763: {
      return 23104;
    }
    case 39764: {
      return 23148;
    }
    case 39765: {
      return 23113;
    }
    case 39766: {
      return 23093;
    }
    case 39767: {
      return 23094;
    }
    case 39768: {
      return 23138;
    }
    case 39769: {
      return 23146;
    }
    case 39770: {
      return 23194;
    }
    case 39771: {
      return 23228;
    }
    case 39772: {
      return 23230;
    }
    case 39773: {
      return 23243;
    }
    case 39774: {
      return 23234;
    }
    case 39775: {
      return 23229;
    }
    case 39776: {
      return 23267;
    }
    case 39777: {
      return 23255;
    }
    case 39778: {
      return 23270;
    }
    case 39779: {
      return 23273;
    }
    case 39780: {
      return 23254;
    }
    case 39781: {
      return 23290;
    }
    case 39782: {
      return 23291;
    }
    case 39783: {
      return 23308;
    }
    case 39784: {
      return 23307;
    }
    case 39785: {
      return 23318;
    }
    case 39786: {
      return 23346;
    }
    case 39787: {
      return 23248;
    }
    case 39788: {
      return 23338;
    }
    case 39789: {
      return 23350;
    }
    case 39790: {
      return 23358;
    }
    case 39791: {
      return 23363;
    }
    case 39792: {
      return 23365;
    }
    case 39793: {
      return 23360;
    }
    case 39794: {
      return 23377;
    }
    case 39795: {
      return 23381;
    }
    case 39796: {
      return 23386;
    }
    case 39797: {
      return 23387;
    }
    case 39798: {
      return 23397;
    }
    case 39799: {
      return 23401;
    }
    case 39800: {
      return 23408;
    }
    case 39801: {
      return 23411;
    }
    case 39802: {
      return 23413;
    }
    case 39803: {
      return 23416;
    }
    case 39804: {
      return 25992;
    }
    case 39805: {
      return 23418;
    }
    case 39806: {
      return 23424;
    }
    case 39808: {
      return 23427;
    }
    case 39809: {
      return 23462;
    }
    case 39810: {
      return 23480;
    }
    case 39811: {
      return 23491;
    }
    case 39812: {
      return 23495;
    }
    case 39813: {
      return 23497;
    }
    case 39814: {
      return 23508;
    }
    case 39815: {
      return 23504;
    }
    case 39816: {
      return 23524;
    }
    case 39817: {
      return 23526;
    }
    case 39818: {
      return 23522;
    }
    case 39819: {
      return 23518;
    }
    case 39820: {
      return 23525;
    }
    case 39821: {
      return 23531;
    }
    case 39822: {
      return 23536;
    }
    case 39823: {
      return 23542;
    }
    case 39824: {
      return 23539;
    }
    case 39825: {
      return 23557;
    }
    case 39826: {
      return 23559;
    }
    case 39827: {
      return 23560;
    }
    case 39828: {
      return 23565;
    }
    case 39829: {
      return 23571;
    }
    case 39830: {
      return 23584;
    }
    case 39831: {
      return 23586;
    }
    case 39832: {
      return 23592;
    }
    case 39833: {
      return 23608;
    }
    case 39834: {
      return 23609;
    }
    case 39835: {
      return 23617;
    }
    case 39836: {
      return 23622;
    }
    case 39837: {
      return 23630;
    }
    case 39838: {
      return 23635;
    }
    case 39839: {
      return 23632;
    }
    case 39840: {
      return 23631;
    }
    case 39841: {
      return 23409;
    }
    case 39842: {
      return 23660;
    }
    case 39843: {
      return 23662;
    }
    case 39844: {
      return 20066;
    }
    case 39845: {
      return 23670;
    }
    case 39846: {
      return 23673;
    }
    case 39847: {
      return 23692;
    }
    case 39848: {
      return 23697;
    }
    case 39849: {
      return 23700;
    }
    case 39850: {
      return 22939;
    }
    case 39851: {
      return 23723;
    }
    case 39852: {
      return 23739;
    }
    case 39853: {
      return 23734;
    }
    case 39854: {
      return 23740;
    }
    case 39855: {
      return 23735;
    }
    case 39856: {
      return 23749;
    }
    case 39857: {
      return 23742;
    }
    case 39858: {
      return 23751;
    }
    case 39859: {
      return 23769;
    }
    case 39860: {
      return 23785;
    }
    case 39861: {
      return 23805;
    }
    case 39862: {
      return 23802;
    }
    case 39863: {
      return 23789;
    }
    case 39864: {
      return 23948;
    }
    case 39865: {
      return 23786;
    }
    case 39866: {
      return 23819;
    }
    case 39867: {
      return 23829;
    }
    case 39868: {
      return 23831;
    }
    case 39869: {
      return 23900;
    }
    case 39870: {
      return 23839;
    }
    case 39871: {
      return 23835;
    }
    case 39872: {
      return 23825;
    }
    case 39873: {
      return 23828;
    }
    case 39874: {
      return 23842;
    }
    case 39875: {
      return 23834;
    }
    case 39876: {
      return 23833;
    }
    case 39877: {
      return 23832;
    }
    case 39878: {
      return 23884;
    }
    case 39879: {
      return 23890;
    }
    case 39880: {
      return 23886;
    }
    case 39881: {
      return 23883;
    }
    case 39882: {
      return 23916;
    }
    case 39883: {
      return 23923;
    }
    case 39884: {
      return 23926;
    }
    case 39885: {
      return 23943;
    }
    case 39886: {
      return 23940;
    }
    case 39887: {
      return 23938;
    }
    case 39888: {
      return 23970;
    }
    case 39889: {
      return 23965;
    }
    case 39890: {
      return 23980;
    }
    case 39891: {
      return 23982;
    }
    case 39892: {
      return 23997;
    }
    case 39893: {
      return 23952;
    }
    case 39894: {
      return 23991;
    }
    case 39895: {
      return 23996;
    }
    case 39896: {
      return 24009;
    }
    case 39897: {
      return 24013;
    }
    case 39898: {
      return 24019;
    }
    case 39899: {
      return 24018;
    }
    case 39900: {
      return 24022;
    }
    case 39901: {
      return 24027;
    }
    case 39902: {
      return 24043;
    }
    case 39903: {
      return 24050;
    }
    case 39904: {
      return 24053;
    }
    case 39905: {
      return 24075;
    }
    case 39906: {
      return 24090;
    }
    case 39907: {
      return 24089;
    }
    case 39908: {
      return 24081;
    }
    case 39909: {
      return 24091;
    }
    case 39910: {
      return 24118;
    }
    case 39911: {
      return 24119;
    }
    case 39912: {
      return 24132;
    }
    case 39913: {
      return 24131;
    }
    case 39914: {
      return 24128;
    }
    case 39915: {
      return 24142;
    }
    case 39916: {
      return 24151;
    }
    case 39917: {
      return 24148;
    }
    case 39918: {
      return 24159;
    }
    case 39919: {
      return 24162;
    }
    case 39920: {
      return 24164;
    }
    case 39921: {
      return 24135;
    }
    case 39922: {
      return 24181;
    }
    case 39923: {
      return 24182;
    }
    case 39924: {
      return 24186;
    }
    case 39925: {
      return 40636;
    }
    case 39926: {
      return 24191;
    }
    case 39927: {
      return 24224;
    }
    case 39928: {
      return 24257;
    }
    case 39929: {
      return 24258;
    }
    case 39930: {
      return 24264;
    }
    case 39931: {
      return 24272;
    }
    case 39932: {
      return 24271;
    }
    case 40000: {
      return 24278;
    }
    case 40001: {
      return 24291;
    }
    case 40002: {
      return 24285;
    }
    case 40003: {
      return 24282;
    }
    case 40004: {
      return 24283;
    }
    case 40005: {
      return 24290;
    }
    case 40006: {
      return 24289;
    }
    case 40007: {
      return 24296;
    }
    case 40008: {
      return 24297;
    }
    case 40009: {
      return 24300;
    }
    case 40010: {
      return 24305;
    }
    case 40011: {
      return 24307;
    }
    case 40012: {
      return 24304;
    }
    case 40013: {
      return 24308;
    }
    case 40014: {
      return 24312;
    }
    case 40015: {
      return 24318;
    }
    case 40016: {
      return 24323;
    }
    case 40017: {
      return 24329;
    }
    case 40018: {
      return 24413;
    }
    case 40019: {
      return 24412;
    }
    case 40020: {
      return 24331;
    }
    case 40021: {
      return 24337;
    }
    case 40022: {
      return 24342;
    }
    case 40023: {
      return 24361;
    }
    case 40024: {
      return 24365;
    }
    case 40025: {
      return 24376;
    }
    case 40026: {
      return 24385;
    }
    case 40027: {
      return 24392;
    }
    case 40028: {
      return 24396;
    }
    case 40029: {
      return 24398;
    }
    case 40030: {
      return 24367;
    }
    case 40031: {
      return 24401;
    }
    case 40032: {
      return 24406;
    }
    case 40033: {
      return 24407;
    }
    case 40034: {
      return 24409;
    }
    case 40035: {
      return 24417;
    }
    case 40036: {
      return 24429;
    }
    case 40037: {
      return 24435;
    }
    case 40038: {
      return 24439;
    }
    case 40039: {
      return 24451;
    }
    case 40040: {
      return 24450;
    }
    case 40041: {
      return 24447;
    }
    case 40042: {
      return 24458;
    }
    case 40043: {
      return 24456;
    }
    case 40044: {
      return 24465;
    }
    case 40045: {
      return 24455;
    }
    case 40046: {
      return 24478;
    }
    case 40047: {
      return 24473;
    }
    case 40048: {
      return 24472;
    }
    case 40049: {
      return 24480;
    }
    case 40050: {
      return 24488;
    }
    case 40051: {
      return 24493;
    }
    case 40052: {
      return 24508;
    }
    case 40053: {
      return 24534;
    }
    case 40054: {
      return 24571;
    }
    case 40055: {
      return 24548;
    }
    case 40056: {
      return 24568;
    }
    case 40057: {
      return 24561;
    }
    case 40058: {
      return 24541;
    }
    case 40059: {
      return 24755;
    }
    case 40060: {
      return 24575;
    }
    case 40061: {
      return 24609;
    }
    case 40062: {
      return 24672;
    }
    case 40064: {
      return 24601;
    }
    case 40065: {
      return 24592;
    }
    case 40066: {
      return 24617;
    }
    case 40067: {
      return 24590;
    }
    case 40068: {
      return 24625;
    }
    case 40069: {
      return 24603;
    }
    case 40070: {
      return 24597;
    }
    case 40071: {
      return 24619;
    }
    case 40072: {
      return 24614;
    }
    case 40073: {
      return 24591;
    }
    case 40074: {
      return 24634;
    }
    case 40075: {
      return 24666;
    }
    case 40076: {
      return 24641;
    }
    case 40077: {
      return 24682;
    }
    case 40078: {
      return 24695;
    }
    case 40079: {
      return 24671;
    }
    case 40080: {
      return 24650;
    }
    case 40081: {
      return 24646;
    }
    case 40082: {
      return 24653;
    }
    case 40083: {
      return 24675;
    }
    case 40084: {
      return 24643;
    }
    case 40085: {
      return 24676;
    }
    case 40086: {
      return 24642;
    }
    case 40087: {
      return 24684;
    }
    case 40088: {
      return 24683;
    }
    case 40089: {
      return 24665;
    }
    case 40090: {
      return 24705;
    }
    case 40091: {
      return 24717;
    }
    case 40092: {
      return 24807;
    }
    case 40093: {
      return 24707;
    }
    case 40094: {
      return 24730;
    }
    case 40095: {
      return 24708;
    }
    case 40096: {
      return 24731;
    }
    case 40097: {
      return 24726;
    }
    case 40098: {
      return 24727;
    }
    case 40099: {
      return 24722;
    }
    case 40100: {
      return 24743;
    }
    case 40101: {
      return 24715;
    }
    case 40102: {
      return 24801;
    }
    case 40103: {
      return 24760;
    }
    case 40104: {
      return 24800;
    }
    case 40105: {
      return 24787;
    }
    case 40106: {
      return 24756;
    }
    case 40107: {
      return 24560;
    }
    case 40108: {
      return 24765;
    }
    case 40109: {
      return 24774;
    }
    case 40110: {
      return 24757;
    }
    case 40111: {
      return 24792;
    }
    case 40112: {
      return 24909;
    }
    case 40113: {
      return 24853;
    }
    case 40114: {
      return 24838;
    }
    case 40115: {
      return 24822;
    }
    case 40116: {
      return 24823;
    }
    case 40117: {
      return 24832;
    }
    case 40118: {
      return 24820;
    }
    case 40119: {
      return 24826;
    }
    case 40120: {
      return 24835;
    }
    case 40121: {
      return 24865;
    }
    case 40122: {
      return 24827;
    }
    case 40123: {
      return 24817;
    }
    case 40124: {
      return 24845;
    }
    case 40125: {
      return 24846;
    }
    case 40126: {
      return 24903;
    }
    case 40127: {
      return 24894;
    }
    case 40128: {
      return 24872;
    }
    case 40129: {
      return 24871;
    }
    case 40130: {
      return 24906;
    }
    case 40131: {
      return 24895;
    }
    case 40132: {
      return 24892;
    }
    case 40133: {
      return 24876;
    }
    case 40134: {
      return 24884;
    }
    case 40135: {
      return 24893;
    }
    case 40136: {
      return 24898;
    }
    case 40137: {
      return 24900;
    }
    case 40138: {
      return 24947;
    }
    case 40139: {
      return 24951;
    }
    case 40140: {
      return 24920;
    }
    case 40141: {
      return 24921;
    }
    case 40142: {
      return 24922;
    }
    case 40143: {
      return 24939;
    }
    case 40144: {
      return 24948;
    }
    case 40145: {
      return 24943;
    }
    case 40146: {
      return 24933;
    }
    case 40147: {
      return 24945;
    }
    case 40148: {
      return 24927;
    }
    case 40149: {
      return 24925;
    }
    case 40150: {
      return 24915;
    }
    case 40151: {
      return 24949;
    }
    case 40152: {
      return 24985;
    }
    case 40153: {
      return 24982;
    }
    case 40154: {
      return 24967;
    }
    case 40155: {
      return 25004;
    }
    case 40156: {
      return 24980;
    }
    case 40157: {
      return 24986;
    }
    case 40158: {
      return 24970;
    }
    case 40159: {
      return 24977;
    }
    case 40160: {
      return 25003;
    }
    case 40161: {
      return 25006;
    }
    case 40162: {
      return 25036;
    }
    case 40163: {
      return 25034;
    }
    case 40164: {
      return 25033;
    }
    case 40165: {
      return 25079;
    }
    case 40166: {
      return 25032;
    }
    case 40167: {
      return 25027;
    }
    case 40168: {
      return 25030;
    }
    case 40169: {
      return 25018;
    }
    case 40170: {
      return 25035;
    }
    case 40171: {
      return 32633;
    }
    case 40172: {
      return 25037;
    }
    case 40173: {
      return 25062;
    }
    case 40174: {
      return 25059;
    }
    case 40175: {
      return 25078;
    }
    case 40176: {
      return 25082;
    }
    case 40177: {
      return 25076;
    }
    case 40178: {
      return 25087;
    }
    case 40179: {
      return 25085;
    }
    case 40180: {
      return 25084;
    }
    case 40181: {
      return 25086;
    }
    case 40182: {
      return 25088;
    }
    case 40183: {
      return 25096;
    }
    case 40184: {
      return 25097;
    }
    case 40185: {
      return 25101;
    }
    case 40186: {
      return 25100;
    }
    case 40187: {
      return 25108;
    }
    case 40188: {
      return 25115;
    }
    case 40256: {
      return 25118;
    }
    case 40257: {
      return 25121;
    }
    case 40258: {
      return 25130;
    }
    case 40259: {
      return 25134;
    }
    case 40260: {
      return 25136;
    }
    case 40261: {
      return 25138;
    }
    case 40262: {
      return 25139;
    }
    case 40263: {
      return 25153;
    }
    case 40264: {
      return 25166;
    }
    case 40265: {
      return 25182;
    }
    case 40266: {
      return 25187;
    }
    case 40267: {
      return 25179;
    }
    case 40268: {
      return 25184;
    }
    case 40269: {
      return 25192;
    }
    case 40270: {
      return 25212;
    }
    case 40271: {
      return 25218;
    }
    case 40272: {
      return 25225;
    }
    case 40273: {
      return 25214;
    }
    case 40274: {
      return 25234;
    }
    case 40275: {
      return 25235;
    }
    case 40276: {
      return 25238;
    }
    case 40277: {
      return 25300;
    }
    case 40278: {
      return 25219;
    }
    case 40279: {
      return 25236;
    }
    case 40280: {
      return 25303;
    }
    case 40281: {
      return 25297;
    }
    case 40282: {
      return 25275;
    }
    case 40283: {
      return 25295;
    }
    case 40284: {
      return 25343;
    }
    case 40285: {
      return 25286;
    }
    case 40286: {
      return 25812;
    }
    case 40287: {
      return 25288;
    }
    case 40288: {
      return 25308;
    }
    case 40289: {
      return 25292;
    }
    case 40290: {
      return 25290;
    }
    case 40291: {
      return 25282;
    }
    case 40292: {
      return 25287;
    }
    case 40293: {
      return 25243;
    }
    case 40294: {
      return 25289;
    }
    case 40295: {
      return 25356;
    }
    case 40296: {
      return 25326;
    }
    case 40297: {
      return 25329;
    }
    case 40298: {
      return 25383;
    }
    case 40299: {
      return 25346;
    }
    case 40300: {
      return 25352;
    }
    case 40301: {
      return 25327;
    }
    case 40302: {
      return 25333;
    }
    case 40303: {
      return 25424;
    }
    case 40304: {
      return 25406;
    }
    case 40305: {
      return 25421;
    }
    case 40306: {
      return 25628;
    }
    case 40307: {
      return 25423;
    }
    case 40308: {
      return 25494;
    }
    case 40309: {
      return 25486;
    }
    case 40310: {
      return 25472;
    }
    case 40311: {
      return 25515;
    }
    case 40312: {
      return 25462;
    }
    case 40313: {
      return 25507;
    }
    case 40314: {
      return 25487;
    }
    case 40315: {
      return 25481;
    }
    case 40316: {
      return 25503;
    }
    case 40317: {
      return 25525;
    }
    case 40318: {
      return 25451;
    }
    case 40320: {
      return 25449;
    }
    case 40321: {
      return 25534;
    }
    case 40322: {
      return 25577;
    }
    case 40323: {
      return 25536;
    }
    case 40324: {
      return 25542;
    }
    case 40325: {
      return 25571;
    }
    case 40326: {
      return 25545;
    }
    case 40327: {
      return 25554;
    }
    case 40328: {
      return 25590;
    }
    case 40329: {
      return 25540;
    }
    case 40330: {
      return 25622;
    }
    case 40331: {
      return 25652;
    }
    case 40332: {
      return 25606;
    }
    case 40333: {
      return 25619;
    }
    case 40334: {
      return 25638;
    }
    case 40335: {
      return 25654;
    }
    case 40336: {
      return 25885;
    }
    case 40337: {
      return 25623;
    }
    case 40338: {
      return 25640;
    }
    case 40339: {
      return 25615;
    }
    case 40340: {
      return 25703;
    }
    case 40341: {
      return 25711;
    }
    case 40342: {
      return 25718;
    }
    case 40343: {
      return 25678;
    }
    case 40344: {
      return 25898;
    }
    case 40345: {
      return 25749;
    }
    case 40346: {
      return 25747;
    }
    case 40347: {
      return 25765;
    }
    case 40348: {
      return 25769;
    }
    case 40349: {
      return 25736;
    }
    case 40350: {
      return 25788;
    }
    case 40351: {
      return 25818;
    }
    case 40352: {
      return 25810;
    }
    case 40353: {
      return 25797;
    }
    case 40354: {
      return 25799;
    }
    case 40355: {
      return 25787;
    }
    case 40356: {
      return 25816;
    }
    case 40357: {
      return 25794;
    }
    case 40358: {
      return 25841;
    }
    case 40359: {
      return 25831;
    }
    case 40360: {
      return 33289;
    }
    case 40361: {
      return 25824;
    }
    case 40362: {
      return 25825;
    }
    case 40363: {
      return 25260;
    }
    case 40364: {
      return 25827;
    }
    case 40365: {
      return 25839;
    }
    case 40366: {
      return 25900;
    }
    case 40367: {
      return 25846;
    }
    case 40368: {
      return 25844;
    }
    case 40369: {
      return 25842;
    }
    case 40370: {
      return 25850;
    }
    case 40371: {
      return 25856;
    }
    case 40372: {
      return 25853;
    }
    case 40373: {
      return 25880;
    }
    case 40374: {
      return 25884;
    }
    case 40375: {
      return 25861;
    }
    case 40376: {
      return 25892;
    }
    case 40377: {
      return 25891;
    }
    case 40378: {
      return 25899;
    }
    case 40379: {
      return 25908;
    }
    case 40380: {
      return 25909;
    }
    case 40381: {
      return 25911;
    }
    case 40382: {
      return 25910;
    }
    case 40383: {
      return 25912;
    }
    case 40384: {
      return 30027;
    }
    case 40385: {
      return 25928;
    }
    case 40386: {
      return 25942;
    }
    case 40387: {
      return 25941;
    }
    case 40388: {
      return 25933;
    }
    case 40389: {
      return 25944;
    }
    case 40390: {
      return 25950;
    }
    case 40391: {
      return 25949;
    }
    case 40392: {
      return 25970;
    }
    case 40393: {
      return 25976;
    }
    case 40394: {
      return 25986;
    }
    case 40395: {
      return 25987;
    }
    case 40396: {
      return 35722;
    }
    case 40397: {
      return 26011;
    }
    case 40398: {
      return 26015;
    }
    case 40399: {
      return 26027;
    }
    case 40400: {
      return 26039;
    }
    case 40401: {
      return 26051;
    }
    case 40402: {
      return 26054;
    }
    case 40403: {
      return 26049;
    }
    case 40404: {
      return 26052;
    }
    case 40405: {
      return 26060;
    }
    case 40406: {
      return 26066;
    }
    case 40407: {
      return 26075;
    }
    case 40408: {
      return 26073;
    }
    case 40409: {
      return 26080;
    }
    case 40410: {
      return 26081;
    }
    case 40411: {
      return 26097;
    }
    case 40412: {
      return 26482;
    }
    case 40413: {
      return 26122;
    }
    case 40414: {
      return 26115;
    }
    case 40415: {
      return 26107;
    }
    case 40416: {
      return 26483;
    }
    case 40417: {
      return 26165;
    }
    case 40418: {
      return 26166;
    }
    case 40419: {
      return 26164;
    }
    case 40420: {
      return 26140;
    }
    case 40421: {
      return 26191;
    }
    case 40422: {
      return 26180;
    }
    case 40423: {
      return 26185;
    }
    case 40424: {
      return 26177;
    }
    case 40425: {
      return 26206;
    }
    case 40426: {
      return 26205;
    }
    case 40427: {
      return 26212;
    }
    case 40428: {
      return 26215;
    }
    case 40429: {
      return 26216;
    }
    case 40430: {
      return 26207;
    }
    case 40431: {
      return 26210;
    }
    case 40432: {
      return 26224;
    }
    case 40433: {
      return 26243;
    }
    case 40434: {
      return 26248;
    }
    case 40435: {
      return 26254;
    }
    case 40436: {
      return 26249;
    }
    case 40437: {
      return 26244;
    }
    case 40438: {
      return 26264;
    }
    case 40439: {
      return 26269;
    }
    case 40440: {
      return 26305;
    }
    case 40441: {
      return 26297;
    }
    case 40442: {
      return 26313;
    }
    case 40443: {
      return 26302;
    }
    case 40444: {
      return 26300;
    }
    case 40512: {
      return 26308;
    }
    case 40513: {
      return 26296;
    }
    case 40514: {
      return 26326;
    }
    case 40515: {
      return 26330;
    }
    case 40516: {
      return 26336;
    }
    case 40517: {
      return 26175;
    }
    case 40518: {
      return 26342;
    }
    case 40519: {
      return 26345;
    }
    case 40520: {
      return 26352;
    }
    case 40521: {
      return 26357;
    }
    case 40522: {
      return 26359;
    }
    case 40523: {
      return 26383;
    }
    case 40524: {
      return 26390;
    }
    case 40525: {
      return 26398;
    }
    case 40526: {
      return 26406;
    }
    case 40527: {
      return 26407;
    }
    case 40528: {
      return 38712;
    }
    case 40529: {
      return 26414;
    }
    case 40530: {
      return 26431;
    }
    case 40531: {
      return 26422;
    }
    case 40532: {
      return 26433;
    }
    case 40533: {
      return 26424;
    }
    case 40534: {
      return 26423;
    }
    case 40535: {
      return 26438;
    }
    case 40536: {
      return 26462;
    }
    case 40537: {
      return 26464;
    }
    case 40538: {
      return 26457;
    }
    case 40539: {
      return 26467;
    }
    case 40540: {
      return 26468;
    }
    case 40541: {
      return 26505;
    }
    case 40542: {
      return 26480;
    }
    case 40543: {
      return 26537;
    }
    case 40544: {
      return 26492;
    }
    case 40545: {
      return 26474;
    }
    case 40546: {
      return 26508;
    }
    case 40547: {
      return 26507;
    }
    case 40548: {
      return 26534;
    }
    case 40549: {
      return 26529;
    }
    case 40550: {
      return 26501;
    }
    case 40551: {
      return 26551;
    }
    case 40552: {
      return 26607;
    }
    case 40553: {
      return 26548;
    }
    case 40554: {
      return 26604;
    }
    case 40555: {
      return 26547;
    }
    case 40556: {
      return 26601;
    }
    case 40557: {
      return 26552;
    }
    case 40558: {
      return 26596;
    }
    case 40559: {
      return 26590;
    }
    case 40560: {
      return 26589;
    }
    case 40561: {
      return 26594;
    }
    case 40562: {
      return 26606;
    }
    case 40563: {
      return 26553;
    }
    case 40564: {
      return 26574;
    }
    case 40565: {
      return 26566;
    }
    case 40566: {
      return 26599;
    }
    case 40567: {
      return 27292;
    }
    case 40568: {
      return 26654;
    }
    case 40569: {
      return 26694;
    }
    case 40570: {
      return 26665;
    }
    case 40571: {
      return 26688;
    }
    case 40572: {
      return 26701;
    }
    case 40573: {
      return 26674;
    }
    case 40574: {
      return 26702;
    }
    case 40576: {
      return 26803;
    }
    case 40577: {
      return 26667;
    }
    case 40578: {
      return 26713;
    }
    case 40579: {
      return 26723;
    }
    case 40580: {
      return 26743;
    }
    case 40581: {
      return 26751;
    }
    case 40582: {
      return 26783;
    }
    case 40583: {
      return 26767;
    }
    case 40584: {
      return 26797;
    }
    case 40585: {
      return 26772;
    }
    case 40586: {
      return 26781;
    }
    case 40587: {
      return 26779;
    }
    case 40588: {
      return 26755;
    }
    case 40589: {
      return 27310;
    }
    case 40590: {
      return 26809;
    }
    case 40591: {
      return 26740;
    }
    case 40592: {
      return 26805;
    }
    case 40593: {
      return 26784;
    }
    case 40594: {
      return 26810;
    }
    case 40595: {
      return 26895;
    }
    case 40596: {
      return 26765;
    }
    case 40597: {
      return 26750;
    }
    case 40598: {
      return 26881;
    }
    case 40599: {
      return 26826;
    }
    case 40600: {
      return 26888;
    }
    case 40601: {
      return 26840;
    }
    case 40602: {
      return 26914;
    }
    case 40603: {
      return 26918;
    }
    case 40604: {
      return 26849;
    }
    case 40605: {
      return 26892;
    }
    case 40606: {
      return 26829;
    }
    case 40607: {
      return 26836;
    }
    case 40608: {
      return 26855;
    }
    case 40609: {
      return 26837;
    }
    case 40610: {
      return 26934;
    }
    case 40611: {
      return 26898;
    }
    case 40612: {
      return 26884;
    }
    case 40613: {
      return 26839;
    }
    case 40614: {
      return 26851;
    }
    case 40615: {
      return 26917;
    }
    case 40616: {
      return 26873;
    }
    case 40617: {
      return 26848;
    }
    case 40618: {
      return 26863;
    }
    case 40619: {
      return 26920;
    }
    case 40620: {
      return 26922;
    }
    case 40621: {
      return 26906;
    }
    case 40622: {
      return 26915;
    }
    case 40623: {
      return 26913;
    }
    case 40624: {
      return 26822;
    }
    case 40625: {
      return 27001;
    }
    case 40626: {
      return 26999;
    }
    case 40627: {
      return 26972;
    }
    case 40628: {
      return 27000;
    }
    case 40629: {
      return 26987;
    }
    case 40630: {
      return 26964;
    }
    case 40631: {
      return 27006;
    }
    case 40632: {
      return 26990;
    }
    case 40633: {
      return 26937;
    }
    case 40634: {
      return 26996;
    }
    case 40635: {
      return 26941;
    }
    case 40636: {
      return 26969;
    }
    case 40637: {
      return 26928;
    }
    case 40638: {
      return 26977;
    }
    case 40639: {
      return 26974;
    }
    case 40640: {
      return 26973;
    }
    case 40641: {
      return 27009;
    }
    case 40642: {
      return 26986;
    }
    case 40643: {
      return 27058;
    }
    case 40644: {
      return 27054;
    }
    case 40645: {
      return 27088;
    }
    case 40646: {
      return 27071;
    }
    case 40647: {
      return 27073;
    }
    case 40648: {
      return 27091;
    }
    case 40649: {
      return 27070;
    }
    case 40650: {
      return 27086;
    }
    case 40651: {
      return 23528;
    }
    case 40652: {
      return 27082;
    }
    case 40653: {
      return 27101;
    }
    case 40654: {
      return 27067;
    }
    case 40655: {
      return 27075;
    }
    case 40656: {
      return 27047;
    }
    case 40657: {
      return 27182;
    }
    case 40658: {
      return 27025;
    }
    case 40659: {
      return 27040;
    }
    case 40660: {
      return 27036;
    }
    case 40661: {
      return 27029;
    }
    case 40662: {
      return 27060;
    }
    case 40663: {
      return 27102;
    }
    case 40664: {
      return 27112;
    }
    case 40665: {
      return 27138;
    }
    case 40666: {
      return 27163;
    }
    case 40667: {
      return 27135;
    }
    case 40668: {
      return 27402;
    }
    case 40669: {
      return 27129;
    }
    case 40670: {
      return 27122;
    }
    case 40671: {
      return 27111;
    }
    case 40672: {
      return 27141;
    }
    case 40673: {
      return 27057;
    }
    case 40674: {
      return 27166;
    }
    case 40675: {
      return 27117;
    }
    case 40676: {
      return 27156;
    }
    case 40677: {
      return 27115;
    }
    case 40678: {
      return 27146;
    }
    case 40679: {
      return 27154;
    }
    case 40680: {
      return 27329;
    }
    case 40681: {
      return 27171;
    }
    case 40682: {
      return 27155;
    }
    case 40683: {
      return 27204;
    }
    case 40684: {
      return 27148;
    }
    case 40685: {
      return 27250;
    }
    case 40686: {
      return 27190;
    }
    case 40687: {
      return 27256;
    }
    case 40688: {
      return 27207;
    }
    case 40689: {
      return 27234;
    }
    case 40690: {
      return 27225;
    }
    case 40691: {
      return 27238;
    }
    case 40692: {
      return 27208;
    }
    case 40693: {
      return 27192;
    }
    case 40694: {
      return 27170;
    }
    case 40695: {
      return 27280;
    }
    case 40696: {
      return 27277;
    }
    case 40697: {
      return 27296;
    }
    case 40698: {
      return 27268;
    }
    case 40699: {
      return 27298;
    }
    case 40700: {
      return 27299;
    }
    case 40768: {
      return 27287;
    }
    case 40769: {
      return 34327;
    }
    case 40770: {
      return 27323;
    }
    case 40771: {
      return 27331;
    }
    case 40772: {
      return 27330;
    }
    case 40773: {
      return 27320;
    }
    case 40774: {
      return 27315;
    }
    case 40775: {
      return 27308;
    }
    case 40776: {
      return 27358;
    }
    case 40777: {
      return 27345;
    }
    case 40778: {
      return 27359;
    }
    case 40779: {
      return 27306;
    }
    case 40780: {
      return 27354;
    }
    case 40781: {
      return 27370;
    }
    case 40782: {
      return 27387;
    }
    case 40783: {
      return 27397;
    }
    case 40784: {
      return 34326;
    }
    case 40785: {
      return 27386;
    }
    case 40786: {
      return 27410;
    }
    case 40787: {
      return 27414;
    }
    case 40788: {
      return 39729;
    }
    case 40789: {
      return 27423;
    }
    case 40790: {
      return 27448;
    }
    case 40791: {
      return 27447;
    }
    case 40792: {
      return 30428;
    }
    case 40793: {
      return 27449;
    }
    case 40794: {
      return 39150;
    }
    case 40795: {
      return 27463;
    }
    case 40796: {
      return 27459;
    }
    case 40797: {
      return 27465;
    }
    case 40798: {
      return 27472;
    }
    case 40799: {
      return 27481;
    }
    case 40800: {
      return 27476;
    }
    case 40801: {
      return 27483;
    }
    case 40802: {
      return 27487;
    }
    case 40803: {
      return 27489;
    }
    case 40804: {
      return 27512;
    }
    case 40805: {
      return 27513;
    }
    case 40806: {
      return 27519;
    }
    case 40807: {
      return 27520;
    }
    case 40808: {
      return 27524;
    }
    case 40809: {
      return 27523;
    }
    case 40810: {
      return 27533;
    }
    case 40811: {
      return 27544;
    }
    case 40812: {
      return 27541;
    }
    case 40813: {
      return 27550;
    }
    case 40814: {
      return 27556;
    }
    case 40815: {
      return 27562;
    }
    case 40816: {
      return 27563;
    }
    case 40817: {
      return 27567;
    }
    case 40818: {
      return 27570;
    }
    case 40819: {
      return 27569;
    }
    case 40820: {
      return 27571;
    }
    case 40821: {
      return 27575;
    }
    case 40822: {
      return 27580;
    }
    case 40823: {
      return 27590;
    }
    case 40824: {
      return 27595;
    }
    case 40825: {
      return 27603;
    }
    case 40826: {
      return 27615;
    }
    case 40827: {
      return 27628;
    }
    case 40828: {
      return 27627;
    }
    case 40829: {
      return 27635;
    }
    case 40830: {
      return 27631;
    }
    case 40832: {
      return 40638;
    }
    case 40833: {
      return 27656;
    }
    case 40834: {
      return 27667;
    }
    case 40835: {
      return 27668;
    }
    case 40836: {
      return 27675;
    }
    case 40837: {
      return 27684;
    }
    case 40838: {
      return 27683;
    }
    case 40839: {
      return 27742;
    }
    case 40840: {
      return 27733;
    }
    case 40841: {
      return 27746;
    }
    case 40842: {
      return 27754;
    }
    case 40843: {
      return 27778;
    }
    case 40844: {
      return 27789;
    }
    case 40845: {
      return 27802;
    }
    case 40846: {
      return 27777;
    }
    case 40847: {
      return 27803;
    }
    case 40848: {
      return 27774;
    }
    case 40849: {
      return 27752;
    }
    case 40850: {
      return 27763;
    }
    case 40851: {
      return 27794;
    }
    case 40852: {
      return 27792;
    }
    case 40853: {
      return 27844;
    }
    case 40854: {
      return 27889;
    }
    case 40855: {
      return 27859;
    }
    case 40856: {
      return 27837;
    }
    case 40857: {
      return 27863;
    }
    case 40858: {
      return 27845;
    }
    case 40859: {
      return 27869;
    }
    case 40860: {
      return 27822;
    }
    case 40861: {
      return 27825;
    }
    case 40862: {
      return 27838;
    }
    case 40863: {
      return 27834;
    }
    case 40864: {
      return 27867;
    }
    case 40865: {
      return 27887;
    }
    case 40866: {
      return 27865;
    }
    case 40867: {
      return 27882;
    }
    case 40868: {
      return 27935;
    }
    case 40869: {
      return 34893;
    }
    case 40870: {
      return 27958;
    }
    case 40871: {
      return 27947;
    }
    case 40872: {
      return 27965;
    }
    case 40873: {
      return 27960;
    }
    case 40874: {
      return 27929;
    }
    case 40875: {
      return 27957;
    }
    case 40876: {
      return 27955;
    }
    case 40877: {
      return 27922;
    }
    case 40878: {
      return 27916;
    }
    case 40879: {
      return 28003;
    }
    case 40880: {
      return 28051;
    }
    case 40881: {
      return 28004;
    }
    case 40882: {
      return 27994;
    }
    case 40883: {
      return 28025;
    }
    case 40884: {
      return 27993;
    }
    case 40885: {
      return 28046;
    }
    case 40886: {
      return 28053;
    }
    case 40887: {
      return 28644;
    }
    case 40888: {
      return 28037;
    }
    case 40889: {
      return 28153;
    }
    case 40890: {
      return 28181;
    }
    case 40891: {
      return 28170;
    }
    case 40892: {
      return 28085;
    }
    case 40893: {
      return 28103;
    }
    case 40894: {
      return 28134;
    }
    case 40895: {
      return 28088;
    }
    case 40896: {
      return 28102;
    }
    case 40897: {
      return 28140;
    }
    case 40898: {
      return 28126;
    }
    case 40899: {
      return 28108;
    }
    case 40900: {
      return 28136;
    }
    case 40901: {
      return 28114;
    }
    case 40902: {
      return 28101;
    }
    case 40903: {
      return 28154;
    }
    case 40904: {
      return 28121;
    }
    case 40905: {
      return 28132;
    }
    case 40906: {
      return 28117;
    }
    case 40907: {
      return 28138;
    }
    case 40908: {
      return 28142;
    }
    case 40909: {
      return 28205;
    }
    case 40910: {
      return 28270;
    }
    case 40911: {
      return 28206;
    }
    case 40912: {
      return 28185;
    }
    case 40913: {
      return 28274;
    }
    case 40914: {
      return 28255;
    }
    case 40915: {
      return 28222;
    }
    case 40916: {
      return 28195;
    }
    case 40917: {
      return 28267;
    }
    case 40918: {
      return 28203;
    }
    case 40919: {
      return 28278;
    }
    case 40920: {
      return 28237;
    }
    case 40921: {
      return 28191;
    }
    case 40922: {
      return 28227;
    }
    case 40923: {
      return 28218;
    }
    case 40924: {
      return 28238;
    }
    case 40925: {
      return 28196;
    }
    case 40926: {
      return 28415;
    }
    case 40927: {
      return 28189;
    }
    case 40928: {
      return 28216;
    }
    case 40929: {
      return 28290;
    }
    case 40930: {
      return 28330;
    }
    case 40931: {
      return 28312;
    }
    case 40932: {
      return 28361;
    }
    case 40933: {
      return 28343;
    }
    case 40934: {
      return 28371;
    }
    case 40935: {
      return 28349;
    }
    case 40936: {
      return 28335;
    }
    case 40937: {
      return 28356;
    }
    case 40938: {
      return 28338;
    }
    case 40939: {
      return 28372;
    }
    case 40940: {
      return 28373;
    }
    case 40941: {
      return 28303;
    }
    case 40942: {
      return 28325;
    }
    case 40943: {
      return 28354;
    }
    case 40944: {
      return 28319;
    }
    case 40945: {
      return 28481;
    }
    case 40946: {
      return 28433;
    }
    case 40947: {
      return 28748;
    }
    case 40948: {
      return 28396;
    }
    case 40949: {
      return 28408;
    }
    case 40950: {
      return 28414;
    }
    case 40951: {
      return 28479;
    }
    case 40952: {
      return 28402;
    }
    case 40953: {
      return 28465;
    }
    case 40954: {
      return 28399;
    }
    case 40955: {
      return 28466;
    }
    case 40956: {
      return 28364;
    }
    case 57408: {
      return 28478;
    }
    case 57409: {
      return 28435;
    }
    case 57410: {
      return 28407;
    }
    case 57411: {
      return 28550;
    }
    case 57412: {
      return 28538;
    }
    case 57413: {
      return 28536;
    }
    case 57414: {
      return 28545;
    }
    case 57415: {
      return 28544;
    }
    case 57416: {
      return 28527;
    }
    case 57417: {
      return 28507;
    }
    case 57418: {
      return 28659;
    }
    case 57419: {
      return 28525;
    }
    case 57420: {
      return 28546;
    }
    case 57421: {
      return 28540;
    }
    case 57422: {
      return 28504;
    }
    case 57423: {
      return 28558;
    }
    case 57424: {
      return 28561;
    }
    case 57425: {
      return 28610;
    }
    case 57426: {
      return 28518;
    }
    case 57427: {
      return 28595;
    }
    case 57428: {
      return 28579;
    }
    case 57429: {
      return 28577;
    }
    case 57430: {
      return 28580;
    }
    case 57431: {
      return 28601;
    }
    case 57432: {
      return 28614;
    }
    case 57433: {
      return 28586;
    }
    case 57434: {
      return 28639;
    }
    case 57435: {
      return 28629;
    }
    case 57436: {
      return 28652;
    }
    case 57437: {
      return 28628;
    }
    case 57438: {
      return 28632;
    }
    case 57439: {
      return 28657;
    }
    case 57440: {
      return 28654;
    }
    case 57441: {
      return 28635;
    }
    case 57442: {
      return 28681;
    }
    case 57443: {
      return 28683;
    }
    case 57444: {
      return 28666;
    }
    case 57445: {
      return 28689;
    }
    case 57446: {
      return 28673;
    }
    case 57447: {
      return 28687;
    }
    case 57448: {
      return 28670;
    }
    case 57449: {
      return 28699;
    }
    case 57450: {
      return 28698;
    }
    case 57451: {
      return 28532;
    }
    case 57452: {
      return 28701;
    }
    case 57453: {
      return 28696;
    }
    case 57454: {
      return 28703;
    }
    case 57455: {
      return 28720;
    }
    case 57456: {
      return 28734;
    }
    case 57457: {
      return 28722;
    }
    case 57458: {
      return 28753;
    }
    case 57459: {
      return 28771;
    }
    case 57460: {
      return 28825;
    }
    case 57461: {
      return 28818;
    }
    case 57462: {
      return 28847;
    }
    case 57463: {
      return 28913;
    }
    case 57464: {
      return 28844;
    }
    case 57465: {
      return 28856;
    }
    case 57466: {
      return 28851;
    }
    case 57467: {
      return 28846;
    }
    case 57468: {
      return 28895;
    }
    case 57469: {
      return 28875;
    }
    case 57470: {
      return 28893;
    }
    case 57472: {
      return 28889;
    }
    case 57473: {
      return 28937;
    }
    case 57474: {
      return 28925;
    }
    case 57475: {
      return 28956;
    }
    case 57476: {
      return 28953;
    }
    case 57477: {
      return 29029;
    }
    case 57478: {
      return 29013;
    }
    case 57479: {
      return 29064;
    }
    case 57480: {
      return 29030;
    }
    case 57481: {
      return 29026;
    }
    case 57482: {
      return 29004;
    }
    case 57483: {
      return 29014;
    }
    case 57484: {
      return 29036;
    }
    case 57485: {
      return 29071;
    }
    case 57486: {
      return 29179;
    }
    case 57487: {
      return 29060;
    }
    case 57488: {
      return 29077;
    }
    case 57489: {
      return 29096;
    }
    case 57490: {
      return 29100;
    }
    case 57491: {
      return 29143;
    }
    case 57492: {
      return 29113;
    }
    case 57493: {
      return 29118;
    }
    case 57494: {
      return 29138;
    }
    case 57495: {
      return 29129;
    }
    case 57496: {
      return 29140;
    }
    case 57497: {
      return 29134;
    }
    case 57498: {
      return 29152;
    }
    case 57499: {
      return 29164;
    }
    case 57500: {
      return 29159;
    }
    case 57501: {
      return 29173;
    }
    case 57502: {
      return 29180;
    }
    case 57503: {
      return 29177;
    }
    case 57504: {
      return 29183;
    }
    case 57505: {
      return 29197;
    }
    case 57506: {
      return 29200;
    }
    case 57507: {
      return 29211;
    }
    case 57508: {
      return 29224;
    }
    case 57509: {
      return 29229;
    }
    case 57510: {
      return 29228;
    }
    case 57511: {
      return 29232;
    }
    case 57512: {
      return 29234;
    }
    case 57513: {
      return 29243;
    }
    case 57514: {
      return 29244;
    }
    case 57515: {
      return 29247;
    }
    case 57516: {
      return 29248;
    }
    case 57517: {
      return 29254;
    }
    case 57518: {
      return 29259;
    }
    case 57519: {
      return 29272;
    }
    case 57520: {
      return 29300;
    }
    case 57521: {
      return 29310;
    }
    case 57522: {
      return 29314;
    }
    case 57523: {
      return 29313;
    }
    case 57524: {
      return 29319;
    }
    case 57525: {
      return 29330;
    }
    case 57526: {
      return 29334;
    }
    case 57527: {
      return 29346;
    }
    case 57528: {
      return 29351;
    }
    case 57529: {
      return 29369;
    }
    case 57530: {
      return 29362;
    }
    case 57531: {
      return 29379;
    }
    case 57532: {
      return 29382;
    }
    case 57533: {
      return 29380;
    }
    case 57534: {
      return 29390;
    }
    case 57535: {
      return 29394;
    }
    case 57536: {
      return 29410;
    }
    case 57537: {
      return 29408;
    }
    case 57538: {
      return 29409;
    }
    case 57539: {
      return 29433;
    }
    case 57540: {
      return 29431;
    }
    case 57541: {
      return 20495;
    }
    case 57542: {
      return 29463;
    }
    case 57543: {
      return 29450;
    }
    case 57544: {
      return 29468;
    }
    case 57545: {
      return 29462;
    }
    case 57546: {
      return 29469;
    }
    case 57547: {
      return 29492;
    }
    case 57548: {
      return 29487;
    }
    case 57549: {
      return 29481;
    }
    case 57550: {
      return 29477;
    }
    case 57551: {
      return 29502;
    }
    case 57552: {
      return 29518;
    }
    case 57553: {
      return 29519;
    }
    case 57554: {
      return 40664;
    }
    case 57555: {
      return 29527;
    }
    case 57556: {
      return 29546;
    }
    case 57557: {
      return 29544;
    }
    case 57558: {
      return 29552;
    }
    case 57559: {
      return 29560;
    }
    case 57560: {
      return 29557;
    }
    case 57561: {
      return 29563;
    }
    case 57562: {
      return 29562;
    }
    case 57563: {
      return 29640;
    }
    case 57564: {
      return 29619;
    }
    case 57565: {
      return 29646;
    }
    case 57566: {
      return 29627;
    }
    case 57567: {
      return 29632;
    }
    case 57568: {
      return 29669;
    }
    case 57569: {
      return 29678;
    }
    case 57570: {
      return 29662;
    }
    case 57571: {
      return 29858;
    }
    case 57572: {
      return 29701;
    }
    case 57573: {
      return 29807;
    }
    case 57574: {
      return 29733;
    }
    case 57575: {
      return 29688;
    }
    case 57576: {
      return 29746;
    }
    case 57577: {
      return 29754;
    }
    case 57578: {
      return 29781;
    }
    case 57579: {
      return 29759;
    }
    case 57580: {
      return 29791;
    }
    case 57581: {
      return 29785;
    }
    case 57582: {
      return 29761;
    }
    case 57583: {
      return 29788;
    }
    case 57584: {
      return 29801;
    }
    case 57585: {
      return 29808;
    }
    case 57586: {
      return 29795;
    }
    case 57587: {
      return 29802;
    }
    case 57588: {
      return 29814;
    }
    case 57589: {
      return 29822;
    }
    case 57590: {
      return 29835;
    }
    case 57591: {
      return 29854;
    }
    case 57592: {
      return 29863;
    }
    case 57593: {
      return 29898;
    }
    case 57594: {
      return 29903;
    }
    case 57595: {
      return 29908;
    }
    case 57596: {
      return 29681;
    }
    case 57664: {
      return 29920;
    }
    case 57665: {
      return 29923;
    }
    case 57666: {
      return 29927;
    }
    case 57667: {
      return 29929;
    }
    case 57668: {
      return 29934;
    }
    case 57669: {
      return 29938;
    }
    case 57670: {
      return 29936;
    }
    case 57671: {
      return 29937;
    }
    case 57672: {
      return 29944;
    }
    case 57673: {
      return 29943;
    }
    case 57674: {
      return 29956;
    }
    case 57675: {
      return 29955;
    }
    case 57676: {
      return 29957;
    }
    case 57677: {
      return 29964;
    }
    case 57678: {
      return 29966;
    }
    case 57679: {
      return 29965;
    }
    case 57680: {
      return 29973;
    }
    case 57681: {
      return 29971;
    }
    case 57682: {
      return 29982;
    }
    case 57683: {
      return 29990;
    }
    case 57684: {
      return 29996;
    }
    case 57685: {
      return 30012;
    }
    case 57686: {
      return 30020;
    }
    case 57687: {
      return 30029;
    }
    case 57688: {
      return 30026;
    }
    case 57689: {
      return 30025;
    }
    case 57690: {
      return 30043;
    }
    case 57691: {
      return 30022;
    }
    case 57692: {
      return 30042;
    }
    case 57693: {
      return 30057;
    }
    case 57694: {
      return 30052;
    }
    case 57695: {
      return 30055;
    }
    case 57696: {
      return 30059;
    }
    case 57697: {
      return 30061;
    }
    case 57698: {
      return 30072;
    }
    case 57699: {
      return 30070;
    }
    case 57700: {
      return 30086;
    }
    case 57701: {
      return 30087;
    }
    case 57702: {
      return 30068;
    }
    case 57703: {
      return 30090;
    }
    case 57704: {
      return 30089;
    }
    case 57705: {
      return 30082;
    }
    case 57706: {
      return 30100;
    }
    case 57707: {
      return 30106;
    }
    case 57708: {
      return 30109;
    }
    case 57709: {
      return 30117;
    }
    case 57710: {
      return 30115;
    }
    case 57711: {
      return 30146;
    }
    case 57712: {
      return 30131;
    }
    case 57713: {
      return 30147;
    }
    case 57714: {
      return 30133;
    }
    case 57715: {
      return 30141;
    }
    case 57716: {
      return 30136;
    }
    case 57717: {
      return 30140;
    }
    case 57718: {
      return 30129;
    }
    case 57719: {
      return 30157;
    }
    case 57720: {
      return 30154;
    }
    case 57721: {
      return 30162;
    }
    case 57722: {
      return 30169;
    }
    case 57723: {
      return 30179;
    }
    case 57724: {
      return 30174;
    }
    case 57725: {
      return 30206;
    }
    case 57726: {
      return 30207;
    }
    case 57728: {
      return 30204;
    }
    case 57729: {
      return 30209;
    }
    case 57730: {
      return 30192;
    }
    case 57731: {
      return 30202;
    }
    case 57732: {
      return 30194;
    }
    case 57733: {
      return 30195;
    }
    case 57734: {
      return 30219;
    }
    case 57735: {
      return 30221;
    }
    case 57736: {
      return 30217;
    }
    case 57737: {
      return 30239;
    }
    case 57738: {
      return 30247;
    }
    case 57739: {
      return 30240;
    }
    case 57740: {
      return 30241;
    }
    case 57741: {
      return 30242;
    }
    case 57742: {
      return 30244;
    }
    case 57743: {
      return 30260;
    }
    case 57744: {
      return 30256;
    }
    case 57745: {
      return 30267;
    }
    case 57746: {
      return 30279;
    }
    case 57747: {
      return 30280;
    }
    case 57748: {
      return 30278;
    }
    case 57749: {
      return 30300;
    }
    case 57750: {
      return 30296;
    }
    case 57751: {
      return 30305;
    }
    case 57752: {
      return 30306;
    }
    case 57753: {
      return 30312;
    }
    case 57754: {
      return 30313;
    }
    case 57755: {
      return 30314;
    }
    case 57756: {
      return 30311;
    }
    case 57757: {
      return 30316;
    }
    case 57758: {
      return 30320;
    }
    case 57759: {
      return 30322;
    }
    case 57760: {
      return 30326;
    }
    case 57761: {
      return 30328;
    }
    case 57762: {
      return 30332;
    }
    case 57763: {
      return 30336;
    }
    case 57764: {
      return 30339;
    }
    case 57765: {
      return 30344;
    }
    case 57766: {
      return 30347;
    }
    case 57767: {
      return 30350;
    }
    case 57768: {
      return 30358;
    }
    case 57769: {
      return 30355;
    }
    case 57770: {
      return 30361;
    }
    case 57771: {
      return 30362;
    }
    case 57772: {
      return 30384;
    }
    case 57773: {
      return 30388;
    }
    case 57774: {
      return 30392;
    }
    case 57775: {
      return 30393;
    }
    case 57776: {
      return 30394;
    }
    case 57777: {
      return 30402;
    }
    case 57778: {
      return 30413;
    }
    case 57779: {
      return 30422;
    }
    case 57780: {
      return 30418;
    }
    case 57781: {
      return 30430;
    }
    case 57782: {
      return 30433;
    }
    case 57783: {
      return 30437;
    }
    case 57784: {
      return 30439;
    }
    case 57785: {
      return 30442;
    }
    case 57786: {
      return 34351;
    }
    case 57787: {
      return 30459;
    }
    case 57788: {
      return 30472;
    }
    case 57789: {
      return 30471;
    }
    case 57790: {
      return 30468;
    }
    case 57791: {
      return 30505;
    }
    case 57792: {
      return 30500;
    }
    case 57793: {
      return 30494;
    }
    case 57794: {
      return 30501;
    }
    case 57795: {
      return 30502;
    }
    case 57796: {
      return 30491;
    }
    case 57797: {
      return 30519;
    }
    case 57798: {
      return 30520;
    }
    case 57799: {
      return 30535;
    }
    case 57800: {
      return 30554;
    }
    case 57801: {
      return 30568;
    }
    case 57802: {
      return 30571;
    }
    case 57803: {
      return 30555;
    }
    case 57804: {
      return 30565;
    }
    case 57805: {
      return 30591;
    }
    case 57806: {
      return 30590;
    }
    case 57807: {
      return 30585;
    }
    case 57808: {
      return 30606;
    }
    case 57809: {
      return 30603;
    }
    case 57810: {
      return 30609;
    }
    case 57811: {
      return 30624;
    }
    case 57812: {
      return 30622;
    }
    case 57813: {
      return 30640;
    }
    case 57814: {
      return 30646;
    }
    case 57815: {
      return 30649;
    }
    case 57816: {
      return 30655;
    }
    case 57817: {
      return 30652;
    }
    case 57818: {
      return 30653;
    }
    case 57819: {
      return 30651;
    }
    case 57820: {
      return 30663;
    }
    case 57821: {
      return 30669;
    }
    case 57822: {
      return 30679;
    }
    case 57823: {
      return 30682;
    }
    case 57824: {
      return 30684;
    }
    case 57825: {
      return 30691;
    }
    case 57826: {
      return 30702;
    }
    case 57827: {
      return 30716;
    }
    case 57828: {
      return 30732;
    }
    case 57829: {
      return 30738;
    }
    case 57830: {
      return 31014;
    }
    case 57831: {
      return 30752;
    }
    case 57832: {
      return 31018;
    }
    case 57833: {
      return 30789;
    }
    case 57834: {
      return 30862;
    }
    case 57835: {
      return 30836;
    }
    case 57836: {
      return 30854;
    }
    case 57837: {
      return 30844;
    }
    case 57838: {
      return 30874;
    }
    case 57839: {
      return 30860;
    }
    case 57840: {
      return 30883;
    }
    case 57841: {
      return 30901;
    }
    case 57842: {
      return 30890;
    }
    case 57843: {
      return 30895;
    }
    case 57844: {
      return 30929;
    }
    case 57845: {
      return 30918;
    }
    case 57846: {
      return 30923;
    }
    case 57847: {
      return 30932;
    }
    case 57848: {
      return 30910;
    }
    case 57849: {
      return 30908;
    }
    case 57850: {
      return 30917;
    }
    case 57851: {
      return 30922;
    }
    case 57852: {
      return 30956;
    }
    case 57920: {
      return 30951;
    }
    case 57921: {
      return 30938;
    }
    case 57922: {
      return 30973;
    }
    case 57923: {
      return 30964;
    }
    case 57924: {
      return 30983;
    }
    case 57925: {
      return 30994;
    }
    case 57926: {
      return 30993;
    }
    case 57927: {
      return 31001;
    }
    case 57928: {
      return 31020;
    }
    case 57929: {
      return 31019;
    }
    case 57930: {
      return 31040;
    }
    case 57931: {
      return 31072;
    }
    case 57932: {
      return 31063;
    }
    case 57933: {
      return 31071;
    }
    case 57934: {
      return 31066;
    }
    case 57935: {
      return 31061;
    }
    case 57936: {
      return 31059;
    }
    case 57937: {
      return 31098;
    }
    case 57938: {
      return 31103;
    }
    case 57939: {
      return 31114;
    }
    case 57940: {
      return 31133;
    }
    case 57941: {
      return 31143;
    }
    case 57942: {
      return 40779;
    }
    case 57943: {
      return 31146;
    }
    case 57944: {
      return 31150;
    }
    case 57945: {
      return 31155;
    }
    case 57946: {
      return 31161;
    }
    case 57947: {
      return 31162;
    }
    case 57948: {
      return 31177;
    }
    case 57949: {
      return 31189;
    }
    case 57950: {
      return 31207;
    }
    case 57951: {
      return 31212;
    }
    case 57952: {
      return 31201;
    }
    case 57953: {
      return 31203;
    }
    case 57954: {
      return 31240;
    }
    case 57955: {
      return 31245;
    }
    case 57956: {
      return 31256;
    }
    case 57957: {
      return 31257;
    }
    case 57958: {
      return 31264;
    }
    case 57959: {
      return 31263;
    }
    case 57960: {
      return 31104;
    }
    case 57961: {
      return 31281;
    }
    case 57962: {
      return 31291;
    }
    case 57963: {
      return 31294;
    }
    case 57964: {
      return 31287;
    }
    case 57965: {
      return 31299;
    }
    case 57966: {
      return 31319;
    }
    case 57967: {
      return 31305;
    }
    case 57968: {
      return 31329;
    }
    case 57969: {
      return 31330;
    }
    case 57970: {
      return 31337;
    }
    case 57971: {
      return 40861;
    }
    case 57972: {
      return 31344;
    }
    case 57973: {
      return 31353;
    }
    case 57974: {
      return 31357;
    }
    case 57975: {
      return 31368;
    }
    case 57976: {
      return 31383;
    }
    case 57977: {
      return 31381;
    }
    case 57978: {
      return 31384;
    }
    case 57979: {
      return 31382;
    }
    case 57980: {
      return 31401;
    }
    case 57981: {
      return 31432;
    }
    case 57982: {
      return 31408;
    }
    case 57984: {
      return 31414;
    }
    case 57985: {
      return 31429;
    }
    case 57986: {
      return 31428;
    }
    case 57987: {
      return 31423;
    }
    case 57988: {
      return 36995;
    }
    case 57989: {
      return 31431;
    }
    case 57990: {
      return 31434;
    }
    case 57991: {
      return 31437;
    }
    case 57992: {
      return 31439;
    }
    case 57993: {
      return 31445;
    }
    case 57994: {
      return 31443;
    }
    case 57995: {
      return 31449;
    }
    case 57996: {
      return 31450;
    }
    case 57997: {
      return 31453;
    }
    case 57998: {
      return 31457;
    }
    case 57999: {
      return 31458;
    }
    case 58000: {
      return 31462;
    }
    case 58001: {
      return 31469;
    }
    case 58002: {
      return 31472;
    }
    case 58003: {
      return 31490;
    }
    case 58004: {
      return 31503;
    }
    case 58005: {
      return 31498;
    }
    case 58006: {
      return 31494;
    }
    case 58007: {
      return 31539;
    }
    case 58008: {
      return 31512;
    }
    case 58009: {
      return 31513;
    }
    case 58010: {
      return 31518;
    }
    case 58011: {
      return 31541;
    }
    case 58012: {
      return 31528;
    }
    case 58013: {
      return 31542;
    }
    case 58014: {
      return 31568;
    }
    case 58015: {
      return 31610;
    }
    case 58016: {
      return 31492;
    }
    case 58017: {
      return 31565;
    }
    case 58018: {
      return 31499;
    }
    case 58019: {
      return 31564;
    }
    case 58020: {
      return 31557;
    }
    case 58021: {
      return 31605;
    }
    case 58022: {
      return 31589;
    }
    case 58023: {
      return 31604;
    }
    case 58024: {
      return 31591;
    }
    case 58025: {
      return 31600;
    }
    case 58026: {
      return 31601;
    }
    case 58027: {
      return 31596;
    }
    case 58028: {
      return 31598;
    }
    case 58029: {
      return 31645;
    }
    case 58030: {
      return 31640;
    }
    case 58031: {
      return 31647;
    }
    case 58032: {
      return 31629;
    }
    case 58033: {
      return 31644;
    }
    case 58034: {
      return 31642;
    }
    case 58035: {
      return 31627;
    }
    case 58036: {
      return 31634;
    }
    case 58037: {
      return 31631;
    }
    case 58038: {
      return 31581;
    }
    case 58039: {
      return 31641;
    }
    case 58040: {
      return 31691;
    }
    case 58041: {
      return 31681;
    }
    case 58042: {
      return 31692;
    }
    case 58043: {
      return 31695;
    }
    case 58044: {
      return 31668;
    }
    case 58045: {
      return 31686;
    }
    case 58046: {
      return 31709;
    }
    case 58047: {
      return 31721;
    }
    case 58048: {
      return 31761;
    }
    case 58049: {
      return 31764;
    }
    case 58050: {
      return 31718;
    }
    case 58051: {
      return 31717;
    }
    case 58052: {
      return 31840;
    }
    case 58053: {
      return 31744;
    }
    case 58054: {
      return 31751;
    }
    case 58055: {
      return 31763;
    }
    case 58056: {
      return 31731;
    }
    case 58057: {
      return 31735;
    }
    case 58058: {
      return 31767;
    }
    case 58059: {
      return 31757;
    }
    case 58060: {
      return 31734;
    }
    case 58061: {
      return 31779;
    }
    case 58062: {
      return 31783;
    }
    case 58063: {
      return 31786;
    }
    case 58064: {
      return 31775;
    }
    case 58065: {
      return 31799;
    }
    case 58066: {
      return 31787;
    }
    case 58067: {
      return 31805;
    }
    case 58068: {
      return 31820;
    }
    case 58069: {
      return 31811;
    }
    case 58070: {
      return 31828;
    }
    case 58071: {
      return 31823;
    }
    case 58072: {
      return 31808;
    }
    case 58073: {
      return 31824;
    }
    case 58074: {
      return 31832;
    }
    case 58075: {
      return 31839;
    }
    case 58076: {
      return 31844;
    }
    case 58077: {
      return 31830;
    }
    case 58078: {
      return 31845;
    }
    case 58079: {
      return 31852;
    }
    case 58080: {
      return 31861;
    }
    case 58081: {
      return 31875;
    }
    case 58082: {
      return 31888;
    }
    case 58083: {
      return 31908;
    }
    case 58084: {
      return 31917;
    }
    case 58085: {
      return 31906;
    }
    case 58086: {
      return 31915;
    }
    case 58087: {
      return 31905;
    }
    case 58088: {
      return 31912;
    }
    case 58089: {
      return 31923;
    }
    case 58090: {
      return 31922;
    }
    case 58091: {
      return 31921;
    }
    case 58092: {
      return 31918;
    }
    case 58093: {
      return 31929;
    }
    case 58094: {
      return 31933;
    }
    case 58095: {
      return 31936;
    }
    case 58096: {
      return 31941;
    }
    case 58097: {
      return 31938;
    }
    case 58098: {
      return 31960;
    }
    case 58099: {
      return 31954;
    }
    case 58100: {
      return 31964;
    }
    case 58101: {
      return 31970;
    }
    case 58102: {
      return 39739;
    }
    case 58103: {
      return 31983;
    }
    case 58104: {
      return 31986;
    }
    case 58105: {
      return 31988;
    }
    case 58106: {
      return 31990;
    }
    case 58107: {
      return 31994;
    }
    case 58108: {
      return 32006;
    }
    case 58176: {
      return 32002;
    }
    case 58177: {
      return 32028;
    }
    case 58178: {
      return 32021;
    }
    case 58179: {
      return 32010;
    }
    case 58180: {
      return 32069;
    }
    case 58181: {
      return 32075;
    }
    case 58182: {
      return 32046;
    }
    case 58183: {
      return 32050;
    }
    case 58184: {
      return 32063;
    }
    case 58185: {
      return 32053;
    }
    case 58186: {
      return 32070;
    }
    case 58187: {
      return 32115;
    }
    case 58188: {
      return 32086;
    }
    case 58189: {
      return 32078;
    }
    case 58190: {
      return 32114;
    }
    case 58191: {
      return 32104;
    }
    case 58192: {
      return 32110;
    }
    case 58193: {
      return 32079;
    }
    case 58194: {
      return 32099;
    }
    case 58195: {
      return 32147;
    }
    case 58196: {
      return 32137;
    }
    case 58197: {
      return 32091;
    }
    case 58198: {
      return 32143;
    }
    case 58199: {
      return 32125;
    }
    case 58200: {
      return 32155;
    }
    case 58201: {
      return 32186;
    }
    case 58202: {
      return 32174;
    }
    case 58203: {
      return 32163;
    }
    case 58204: {
      return 32181;
    }
    case 58205: {
      return 32199;
    }
    case 58206: {
      return 32189;
    }
    case 58207: {
      return 32171;
    }
    case 58208: {
      return 32317;
    }
    case 58209: {
      return 32162;
    }
    case 58210: {
      return 32175;
    }
    case 58211: {
      return 32220;
    }
    case 58212: {
      return 32184;
    }
    case 58213: {
      return 32159;
    }
    case 58214: {
      return 32176;
    }
    case 58215: {
      return 32216;
    }
    case 58216: {
      return 32221;
    }
    case 58217: {
      return 32228;
    }
    case 58218: {
      return 32222;
    }
    case 58219: {
      return 32251;
    }
    case 58220: {
      return 32242;
    }
    case 58221: {
      return 32225;
    }
    case 58222: {
      return 32261;
    }
    case 58223: {
      return 32266;
    }
    case 58224: {
      return 32291;
    }
    case 58225: {
      return 32289;
    }
    case 58226: {
      return 32274;
    }
    case 58227: {
      return 32305;
    }
    case 58228: {
      return 32287;
    }
    case 58229: {
      return 32265;
    }
    case 58230: {
      return 32267;
    }
    case 58231: {
      return 32290;
    }
    case 58232: {
      return 32326;
    }
    case 58233: {
      return 32358;
    }
    case 58234: {
      return 32315;
    }
    case 58235: {
      return 32309;
    }
    case 58236: {
      return 32313;
    }
    case 58237: {
      return 32323;
    }
    case 58238: {
      return 32311;
    }
    case 58240: {
      return 32306;
    }
    case 58241: {
      return 32314;
    }
    case 58242: {
      return 32359;
    }
    case 58243: {
      return 32349;
    }
    case 58244: {
      return 32342;
    }
    case 58245: {
      return 32350;
    }
    case 58246: {
      return 32345;
    }
    case 58247: {
      return 32346;
    }
    case 58248: {
      return 32377;
    }
    case 58249: {
      return 32362;
    }
    case 58250: {
      return 32361;
    }
    case 58251: {
      return 32380;
    }
    case 58252: {
      return 32379;
    }
    case 58253: {
      return 32387;
    }
    case 58254: {
      return 32213;
    }
    case 58255: {
      return 32381;
    }
    case 58256: {
      return 36782;
    }
    case 58257: {
      return 32383;
    }
    case 58258: {
      return 32392;
    }
    case 58259: {
      return 32393;
    }
    case 58260: {
      return 32396;
    }
    case 58261: {
      return 32402;
    }
    case 58262: {
      return 32400;
    }
    case 58263: {
      return 32403;
    }
    case 58264: {
      return 32404;
    }
    case 58265: {
      return 32406;
    }
    case 58266: {
      return 32398;
    }
    case 58267: {
      return 32411;
    }
    case 58268: {
      return 32412;
    }
    case 58269: {
      return 32568;
    }
    case 58270: {
      return 32570;
    }
    case 58271: {
      return 32581;
    }
    case 58272: {
      return 32588;
    }
    case 58273: {
      return 32589;
    }
    case 58274: {
      return 32590;
    }
    case 58275: {
      return 32592;
    }
    case 58276: {
      return 32593;
    }
    case 58277: {
      return 32597;
    }
    case 58278: {
      return 32596;
    }
    case 58279: {
      return 32600;
    }
    case 58280: {
      return 32607;
    }
    case 58281: {
      return 32608;
    }
    case 58282: {
      return 32616;
    }
    case 58283: {
      return 32617;
    }
    case 58284: {
      return 32615;
    }
    case 58285: {
      return 32632;
    }
    case 58286: {
      return 32642;
    }
    case 58287: {
      return 32646;
    }
    case 58288: {
      return 32643;
    }
    case 58289: {
      return 32648;
    }
    case 58290: {
      return 32647;
    }
    case 58291: {
      return 32652;
    }
    case 58292: {
      return 32660;
    }
    case 58293: {
      return 32670;
    }
    case 58294: {
      return 32669;
    }
    case 58295: {
      return 32666;
    }
    case 58296: {
      return 32675;
    }
    case 58297: {
      return 32687;
    }
    case 58298: {
      return 32690;
    }
    case 58299: {
      return 32697;
    }
    case 58300: {
      return 32686;
    }
    case 58301: {
      return 32694;
    }
    case 58302: {
      return 32696;
    }
    case 58303: {
      return 35697;
    }
    case 58304: {
      return 32709;
    }
    case 58305: {
      return 32710;
    }
    case 58306: {
      return 32714;
    }
    case 58307: {
      return 32725;
    }
    case 58308: {
      return 32724;
    }
    case 58309: {
      return 32737;
    }
    case 58310: {
      return 32742;
    }
    case 58311: {
      return 32745;
    }
    case 58312: {
      return 32755;
    }
    case 58313: {
      return 32761;
    }
    case 58314: {
      return 39132;
    }
    case 58315: {
      return 32774;
    }
    case 58316: {
      return 32772;
    }
    case 58317: {
      return 32779;
    }
    case 58318: {
      return 32786;
    }
    case 58319: {
      return 32792;
    }
    case 58320: {
      return 32793;
    }
    case 58321: {
      return 32796;
    }
    case 58322: {
      return 32801;
    }
    case 58323: {
      return 32808;
    }
    case 58324: {
      return 32831;
    }
    case 58325: {
      return 32827;
    }
    case 58326: {
      return 32842;
    }
    case 58327: {
      return 32838;
    }
    case 58328: {
      return 32850;
    }
    case 58329: {
      return 32856;
    }
    case 58330: {
      return 32858;
    }
    case 58331: {
      return 32863;
    }
    case 58332: {
      return 32866;
    }
    case 58333: {
      return 32872;
    }
    case 58334: {
      return 32883;
    }
    case 58335: {
      return 32882;
    }
    case 58336: {
      return 32880;
    }
    case 58337: {
      return 32886;
    }
    case 58338: {
      return 32889;
    }
    case 58339: {
      return 32893;
    }
    case 58340: {
      return 32895;
    }
    case 58341: {
      return 32900;
    }
    case 58342: {
      return 32902;
    }
    case 58343: {
      return 32901;
    }
    case 58344: {
      return 32923;
    }
    case 58345: {
      return 32915;
    }
    case 58346: {
      return 32922;
    }
    case 58347: {
      return 32941;
    }
    case 58348: {
      return 20880;
    }
    case 58349: {
      return 32940;
    }
    case 58350: {
      return 32987;
    }
    case 58351: {
      return 32997;
    }
    case 58352: {
      return 32985;
    }
    case 58353: {
      return 32989;
    }
    case 58354: {
      return 32964;
    }
    case 58355: {
      return 32986;
    }
    case 58356: {
      return 32982;
    }
    case 58357: {
      return 33033;
    }
    case 58358: {
      return 33007;
    }
    case 58359: {
      return 33009;
    }
    case 58360: {
      return 33051;
    }
    case 58361: {
      return 33065;
    }
    case 58362: {
      return 33059;
    }
    case 58363: {
      return 33071;
    }
    case 58364: {
      return 33099;
    }
    case 58432: {
      return 38539;
    }
    case 58433: {
      return 33094;
    }
    case 58434: {
      return 33086;
    }
    case 58435: {
      return 33107;
    }
    case 58436: {
      return 33105;
    }
    case 58437: {
      return 33020;
    }
    case 58438: {
      return 33137;
    }
    case 58439: {
      return 33134;
    }
    case 58440: {
      return 33125;
    }
    case 58441: {
      return 33126;
    }
    case 58442: {
      return 33140;
    }
    case 58443: {
      return 33155;
    }
    case 58444: {
      return 33160;
    }
    case 58445: {
      return 33162;
    }
    case 58446: {
      return 33152;
    }
    case 58447: {
      return 33154;
    }
    case 58448: {
      return 33184;
    }
    case 58449: {
      return 33173;
    }
    case 58450: {
      return 33188;
    }
    case 58451: {
      return 33187;
    }
    case 58452: {
      return 33119;
    }
    case 58453: {
      return 33171;
    }
    case 58454: {
      return 33193;
    }
    case 58455: {
      return 33200;
    }
    case 58456: {
      return 33205;
    }
    case 58457: {
      return 33214;
    }
    case 58458: {
      return 33208;
    }
    case 58459: {
      return 33213;
    }
    case 58460: {
      return 33216;
    }
    case 58461: {
      return 33218;
    }
    case 58462: {
      return 33210;
    }
    case 58463: {
      return 33225;
    }
    case 58464: {
      return 33229;
    }
    case 58465: {
      return 33233;
    }
    case 58466: {
      return 33241;
    }
    case 58467: {
      return 33240;
    }
    case 58468: {
      return 33224;
    }
    case 58469: {
      return 33242;
    }
    case 58470: {
      return 33247;
    }
    case 58471: {
      return 33248;
    }
    case 58472: {
      return 33255;
    }
    case 58473: {
      return 33274;
    }
    case 58474: {
      return 33275;
    }
    case 58475: {
      return 33278;
    }
    case 58476: {
      return 33281;
    }
    case 58477: {
      return 33282;
    }
    case 58478: {
      return 33285;
    }
    case 58479: {
      return 33287;
    }
    case 58480: {
      return 33290;
    }
    case 58481: {
      return 33293;
    }
    case 58482: {
      return 33296;
    }
    case 58483: {
      return 33302;
    }
    case 58484: {
      return 33321;
    }
    case 58485: {
      return 33323;
    }
    case 58486: {
      return 33336;
    }
    case 58487: {
      return 33331;
    }
    case 58488: {
      return 33344;
    }
    case 58489: {
      return 33369;
    }
    case 58490: {
      return 33368;
    }
    case 58491: {
      return 33373;
    }
    case 58492: {
      return 33370;
    }
    case 58493: {
      return 33375;
    }
    case 58494: {
      return 33380;
    }
    case 58496: {
      return 33378;
    }
    case 58497: {
      return 33384;
    }
    case 58498: {
      return 33386;
    }
    case 58499: {
      return 33387;
    }
    case 58500: {
      return 33326;
    }
    case 58501: {
      return 33393;
    }
    case 58502: {
      return 33399;
    }
    case 58503: {
      return 33400;
    }
    case 58504: {
      return 33406;
    }
    case 58505: {
      return 33421;
    }
    case 58506: {
      return 33426;
    }
    case 58507: {
      return 33451;
    }
    case 58508: {
      return 33439;
    }
    case 58509: {
      return 33467;
    }
    case 58510: {
      return 33452;
    }
    case 58511: {
      return 33505;
    }
    case 58512: {
      return 33507;
    }
    case 58513: {
      return 33503;
    }
    case 58514: {
      return 33490;
    }
    case 58515: {
      return 33524;
    }
    case 58516: {
      return 33523;
    }
    case 58517: {
      return 33530;
    }
    case 58518: {
      return 33683;
    }
    case 58519: {
      return 33539;
    }
    case 58520: {
      return 33531;
    }
    case 58521: {
      return 33529;
    }
    case 58522: {
      return 33502;
    }
    case 58523: {
      return 33542;
    }
    case 58524: {
      return 33500;
    }
    case 58525: {
      return 33545;
    }
    case 58526: {
      return 33497;
    }
    case 58527: {
      return 33589;
    }
    case 58528: {
      return 33588;
    }
    case 58529: {
      return 33558;
    }
    case 58530: {
      return 33586;
    }
    case 58531: {
      return 33585;
    }
    case 58532: {
      return 33600;
    }
    case 58533: {
      return 33593;
    }
    case 58534: {
      return 33616;
    }
    case 58535: {
      return 33605;
    }
    case 58536: {
      return 33583;
    }
    case 58537: {
      return 33579;
    }
    case 58538: {
      return 33559;
    }
    case 58539: {
      return 33560;
    }
    case 58540: {
      return 33669;
    }
    case 58541: {
      return 33690;
    }
    case 58542: {
      return 33706;
    }
    case 58543: {
      return 33695;
    }
    case 58544: {
      return 33698;
    }
    case 58545: {
      return 33686;
    }
    case 58546: {
      return 33571;
    }
    case 58547: {
      return 33678;
    }
    case 58548: {
      return 33671;
    }
    case 58549: {
      return 33674;
    }
    case 58550: {
      return 33660;
    }
    case 58551: {
      return 33717;
    }
    case 58552: {
      return 33651;
    }
    case 58553: {
      return 33653;
    }
    case 58554: {
      return 33696;
    }
    case 58555: {
      return 33673;
    }
    case 58556: {
      return 33704;
    }
    case 58557: {
      return 33780;
    }
    case 58558: {
      return 33811;
    }
    case 58559: {
      return 33771;
    }
    case 58560: {
      return 33742;
    }
    case 58561: {
      return 33789;
    }
    case 58562: {
      return 33795;
    }
    case 58563: {
      return 33752;
    }
    case 58564: {
      return 33803;
    }
    case 58565: {
      return 33729;
    }
    case 58566: {
      return 33783;
    }
    case 58567: {
      return 33799;
    }
    case 58568: {
      return 33760;
    }
    case 58569: {
      return 33778;
    }
    case 58570: {
      return 33805;
    }
    case 58571: {
      return 33826;
    }
    case 58572: {
      return 33824;
    }
    case 58573: {
      return 33725;
    }
    case 58574: {
      return 33848;
    }
    case 58575: {
      return 34054;
    }
    case 58576: {
      return 33787;
    }
    case 58577: {
      return 33901;
    }
    case 58578: {
      return 33834;
    }
    case 58579: {
      return 33852;
    }
    case 58580: {
      return 34138;
    }
    case 58581: {
      return 33924;
    }
    case 58582: {
      return 33911;
    }
    case 58583: {
      return 33899;
    }
    case 58584: {
      return 33965;
    }
    case 58585: {
      return 33902;
    }
    case 58586: {
      return 33922;
    }
    case 58587: {
      return 33897;
    }
    case 58588: {
      return 33862;
    }
    case 58589: {
      return 33836;
    }
    case 58590: {
      return 33903;
    }
    case 58591: {
      return 33913;
    }
    case 58592: {
      return 33845;
    }
    case 58593: {
      return 33994;
    }
    case 58594: {
      return 33890;
    }
    case 58595: {
      return 33977;
    }
    case 58596: {
      return 33983;
    }
    case 58597: {
      return 33951;
    }
    case 58598: {
      return 34009;
    }
    case 58599: {
      return 33997;
    }
    case 58600: {
      return 33979;
    }
    case 58601: {
      return 34010;
    }
    case 58602: {
      return 34000;
    }
    case 58603: {
      return 33985;
    }
    case 58604: {
      return 33990;
    }
    case 58605: {
      return 34006;
    }
    case 58606: {
      return 33953;
    }
    case 58607: {
      return 34081;
    }
    case 58608: {
      return 34047;
    }
    case 58609: {
      return 34036;
    }
    case 58610: {
      return 34071;
    }
    case 58611: {
      return 34072;
    }
    case 58612: {
      return 34092;
    }
    case 58613: {
      return 34079;
    }
    case 58614: {
      return 34069;
    }
    case 58615: {
      return 34068;
    }
    case 58616: {
      return 34044;
    }
    case 58617: {
      return 34112;
    }
    case 58618: {
      return 34147;
    }
    case 58619: {
      return 34136;
    }
    case 58620: {
      return 34120;
    }
    case 58688: {
      return 34113;
    }
    case 58689: {
      return 34306;
    }
    case 58690: {
      return 34123;
    }
    case 58691: {
      return 34133;
    }
    case 58692: {
      return 34176;
    }
    case 58693: {
      return 34212;
    }
    case 58694: {
      return 34184;
    }
    case 58695: {
      return 34193;
    }
    case 58696: {
      return 34186;
    }
    case 58697: {
      return 34216;
    }
    case 58698: {
      return 34157;
    }
    case 58699: {
      return 34196;
    }
    case 58700: {
      return 34203;
    }
    case 58701: {
      return 34282;
    }
    case 58702: {
      return 34183;
    }
    case 58703: {
      return 34204;
    }
    case 58704: {
      return 34167;
    }
    case 58705: {
      return 34174;
    }
    case 58706: {
      return 34192;
    }
    case 58707: {
      return 34249;
    }
    case 58708: {
      return 34234;
    }
    case 58709: {
      return 34255;
    }
    case 58710: {
      return 34233;
    }
    case 58711: {
      return 34256;
    }
    case 58712: {
      return 34261;
    }
    case 58713: {
      return 34269;
    }
    case 58714: {
      return 34277;
    }
    case 58715: {
      return 34268;
    }
    case 58716: {
      return 34297;
    }
    case 58717: {
      return 34314;
    }
    case 58718: {
      return 34323;
    }
    case 58719: {
      return 34315;
    }
    case 58720: {
      return 34302;
    }
    case 58721: {
      return 34298;
    }
    case 58722: {
      return 34310;
    }
    case 58723: {
      return 34338;
    }
    case 58724: {
      return 34330;
    }
    case 58725: {
      return 34352;
    }
    case 58726: {
      return 34367;
    }
    case 58727: {
      return 34381;
    }
    case 58728: {
      return 20053;
    }
    case 58729: {
      return 34388;
    }
    case 58730: {
      return 34399;
    }
    case 58731: {
      return 34407;
    }
    case 58732: {
      return 34417;
    }
    case 58733: {
      return 34451;
    }
    case 58734: {
      return 34467;
    }
    case 58735: {
      return 34473;
    }
    case 58736: {
      return 34474;
    }
    case 58737: {
      return 34443;
    }
    case 58738: {
      return 34444;
    }
    case 58739: {
      return 34486;
    }
    case 58740: {
      return 34479;
    }
    case 58741: {
      return 34500;
    }
    case 58742: {
      return 34502;
    }
    case 58743: {
      return 34480;
    }
    case 58744: {
      return 34505;
    }
    case 58745: {
      return 34851;
    }
    case 58746: {
      return 34475;
    }
    case 58747: {
      return 34516;
    }
    case 58748: {
      return 34526;
    }
    case 58749: {
      return 34537;
    }
    case 58750: {
      return 34540;
    }
    case 58752: {
      return 34527;
    }
    case 58753: {
      return 34523;
    }
    case 58754: {
      return 34543;
    }
    case 58755: {
      return 34578;
    }
    case 58756: {
      return 34566;
    }
    case 58757: {
      return 34568;
    }
    case 58758: {
      return 34560;
    }
    case 58759: {
      return 34563;
    }
    case 58760: {
      return 34555;
    }
    case 58761: {
      return 34577;
    }
    case 58762: {
      return 34569;
    }
    case 58763: {
      return 34573;
    }
    case 58764: {
      return 34553;
    }
    case 58765: {
      return 34570;
    }
    case 58766: {
      return 34612;
    }
    case 58767: {
      return 34623;
    }
    case 58768: {
      return 34615;
    }
    case 58769: {
      return 34619;
    }
    case 58770: {
      return 34597;
    }
    case 58771: {
      return 34601;
    }
    case 58772: {
      return 34586;
    }
    case 58773: {
      return 34656;
    }
    case 58774: {
      return 34655;
    }
    case 58775: {
      return 34680;
    }
    case 58776: {
      return 34636;
    }
    case 58777: {
      return 34638;
    }
    case 58778: {
      return 34676;
    }
    case 58779: {
      return 34647;
    }
    case 58780: {
      return 34664;
    }
    case 58781: {
      return 34670;
    }
    case 58782: {
      return 34649;
    }
    case 58783: {
      return 34643;
    }
    case 58784: {
      return 34659;
    }
    case 58785: {
      return 34666;
    }
    case 58786: {
      return 34821;
    }
    case 58787: {
      return 34722;
    }
    case 58788: {
      return 34719;
    }
    case 58789: {
      return 34690;
    }
    case 58790: {
      return 34735;
    }
    case 58791: {
      return 34763;
    }
    case 58792: {
      return 34749;
    }
    case 58793: {
      return 34752;
    }
    case 58794: {
      return 34768;
    }
    case 58795: {
      return 38614;
    }
    case 58796: {
      return 34731;
    }
    case 58797: {
      return 34756;
    }
    case 58798: {
      return 34739;
    }
    case 58799: {
      return 34759;
    }
    case 58800: {
      return 34758;
    }
    case 58801: {
      return 34747;
    }
    case 58802: {
      return 34799;
    }
    case 58803: {
      return 34802;
    }
    case 58804: {
      return 34784;
    }
    case 58805: {
      return 34831;
    }
    case 58806: {
      return 34829;
    }
    case 58807: {
      return 34814;
    }
    case 58808: {
      return 34806;
    }
    case 58809: {
      return 34807;
    }
    case 58810: {
      return 34830;
    }
    case 58811: {
      return 34770;
    }
    case 58812: {
      return 34833;
    }
    case 58813: {
      return 34838;
    }
    case 58814: {
      return 34837;
    }
    case 58815: {
      return 34850;
    }
    case 58816: {
      return 34849;
    }
    case 58817: {
      return 34865;
    }
    case 58818: {
      return 34870;
    }
    case 58819: {
      return 34873;
    }
    case 58820: {
      return 34855;
    }
    case 58821: {
      return 34875;
    }
    case 58822: {
      return 34884;
    }
    case 58823: {
      return 34882;
    }
    case 58824: {
      return 34898;
    }
    case 58825: {
      return 34905;
    }
    case 58826: {
      return 34910;
    }
    case 58827: {
      return 34914;
    }
    case 58828: {
      return 34923;
    }
    case 58829: {
      return 34945;
    }
    case 58830: {
      return 34942;
    }
    case 58831: {
      return 34974;
    }
    case 58832: {
      return 34933;
    }
    case 58833: {
      return 34941;
    }
    case 58834: {
      return 34997;
    }
    case 58835: {
      return 34930;
    }
    case 58836: {
      return 34946;
    }
    case 58837: {
      return 34967;
    }
    case 58838: {
      return 34962;
    }
    case 58839: {
      return 34990;
    }
    case 58840: {
      return 34969;
    }
    case 58841: {
      return 34978;
    }
    case 58842: {
      return 34957;
    }
    case 58843: {
      return 34980;
    }
    case 58844: {
      return 34992;
    }
    case 58845: {
      return 35007;
    }
    case 58846: {
      return 34993;
    }
    case 58847: {
      return 35011;
    }
    case 58848: {
      return 35012;
    }
    case 58849: {
      return 35028;
    }
    case 58850: {
      return 35032;
    }
    case 58851: {
      return 35033;
    }
    case 58852: {
      return 35037;
    }
    case 58853: {
      return 35065;
    }
    case 58854: {
      return 35074;
    }
    case 58855: {
      return 35068;
    }
    case 58856: {
      return 35060;
    }
    case 58857: {
      return 35048;
    }
    case 58858: {
      return 35058;
    }
    case 58859: {
      return 35076;
    }
    case 58860: {
      return 35084;
    }
    case 58861: {
      return 35082;
    }
    case 58862: {
      return 35091;
    }
    case 58863: {
      return 35139;
    }
    case 58864: {
      return 35102;
    }
    case 58865: {
      return 35109;
    }
    case 58866: {
      return 35114;
    }
    case 58867: {
      return 35115;
    }
    case 58868: {
      return 35137;
    }
    case 58869: {
      return 35140;
    }
    case 58870: {
      return 35131;
    }
    case 58871: {
      return 35126;
    }
    case 58872: {
      return 35128;
    }
    case 58873: {
      return 35148;
    }
    case 58874: {
      return 35101;
    }
    case 58875: {
      return 35168;
    }
    case 58876: {
      return 35166;
    }
    case 58944: {
      return 35174;
    }
    case 58945: {
      return 35172;
    }
    case 58946: {
      return 35181;
    }
    case 58947: {
      return 35178;
    }
    case 58948: {
      return 35183;
    }
    case 58949: {
      return 35188;
    }
    case 58950: {
      return 35191;
    }
    case 58951: {
      return 35198;
    }
    case 58952: {
      return 35203;
    }
    case 58953: {
      return 35208;
    }
    case 58954: {
      return 35210;
    }
    case 58955: {
      return 35219;
    }
    case 58956: {
      return 35224;
    }
    case 58957: {
      return 35233;
    }
    case 58958: {
      return 35241;
    }
    case 58959: {
      return 35238;
    }
    case 58960: {
      return 35244;
    }
    case 58961: {
      return 35247;
    }
    case 58962: {
      return 35250;
    }
    case 58963: {
      return 35258;
    }
    case 58964: {
      return 35261;
    }
    case 58965: {
      return 35263;
    }
    case 58966: {
      return 35264;
    }
    case 58967: {
      return 35290;
    }
    case 58968: {
      return 35292;
    }
    case 58969: {
      return 35293;
    }
    case 58970: {
      return 35303;
    }
    case 58971: {
      return 35316;
    }
    case 58972: {
      return 35320;
    }
    case 58973: {
      return 35331;
    }
    case 58974: {
      return 35350;
    }
    case 58975: {
      return 35344;
    }
    case 58976: {
      return 35340;
    }
    case 58977: {
      return 35355;
    }
    case 58978: {
      return 35357;
    }
    case 58979: {
      return 35365;
    }
    case 58980: {
      return 35382;
    }
    case 58981: {
      return 35393;
    }
    case 58982: {
      return 35419;
    }
    case 58983: {
      return 35410;
    }
    case 58984: {
      return 35398;
    }
    case 58985: {
      return 35400;
    }
    case 58986: {
      return 35452;
    }
    case 58987: {
      return 35437;
    }
    case 58988: {
      return 35436;
    }
    case 58989: {
      return 35426;
    }
    case 58990: {
      return 35461;
    }
    case 58991: {
      return 35458;
    }
    case 58992: {
      return 35460;
    }
    case 58993: {
      return 35496;
    }
    case 58994: {
      return 35489;
    }
    case 58995: {
      return 35473;
    }
    case 58996: {
      return 35493;
    }
    case 58997: {
      return 35494;
    }
    case 58998: {
      return 35482;
    }
    case 58999: {
      return 35491;
    }
    case 59000: {
      return 35524;
    }
    case 59001: {
      return 35533;
    }
    case 59002: {
      return 35522;
    }
    case 59003: {
      return 35546;
    }
    case 59004: {
      return 35563;
    }
    case 59005: {
      return 35571;
    }
    case 59006: {
      return 35559;
    }
    case 59008: {
      return 35556;
    }
    case 59009: {
      return 35569;
    }
    case 59010: {
      return 35604;
    }
    case 59011: {
      return 35552;
    }
    case 59012: {
      return 35554;
    }
    case 59013: {
      return 35575;
    }
    case 59014: {
      return 35550;
    }
    case 59015: {
      return 35547;
    }
    case 59016: {
      return 35596;
    }
    case 59017: {
      return 35591;
    }
    case 59018: {
      return 35610;
    }
    case 59019: {
      return 35553;
    }
    case 59020: {
      return 35606;
    }
    case 59021: {
      return 35600;
    }
    case 59022: {
      return 35607;
    }
    case 59023: {
      return 35616;
    }
    case 59024: {
      return 35635;
    }
    case 59025: {
      return 38827;
    }
    case 59026: {
      return 35622;
    }
    case 59027: {
      return 35627;
    }
    case 59028: {
      return 35646;
    }
    case 59029: {
      return 35624;
    }
    case 59030: {
      return 35649;
    }
    case 59031: {
      return 35660;
    }
    case 59032: {
      return 35663;
    }
    case 59033: {
      return 35662;
    }
    case 59034: {
      return 35657;
    }
    case 59035: {
      return 35670;
    }
    case 59036: {
      return 35675;
    }
    case 59037: {
      return 35674;
    }
    case 59038: {
      return 35691;
    }
    case 59039: {
      return 35679;
    }
    case 59040: {
      return 35692;
    }
    case 59041: {
      return 35695;
    }
    case 59042: {
      return 35700;
    }
    case 59043: {
      return 35709;
    }
    case 59044: {
      return 35712;
    }
    case 59045: {
      return 35724;
    }
    case 59046: {
      return 35726;
    }
    case 59047: {
      return 35730;
    }
    case 59048: {
      return 35731;
    }
    case 59049: {
      return 35734;
    }
    case 59050: {
      return 35737;
    }
    case 59051: {
      return 35738;
    }
    case 59052: {
      return 35898;
    }
    case 59053: {
      return 35905;
    }
    case 59054: {
      return 35903;
    }
    case 59055: {
      return 35912;
    }
    case 59056: {
      return 35916;
    }
    case 59057: {
      return 35918;
    }
    case 59058: {
      return 35920;
    }
    case 59059: {
      return 35925;
    }
    case 59060: {
      return 35938;
    }
    case 59061: {
      return 35948;
    }
    case 59062: {
      return 35960;
    }
    case 59063: {
      return 35962;
    }
    case 59064: {
      return 35970;
    }
    case 59065: {
      return 35977;
    }
    case 59066: {
      return 35973;
    }
    case 59067: {
      return 35978;
    }
    case 59068: {
      return 35981;
    }
    case 59069: {
      return 35982;
    }
    case 59070: {
      return 35988;
    }
    case 59071: {
      return 35964;
    }
    case 59072: {
      return 35992;
    }
    case 59073: {
      return 25117;
    }
    case 59074: {
      return 36013;
    }
    case 59075: {
      return 36010;
    }
    case 59076: {
      return 36029;
    }
    case 59077: {
      return 36018;
    }
    case 59078: {
      return 36019;
    }
    case 59079: {
      return 36014;
    }
    case 59080: {
      return 36022;
    }
    case 59081: {
      return 36040;
    }
    case 59082: {
      return 36033;
    }
    case 59083: {
      return 36068;
    }
    case 59084: {
      return 36067;
    }
    case 59085: {
      return 36058;
    }
    case 59086: {
      return 36093;
    }
    case 59087: {
      return 36090;
    }
    case 59088: {
      return 36091;
    }
    case 59089: {
      return 36100;
    }
    case 59090: {
      return 36101;
    }
    case 59091: {
      return 36106;
    }
    case 59092: {
      return 36103;
    }
    case 59093: {
      return 36111;
    }
    case 59094: {
      return 36109;
    }
    case 59095: {
      return 36112;
    }
    case 59096: {
      return 40782;
    }
    case 59097: {
      return 36115;
    }
    case 59098: {
      return 36045;
    }
    case 59099: {
      return 36116;
    }
    case 59100: {
      return 36118;
    }
    case 59101: {
      return 36199;
    }
    case 59102: {
      return 36205;
    }
    case 59103: {
      return 36209;
    }
    case 59104: {
      return 36211;
    }
    case 59105: {
      return 36225;
    }
    case 59106: {
      return 36249;
    }
    case 59107: {
      return 36290;
    }
    case 59108: {
      return 36286;
    }
    case 59109: {
      return 36282;
    }
    case 59110: {
      return 36303;
    }
    case 59111: {
      return 36314;
    }
    case 59112: {
      return 36310;
    }
    case 59113: {
      return 36300;
    }
    case 59114: {
      return 36315;
    }
    case 59115: {
      return 36299;
    }
    case 59116: {
      return 36330;
    }
    case 59117: {
      return 36331;
    }
    case 59118: {
      return 36319;
    }
    case 59119: {
      return 36323;
    }
    case 59120: {
      return 36348;
    }
    case 59121: {
      return 36360;
    }
    case 59122: {
      return 36361;
    }
    case 59123: {
      return 36351;
    }
    case 59124: {
      return 36381;
    }
    case 59125: {
      return 36382;
    }
    case 59126: {
      return 36368;
    }
    case 59127: {
      return 36383;
    }
    case 59128: {
      return 36418;
    }
    case 59129: {
      return 36405;
    }
    case 59130: {
      return 36400;
    }
    case 59131: {
      return 36404;
    }
    case 59132: {
      return 36426;
    }
    case 59200: {
      return 36423;
    }
    case 59201: {
      return 36425;
    }
    case 59202: {
      return 36428;
    }
    case 59203: {
      return 36432;
    }
    case 59204: {
      return 36424;
    }
    case 59205: {
      return 36441;
    }
    case 59206: {
      return 36452;
    }
    case 59207: {
      return 36448;
    }
    case 59208: {
      return 36394;
    }
    case 59209: {
      return 36451;
    }
    case 59210: {
      return 36437;
    }
    case 59211: {
      return 36470;
    }
    case 59212: {
      return 36466;
    }
    case 59213: {
      return 36476;
    }
    case 59214: {
      return 36481;
    }
    case 59215: {
      return 36487;
    }
    case 59216: {
      return 36485;
    }
    case 59217: {
      return 36484;
    }
    case 59218: {
      return 36491;
    }
    case 59219: {
      return 36490;
    }
    case 59220: {
      return 36499;
    }
    case 59221: {
      return 36497;
    }
    case 59222: {
      return 36500;
    }
    case 59223: {
      return 36505;
    }
    case 59224: {
      return 36522;
    }
    case 59225: {
      return 36513;
    }
    case 59226: {
      return 36524;
    }
    case 59227: {
      return 36528;
    }
    case 59228: {
      return 36550;
    }
    case 59229: {
      return 36529;
    }
    case 59230: {
      return 36542;
    }
    case 59231: {
      return 36549;
    }
    case 59232: {
      return 36552;
    }
    case 59233: {
      return 36555;
    }
    case 59234: {
      return 36571;
    }
    case 59235: {
      return 36579;
    }
    case 59236: {
      return 36604;
    }
    case 59237: {
      return 36603;
    }
    case 59238: {
      return 36587;
    }
    case 59239: {
      return 36606;
    }
    case 59240: {
      return 36618;
    }
    case 59241: {
      return 36613;
    }
    case 59242: {
      return 36629;
    }
    case 59243: {
      return 36626;
    }
    case 59244: {
      return 36633;
    }
    case 59245: {
      return 36627;
    }
    case 59246: {
      return 36636;
    }
    case 59247: {
      return 36639;
    }
    case 59248: {
      return 36635;
    }
    case 59249: {
      return 36620;
    }
    case 59250: {
      return 36646;
    }
    case 59251: {
      return 36659;
    }
    case 59252: {
      return 36667;
    }
    case 59253: {
      return 36665;
    }
    case 59254: {
      return 36677;
    }
    case 59255: {
      return 36674;
    }
    case 59256: {
      return 36670;
    }
    case 59257: {
      return 36684;
    }
    case 59258: {
      return 36681;
    }
    case 59259: {
      return 36678;
    }
    case 59260: {
      return 36686;
    }
    case 59261: {
      return 36695;
    }
    case 59262: {
      return 36700;
    }
    case 59264: {
      return 36706;
    }
    case 59265: {
      return 36707;
    }
    case 59266: {
      return 36708;
    }
    case 59267: {
      return 36764;
    }
    case 59268: {
      return 36767;
    }
    case 59269: {
      return 36771;
    }
    case 59270: {
      return 36781;
    }
    case 59271: {
      return 36783;
    }
    case 59272: {
      return 36791;
    }
    case 59273: {
      return 36826;
    }
    case 59274: {
      return 36837;
    }
    case 59275: {
      return 36834;
    }
    case 59276: {
      return 36842;
    }
    case 59277: {
      return 36847;
    }
    case 59278: {
      return 36999;
    }
    case 59279: {
      return 36852;
    }
    case 59280: {
      return 36869;
    }
    case 59281: {
      return 36857;
    }
    case 59282: {
      return 36858;
    }
    case 59283: {
      return 36881;
    }
    case 59284: {
      return 36885;
    }
    case 59285: {
      return 36897;
    }
    case 59286: {
      return 36877;
    }
    case 59287: {
      return 36894;
    }
    case 59288: {
      return 36886;
    }
    case 59289: {
      return 36875;
    }
    case 59290: {
      return 36903;
    }
    case 59291: {
      return 36918;
    }
    case 59292: {
      return 36917;
    }
    case 59293: {
      return 36921;
    }
    case 59294: {
      return 36856;
    }
    case 59295: {
      return 36943;
    }
    case 59296: {
      return 36944;
    }
    case 59297: {
      return 36945;
    }
    case 59298: {
      return 36946;
    }
    case 59299: {
      return 36878;
    }
    case 59300: {
      return 36937;
    }
    case 59301: {
      return 36926;
    }
    case 59302: {
      return 36950;
    }
    case 59303: {
      return 36952;
    }
    case 59304: {
      return 36958;
    }
    case 59305: {
      return 36968;
    }
    case 59306: {
      return 36975;
    }
    case 59307: {
      return 36982;
    }
    case 59308: {
      return 38568;
    }
    case 59309: {
      return 36978;
    }
    case 59310: {
      return 36994;
    }
    case 59311: {
      return 36989;
    }
    case 59312: {
      return 36993;
    }
    case 59313: {
      return 36992;
    }
    case 59314: {
      return 37002;
    }
    case 59315: {
      return 37001;
    }
    case 59316: {
      return 37007;
    }
    case 59317: {
      return 37032;
    }
    case 59318: {
      return 37039;
    }
    case 59319: {
      return 37041;
    }
    case 59320: {
      return 37045;
    }
    case 59321: {
      return 37090;
    }
    case 59322: {
      return 37092;
    }
    case 59323: {
      return 25160;
    }
    case 59324: {
      return 37083;
    }
    case 59325: {
      return 37122;
    }
    case 59326: {
      return 37138;
    }
    case 59327: {
      return 37145;
    }
    case 59328: {
      return 37170;
    }
    case 59329: {
      return 37168;
    }
    case 59330: {
      return 37194;
    }
    case 59331: {
      return 37206;
    }
    case 59332: {
      return 37208;
    }
    case 59333: {
      return 37219;
    }
    case 59334: {
      return 37221;
    }
    case 59335: {
      return 37225;
    }
    case 59336: {
      return 37235;
    }
    case 59337: {
      return 37234;
    }
    case 59338: {
      return 37259;
    }
    case 59339: {
      return 37257;
    }
    case 59340: {
      return 37250;
    }
    case 59341: {
      return 37282;
    }
    case 59342: {
      return 37291;
    }
    case 59343: {
      return 37295;
    }
    case 59344: {
      return 37290;
    }
    case 59345: {
      return 37301;
    }
    case 59346: {
      return 37300;
    }
    case 59347: {
      return 37306;
    }
    case 59348: {
      return 37312;
    }
    case 59349: {
      return 37313;
    }
    case 59350: {
      return 37321;
    }
    case 59351: {
      return 37323;
    }
    case 59352: {
      return 37328;
    }
    case 59353: {
      return 37334;
    }
    case 59354: {
      return 37343;
    }
    case 59355: {
      return 37345;
    }
    case 59356: {
      return 37339;
    }
    case 59357: {
      return 37372;
    }
    case 59358: {
      return 37365;
    }
    case 59359: {
      return 37366;
    }
    case 59360: {
      return 37406;
    }
    case 59361: {
      return 37375;
    }
    case 59362: {
      return 37396;
    }
    case 59363: {
      return 37420;
    }
    case 59364: {
      return 37397;
    }
    case 59365: {
      return 37393;
    }
    case 59366: {
      return 37470;
    }
    case 59367: {
      return 37463;
    }
    case 59368: {
      return 37445;
    }
    case 59369: {
      return 37449;
    }
    case 59370: {
      return 37476;
    }
    case 59371: {
      return 37448;
    }
    case 59372: {
      return 37525;
    }
    case 59373: {
      return 37439;
    }
    case 59374: {
      return 37451;
    }
    case 59375: {
      return 37456;
    }
    case 59376: {
      return 37532;
    }
    case 59377: {
      return 37526;
    }
    case 59378: {
      return 37523;
    }
    case 59379: {
      return 37531;
    }
    case 59380: {
      return 37466;
    }
    case 59381: {
      return 37583;
    }
    case 59382: {
      return 37561;
    }
    case 59383: {
      return 37559;
    }
    case 59384: {
      return 37609;
    }
    case 59385: {
      return 37647;
    }
    case 59386: {
      return 37626;
    }
    case 59387: {
      return 37700;
    }
    case 59388: {
      return 37678;
    }
    case 59456: {
      return 37657;
    }
    case 59457: {
      return 37666;
    }
    case 59458: {
      return 37658;
    }
    case 59459: {
      return 37667;
    }
    case 59460: {
      return 37690;
    }
    case 59461: {
      return 37685;
    }
    case 59462: {
      return 37691;
    }
    case 59463: {
      return 37724;
    }
    case 59464: {
      return 37728;
    }
    case 59465: {
      return 37756;
    }
    case 59466: {
      return 37742;
    }
    case 59467: {
      return 37718;
    }
    case 59468: {
      return 37808;
    }
    case 59469: {
      return 37804;
    }
    case 59470: {
      return 37805;
    }
    case 59471: {
      return 37780;
    }
    case 59472: {
      return 37817;
    }
    case 59473: {
      return 37846;
    }
    case 59474: {
      return 37847;
    }
    case 59475: {
      return 37864;
    }
    case 59476: {
      return 37861;
    }
    case 59477: {
      return 37848;
    }
    case 59478: {
      return 37827;
    }
    case 59479: {
      return 37853;
    }
    case 59480: {
      return 37840;
    }
    case 59481: {
      return 37832;
    }
    case 59482: {
      return 37860;
    }
    case 59483: {
      return 37914;
    }
    case 59484: {
      return 37908;
    }
    case 59485: {
      return 37907;
    }
    case 59486: {
      return 37891;
    }
    case 59487: {
      return 37895;
    }
    case 59488: {
      return 37904;
    }
    case 59489: {
      return 37942;
    }
    case 59490: {
      return 37931;
    }
    case 59491: {
      return 37941;
    }
    case 59492: {
      return 37921;
    }
    case 59493: {
      return 37946;
    }
    case 59494: {
      return 37953;
    }
    case 59495: {
      return 37970;
    }
    case 59496: {
      return 37956;
    }
    case 59497: {
      return 37979;
    }
    case 59498: {
      return 37984;
    }
    case 59499: {
      return 37986;
    }
    case 59500: {
      return 37982;
    }
    case 59501: {
      return 37994;
    }
    case 59502: {
      return 37417;
    }
    case 59503: {
      return 38000;
    }
    case 59504: {
      return 38005;
    }
    case 59505: {
      return 38007;
    }
    case 59506: {
      return 38013;
    }
    case 59507: {
      return 37978;
    }
    case 59508: {
      return 38012;
    }
    case 59509: {
      return 38014;
    }
    case 59510: {
      return 38017;
    }
    case 59511: {
      return 38015;
    }
    case 59512: {
      return 38274;
    }
    case 59513: {
      return 38279;
    }
    case 59514: {
      return 38282;
    }
    case 59515: {
      return 38292;
    }
    case 59516: {
      return 38294;
    }
    case 59517: {
      return 38296;
    }
    case 59518: {
      return 38297;
    }
    case 59520: {
      return 38304;
    }
    case 59521: {
      return 38312;
    }
    case 59522: {
      return 38311;
    }
    case 59523: {
      return 38317;
    }
    case 59524: {
      return 38332;
    }
    case 59525: {
      return 38331;
    }
    case 59526: {
      return 38329;
    }
    case 59527: {
      return 38334;
    }
    case 59528: {
      return 38346;
    }
    case 59529: {
      return 28662;
    }
    case 59530: {
      return 38339;
    }
    case 59531: {
      return 38349;
    }
    case 59532: {
      return 38348;
    }
    case 59533: {
      return 38357;
    }
    case 59534: {
      return 38356;
    }
    case 59535: {
      return 38358;
    }
    case 59536: {
      return 38364;
    }
    case 59537: {
      return 38369;
    }
    case 59538: {
      return 38373;
    }
    case 59539: {
      return 38370;
    }
    case 59540: {
      return 38433;
    }
    case 59541: {
      return 38440;
    }
    case 59542: {
      return 38446;
    }
    case 59543: {
      return 38447;
    }
    case 59544: {
      return 38466;
    }
    case 59545: {
      return 38476;
    }
    case 59546: {
      return 38479;
    }
    case 59547: {
      return 38475;
    }
    case 59548: {
      return 38519;
    }
    case 59549: {
      return 38492;
    }
    case 59550: {
      return 38494;
    }
    case 59551: {
      return 38493;
    }
    case 59552: {
      return 38495;
    }
    case 59553: {
      return 38502;
    }
    case 59554: {
      return 38514;
    }
    case 59555: {
      return 38508;
    }
    case 59556: {
      return 38541;
    }
    case 59557: {
      return 38552;
    }
    case 59558: {
      return 38549;
    }
    case 59559: {
      return 38551;
    }
    case 59560: {
      return 38570;
    }
    case 59561: {
      return 38567;
    }
    case 59562: {
      return 38577;
    }
    case 59563: {
      return 38578;
    }
    case 59564: {
      return 38576;
    }
    case 59565: {
      return 38580;
    }
    case 59566: {
      return 38582;
    }
    case 59567: {
      return 38584;
    }
    case 59568: {
      return 38585;
    }
    case 59569: {
      return 38606;
    }
    case 59570: {
      return 38603;
    }
    case 59571: {
      return 38601;
    }
    case 59572: {
      return 38605;
    }
    case 59573: {
      return 35149;
    }
    case 59574: {
      return 38620;
    }
    case 59575: {
      return 38669;
    }
    case 59576: {
      return 38613;
    }
    case 59577: {
      return 38649;
    }
    case 59578: {
      return 38660;
    }
    case 59579: {
      return 38662;
    }
    case 59580: {
      return 38664;
    }
    case 59581: {
      return 38675;
    }
    case 59582: {
      return 38670;
    }
    case 59583: {
      return 38673;
    }
    case 59584: {
      return 38671;
    }
    case 59585: {
      return 38678;
    }
    case 59586: {
      return 38681;
    }
    case 59587: {
      return 38692;
    }
    case 59588: {
      return 38698;
    }
    case 59589: {
      return 38704;
    }
    case 59590: {
      return 38713;
    }
    case 59591: {
      return 38717;
    }
    case 59592: {
      return 38718;
    }
    case 59593: {
      return 38724;
    }
    case 59594: {
      return 38726;
    }
    case 59595: {
      return 38728;
    }
    case 59596: {
      return 38722;
    }
    case 59597: {
      return 38729;
    }
    case 59598: {
      return 38748;
    }
    case 59599: {
      return 38752;
    }
    case 59600: {
      return 38756;
    }
    case 59601: {
      return 38758;
    }
    case 59602: {
      return 38760;
    }
    case 59603: {
      return 21202;
    }
    case 59604: {
      return 38763;
    }
    case 59605: {
      return 38769;
    }
    case 59606: {
      return 38777;
    }
    case 59607: {
      return 38789;
    }
    case 59608: {
      return 38780;
    }
    case 59609: {
      return 38785;
    }
    case 59610: {
      return 38778;
    }
    case 59611: {
      return 38790;
    }
    case 59612: {
      return 38795;
    }
    case 59613: {
      return 38799;
    }
    case 59614: {
      return 38800;
    }
    case 59615: {
      return 38812;
    }
    case 59616: {
      return 38824;
    }
    case 59617: {
      return 38822;
    }
    case 59618: {
      return 38819;
    }
    case 59619: {
      return 38835;
    }
    case 59620: {
      return 38836;
    }
    case 59621: {
      return 38851;
    }
    case 59622: {
      return 38854;
    }
    case 59623: {
      return 38856;
    }
    case 59624: {
      return 38859;
    }
    case 59625: {
      return 38876;
    }
    case 59626: {
      return 38893;
    }
    case 59627: {
      return 40783;
    }
    case 59628: {
      return 38898;
    }
    case 59629: {
      return 31455;
    }
    case 59630: {
      return 38902;
    }
    case 59631: {
      return 38901;
    }
    case 59632: {
      return 38927;
    }
    case 59633: {
      return 38924;
    }
    case 59634: {
      return 38968;
    }
    case 59635: {
      return 38948;
    }
    case 59636: {
      return 38945;
    }
    case 59637: {
      return 38967;
    }
    case 59638: {
      return 38973;
    }
    case 59639: {
      return 38982;
    }
    case 59640: {
      return 38991;
    }
    case 59641: {
      return 38987;
    }
    case 59642: {
      return 39019;
    }
    case 59643: {
      return 39023;
    }
    case 59644: {
      return 39024;
    }
    case 59712: {
      return 39025;
    }
    case 59713: {
      return 39028;
    }
    case 59714: {
      return 39027;
    }
    case 59715: {
      return 39082;
    }
    case 59716: {
      return 39087;
    }
    case 59717: {
      return 39089;
    }
    case 59718: {
      return 39094;
    }
    case 59719: {
      return 39108;
    }
    case 59720: {
      return 39107;
    }
    case 59721: {
      return 39110;
    }
    case 59722: {
      return 39145;
    }
    case 59723: {
      return 39147;
    }
    case 59724: {
      return 39171;
    }
    case 59725: {
      return 39177;
    }
    case 59726: {
      return 39186;
    }
    case 59727: {
      return 39188;
    }
    case 59728: {
      return 39192;
    }
    case 59729: {
      return 39201;
    }
    case 59730: {
      return 39197;
    }
    case 59731: {
      return 39198;
    }
    case 59732: {
      return 39204;
    }
    case 59733: {
      return 39200;
    }
    case 59734: {
      return 39212;
    }
    case 59735: {
      return 39214;
    }
    case 59736: {
      return 39229;
    }
    case 59737: {
      return 39230;
    }
    case 59738: {
      return 39234;
    }
    case 59739: {
      return 39241;
    }
    case 59740: {
      return 39237;
    }
    case 59741: {
      return 39248;
    }
    case 59742: {
      return 39243;
    }
    case 59743: {
      return 39249;
    }
    case 59744: {
      return 39250;
    }
    case 59745: {
      return 39244;
    }
    case 59746: {
      return 39253;
    }
    case 59747: {
      return 39319;
    }
    case 59748: {
      return 39320;
    }
    case 59749: {
      return 39333;
    }
    case 59750: {
      return 39341;
    }
    case 59751: {
      return 39342;
    }
    case 59752: {
      return 39356;
    }
    case 59753: {
      return 39391;
    }
    case 59754: {
      return 39387;
    }
    case 59755: {
      return 39389;
    }
    case 59756: {
      return 39384;
    }
    case 59757: {
      return 39377;
    }
    case 59758: {
      return 39405;
    }
    case 59759: {
      return 39406;
    }
    case 59760: {
      return 39409;
    }
    case 59761: {
      return 39410;
    }
    case 59762: {
      return 39419;
    }
    case 59763: {
      return 39416;
    }
    case 59764: {
      return 39425;
    }
    case 59765: {
      return 39439;
    }
    case 59766: {
      return 39429;
    }
    case 59767: {
      return 39394;
    }
    case 59768: {
      return 39449;
    }
    case 59769: {
      return 39467;
    }
    case 59770: {
      return 39479;
    }
    case 59771: {
      return 39493;
    }
    case 59772: {
      return 39490;
    }
    case 59773: {
      return 39488;
    }
    case 59774: {
      return 39491;
    }
    case 59776: {
      return 39486;
    }
    case 59777: {
      return 39509;
    }
    case 59778: {
      return 39501;
    }
    case 59779: {
      return 39515;
    }
    case 59780: {
      return 39511;
    }
    case 59781: {
      return 39519;
    }
    case 59782: {
      return 39522;
    }
    case 59783: {
      return 39525;
    }
    case 59784: {
      return 39524;
    }
    case 59785: {
      return 39529;
    }
    case 59786: {
      return 39531;
    }
    case 59787: {
      return 39530;
    }
    case 59788: {
      return 39597;
    }
    case 59789: {
      return 39600;
    }
    case 59790: {
      return 39612;
    }
    case 59791: {
      return 39616;
    }
    case 59792: {
      return 39631;
    }
    case 59793: {
      return 39633;
    }
    case 59794: {
      return 39635;
    }
    case 59795: {
      return 39636;
    }
    case 59796: {
      return 39646;
    }
    case 59797: {
      return 39647;
    }
    case 59798: {
      return 39650;
    }
    case 59799: {
      return 39651;
    }
    case 59800: {
      return 39654;
    }
    case 59801: {
      return 39663;
    }
    case 59802: {
      return 39659;
    }
    case 59803: {
      return 39662;
    }
    case 59804: {
      return 39668;
    }
    case 59805: {
      return 39665;
    }
    case 59806: {
      return 39671;
    }
    case 59807: {
      return 39675;
    }
    case 59808: {
      return 39686;
    }
    case 59809: {
      return 39704;
    }
    case 59810: {
      return 39706;
    }
    case 59811: {
      return 39711;
    }
    case 59812: {
      return 39714;
    }
    case 59813: {
      return 39715;
    }
    case 59814: {
      return 39717;
    }
    case 59815: {
      return 39719;
    }
    case 59816: {
      return 39720;
    }
    case 59817: {
      return 39721;
    }
    case 59818: {
      return 39722;
    }
    case 59819: {
      return 39726;
    }
    case 59820: {
      return 39727;
    }
    case 59821: {
      return 39730;
    }
    case 59822: {
      return 39748;
    }
    case 59823: {
      return 39747;
    }
    case 59824: {
      return 39759;
    }
    case 59825: {
      return 39757;
    }
    case 59826: {
      return 39758;
    }
    case 59827: {
      return 39761;
    }
    case 59828: {
      return 39768;
    }
    case 59829: {
      return 39796;
    }
    case 59830: {
      return 39827;
    }
    case 59831: {
      return 39811;
    }
    case 59832: {
      return 39825;
    }
    case 59833: {
      return 39830;
    }
    case 59834: {
      return 39831;
    }
    case 59835: {
      return 39839;
    }
    case 59836: {
      return 39840;
    }
    case 59837: {
      return 39848;
    }
    case 59838: {
      return 39860;
    }
    case 59839: {
      return 39872;
    }
    case 59840: {
      return 39882;
    }
    case 59841: {
      return 39865;
    }
    case 59842: {
      return 39878;
    }
    case 59843: {
      return 39887;
    }
    case 59844: {
      return 39889;
    }
    case 59845: {
      return 39890;
    }
    case 59846: {
      return 39907;
    }
    case 59847: {
      return 39906;
    }
    case 59848: {
      return 39908;
    }
    case 59849: {
      return 39892;
    }
    case 59850: {
      return 39905;
    }
    case 59851: {
      return 39994;
    }
    case 59852: {
      return 39922;
    }
    case 59853: {
      return 39921;
    }
    case 59854: {
      return 39920;
    }
    case 59855: {
      return 39957;
    }
    case 59856: {
      return 39956;
    }
    case 59857: {
      return 39945;
    }
    case 59858: {
      return 39955;
    }
    case 59859: {
      return 39948;
    }
    case 59860: {
      return 39942;
    }
    case 59861: {
      return 39944;
    }
    case 59862: {
      return 39954;
    }
    case 59863: {
      return 39946;
    }
    case 59864: {
      return 39940;
    }
    case 59865: {
      return 39982;
    }
    case 59866: {
      return 39963;
    }
    case 59867: {
      return 39973;
    }
    case 59868: {
      return 39972;
    }
    case 59869: {
      return 39969;
    }
    case 59870: {
      return 39984;
    }
    case 59871: {
      return 40007;
    }
    case 59872: {
      return 39986;
    }
    case 59873: {
      return 40006;
    }
    case 59874: {
      return 39998;
    }
    case 59875: {
      return 40026;
    }
    case 59876: {
      return 40032;
    }
    case 59877: {
      return 40039;
    }
    case 59878: {
      return 40054;
    }
    case 59879: {
      return 40056;
    }
    case 59880: {
      return 40167;
    }
    case 59881: {
      return 40172;
    }
    case 59882: {
      return 40176;
    }
    case 59883: {
      return 40201;
    }
    case 59884: {
      return 40200;
    }
    case 59885: {
      return 40171;
    }
    case 59886: {
      return 40195;
    }
    case 59887: {
      return 40198;
    }
    case 59888: {
      return 40234;
    }
    case 59889: {
      return 40230;
    }
    case 59890: {
      return 40367;
    }
    case 59891: {
      return 40227;
    }
    case 59892: {
      return 40223;
    }
    case 59893: {
      return 40260;
    }
    case 59894: {
      return 40213;
    }
    case 59895: {
      return 40210;
    }
    case 59896: {
      return 40257;
    }
    case 59897: {
      return 40255;
    }
    case 59898: {
      return 40254;
    }
    case 59899: {
      return 40262;
    }
    case 59900: {
      return 40264;
    }
    case 59968: {
      return 40285;
    }
    case 59969: {
      return 40286;
    }
    case 59970: {
      return 40292;
    }
    case 59971: {
      return 40273;
    }
    case 59972: {
      return 40272;
    }
    case 59973: {
      return 40281;
    }
    case 59974: {
      return 40306;
    }
    case 59975: {
      return 40329;
    }
    case 59976: {
      return 40327;
    }
    case 59977: {
      return 40363;
    }
    case 59978: {
      return 40303;
    }
    case 59979: {
      return 40314;
    }
    case 59980: {
      return 40346;
    }
    case 59981: {
      return 40356;
    }
    case 59982: {
      return 40361;
    }
    case 59983: {
      return 40370;
    }
    case 59984: {
      return 40388;
    }
    case 59985: {
      return 40385;
    }
    case 59986: {
      return 40379;
    }
    case 59987: {
      return 40376;
    }
    case 59988: {
      return 40378;
    }
    case 59989: {
      return 40390;
    }
    case 59990: {
      return 40399;
    }
    case 59991: {
      return 40386;
    }
    case 59992: {
      return 40409;
    }
    case 59993: {
      return 40403;
    }
    case 59994: {
      return 40440;
    }
    case 59995: {
      return 40422;
    }
    case 59996: {
      return 40429;
    }
    case 59997: {
      return 40431;
    }
    case 59998: {
      return 40445;
    }
    case 59999: {
      return 40474;
    }
    case 60000: {
      return 40475;
    }
    case 60001: {
      return 40478;
    }
    case 60002: {
      return 40565;
    }
    case 60003: {
      return 40569;
    }
    case 60004: {
      return 40573;
    }
    case 60005: {
      return 40577;
    }
    case 60006: {
      return 40584;
    }
    case 60007: {
      return 40587;
    }
    case 60008: {
      return 40588;
    }
    case 60009: {
      return 40594;
    }
    case 60010: {
      return 40597;
    }
    case 60011: {
      return 40593;
    }
    case 60012: {
      return 40605;
    }
    case 60013: {
      return 40613;
    }
    case 60014: {
      return 40617;
    }
    case 60015: {
      return 40632;
    }
    case 60016: {
      return 40618;
    }
    case 60017: {
      return 40621;
    }
    case 60018: {
      return 38753;
    }
    case 60019: {
      return 40652;
    }
    case 60020: {
      return 40654;
    }
    case 60021: {
      return 40655;
    }
    case 60022: {
      return 40656;
    }
    case 60023: {
      return 40660;
    }
    case 60024: {
      return 40668;
    }
    case 60025: {
      return 40670;
    }
    case 60026: {
      return 40669;
    }
    case 60027: {
      return 40672;
    }
    case 60028: {
      return 40677;
    }
    case 60029: {
      return 40680;
    }
    case 60030: {
      return 40687;
    }
    case 60032: {
      return 40692;
    }
    case 60033: {
      return 40694;
    }
    case 60034: {
      return 40695;
    }
    case 60035: {
      return 40697;
    }
    case 60036: {
      return 40699;
    }
    case 60037: {
      return 40700;
    }
    case 60038: {
      return 40701;
    }
    case 60039: {
      return 40711;
    }
    case 60040: {
      return 40712;
    }
    case 60041: {
      return 30391;
    }
    case 60042: {
      return 40725;
    }
    case 60043: {
      return 40737;
    }
    case 60044: {
      return 40748;
    }
    case 60045: {
      return 40766;
    }
    case 60046: {
      return 40778;
    }
    case 60047: {
      return 40786;
    }
    case 60048: {
      return 40788;
    }
    case 60049: {
      return 40803;
    }
    case 60050: {
      return 40799;
    }
    case 60051: {
      return 40800;
    }
    case 60052: {
      return 40801;
    }
    case 60053: {
      return 40806;
    }
    case 60054: {
      return 40807;
    }
    case 60055: {
      return 40812;
    }
    case 60056: {
      return 40810;
    }
    case 60057: {
      return 40823;
    }
    case 60058: {
      return 40818;
    }
    case 60059: {
      return 40822;
    }
    case 60060: {
      return 40853;
    }
    case 60061: {
      return 40860;
    }
    case 60062: {
      return 40864;
    }
    case 60063: {
      return 22575;
    }
    case 60064: {
      return 27079;
    }
    case 60065: {
      return 36953;
    }
    case 60066: {
      return 29796;
    }
    case 60067: {
      return 20956;
    }
    case 60068: {
      return 29081;
    }
    default: {
      return -1;
    }
  }
}
function horideicom$encoding_sjis$$Decoder$new() {
  return { pending_first_byte: 0, had_replacements: false };
}
function horideicom$encoding_sjis$$new_decoder() {
  return horideicom$encoding_sjis$$Decoder$new();
}
function horideicom$encoding_sjis$$Decoder$decode_to_string(self, src, last) {
  let result = "";
  let i = 0;
  const len = src.length;
  if (self.pending_first_byte !== 0) {
    if (len === 0) {
      if (last) {
        result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
        self.had_replacements = true;
        self.pending_first_byte = 0;
      }
    } else {
      const b1 = self.pending_first_byte;
      $bound_check(src, 0);
      const b2 = src[0];
      const valid_second = b2 >= 64 && b2 <= 252 && b2 !== 127;
      if (valid_second) {
        const code = b1 << 8 | b2;
        const _bind = horideicom$encoding_sjis$$decode_jis_x_0208(code);
        if (_bind === -1) {
          result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
          self.had_replacements = true;
        } else {
          const _Some = _bind;
          const _ch = _Some;
          result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(_ch)}`;
        }
        i = 1;
      } else {
        result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
        self.had_replacements = true;
        i = 0;
      }
      self.pending_first_byte = 0;
    }
  }
  while (true) {
    if (i < len) {
      const _tmp = i;
      $bound_check(src, _tmp);
      const b1 = src[_tmp];
      if (b1 < 128) {
        result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(b1)}`;
        i = i + 1 | 0;
      } else {
        if (b1 >= 161 && b1 <= 223) {
          const ch = 65377 + (b1 - 161 | 0) | 0;
          result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(ch)}`;
          i = i + 1 | 0;
        } else {
          if (b1 >= 129 && b1 <= 159 || b1 >= 224 && b1 <= 239) {
            if ((i + 1 | 0) < len) {
              const _tmp$2 = i + 1 | 0;
              $bound_check(src, _tmp$2);
              const b2 = src[_tmp$2];
              const valid_second = b2 >= 64 && b2 <= 252 && b2 !== 127;
              if (valid_second) {
                const code = b1 << 8 | b2;
                const _bind = horideicom$encoding_sjis$$decode_jis_x_0208(code);
                if (_bind === -1) {
                  result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
                  self.had_replacements = true;
                } else {
                  const _Some = _bind;
                  const _ch = _Some;
                  result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(_ch)}`;
                }
                i = i + 2 | 0;
              } else {
                result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
                self.had_replacements = true;
                i = i + 1 | 0;
              }
            } else {
              if (last) {
                result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
                self.had_replacements = true;
                i = i + 1 | 0;
              } else {
                self.pending_first_byte = b1;
                i = i + 1 | 0;
              }
            }
          } else {
            result = `${result}${moonbitlang$core$builtin$$Show$to_string$23$(65533)}`;
            self.had_replacements = true;
            i = i + 1 | 0;
          }
        }
      }
      continue;
    } else {
      break;
    }
  }
  return result;
}
function horideicom$encoding_sjis$$decode(src) {
  const decoder = horideicom$encoding_sjis$$new_decoder();
  const result = horideicom$encoding_sjis$$Decoder$decode_to_string(decoder, src, true);
  return { _0: result, _1: decoder.had_replacements };
}
function horideicom$encoding_sjis$$shift_jis_to_utf8(data) {
  const _bind = horideicom$encoding_sjis$$decode(data);
  return _bind._0;
}
function horideicom$jww_parser$core$$LayerGroup$default() {
  const layers = moonbitlang$core$array$$Array$new$46$inner$20$(0);
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < 16) {
      moonbitlang$core$array$$Array$push$20$(layers, horideicom$jww_parser$core$$default$46$record$47$1502);
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { state: 2, write_layer: 0, scale: 1, protect: 0, layers: layers, name: "" };
}
function horideicom$jww_parser$core$$Document$default() {
  const layer_groups = moonbitlang$core$array$$Array$new$46$inner$18$(0);
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < 16) {
      moonbitlang$core$array$$Array$push$18$(layer_groups, horideicom$jww_parser$core$$LayerGroup$default());
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return { version: 0, memo: "", paper_size: 0, write_layer_group: 0, layer_groups: layer_groups, entities: moonbitlang$core$array$$Array$new$46$inner$22$(0), block_defs: moonbitlang$core$array$$Array$new$46$inner$29$(0), embedded_images: moonbitlang$core$array$$Array$new$46$inner$30$(0), print_settings: horideicom$jww_parser$core$$default$46$record$47$1508, sunpou_settings: horideicom$jww_parser$core$$default$46$record$47$1507, metadata_settings: horideicom$jww_parser$core$$default$46$record$47$1506 };
}
function horideicom$jww_parser$core$$Reader$new(data) {
  return { data: moonbitlang$core$bytes$$Bytes$to_array(data), pos: 0 };
}
function horideicom$jww_parser$core$$Reader$read_byte(self) {
  const b = moonbitlang$core$array$$Array$at$4$(self.data, self.pos);
  self.pos = self.pos + 1 | 0;
  return b;
}
function horideicom$jww_parser$core$$Reader$read_word(self) {
  const b0 = horideicom$jww_parser$core$$Reader$read_byte(self);
  const b1 = horideicom$jww_parser$core$$Reader$read_byte(self);
  const _p = 8;
  const _p$2 = b1 << _p & 65535;
  return (b0 | _p$2) & 65535;
}
function horideicom$jww_parser$core$$Reader$read_dword(self) {
  const _p = horideicom$jww_parser$core$$Reader$read_byte(self);
  const b0 = _p;
  const _p$2 = horideicom$jww_parser$core$$Reader$read_byte(self);
  const b1 = _p$2;
  const _p$3 = horideicom$jww_parser$core$$Reader$read_byte(self);
  const b2 = _p$3;
  const _p$4 = horideicom$jww_parser$core$$Reader$read_byte(self);
  const b3 = _p$4;
  return b0 | b1 << 8 | b2 << 16 | b3 << 24;
}
function horideicom$jww_parser$core$$Reader$read_uint64(self) {
  const b0 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b1 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b2 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b3 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b4 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b5 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b6 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  const b7 = moonbitlang$core$byte$$Byte$to_uint64(horideicom$jww_parser$core$$Reader$read_byte(self));
  return moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(moonbitlang$core$builtin$$BitOr$lor$2$(b0, moonbitlang$core$builtin$$Shl$shl$2$(b1, 8)), moonbitlang$core$builtin$$Shl$shl$2$(b2, 16)), moonbitlang$core$builtin$$Shl$shl$2$(b3, 24)), moonbitlang$core$builtin$$Shl$shl$2$(b4, 32)), moonbitlang$core$builtin$$Shl$shl$2$(b5, 40)), moonbitlang$core$builtin$$Shl$shl$2$(b6, 48)), moonbitlang$core$builtin$$Shl$shl$2$(b7, 56));
}
function horideicom$jww_parser$core$$Reader$read_double(self) {
  const bits = horideicom$jww_parser$core$$Reader$read_uint64(self);
  return moonbitlang$core$uint64$$UInt64$reinterpret_as_double(bits);
}
function horideicom$jww_parser$core$$Reader$read_bytes(self, n) {
  if ((self.data.length - self.pos | 0) < n) {
    const _bind = new Uint8Array([]);
    return moonbitlang$core$bytes$$Bytes$from_array({ buf: _bind, start: 0, end: 0 });
  }
  const start = self.pos;
  const end = self.pos + n | 0;
  self.pos = end;
  return moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(self.data, start, end));
}
function horideicom$jww_parser$core$$is_metadata_text(content) {
  return moonbitlang$core$string$$String$has_prefix(content, { str: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$983, start: 0, end: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$983.length }) || (moonbitlang$core$string$$String$has_prefix(content, { str: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$984, start: 0, end: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$984.length }) || moonbitlang$core$string$$String$has_prefix(content, { str: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$985, start: 0, end: horideicom$jww_parser$core$$is_metadata_text$46$42$bind$124$985.length }));
}
function horideicom$jww_parser$core$$find_bm_marker(content) {
  const chars = moonbitlang$core$string$$String$to_array(content);
  const len = chars.length;
  if (len < 4) {
    return undefined;
  }
  let i = 0;
  while (true) {
    if (i < (len - 3 | 0)) {
      if (moonbitlang$core$array$$Array$at$23$(chars, i) === 94 && (moonbitlang$core$array$$Array$at$23$(chars, i + 1 | 0) === 64 && (moonbitlang$core$array$$Array$at$23$(chars, i + 2 | 0) === 66 && moonbitlang$core$array$$Array$at$23$(chars, i + 3 | 0) === 77))) {
        return i;
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function horideicom$jww_parser$core$$normalize_image_path(raw_path) {
  const all_chars = moonbitlang$core$string$$String$to_array(raw_path);
  const chars = moonbitlang$core$string$$String$has_prefix(raw_path, { str: horideicom$jww_parser$core$$normalize_image_path$46$42$bind$124$989, start: 0, end: horideicom$jww_parser$core$$normalize_image_path$46$42$bind$124$989.length }) && all_chars.length > 6 ? moonbitlang$core$array$$Array$from_iter$23$(moonbitlang$core$array$$ArrayView$iter$23$(moonbitlang$core$array$$Array$sub$46$inner$23$(all_chars, 6, undefined))) : all_chars;
  let normalized = "";
  let prev_was_letter = false;
  const _len = chars.length;
  let _tmp = 0;
  while (true) {
    const _i = _tmp;
    if (_i < _len) {
      const c = chars[_i];
      if (c === 95 && prev_was_letter) {
        normalized = `${normalized}/`;
        prev_was_letter = false;
      } else {
        normalized = `${normalized}${moonbitlang$core$builtin$$Show$to_string$23$(c)}`;
        prev_was_letter = c >= 65 && c <= 90 || c >= 97 && c <= 122;
      }
      _tmp = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return normalized;
}
function horideicom$jww_parser$core$$parse_double_or_default(s, default_) {
  let _try_err;
  _L: {
    const _bind = moonbitlang$core$strconv$$parse_double({ str: s, start: 0, end: s.length });
    if (_bind.$tag === 1) {
      const _ok = _bind;
      return _ok._0;
    } else {
      const _err = _bind;
      const _tmp = _err._0;
      _try_err = _tmp;
      break _L;
    }
  }
  return default_;
}
function horideicom$jww_parser$core$$split_by_comma(path_and_params) {
  const result = moonbitlang$core$array$$Array$new$46$inner$19$(0);
  let current = "";
  const _it = moonbitlang$core$string$$String$iterator(path_and_params);
  while (true) {
    const _bind = moonbitlang$core$builtin$$Iterator$next$23$(_it);
    if (_bind === -1) {
      break;
    } else {
      const _Some = _bind;
      const _c = _Some;
      if (_c === 44) {
        moonbitlang$core$array$$Array$push$19$(result, current);
        current = "";
      } else {
        current = `${current}${moonbitlang$core$builtin$$Show$to_string$23$(_c)}`;
      }
      continue;
    }
  }
  const _p = current;
  const _p$2 = "";
  if (!(_p === _p$2)) {
    moonbitlang$core$array$$Array$push$19$(result, current);
  }
  return result;
}
function horideicom$jww_parser$core$$parse_image_from_bm_string(content, base, start_x, start_y, angle, size_x, size_y) {
  const _bind = horideicom$jww_parser$core$$find_bm_marker(content);
  let bm_offset;
  if (_bind === undefined) {
    return undefined;
  } else {
    const _Some = _bind;
    bm_offset = _Some;
  }
  const chars = moonbitlang$core$string$$String$to_array(content);
  if (chars.length <= (bm_offset + 4 | 0)) {
    return undefined;
  }
  const path_and_params = moonbitlang$core$string$$String$from_array(moonbitlang$core$array$$Array$sub$46$inner$23$(chars, bm_offset + 4 | 0, undefined));
  const parts = horideicom$jww_parser$core$$split_by_comma(path_and_params);
  if (parts.length < 1) {
    return undefined;
  }
  const raw_path = moonbitlang$core$array$$Array$at$19$(parts, 0);
  const image_path = horideicom$jww_parser$core$$normalize_image_path(raw_path);
  const width = parts.length >= 2 ? horideicom$jww_parser$core$$parse_double_or_default(moonbitlang$core$array$$Array$at$19$(parts, 1), size_x) : size_x;
  const height = parts.length >= 3 ? horideicom$jww_parser$core$$parse_double_or_default(moonbitlang$core$array$$Array$at$19$(parts, 2), size_y) : size_y;
  return { base: base, image_path: image_path, x: start_x, y: start_y, width: width, height: height, rotation: angle };
}
function horideicom$jww_parser$core$$detect_image_format(data) {
  if (data.length < 4) {
    return 0;
  }
  $bound_check(data, 0);
  const b0 = data[0];
  $bound_check(data, 1);
  const b1 = data[1];
  $bound_check(data, 2);
  const b2 = data[2];
  $bound_check(data, 3);
  const b3 = data[3];
  if (b0 === 255 && (b1 === 216 && b2 === 255)) {
    return 1;
  }
  if (b0 === 137 && (b1 === 80 && (b2 === 78 && b3 === 71))) {
    return 2;
  }
  if (b0 === 66 && b1 === 77) {
    return 3;
  }
  if (b0 === 71 && (b1 === 73 && (b2 === 70 && b3 === 56))) {
    return 4;
  }
  return 0;
}
function horideicom$jww_parser$core$$parse_single_embedded_image(reader, index) {
  if ((reader.data.length - reader.pos | 0) < 4) {
    return undefined;
  }
  const file_size = horideicom$jww_parser$core$$Reader$read_dword(reader);
  if (file_size === 0 || file_size >>> 0 > 100000000 >>> 0) {
    return undefined;
  }
  const file_size_int = file_size;
  if ((reader.data.length - reader.pos | 0) < file_size_int) {
    return undefined;
  }
  const image_data = horideicom$jww_parser$core$$Reader$read_bytes(reader, file_size_int);
  if (image_data.length === 0) {
    return undefined;
  }
  const format = horideicom$jww_parser$core$$detect_image_format(image_data);
  return { index: index, file_size: file_size, data: image_data, format: format };
}
function horideicom$jww_parser$core$$parse_embedded_images(data, offset, version) {
  if (version >>> 0 < 700 >>> 0) {
    return moonbitlang$core$array$$Array$new$46$inner$30$(0);
  }
  if (offset >= data.length) {
    return moonbitlang$core$array$$Array$new$46$inner$30$(0);
  }
  const image_data = moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(moonbitlang$core$bytes$$Bytes$to_array(data), offset, data.length));
  const reader = horideicom$jww_parser$core$$Reader$new(image_data);
  if ((reader.data.length - reader.pos | 0) < 4) {
    return moonbitlang$core$array$$Array$new$46$inner$30$(0);
  }
  const count = horideicom$jww_parser$core$$Reader$read_dword(reader);
  if (count >>> 0 > 1000 >>> 0) {
    return moonbitlang$core$array$$Array$new$46$inner$30$(0);
  }
  const embedded_images = moonbitlang$core$array$$Array$new$46$inner$30$(0);
  const _end370 = count;
  let _tmp = 0;
  while (true) {
    const i = _tmp;
    if (i < _end370) {
      const result = horideicom$jww_parser$core$$parse_single_embedded_image(reader, i);
      if (result === undefined) {
      } else {
        const _Some = result;
        const _img = _Some;
        moonbitlang$core$array$$Array$push$30$(embedded_images, _img);
      }
      _tmp = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return embedded_images;
}
function horideicom$jww_parser$core$$parse_print_settings(reader) {
  const origin_x = horideicom$jww_parser$core$$Reader$read_double(reader);
  const origin_y = horideicom$jww_parser$core$$Reader$read_double(reader);
  const scale = horideicom$jww_parser$core$$Reader$read_double(reader);
  const rotation_setting = horideicom$jww_parser$core$$Reader$read_dword(reader);
  return { origin_x: origin_x, origin_y: origin_y, scale: scale, rotation_setting: rotation_setting };
}
function horideicom$jww_parser$core$$parse_sunpou_settings(reader) {
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < 14) {
      horideicom$jww_parser$core$$Reader$read_dword(reader);
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const sunpou1 = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const sunpou2 = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const sunpou3 = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const sunpou4 = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const sunpou5 = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const dummy = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const max_line_width = horideicom$jww_parser$core$$Reader$read_dword(reader);
  return { sunpou1: sunpou1, sunpou2: sunpou2, sunpou3: sunpou3, sunpou4: sunpou4, sunpou5: sunpou5, dummy: dummy, max_line_width: max_line_width };
}
function horideicom$jww_parser$core$$read_cstring(reader) {
  const len_byte = horideicom$jww_parser$core$$Reader$read_byte(reader);
  let length;
  if (len_byte < 255) {
    length = len_byte;
  } else {
    const len_word = horideicom$jww_parser$core$$Reader$read_word(reader);
    if (len_word < 65535) {
      length = len_word;
    } else {
      const len_dword = horideicom$jww_parser$core$$Reader$read_dword(reader);
      length = len_dword < 0 || len_dword > 1000000 ? 0 : len_dword;
    }
  }
  if (length <= 0 || length > 1000000) {
    return "";
  }
  const actual_length = (reader.data.length - reader.pos | 0) < length ? reader.data.length - reader.pos | 0 : length;
  const bytes = horideicom$jww_parser$core$$Reader$read_bytes(reader, actual_length);
  return horideicom$encoding_sjis$$shift_jis_to_utf8(bytes);
}
function horideicom$jww_parser$core$$parse_layer_names(reader, layer_groups) {
  const layer_names = moonbitlang$core$array$$Array$new$46$inner$21$(0);
  let _tmp = 0;
  while (true) {
    const _g_idx = _tmp;
    if (_g_idx < 16) {
      const group_layer_names = moonbitlang$core$array$$Array$new$46$inner$19$(0);
      let _tmp$2 = 0;
      while (true) {
        const _l_idx = _tmp$2;
        if (_l_idx < 16) {
          const name = horideicom$jww_parser$core$$read_cstring(reader);
          moonbitlang$core$array$$Array$push$19$(group_layer_names, name);
          _tmp$2 = _l_idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      moonbitlang$core$array$$Array$push$21$(layer_names, group_layer_names);
      _tmp = _g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const group_names = moonbitlang$core$array$$Array$new$46$inner$19$(0);
  let _tmp$2 = 0;
  while (true) {
    const _g_idx = _tmp$2;
    if (_g_idx < 16) {
      const name = horideicom$jww_parser$core$$read_cstring(reader);
      moonbitlang$core$array$$Array$push$19$(group_names, name);
      _tmp$2 = _g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const result = moonbitlang$core$array$$Array$new$46$inner$18$(0);
  const _end328 = layer_groups.length;
  let _tmp$3 = 0;
  while (true) {
    const g_idx = _tmp$3;
    if (g_idx < _end328) {
      const lg = moonbitlang$core$array$$Array$at$18$(layer_groups, g_idx);
      const group_name = moonbitlang$core$array$$Array$at$19$(group_names, g_idx);
      const layers = moonbitlang$core$array$$Array$new$46$inner$20$(0);
      const _end336 = lg.layers.length;
      let _tmp$4 = 0;
      while (true) {
        const l_idx = _tmp$4;
        if (l_idx < _end336) {
          const l = moonbitlang$core$array$$Array$at$20$(lg.layers, l_idx);
          const layer_name = moonbitlang$core$array$$Array$at$19$(moonbitlang$core$array$$Array$at$21$(layer_names, g_idx), l_idx);
          const new_layer = { state: l.state, protect: l.protect, name: layer_name };
          moonbitlang$core$array$$Array$push$20$(layers, new_layer);
          _tmp$4 = l_idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const new_group = { state: lg.state, write_layer: lg.write_layer, scale: lg.scale, protect: lg.protect, layers: layers, name: group_name };
      moonbitlang$core$array$$Array$push$18$(result, new_group);
      _tmp$3 = g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function horideicom$jww_parser$core$$set_layer_names(layer_groups) {
  const result = moonbitlang$core$array$$Array$new$46$inner$18$(0);
  const _end288 = layer_groups.length;
  let _tmp = 0;
  while (true) {
    const g_idx = _tmp;
    if (g_idx < _end288) {
      const lg = moonbitlang$core$array$$Array$at$18$(layer_groups, g_idx);
      const group_name = lg.name === "" ? `Group${moonbitlang$core$int$$Int$to_string$46$inner(g_idx, 10)}` : lg.name;
      const layers = moonbitlang$core$array$$Array$new$46$inner$20$(0);
      const _end296 = lg.layers.length;
      let _tmp$2 = 0;
      while (true) {
        const l_idx = _tmp$2;
        if (l_idx < _end296) {
          const l = moonbitlang$core$array$$Array$at$20$(lg.layers, l_idx);
          const layer_name = l.name === "" ? `${moonbitlang$core$int$$Int$to_string$46$inner(g_idx, 10)}-${moonbitlang$core$int$$Int$to_string$46$inner(l_idx, 10)}` : l.name;
          const new_layer = { state: l.state, protect: l.protect, name: layer_name };
          moonbitlang$core$array$$Array$push$20$(layers, new_layer);
          _tmp$2 = l_idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const new_group = { state: lg.state, write_layer: lg.write_layer, scale: lg.scale, protect: lg.protect, layers: layers, name: group_name };
      moonbitlang$core$array$$Array$push$18$(result, new_group);
      _tmp = g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return result;
}
function horideicom$jww_parser$core$$find_entity_list_offset(data, version) {
  const schema_low = version & 255;
  const schema_high = version >>> 8 & 255;
  const search_end = data.length - 20 | 0;
  let i = 100;
  while (true) {
    if (i < search_end) {
      const _tmp = i;
      $bound_check(data, _tmp);
      const b0 = data[_tmp];
      const _tmp$2 = i + 1 | 0;
      $bound_check(data, _tmp$2);
      const b1 = data[_tmp$2];
      if (b0 === 255 && b1 === 255) {
        const _tmp$3 = i + 2 | 0;
        $bound_check(data, _tmp$3);
        const s0 = data[_tmp$3];
        const _tmp$4 = i + 3 | 0;
        $bound_check(data, _tmp$4);
        const s1 = data[_tmp$4];
        if (s0 === schema_low && s1 === schema_high) {
          const _tmp$5 = i + 4 | 0;
          $bound_check(data, _tmp$5);
          const _tmp$6 = data[_tmp$5];
          const _tmp$7 = i + 5 | 0;
          $bound_check(data, _tmp$7);
          const name_len = _tmp$6 | data[_tmp$7] << 8;
          if (name_len >= 8 && (name_len <= 20 && ((i + 6 | 0) + name_len | 0) <= data.length)) {
            const _tmp$8 = i + 6 | 0;
            $bound_check(data, _tmp$8);
            const c0 = data[_tmp$8];
            const _tmp$9 = i + 7 | 0;
            $bound_check(data, _tmp$9);
            const c1 = data[_tmp$9];
            const _tmp$10 = i + 8 | 0;
            $bound_check(data, _tmp$10);
            const c2 = data[_tmp$10];
            const _tmp$11 = i + 9 | 0;
            $bound_check(data, _tmp$11);
            const c3 = data[_tmp$11];
            const _tmp$12 = i + 10 | 0;
            $bound_check(data, _tmp$12);
            const c4 = data[_tmp$12];
            if (c0 === 67 && (c1 === 68 && (c2 === 97 && (c3 === 116 && c4 === 97)))) {
              return i - 2 | 0;
            }
          }
        }
      }
      i = i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return undefined;
}
function horideicom$jww_parser$core$$parse_entity_base(reader, version) {
  const group = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const pen_style = horideicom$jww_parser$core$$Reader$read_byte(reader);
  const pen_color = horideicom$jww_parser$core$$Reader$read_word(reader);
  const pen_width = version >>> 0 >= 351 >>> 0 ? horideicom$jww_parser$core$$Reader$read_word(reader) : 0;
  const layer = horideicom$jww_parser$core$$Reader$read_word(reader);
  const layer_group = horideicom$jww_parser$core$$Reader$read_word(reader);
  const flag = horideicom$jww_parser$core$$Reader$read_word(reader);
  return { group: group, pen_style: pen_style, pen_color: pen_color, pen_width: pen_width, layer: layer, layer_group: layer_group, flag: flag };
}
function horideicom$jww_parser$core$$parse_entity_by_class(class_name, reader, version) {
  if (class_name === "CDataSen") {
    const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
    const start_x = horideicom$jww_parser$core$$Reader$read_double(reader);
    const start_y = horideicom$jww_parser$core$$Reader$read_double(reader);
    const end_x = horideicom$jww_parser$core$$Reader$read_double(reader);
    const end_y = horideicom$jww_parser$core$$Reader$read_double(reader);
    return new $64$horideicom$47$jww_parser$47$core$46$Entity$Line({ base: base, start_x: start_x, start_y: start_y, end_x: end_x, end_y: end_y });
  } else {
    if (class_name === "CDataEnko") {
      const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
      const center_x = horideicom$jww_parser$core$$Reader$read_double(reader);
      const center_y = horideicom$jww_parser$core$$Reader$read_double(reader);
      const radius = horideicom$jww_parser$core$$Reader$read_double(reader);
      const start_angle = horideicom$jww_parser$core$$Reader$read_double(reader);
      const arc_angle = horideicom$jww_parser$core$$Reader$read_double(reader);
      const tilt_angle = horideicom$jww_parser$core$$Reader$read_double(reader);
      const flatness = horideicom$jww_parser$core$$Reader$read_double(reader);
      const full_circle = horideicom$jww_parser$core$$Reader$read_dword(reader);
      return new $64$horideicom$47$jww_parser$47$core$46$Entity$Arc({ base: base, center_x: center_x, center_y: center_y, radius: radius, start_angle: start_angle, arc_angle: arc_angle, tilt_angle: tilt_angle, flatness: flatness, is_full_circle: full_circle !== 0 });
    } else {
      if (class_name === "CDataTen") {
        const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
        const x = horideicom$jww_parser$core$$Reader$read_double(reader);
        const y = horideicom$jww_parser$core$$Reader$read_double(reader);
        const tmp = horideicom$jww_parser$core$$Reader$read_dword(reader);
        const is_temporary = tmp !== 0;
        let code = 0;
        let angle = 0;
        let scale = 1;
        const _p = base.pen_style;
        const _p$2 = 100;
        if (_p === _p$2) {
          code = horideicom$jww_parser$core$$Reader$read_dword(reader);
          angle = horideicom$jww_parser$core$$Reader$read_double(reader);
          scale = horideicom$jww_parser$core$$Reader$read_double(reader);
        }
        return new $64$horideicom$47$jww_parser$47$core$46$Entity$Point({ base: base, x: x, y: y, is_temporary: is_temporary, code: code, angle: angle, scale: scale });
      } else {
        if (class_name === "CDataMoji") {
          const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
          const start_x = horideicom$jww_parser$core$$Reader$read_double(reader);
          const start_y = horideicom$jww_parser$core$$Reader$read_double(reader);
          const end_x = horideicom$jww_parser$core$$Reader$read_double(reader);
          const end_y = horideicom$jww_parser$core$$Reader$read_double(reader);
          const text_type = horideicom$jww_parser$core$$Reader$read_dword(reader);
          const size_x = horideicom$jww_parser$core$$Reader$read_double(reader);
          const size_y = horideicom$jww_parser$core$$Reader$read_double(reader);
          const spacing = horideicom$jww_parser$core$$Reader$read_double(reader);
          const angle = horideicom$jww_parser$core$$Reader$read_double(reader);
          const font_name = horideicom$jww_parser$core$$read_cstring(reader);
          const content = horideicom$jww_parser$core$$read_cstring(reader);
          if (horideicom$jww_parser$core$$is_metadata_text(content)) {
            return undefined;
          } else {
            const _bind = horideicom$jww_parser$core$$find_bm_marker(content);
            if (_bind === undefined) {
              return new $64$horideicom$47$jww_parser$47$core$46$Entity$Text({ base: base, start_x: start_x, start_y: start_y, end_x: end_x, end_y: end_y, text_type: text_type, size_x: size_x, size_y: size_y, spacing: spacing, angle: angle, font_name: font_name, content: content });
            } else {
              const _bind$2 = horideicom$jww_parser$core$$parse_image_from_bm_string(content, base, start_x, start_y, angle, size_x, size_y);
              if (_bind$2 === undefined) {
                return new $64$horideicom$47$jww_parser$47$core$46$Entity$Text({ base: base, start_x: start_x, start_y: start_y, end_x: end_x, end_y: end_y, text_type: text_type, size_x: size_x, size_y: size_y, spacing: spacing, angle: angle, font_name: font_name, content: content });
              } else {
                const _Some = _bind$2;
                const _image = _Some;
                return new $64$horideicom$47$jww_parser$47$core$46$Entity$Image(_image);
              }
            }
          }
        } else {
          if (class_name === "CDataSolid") {
            const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
            const point1_x = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point1_y = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point4_x = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point4_y = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point2_x = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point2_y = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point3_x = horideicom$jww_parser$core$$Reader$read_double(reader);
            const point3_y = horideicom$jww_parser$core$$Reader$read_double(reader);
            let color = 0;
            const _p = base.pen_color;
            const _p$2 = 10;
            if (_p === _p$2) {
              color = horideicom$jww_parser$core$$Reader$read_dword(reader);
            }
            return base.pen_style >= 101 ? new $64$horideicom$47$jww_parser$47$core$46$Entity$ArcSolid({ base: base, center_x: point1_x, center_y: point1_y, radius: point4_x, flatness: point4_y, tilt_angle: point2_x, start_angle: point2_y, arc_angle: point3_x, solid_param: point3_y, color: color }) : new $64$horideicom$47$jww_parser$47$core$46$Entity$Solid({ base: base, point1_x: point1_x, point1_y: point1_y, point2_x: point2_x, point2_y: point2_y, point3_x: point3_x, point3_y: point3_y, point4_x: point4_x, point4_y: point4_y, color: color });
          } else {
            if (class_name === "CDataBlock") {
              const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
              const ref_x = horideicom$jww_parser$core$$Reader$read_double(reader);
              const ref_y = horideicom$jww_parser$core$$Reader$read_double(reader);
              const scale_x = horideicom$jww_parser$core$$Reader$read_double(reader);
              const scale_y = horideicom$jww_parser$core$$Reader$read_double(reader);
              const rotation = horideicom$jww_parser$core$$Reader$read_double(reader);
              const def_number = horideicom$jww_parser$core$$Reader$read_dword(reader);
              return new $64$horideicom$47$jww_parser$47$core$46$Entity$Block({ base: base, ref_x: ref_x, ref_y: ref_y, scale_x: scale_x, scale_y: scale_y, rotation: rotation, def_number: def_number });
            } else {
              if (class_name === "CDataSunpou") {
                horideicom$jww_parser$core$$parse_entity_base(reader, version);
                const line_base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
                const start_x = horideicom$jww_parser$core$$Reader$read_double(reader);
                const start_y = horideicom$jww_parser$core$$Reader$read_double(reader);
                const end_x = horideicom$jww_parser$core$$Reader$read_double(reader);
                const end_y = horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$parse_entity_base(reader, version);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_dword(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$Reader$read_double(reader);
                horideicom$jww_parser$core$$read_cstring(reader);
                horideicom$jww_parser$core$$read_cstring(reader);
                if (version >>> 0 >= 420 >>> 0) {
                  horideicom$jww_parser$core$$Reader$read_word(reader);
                  let _tmp = 0;
                  while (true) {
                    const _ = _tmp;
                    if (_ < 2) {
                      horideicom$jww_parser$core$$parse_entity_base(reader, version);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      _tmp = _ + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                  let _tmp$2 = 0;
                  while (true) {
                    const _ = _tmp$2;
                    if (_ < 4) {
                      horideicom$jww_parser$core$$parse_entity_base(reader, version);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      horideicom$jww_parser$core$$Reader$read_double(reader);
                      horideicom$jww_parser$core$$Reader$read_dword(reader);
                      _tmp$2 = _ + 1 | 0;
                      continue;
                    } else {
                      break;
                    }
                  }
                }
                return new $64$horideicom$47$jww_parser$47$core$46$Entity$Line({ base: line_base, start_x: start_x, start_y: start_y, end_x: end_x, end_y: end_y });
              } else {
                return undefined;
              }
            }
          }
        }
      }
    }
  }
}
function horideicom$jww_parser$core$$parse_entity_with_pid_tracking(reader, version, pid_to_class, next_pid) {
  const class_id = horideicom$jww_parser$core$$Reader$read_word(reader);
  let class_name = "";
  let updated_next_pid = next_pid;
  if (class_id === 65535) {
    horideicom$jww_parser$core$$Reader$read_word(reader);
    const name_len = horideicom$jww_parser$core$$Reader$read_word(reader);
    const name_bytes = horideicom$jww_parser$core$$Reader$read_bytes(reader, name_len);
    let name_chars = "";
    const _end222 = name_bytes.length;
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < _end222) {
        const _tmp$2 = name_chars;
        $bound_check(name_bytes, i);
        const _p = name_bytes[i];
        name_chars = `${_tmp$2}${moonbitlang$core$builtin$$Show$to_string$23$(_p)}`;
        _tmp = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    class_name = name_chars;
    const pid = updated_next_pid;
    const pid_int = pid;
    if (pid_int < 65536) {
      moonbitlang$core$array$$Array$set$19$(pid_to_class, pid_int, class_name);
    }
    updated_next_pid = (pid >>> 0) + (1 >>> 0) | 0;
  } else {
    if (class_id === 32768) {
      return { entity: undefined, pid_to_class: pid_to_class, next_pid: (next_pid >>> 0) + (1 >>> 0) | 0 };
    } else {
      const class_pid = class_id & 32767;
      if (class_pid < 65536) {
        const name = moonbitlang$core$array$$Array$at$19$(pid_to_class, class_pid);
        if (name === "") {
          horideicom$jww_parser$core$$parse_entity_base(reader, version);
          horideicom$jww_parser$core$$Reader$read_double(reader);
          horideicom$jww_parser$core$$Reader$read_double(reader);
          horideicom$jww_parser$core$$Reader$read_double(reader);
          horideicom$jww_parser$core$$Reader$read_double(reader);
          return { entity: undefined, pid_to_class: pid_to_class, next_pid: (next_pid >>> 0) + (1 >>> 0) | 0 };
        }
        class_name = name;
      } else {
        horideicom$jww_parser$core$$parse_entity_base(reader, version);
        horideicom$jww_parser$core$$Reader$read_double(reader);
        horideicom$jww_parser$core$$Reader$read_double(reader);
        horideicom$jww_parser$core$$Reader$read_double(reader);
        horideicom$jww_parser$core$$Reader$read_double(reader);
        return { entity: undefined, pid_to_class: pid_to_class, next_pid: (next_pid >>> 0) + (1 >>> 0) | 0 };
      }
    }
  }
  const entity = horideicom$jww_parser$core$$parse_entity_by_class(class_name, reader, version);
  return { entity: entity, pid_to_class: pid_to_class, next_pid: (updated_next_pid >>> 0) + (1 >>> 0) | 0 };
}
function horideicom$jww_parser$core$$parse_entity_list(data, offset, version) {
  const entity_data = moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(moonbitlang$core$bytes$$Bytes$to_array(data), offset, data.length));
  const reader = horideicom$jww_parser$core$$Reader$new(entity_data);
  const start_pos = reader.pos;
  const count = horideicom$jww_parser$core$$Reader$read_word(reader);
  const entities = moonbitlang$core$array$$Array$new$46$inner$22$(0);
  let pid_to_class = moonbitlang$core$array$$Array$new$46$inner$19$(0);
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < 65536) {
      moonbitlang$core$array$$Array$push$19$(pid_to_class, "");
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let next_pid = 1;
  let _tmp$2 = 0;
  while (true) {
    const _ = _tmp$2;
    if (_ < count) {
      if ((reader.data.length - reader.pos | 0) < 4) {
        break;
      }
      const result = horideicom$jww_parser$core$$parse_entity_with_pid_tracking(reader, version, pid_to_class, next_pid);
      const _x = result.entity;
      if (_x === undefined) {
        const _p2c = result.pid_to_class;
        const _npid = result.next_pid;
        pid_to_class = _p2c;
        next_pid = _npid;
      } else {
        const _Some = _x;
        const _ent = _Some;
        const _p2c = result.pid_to_class;
        const _npid = result.next_pid;
        moonbitlang$core$array$$Array$push$22$(entities, _ent);
        pid_to_class = _p2c;
        next_pid = _npid;
      }
      _tmp$2 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const end_pos = reader.pos;
  return { entities: entities, bytes_consumed: end_pos - start_pos | 0 };
}
function horideicom$jww_parser$core$$parse_block_def_with_tracking(reader, version, class_map, next_id) {
  const class_id = horideicom$jww_parser$core$$Reader$read_word(reader);
  let _bind;
  if (class_id === 65535) {
    horideicom$jww_parser$core$$Reader$read_word(reader);
    const name_len = horideicom$jww_parser$core$$Reader$read_word(reader);
    const name_bytes = horideicom$jww_parser$core$$Reader$read_bytes(reader, name_len);
    let name_chars = "";
    const _end75 = name_bytes.length;
    let _tmp = 0;
    while (true) {
      const i = _tmp;
      if (i < _end75) {
        const _tmp$2 = name_chars;
        $bound_check(name_bytes, i);
        const _p = name_bytes[i];
        name_chars = `${_tmp$2}${moonbitlang$core$builtin$$Show$to_string$23$(_p)}`;
        _tmp = i + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    const class_name = name_chars;
    const id_int = next_id;
    if (id_int < 256) {
      moonbitlang$core$array$$Array$set$19$(class_map, id_int, class_name);
    }
    const _p = 1;
    _bind = { _0: class_map, _1: (next_id + _p | 0) & 65535 };
  } else {
    if (class_id === 32768) {
      const _p = 1;
      return { block_def: undefined, class_map: class_map, next_id: (next_id + _p | 0) & 65535 };
    } else {
      const class_pid = class_id & 32767;
      if (class_pid < 256) {
        moonbitlang$core$array$$Array$at$19$(class_map, class_pid);
        _bind = { _0: class_map, _1: next_id };
      } else {
        const _p = 1;
        return { block_def: undefined, class_map: class_map, next_id: (next_id + _p | 0) & 65535 };
      }
    }
  }
  const _updated_class_map = _bind._0;
  const _updated_next_id = _bind._1;
  const base = horideicom$jww_parser$core$$parse_entity_base(reader, version);
  const number = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const ref_flag = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const is_referenced = ref_flag !== 0;
  horideicom$jww_parser$core$$Reader$read_dword(reader);
  const name = horideicom$jww_parser$core$$read_cstring(reader);
  const nested_offset = reader.pos;
  const _bind$2 = reader.data;
  const nested_result = horideicom$jww_parser$core$$parse_entity_list(moonbitlang$core$bytes$$Bytes$from_array({ buf: _bind$2, start: 0, end: _bind$2.length }), nested_offset, version);
  return { block_def: { base: base, number: number, is_referenced: is_referenced, name: name, entities: nested_result.entities }, class_map: _updated_class_map, next_id: _updated_next_id };
}
function horideicom$jww_parser$core$$parse_block_def_list(data, offset, version) {
  if (offset >= data.length) {
    return { block_defs: moonbitlang$core$array$$Array$new$46$inner$29$(0), end_offset: offset };
  }
  const block_data = moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(moonbitlang$core$bytes$$Bytes$to_array(data), offset, data.length));
  const reader = horideicom$jww_parser$core$$Reader$new(block_data);
  const start_pos = reader.pos;
  if ((reader.data.length - reader.pos | 0) < 4) {
    return { block_defs: moonbitlang$core$array$$Array$new$46$inner$29$(0), end_offset: offset };
  }
  const count = horideicom$jww_parser$core$$Reader$read_dword(reader);
  if (count >>> 0 > 10000 >>> 0) {
    return { block_defs: moonbitlang$core$array$$Array$new$46$inner$29$(0), end_offset: offset };
  }
  const block_defs = moonbitlang$core$array$$Array$new$46$inner$29$(0);
  let class_map = moonbitlang$core$array$$Array$new$46$inner$19$(0);
  let _tmp = 0;
  while (true) {
    const _ = _tmp;
    if (_ < 256) {
      moonbitlang$core$array$$Array$push$19$(class_map, "");
      _tmp = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  let next_id = 1;
  const _end109 = count;
  let _tmp$2 = 0;
  while (true) {
    const _ = _tmp$2;
    if (_ < _end109) {
      if ((reader.data.length - reader.pos | 0) < 8) {
        break;
      }
      const result = horideicom$jww_parser$core$$parse_block_def_with_tracking(reader, version, class_map, next_id);
      const _bind = result.block_def;
      if (_bind === undefined) {
        class_map;
      } else {
        const _Some = _bind;
        const _bd = _Some;
        moonbitlang$core$array$$Array$push$29$(block_defs, _bd);
      }
      class_map = result.class_map;
      next_id = result.next_id;
      _tmp$2 = _ + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const end_pos = reader.pos;
  return { block_defs: block_defs, end_offset: offset + (end_pos - start_pos | 0) | 0 };
}
function horideicom$jww_parser$core$$parse(data) {
  if (data.length < 8) {
    return horideicom$jww_parser$core$$Document$default();
  }
  const sig = moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(moonbitlang$core$bytes$$Bytes$to_array(data), 0, horideicom$jww_parser$core$$parse$46$constr$47$1879));
  if (moonbitlang$core$builtin$$op_notequal$17$(sig, $bytes_literal$1)) {
    return horideicom$jww_parser$core$$Document$default();
  }
  const reader = horideicom$jww_parser$core$$Reader$new(moonbitlang$core$bytes$$Bytes$from_array(moonbitlang$core$array$$Array$sub$46$inner$4$(moonbitlang$core$bytes$$Bytes$to_array(data), 8, data.length)));
  const version = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const memo = horideicom$jww_parser$core$$read_cstring(reader);
  const paper_size = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const write_layer_group = horideicom$jww_parser$core$$Reader$read_dword(reader);
  const layer_groups = moonbitlang$core$array$$Array$new$46$inner$18$(0);
  let _tmp = 0;
  while (true) {
    const _g_idx = _tmp;
    if (_g_idx < 16) {
      const state = horideicom$jww_parser$core$$Reader$read_dword(reader);
      const write_layer = horideicom$jww_parser$core$$Reader$read_dword(reader);
      const scale = horideicom$jww_parser$core$$Reader$read_double(reader);
      const protect = horideicom$jww_parser$core$$Reader$read_dword(reader);
      const layers = moonbitlang$core$array$$Array$new$46$inner$20$(0);
      let _tmp$2 = 0;
      while (true) {
        const _l_idx = _tmp$2;
        if (_l_idx < 16) {
          const lay_state = horideicom$jww_parser$core$$Reader$read_dword(reader);
          const lay_protect = horideicom$jww_parser$core$$Reader$read_dword(reader);
          moonbitlang$core$array$$Array$push$20$(layers, { state: lay_state, protect: lay_protect, name: "" });
          _tmp$2 = _l_idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      moonbitlang$core$array$$Array$push$18$(layer_groups, { state: state, write_layer: write_layer, scale: scale, protect: protect, layers: layers, name: "" });
      _tmp = _g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const print_settings = horideicom$jww_parser$core$$parse_print_settings(reader);
  const sunpou_settings = horideicom$jww_parser$core$$parse_sunpou_settings(reader);
  const layer_groups$2 = horideicom$jww_parser$core$$parse_layer_names(reader, layer_groups);
  const entity_offset = horideicom$jww_parser$core$$find_entity_list_offset(data, version);
  let _bind;
  if (entity_offset === undefined) {
    _bind = { _0: moonbitlang$core$array$$Array$new$46$inner$22$(0), _1: moonbitlang$core$array$$Array$new$46$inner$29$(0), _2: 0 };
  } else {
    const _Some = entity_offset;
    const _offset = _Some;
    const entity_result = horideicom$jww_parser$core$$parse_entity_list(data, _offset, version);
    const block_offset = _offset + entity_result.bytes_consumed | 0;
    const block_result = horideicom$jww_parser$core$$parse_block_def_list(data, block_offset, version);
    _bind = { _0: entity_result.entities, _1: block_result.block_defs, _2: block_result.end_offset };
  }
  const _entities = _bind._0;
  const _block_defs = _bind._1;
  const _block_end_offset = _bind._2;
  const embedded_images = version >>> 0 >= 700 >>> 0 ? horideicom$jww_parser$core$$parse_embedded_images(data, _block_end_offset, version) : moonbitlang$core$array$$Array$new$46$inner$30$(0);
  const named_layer_groups = horideicom$jww_parser$core$$set_layer_names(layer_groups$2);
  return { version: version, memo: memo, paper_size: paper_size, write_layer_group: write_layer_group, layer_groups: named_layer_groups, entities: _entities, block_defs: _block_defs, embedded_images: embedded_images, print_settings: print_settings, sunpou_settings: sunpou_settings, metadata_settings: horideicom$jww_parser$core$$default$46$record$47$1506 };
}
function horideicom$svg_jww$$attr(key, value) {
  return { _0: key, _1: value };
}
function horideicom$svg_jww$$svg_self_closing(tag, attributes) {
  return new SvgElement$ElementNode({ tag: tag, attributes: attributes, children: [], self_closing: true });
}
function horideicom$svg_jww$$circle(attributes) {
  return horideicom$svg_jww$$svg_self_closing("circle", attributes);
}
function horideicom$svg_jww$$cos_d(x) {
  return moonbitlang$core$math$$cos(x);
}
function horideicom$svg_jww$$path(attributes) {
  return horideicom$svg_jww$$svg_self_closing("path", attributes);
}
function horideicom$svg_jww$$sin_d(x) {
  return moonbitlang$core$math$$sin(x);
}
function horideicom$svg_jww$$stroke_attr(color) {
  return { _0: "stroke", _1: color };
}
function horideicom$svg_jww$$to_svg_color(pen_color) {
  switch (pen_color) {
    case 1: {
      return "#00c0c0";
    }
    case 2: {
      return "#ffffff";
    }
    case 3: {
      return "#00c000";
    }
    case 4: {
      return "#c0c000";
    }
    case 5: {
      return "#c000c0";
    }
    case 6: {
      return "#0000ff";
    }
    case 7: {
      return "#008080";
    }
    case 8: {
      return "#ff0080";
    }
    case 9: {
      return "#ff80ff";
    }
    default: {
      return "#000000";
    }
  }
}
function horideicom$svg_jww$$rect(attributes) {
  return horideicom$svg_jww$$svg_self_closing("rect", attributes);
}
function horideicom$svg_jww$$style_attr(style) {
  return { _0: "style", _1: style };
}
function horideicom$svg_jww$$image_elem(attributes) {
  return horideicom$svg_jww$$svg_self_closing("image", attributes);
}
function horideicom$svg_jww$$svg_line(attributes) {
  return horideicom$svg_jww$$svg_self_closing("line", attributes);
}
function horideicom$svg_jww$$fill_attr(color) {
  return { _0: "fill", _1: color };
}
function horideicom$svg_jww$$polygon(attributes) {
  return horideicom$svg_jww$$svg_self_closing("polygon", attributes);
}
function horideicom$svg_jww$$text_elem(attributes, content) {
  return new SvgElement$ElementNode({ tag: "text", attributes: attributes, children: [new SvgElement$Text(content)], self_closing: false });
}
function horideicom$svg_jww$$svg_element(tag, attributes, children) {
  return new SvgElement$ElementNode({ tag: tag, attributes: attributes, children: children, self_closing: false });
}
function horideicom$svg_jww$$svg(attributes, children) {
  return horideicom$svg_jww$$svg_element("svg", attributes, children);
}
function horideicom$svg_jww$$g(attributes, children) {
  return horideicom$svg_jww$$svg_element("g", attributes, children);
}
function horideicom$svg_jww$$ellipse(attributes) {
  return horideicom$svg_jww$$svg_self_closing("ellipse", attributes);
}
function horideicom$svg_jww$$escape_xml(s) {
  return moonbitlang$core$string$$String$replace(moonbitlang$core$string$$String$replace(moonbitlang$core$string$$String$replace(s, { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$786, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$786.length }, { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$787, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$787.length }), { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$788, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$788.length }, { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$789, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$789.length }), { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$790, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$790.length }, { str: horideicom$svg_jww$$escape_xml$46$42$bind$124$791, start: 0, end: horideicom$svg_jww$$escape_xml$46$42$bind$124$791.length });
}
function horideicom$svg_jww$$escape_xml_attr(s) {
  return moonbitlang$core$string$$String$replace(horideicom$svg_jww$$escape_xml(s), { str: horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$792, start: 0, end: horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$792.length }, { str: horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$793, start: 0, end: horideicom$svg_jww$$escape_xml_attr$46$42$bind$124$793.length });
}
function horideicom$svg_jww$$join_attributes(attributes) {
  const _p = new Array(attributes.length);
  const _p$2 = attributes.length;
  let _tmp = 0;
  while (true) {
    const _p$3 = _tmp;
    if (_p$3 < _p$2) {
      const _p$4 = attributes[_p$3];
      const _p$5 = _p$4._0;
      const _p$6 = _p$4._1;
      _p[_p$3] = `${_p$5}=\"${horideicom$svg_jww$$escape_xml_attr(_p$6)}\"`;
      _tmp = _p$3 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return moonbitlang$core$array$$Array$join$19$(_p, { str: horideicom$svg_jww$$join_attributes$46$42$bind$124$798, start: 0, end: horideicom$svg_jww$$join_attributes$46$42$bind$124$798.length });
}
function horideicom$svg_jww$$to_string(elem) {
  if (elem.$tag === 0) {
    const _Text = elem;
    const _s = _Text._0;
    return horideicom$svg_jww$$escape_xml(_s);
  } else {
    const _ElementNode = elem;
    const _data = _ElementNode._0;
    const attrs = _data.attributes.length > 0 ? ` ${horideicom$svg_jww$$join_attributes(_data.attributes)}` : "";
    if (_data.self_closing) {
      return `<${_data.tag}${attrs} />`;
    } else {
      const children_str = horideicom$svg_jww$$join_children(_data.children);
      return `<${_data.tag}${attrs}>${children_str}</${_data.tag}>`;
    }
  }
}
function horideicom$svg_jww$$join_children(children) {
  const _p = new Array(children.length);
  const _p$2 = children.length;
  let _tmp = 0;
  while (true) {
    const _p$3 = _tmp;
    if (_p$3 < _p$2) {
      const _p$4 = children[_p$3];
      _p[_p$3] = horideicom$svg_jww$$to_string(_p$4);
      _tmp = _p$3 + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return moonbitlang$core$array$$Array$join$19$(_p, { str: horideicom$svg_jww$$join_children$46$42$bind$124$805, start: 0, end: horideicom$svg_jww$$join_children$46$42$bind$124$805.length });
}
function horideicom$svg_jww$$int_to_hex2(n) {
  const hex_chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  const h = n / 16 | 0;
  const l = n % 16 | 0;
  const hs = h >= 0 && h < 16 ? moonbitlang$core$array$$Array$at$19$(hex_chars, h) : "0";
  const ls = l >= 0 && l < 16 ? moonbitlang$core$array$$Array$at$19$(hex_chars, l) : "0";
  return `${hs}${ls}`;
}
function horideicom$svg_jww$$to_rgb_color(r, g, b) {
  return `#${horideicom$svg_jww$$int_to_hex2(r)}${horideicom$svg_jww$$int_to_hex2(g)}${horideicom$svg_jww$$int_to_hex2(b)}`;
}
function horideicom$svg_jww$$RenderOptions$with_bounds(width, height, bounds_max_y, padding) {
  return { scale: 1, offset_x: 0, offset_y: 0, width: width, height: height, background_color: "#ffffff", stroke_width_scale: 1, show_print_area: false, bounds_max_y: bounds_max_y, padding: padding };
}
function horideicom$svg_jww$$attr_double(key, value) {
  return { _0: key, _1: moonbitlang$core$double$$Double$to_string(value) };
}
function horideicom$svg_jww$$class_attr(class_name) {
  return { _0: "class", _1: class_name };
}
function horideicom$svg_jww$$stroke_width_double(width) {
  return { _0: "stroke-width", _1: moonbitlang$core$double$$Double$to_string(width) };
}
function horideicom$svg_jww$$pen_style_to_line_type(pen_style) {
  switch (pen_style) {
    case 0: {
      return LineType$Solid;
    }
    case 1: {
      return LineType$Solid;
    }
    case 2: {
      return new LineType$Custom([1, 2]);
    }
    case 3: {
      return new LineType$Custom([2, 2]);
    }
    case 4: {
      return new LineType$Custom([8, 3, 1, 3]);
    }
    case 5: {
      return new LineType$Custom([12, 3, 2, 3]);
    }
    case 6: {
      return new LineType$Custom([8, 3, 1, 3, 1, 3]);
    }
    case 7: {
      return new LineType$Custom([12, 3, 2, 3, 2, 3]);
    }
    case 8: {
      return new LineType$Custom([1, 4]);
    }
    default: {
      return LineType$Solid;
    }
  }
}
function horideicom$svg_jww$$line_type_to_dasharray(line_type, scale) {
  switch (line_type.$tag) {
    case 0: {
      return undefined;
    }
    case 1: {
      return { _0: "stroke-dasharray", _1: `${moonbitlang$core$double$$Double$to_string(5 * scale)},${moonbitlang$core$double$$Double$to_string(5 * scale)}` };
    }
    case 2: {
      return { _0: "stroke-dasharray", _1: `${moonbitlang$core$double$$Double$to_string(1 * scale)},${moonbitlang$core$double$$Double$to_string(2 * scale)}` };
    }
    case 3: {
      return { _0: "stroke-dasharray", _1: `${moonbitlang$core$double$$Double$to_string(8 * scale)},${moonbitlang$core$double$$Double$to_string(3 * scale)},${moonbitlang$core$double$$Double$to_string(1 * scale)},${moonbitlang$core$double$$Double$to_string(3 * scale)}` };
    }
    default: {
      const _Custom = line_type;
      const _pattern = _Custom._0;
      const _p = new Array(_pattern.length);
      const _p$2 = _pattern.length;
      let _tmp = 0;
      while (true) {
        const _p$3 = _tmp;
        if (_p$3 < _p$2) {
          const _p$4 = _pattern[_p$3];
          _p[_p$3] = moonbitlang$core$double$$Double$to_string(_p$4 * scale);
          _tmp = _p$3 + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      const scaled = moonbitlang$core$array$$Array$join$19$(_p, { str: horideicom$svg_jww$$line_type_to_dasharray$46$42$bind$124$816, start: 0, end: horideicom$svg_jww$$line_type_to_dasharray$46$42$bind$124$816.length });
      return { _0: "stroke-dasharray", _1: scaled };
    }
  }
}
function horideicom$svg_jww$$build_parsed_document(doc, svg, bounds, layers, counts) {
  const ps = doc.print_settings;
  const print_settings = { origin_x: ps.origin_x, origin_y: ps.origin_y, scale: ps.scale, rotation_setting: ps.rotation_setting };
  return { svg: svg, bounds: bounds, layers: layers, entity_counts: counts, version: moonbitlang$core$uint$$UInt$to_string$46$inner(doc.version, 10), paper_size: doc.paper_size, memo: doc.memo, print_settings: print_settings };
}
function horideicom$svg_jww$$build_layer_info(doc) {
  if (doc.layer_groups.length === 0) {
    return [];
  } else {
    const _p = doc.layer_groups.length;
    const _p$2 = 16;
    const max_groups = _p < _p$2 ? _p : _p$2;
    let all_layers = [];
    let _tmp = 0;
    while (true) {
      const g_idx = _tmp;
      if (g_idx < max_groups) {
        const lg = moonbitlang$core$array$$Array$at$18$(doc.layer_groups, g_idx);
        const _p$3 = lg.layers.length;
        const _p$4 = 16;
        const max_layers = _p$3 < _p$4 ? _p$3 : _p$4;
        let _tmp$2 = 0;
        while (true) {
          const l_idx = _tmp$2;
          if (l_idx < max_layers) {
            const l = moonbitlang$core$array$$Array$at$20$(lg.layers, l_idx);
            const layer_id = (Math.imul(g_idx, 16) | 0) + l_idx | 0;
            const name = l.name === "" ? `L${moonbitlang$core$int$$Int$to_string$46$inner(layer_id, 10)}` : l.name;
            const visible = l.state !== 0;
            const layer_info = { id: layer_id, name: name, entity_count: 0, visible: visible };
            all_layers = moonbitlang$core$builtin$$Add$add$35$(all_layers, [layer_info]);
            _tmp$2 = l_idx + 1 | 0;
            continue;
          } else {
            break;
          }
        }
        _tmp = g_idx + 1 | 0;
        continue;
      } else {
        break;
      }
    }
    return all_layers;
  }
}
function horideicom$svg_jww$$arc_radii(radius, flatness) {
  const rx = Math.abs(radius);
  const f = Math.abs(flatness);
  const ry = f <= 0 ? rx : rx * f;
  return { _0: rx, _1: ry };
}
function horideicom$svg_jww$$ellipse_extents(rx, ry, tilt) {
  const cos_t = horideicom$svg_jww$$cos_d(tilt);
  const sin_t = horideicom$svg_jww$$sin_d(tilt);
  const rx_cos = rx * cos_t;
  const rx_sin = rx * sin_t;
  const ry_cos = ry * cos_t;
  const ry_sin = ry * sin_t;
  const x_extent = Math.sqrt(rx_cos * rx_cos + ry_sin * ry_sin);
  const y_extent = Math.sqrt(rx_sin * rx_sin + ry_cos * ry_cos);
  return { _0: x_extent, _1: y_extent };
}
function horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, x, y, initialized) {
  if (x === x && Math.abs(x) < 1000000000 && (y === y && Math.abs(y) < 1000000000)) {
    if (initialized) {
      const new_min_x = x < min_x ? x : min_x;
      const new_min_y = y < min_y ? y : min_y;
      const new_max_x = x > max_x ? x : max_x;
      const new_max_y = y > max_y ? y : max_y;
      return { _0: new_min_x, _1: new_min_y, _2: new_max_x, _3: new_max_y, _4: true };
    } else {
      return { _0: x, _1: y, _2: x, _3: y, _4: true };
    }
  } else {
    return { _0: min_x, _1: min_y, _2: max_x, _3: max_y, _4: initialized };
  }
}
function horideicom$svg_jww$$calculate_bounds(doc) {
  let min_x = 0;
  let min_y = 0;
  let max_x = 400;
  let max_y = 300;
  let initialized = false;
  const _arr = doc.entities;
  const _len = _arr.length;
  let _tmp = 0;
  while (true) {
    const _i = _tmp;
    if (_i < _len) {
      const entity = _arr[_i];
      switch (entity.$tag) {
        case 0: {
          const _Line = entity;
          const _l = _Line._0;
          const _bind = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _l.start_x, _l.start_y, initialized);
          const _nx = _bind._0;
          const _ny = _bind._1;
          const _xx = _bind._2;
          const _xy = _bind._3;
          const _init = _bind._4;
          min_x = _nx;
          min_y = _ny;
          max_x = _xx;
          max_y = _xy;
          initialized = _init;
          const _bind$2 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _l.end_x, _l.end_y, initialized);
          const _nx2 = _bind$2._0;
          const _ny2 = _bind$2._1;
          const _xx2 = _bind$2._2;
          const _xy2 = _bind$2._3;
          const _init2 = _bind$2._4;
          min_x = _nx2;
          min_y = _ny2;
          max_x = _xx2;
          max_y = _xy2;
          initialized = _init2;
          break;
        }
        case 1: {
          const _Arc = entity;
          const _a = _Arc._0;
          let _tmp$2;
          const _p = _a.center_x;
          if (_p === _p && Math.abs(_p) < 1000000000) {
            let _tmp$3;
            const _p$2 = _a.center_y;
            if (_p$2 === _p$2 && Math.abs(_p$2) < 1000000000) {
              let _tmp$4;
              const _p$3 = _a.radius;
              if (_p$3 === _p$3 && Math.abs(_p$3) < 1000000000) {
                let _tmp$5;
                const _p$4 = _a.flatness;
                if (_p$4 === _p$4 && Math.abs(_p$4) < 1000000000) {
                  let _tmp$6;
                  const _p$5 = _a.tilt_angle;
                  if (_p$5 === _p$5 && Math.abs(_p$5) < 1000000000) {
                    _tmp$6 = _a.radius > 0;
                  } else {
                    _tmp$6 = false;
                  }
                  _tmp$5 = _tmp$6;
                } else {
                  _tmp$5 = false;
                }
                _tmp$4 = _tmp$5;
              } else {
                _tmp$4 = false;
              }
              _tmp$3 = _tmp$4;
            } else {
              _tmp$3 = false;
            }
            _tmp$2 = _tmp$3;
          } else {
            _tmp$2 = false;
          }
          if (_tmp$2) {
            const _bind$3 = horideicom$svg_jww$$arc_radii(_a.radius, _a.flatness);
            const _rx = _bind$3._0;
            const _ry = _bind$3._1;
            const _bind$4 = horideicom$svg_jww$$ellipse_extents(_rx, _ry, _a.tilt_angle);
            const _x_ext = _bind$4._0;
            const _y_ext = _bind$4._1;
            const _bind$5 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _a.center_x - _x_ext, _a.center_y - _y_ext, initialized);
            const _nx$2 = _bind$5._0;
            const _ny$2 = _bind$5._1;
            const _xx$2 = _bind$5._2;
            const _xy$2 = _bind$5._3;
            const _init$2 = _bind$5._4;
            min_x = _nx$2;
            min_y = _ny$2;
            max_x = _xx$2;
            max_y = _xy$2;
            initialized = _init$2;
            const _bind$6 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _a.center_x + _x_ext, _a.center_y + _y_ext, initialized);
            const _nx2$2 = _bind$6._0;
            const _ny2$2 = _bind$6._1;
            const _xx2$2 = _bind$6._2;
            const _xy2$2 = _bind$6._3;
            const _init2$2 = _bind$6._4;
            min_x = _nx2$2;
            min_y = _ny2$2;
            max_x = _xx2$2;
            max_y = _xy2$2;
            initialized = _init2$2;
          }
          break;
        }
        case 3: {
          const _Text = entity;
          const _t = _Text._0;
          const _bind$3 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _t.start_x, _t.start_y, initialized);
          const _nx$2 = _bind$3._0;
          const _ny$2 = _bind$3._1;
          const _xx$2 = _bind$3._2;
          const _xy$2 = _bind$3._3;
          const _init$2 = _bind$3._4;
          min_x = _nx$2;
          min_y = _ny$2;
          max_x = _xx$2;
          max_y = _xy$2;
          initialized = _init$2;
          const _bind$4 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _t.end_x, _t.end_y, initialized);
          const _nx2$2 = _bind$4._0;
          const _ny2$2 = _bind$4._1;
          const _xx2$2 = _bind$4._2;
          const _xy2$2 = _bind$4._3;
          const _init2$2 = _bind$4._4;
          min_x = _nx2$2;
          min_y = _ny2$2;
          max_x = _xx2$2;
          max_y = _xy2$2;
          initialized = _init2$2;
          break;
        }
        case 2: {
          const _Point = entity;
          const _p$2 = _Point._0;
          const _bind$5 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _p$2.x, _p$2.y, initialized);
          const _nx$3 = _bind$5._0;
          const _ny$3 = _bind$5._1;
          const _xx$3 = _bind$5._2;
          const _xy$3 = _bind$5._3;
          const _init$3 = _bind$5._4;
          min_x = _nx$3;
          min_y = _ny$3;
          max_x = _xx$3;
          max_y = _xy$3;
          initialized = _init$3;
          break;
        }
        case 4: {
          const _Solid = entity;
          const _s = _Solid._0;
          const points = [{ _0: _s.point1_x, _1: _s.point1_y }, { _0: _s.point2_x, _1: _s.point2_y }, { _0: _s.point3_x, _1: _s.point3_y }, { _0: _s.point4_x, _1: _s.point4_y }];
          const _len$2 = points.length;
          let _tmp$3 = 0;
          while (true) {
            const _i$2 = _tmp$3;
            if (_i$2 < _len$2) {
              const pt = points[_i$2];
              const _px = pt._0;
              const _py = pt._1;
              const _bind$6 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _px, _py, initialized);
              const _nx$4 = _bind$6._0;
              const _ny$4 = _bind$6._1;
              const _xx$4 = _bind$6._2;
              const _xy$4 = _bind$6._3;
              const _init$4 = _bind$6._4;
              min_x = _nx$4;
              min_y = _ny$4;
              max_x = _xx$4;
              max_y = _xy$4;
              initialized = _init$4;
              _tmp$3 = _i$2 + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          break;
        }
        case 6: {
          const _Block = entity;
          const _b = _Block._0;
          let _tmp$4;
          const _p$3 = _b.ref_x;
          if (_p$3 === _p$3 && Math.abs(_p$3) < 1000000000) {
            const _p$4 = _b.ref_y;
            _tmp$4 = _p$4 === _p$4 && Math.abs(_p$4) < 1000000000;
          } else {
            _tmp$4 = false;
          }
          if (_tmp$4) {
            const _bind$6 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _b.ref_x - 10, _b.ref_y - 10, initialized);
            const _nx$4 = _bind$6._0;
            const _ny$4 = _bind$6._1;
            const _xx$4 = _bind$6._2;
            const _xy$4 = _bind$6._3;
            const _init$4 = _bind$6._4;
            min_x = _nx$4;
            min_y = _ny$4;
            max_x = _xx$4;
            max_y = _xy$4;
            initialized = _init$4;
            const _bind$7 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _b.ref_x + 10, _b.ref_y + 10, initialized);
            const _nx2$3 = _bind$7._0;
            const _ny2$3 = _bind$7._1;
            const _xx2$3 = _bind$7._2;
            const _xy2$3 = _bind$7._3;
            const _init2$3 = _bind$7._4;
            min_x = _nx2$3;
            min_y = _ny2$3;
            max_x = _xx2$3;
            max_y = _xy2$3;
            initialized = _init2$3;
          }
          break;
        }
        case 7: {
          const _Image = entity;
          const _i$2 = _Image._0;
          let _tmp$5;
          const _p$4 = _i$2.x;
          if (_p$4 === _p$4 && Math.abs(_p$4) < 1000000000) {
            let _tmp$6;
            const _p$5 = _i$2.y;
            if (_p$5 === _p$5 && Math.abs(_p$5) < 1000000000) {
              let _tmp$7;
              const _p$6 = _i$2.width;
              if (_p$6 === _p$6 && Math.abs(_p$6) < 1000000000) {
                const _p$7 = _i$2.height;
                _tmp$7 = _p$7 === _p$7 && Math.abs(_p$7) < 1000000000;
              } else {
                _tmp$7 = false;
              }
              _tmp$6 = _tmp$7;
            } else {
              _tmp$6 = false;
            }
            _tmp$5 = _tmp$6;
          } else {
            _tmp$5 = false;
          }
          if (_tmp$5) {
            const _bind$6 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _i$2.x, _i$2.y, initialized);
            const _nx$4 = _bind$6._0;
            const _ny$4 = _bind$6._1;
            const _xx$4 = _bind$6._2;
            const _xy$4 = _bind$6._3;
            const _init$4 = _bind$6._4;
            min_x = _nx$4;
            min_y = _ny$4;
            max_x = _xx$4;
            max_y = _xy$4;
            initialized = _init$4;
            const _bind$7 = horideicom$svg_jww$$update_bounds(min_x, min_y, max_x, max_y, _i$2.x + _i$2.width, _i$2.y + _i$2.height, initialized);
            const _nx2$3 = _bind$7._0;
            const _ny2$3 = _bind$7._1;
            const _xx2$3 = _bind$7._2;
            const _xy2$3 = _bind$7._3;
            const _init2$3 = _bind$7._4;
            min_x = _nx2$3;
            min_y = _ny2$3;
            max_x = _xx2$3;
            max_y = _xy2$3;
            initialized = _init2$3;
          }
          break;
        }
      }
      _tmp = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return initialized ? { min_x: min_x, min_y: min_y, max_x: max_x, max_y: max_y } : horideicom$svg_jww$$calculate_bounds$46$record$47$2033;
}
function horideicom$svg_jww$$append_svg_children(elem, extra) {
  if (elem.$tag === 1) {
    const _ElementNode = elem;
    const _data = _ElementNode._0;
    const children = moonbitlang$core$builtin$$Add$add$36$(_data.children, extra);
    return new SvgElement$ElementNode({ tag: _data.tag, attributes: _data.attributes, children: children, self_closing: _data.self_closing });
  } else {
    return elem;
  }
}
function horideicom$svg_jww$$render_debug_axes(bounds, opts, padding) {
  const x_min = bounds.min_x - padding;
  const x_max = x_min + opts.width;
  const _p = 0;
  const y_axis = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const axis_style = horideicom$svg_jww$$style_attr("stroke-dasharray: 4,4;");
  const x_axis = horideicom$svg_jww$$svg_line([horideicom$svg_jww$$attr_double("x1", 0), horideicom$svg_jww$$attr_double("y1", 0), horideicom$svg_jww$$attr_double("x2", 0), horideicom$svg_jww$$attr_double("y2", opts.height), horideicom$svg_jww$$stroke_attr("#22c55e"), horideicom$svg_jww$$stroke_width_double(0.8), axis_style]);
  const y_axis_line = horideicom$svg_jww$$svg_line([horideicom$svg_jww$$attr_double("x1", x_min), horideicom$svg_jww$$attr_double("y1", y_axis), horideicom$svg_jww$$attr_double("x2", x_max), horideicom$svg_jww$$attr_double("y2", y_axis), horideicom$svg_jww$$stroke_attr("#3b82f6"), horideicom$svg_jww$$stroke_width_double(0.8), axis_style]);
  const x_label = horideicom$svg_jww$$text_elem([horideicom$svg_jww$$attr_double("x", 4), horideicom$svg_jww$$attr_double("y", 12), horideicom$svg_jww$$attr("font-size", "10"), horideicom$svg_jww$$fill_attr("#22c55e")], "X=0");
  const y_label = horideicom$svg_jww$$text_elem([horideicom$svg_jww$$attr_double("x", x_min + 4), horideicom$svg_jww$$attr_double("y", y_axis + 12), horideicom$svg_jww$$attr("font-size", "10"), horideicom$svg_jww$$fill_attr("#3b82f6")], "Y=0");
  return horideicom$svg_jww$$g([horideicom$svg_jww$$class_attr("jww-debug-axes")], [x_axis, y_axis_line, x_label, y_label]);
}
function horideicom$svg_jww$$render_debug_bounds(bounds, opts) {
  const width = bounds.max_x - bounds.min_x;
  const height = bounds.max_y - bounds.min_y;
  const x = bounds.min_x;
  const _p = bounds.max_y;
  const y = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const rect_elem = horideicom$svg_jww$$rect([horideicom$svg_jww$$attr_double("x", x), horideicom$svg_jww$$attr_double("y", y), horideicom$svg_jww$$attr_double("width", width), horideicom$svg_jww$$attr_double("height", height), horideicom$svg_jww$$stroke_attr("#f97316"), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_width_double(1), horideicom$svg_jww$$style_attr("stroke-dasharray: 6,4;")]);
  const label = horideicom$svg_jww$$text_elem([horideicom$svg_jww$$attr_double("x", x + 4), horideicom$svg_jww$$attr_double("y", y + 12), horideicom$svg_jww$$attr("font-size", "12"), horideicom$svg_jww$$fill_attr("#f97316")], "bounds");
  return horideicom$svg_jww$$g([horideicom$svg_jww$$class_attr("jww-debug-bounds")], [rect_elem, label]);
}
function horideicom$svg_jww$$debug_adjust_origin_for_rotation(origin_x, origin_y, width, height, rotation_setting) {
  switch (rotation_setting) {
    case 0: {
      return { _0: origin_x, _1: origin_y };
    }
    case 1: {
      return { _0: origin_x, _1: origin_y };
    }
    case 2: {
      return { _0: origin_x - width, _1: origin_y };
    }
    case 3: {
      return { _0: origin_x, _1: origin_y - height };
    }
    case 4: {
      return { _0: origin_x - width, _1: origin_y - height };
    }
    case 5: {
      return { _0: origin_x - width / 2, _1: origin_y - height / 2 };
    }
    case 6: {
      return { _0: origin_x, _1: origin_y - height / 2 };
    }
    case 7: {
      return { _0: origin_x - width / 2, _1: origin_y - height };
    }
    case 8: {
      return { _0: origin_x - width, _1: origin_y - height / 2 };
    }
    case 9: {
      return { _0: origin_x - width / 2, _1: origin_y };
    }
    default: {
      return { _0: origin_x, _1: origin_y };
    }
  }
}
function horideicom$svg_jww$$debug_paper_size_to_mm(paper_size) {
  switch (paper_size) {
    case 0: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2173;
    }
    case 1: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2174;
    }
    case 2: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2175;
    }
    case 3: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2176;
    }
    case 4: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2177;
    }
    case 8: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2178;
    }
    case 9: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2179;
    }
    default: {
      return horideicom$svg_jww$$debug_paper_size_to_mm$46$tuple$47$2180;
    }
  }
}
function horideicom$svg_jww$$render_debug_print_area(doc, opts) {
  const ps = doc.print_settings;
  const _bind = horideicom$svg_jww$$debug_paper_size_to_mm(doc.paper_size);
  const _paper_width = _bind._0;
  const _paper_height = _bind._1;
  const scale_factor = ps.scale > 0 ? ps.scale : 1;
  const scaled_width = _paper_width / scale_factor;
  const scaled_height = _paper_height / scale_factor;
  let final_width;
  let final_height;
  _L: {
    const _p = ps.rotation_setting;
    if (_p >>> 0 >= 1 >>> 0 && _p >>> 0 <= 5 >>> 0) {
      final_width = scaled_height;
      final_height = scaled_width;
      break _L;
    } else {
      final_width = scaled_width;
      final_height = scaled_height;
      break _L;
    }
  }
  const _bind$2 = horideicom$svg_jww$$debug_adjust_origin_for_rotation(ps.origin_x, ps.origin_y, final_width, final_height, ps.rotation_setting);
  const _adjusted_x = _bind$2._0;
  const _adjusted_y = _bind$2._1;
  const y = (opts.bounds_max_y - _adjusted_y) * opts.scale + opts.offset_y + opts.padding;
  const width = final_width * opts.scale;
  const height = final_height * opts.scale;
  const base_attrs = [horideicom$svg_jww$$attr_double("x", _adjusted_x), horideicom$svg_jww$$attr_double("y", y), horideicom$svg_jww$$attr_double("width", width), horideicom$svg_jww$$attr_double("height", height), horideicom$svg_jww$$stroke_attr("#ef4444"), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_width_double(1), horideicom$svg_jww$$style_attr("stroke-dasharray: 5,5;")];
  let attrs;
  const _p = ps.rotation_setting;
  if (_p >>> 0 >= 1 >>> 0 && _p >>> 0 <= 5 >>> 0) {
    const center_x = _adjusted_x + width / 2;
    const center_y = y + height / 2;
    const transform_attr = horideicom$svg_jww$$attr("transform", `rotate(90, ${moonbitlang$core$double$$Double$to_string(center_x)}, ${moonbitlang$core$double$$Double$to_string(center_y)})`);
    attrs = [horideicom$svg_jww$$attr_double("x", _adjusted_x), horideicom$svg_jww$$attr_double("y", y), horideicom$svg_jww$$attr_double("width", width), horideicom$svg_jww$$attr_double("height", height), horideicom$svg_jww$$stroke_attr("#ef4444"), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_width_double(1), horideicom$svg_jww$$style_attr("stroke-dasharray: 5,5;"), transform_attr];
  } else {
    attrs = base_attrs;
  }
  return horideicom$svg_jww$$rect(attrs);
}
function horideicom$svg_jww$$build_debug_overlays(doc, opts, bounds, padding, debug) {
  let overlays = [];
  if (debug.show_bounds) {
    overlays = moonbitlang$core$builtin$$Add$add$36$(overlays, [horideicom$svg_jww$$render_debug_bounds(bounds, opts)]);
  }
  if (debug.show_axes) {
    overlays = moonbitlang$core$builtin$$Add$add$36$(overlays, [horideicom$svg_jww$$render_debug_axes(bounds, opts, padding)]);
  }
  if (debug.show_print_area) {
    overlays = moonbitlang$core$builtin$$Add$add$36$(overlays, [horideicom$svg_jww$$render_debug_print_area(doc, opts)]);
  }
  return overlays;
}
function horideicom$svg_jww$$get_entity_layer_conv(entity) {
  switch (entity.$tag) {
    case 0: {
      const _Line = entity;
      const _l = _Line._0;
      return _l.base.layer;
    }
    case 1: {
      const _Arc = entity;
      const _a = _Arc._0;
      return _a.base.layer;
    }
    case 3: {
      const _Text = entity;
      const _t = _Text._0;
      return _t.base.layer;
    }
    case 2: {
      const _Point = entity;
      const _p = _Point._0;
      return _p.base.layer;
    }
    case 4: {
      const _Solid = entity;
      const _s = _Solid._0;
      return _s.base.layer;
    }
    case 6: {
      const _Block = entity;
      const _b = _Block._0;
      return _b.base.layer;
    }
    case 7: {
      const _Image = entity;
      const _i = _Image._0;
      return _i.base.layer;
    }
    default: {
      const _ArcSolid = entity;
      const _a$2 = _ArcSolid._0;
      return _a$2.base.layer;
    }
  }
}
function horideicom$svg_jww$$ellipse_point(cx, cy, rx, ry, tilt, angle) {
  const cos_a = horideicom$svg_jww$$cos_d(angle);
  const sin_a = horideicom$svg_jww$$sin_d(angle);
  const cos_t = horideicom$svg_jww$$cos_d(tilt);
  const sin_t = horideicom$svg_jww$$sin_d(tilt);
  const x = cx + rx * cos_a * cos_t - ry * sin_a * sin_t;
  const y = cy + rx * cos_a * sin_t + ry * sin_a * cos_t;
  return { _0: x, _1: y };
}
function horideicom$svg_jww$$entity_picker_attrs(entity_type, entity_index, base) {
  return [horideicom$svg_jww$$attr("data-entity-index", moonbitlang$core$int$$Int$to_string$46$inner(entity_index, 10)), horideicom$svg_jww$$attr("data-entity-type", entity_type), horideicom$svg_jww$$attr("data-entity-layer", moonbitlang$core$uint16$$UInt16$to_string$46$inner(base.layer, 10)), horideicom$svg_jww$$attr("data-entity-layer-group", moonbitlang$core$uint16$$UInt16$to_string$46$inner(base.layer_group, 10)), horideicom$svg_jww$$attr("data-entity-group", moonbitlang$core$uint$$UInt$to_string$46$inner(base.group, 10)), horideicom$svg_jww$$attr("data-entity-pen-style", moonbitlang$core$int$$Int$to_string$46$inner(base.pen_style, 10)), horideicom$svg_jww$$attr("data-entity-pen-color", moonbitlang$core$uint16$$UInt16$to_string$46$inner(base.pen_color, 10)), horideicom$svg_jww$$attr("data-entity-pen-width", moonbitlang$core$uint16$$UInt16$to_string$46$inner(base.pen_width, 10)), horideicom$svg_jww$$attr("data-entity-flag", moonbitlang$core$uint16$$UInt16$to_string$46$inner(base.flag, 10))];
}
function horideicom$svg_jww$$stroke_width_min(pen_width) {
  const pw = pen_width;
  const base = pw <= 0 ? 1 : pw;
  const w = Math.imul(base, 10) | 0;
  return w + 0;
}
function horideicom$svg_jww$$render_arc_conv(a, entity_index, opts) {
  const cx = a.center_x;
  const _p = a.center_y;
  const cy = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const _bind = horideicom$svg_jww$$arc_radii(a.radius, a.flatness);
  const _rx = _bind._0;
  const _ry = _bind._1;
  const _p$2 = -a.tilt_angle;
  const rotation = _p$2 * 57.2957795130823229;
  const color = horideicom$svg_jww$$to_svg_color(a.base.pen_color);
  const stroke_w = horideicom$svg_jww$$stroke_width_min(a.base.pen_width);
  const line_type = horideicom$svg_jww$$pen_style_to_line_type(a.base.pen_style);
  const scale = stroke_w / 100;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("arc", entity_index, a.base), [horideicom$svg_jww$$attr_double("data-entity-center-x", a.center_x), horideicom$svg_jww$$attr_double("data-entity-center-y", a.center_y), horideicom$svg_jww$$attr_double("data-entity-radius", a.radius), horideicom$svg_jww$$attr_double("data-entity-start-angle", a.start_angle), horideicom$svg_jww$$attr_double("data-entity-arc-angle", a.arc_angle), horideicom$svg_jww$$attr_double("data-entity-tilt-angle", a.tilt_angle), horideicom$svg_jww$$attr_double("data-entity-flatness", a.flatness), horideicom$svg_jww$$attr("data-entity-is-full-circle", a.is_full_circle ? "true" : "false")]);
  if (a.is_full_circle) {
    if (a.flatness === 1) {
      const base_attrs = moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("cx", cx), horideicom$svg_jww$$attr_double("cy", cy), horideicom$svg_jww$$attr_double("r", _rx), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_attr(color), horideicom$svg_jww$$stroke_width_double(scale)], picker_attrs);
      const _bind$2 = horideicom$svg_jww$$line_type_to_dasharray(line_type, scale);
      if (_bind$2 === undefined) {
        return horideicom$svg_jww$$circle(base_attrs);
      } else {
        const _Some = _bind$2;
        const _dash_attr = _Some;
        return horideicom$svg_jww$$circle(moonbitlang$core$builtin$$Add$add$37$(base_attrs, [_dash_attr]));
      }
    } else {
      const base_attrs = moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("cx", cx), horideicom$svg_jww$$attr_double("cy", cy), horideicom$svg_jww$$attr_double("rx", _rx), horideicom$svg_jww$$attr_double("ry", _ry), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_attr(color), horideicom$svg_jww$$stroke_width_double(scale)], picker_attrs);
      const ellipse_attrs = a.tilt_angle !== 0 ? moonbitlang$core$builtin$$Add$add$37$(base_attrs, [horideicom$svg_jww$$attr("transform", `rotate(${moonbitlang$core$double$$Double$to_string(rotation)} ${moonbitlang$core$double$$Double$to_string(cx)} ${moonbitlang$core$double$$Double$to_string(cy)})`)]) : base_attrs;
      const _bind$2 = horideicom$svg_jww$$line_type_to_dasharray(line_type, scale);
      if (_bind$2 === undefined) {
        return horideicom$svg_jww$$ellipse(ellipse_attrs);
      } else {
        const _Some = _bind$2;
        const _dash_attr = _Some;
        return horideicom$svg_jww$$ellipse(moonbitlang$core$builtin$$Add$add$37$(ellipse_attrs, [_dash_attr]));
      }
    }
  } else {
    const start_angle = a.start_angle;
    const end_angle = start_angle + a.arc_angle;
    const _bind$2 = horideicom$svg_jww$$ellipse_point(a.center_x, a.center_y, _rx, _ry, a.tilt_angle, start_angle);
    const _x1_raw = _bind$2._0;
    const _y1_raw = _bind$2._1;
    const _bind$3 = horideicom$svg_jww$$ellipse_point(a.center_x, a.center_y, _rx, _ry, a.tilt_angle, end_angle);
    const _x2_raw = _bind$3._0;
    const _y2_raw = _bind$3._1;
    const y1 = (opts.bounds_max_y - _y1_raw) * opts.scale + opts.offset_y + opts.padding;
    const y2 = (opts.bounds_max_y - _y2_raw) * opts.scale + opts.offset_y + opts.padding;
    const large_arc = Math.abs(a.arc_angle) > 3.14159 ? 1 : 0;
    const sweep = a.arc_angle > 0 ? 0 : 1;
    const path_d = `M ${moonbitlang$core$double$$Double$to_string(_x1_raw)} ${moonbitlang$core$double$$Double$to_string(y1)} A ${moonbitlang$core$double$$Double$to_string(_rx)} ${moonbitlang$core$double$$Double$to_string(_ry)} ${moonbitlang$core$double$$Double$to_string(rotation)} ${moonbitlang$core$int$$Int$to_string$46$inner(large_arc, 10)} ${moonbitlang$core$int$$Int$to_string$46$inner(sweep, 10)} ${moonbitlang$core$double$$Double$to_string(_x2_raw)} ${moonbitlang$core$double$$Double$to_string(y2)}`;
    const base_attrs = moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr("d", path_d), horideicom$svg_jww$$fill_none$46$tuple$47$1920, horideicom$svg_jww$$stroke_attr(color), horideicom$svg_jww$$stroke_width_double(scale)], picker_attrs);
    const _bind$4 = horideicom$svg_jww$$line_type_to_dasharray(line_type, scale);
    if (_bind$4 === undefined) {
      return horideicom$svg_jww$$path(base_attrs);
    } else {
      const _Some = _bind$4;
      const _dash_attr = _Some;
      return horideicom$svg_jww$$path(moonbitlang$core$builtin$$Add$add$37$(base_attrs, [_dash_attr]));
    }
  }
}
function horideicom$svg_jww$$color_from_custom_rgb(color) {
  const r = color & 255;
  const g = color >>> 8 & 255;
  const b = color >>> 16 & 255;
  return horideicom$svg_jww$$to_rgb_color(r, g, b);
}
function horideicom$svg_jww$$fill_color_from_pen(pen_color, custom_color) {
  const _p = 10;
  if (pen_color === _p) {
    return horideicom$svg_jww$$color_from_custom_rgb(custom_color);
  } else {
    return horideicom$svg_jww$$to_svg_color(pen_color);
  }
}
function horideicom$svg_jww$$render_arc_solid_conv(a, entity_index, opts) {
  const cx = a.center_x;
  const _p = a.center_y;
  const cy = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const _bind = horideicom$svg_jww$$arc_radii(a.radius, a.flatness);
  const _rx = _bind._0;
  const _ry = _bind._1;
  const _p$2 = -a.tilt_angle;
  const rotation = _p$2 * 57.2957795130823229;
  const color = horideicom$svg_jww$$fill_color_from_pen(a.base.pen_color, a.color);
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("arc_solid", entity_index, a.base), [horideicom$svg_jww$$attr_double("data-entity-center-x", a.center_x), horideicom$svg_jww$$attr_double("data-entity-center-y", a.center_y), horideicom$svg_jww$$attr_double("data-entity-radius", a.radius), horideicom$svg_jww$$attr_double("data-entity-flatness", a.flatness), horideicom$svg_jww$$attr_double("data-entity-tilt-angle", a.tilt_angle), horideicom$svg_jww$$attr_double("data-entity-start-angle", a.start_angle), horideicom$svg_jww$$attr_double("data-entity-arc-angle", a.arc_angle), horideicom$svg_jww$$attr_double("data-entity-solid-param", a.solid_param), horideicom$svg_jww$$attr("data-entity-color", moonbitlang$core$uint$$UInt$to_string$46$inner(a.color, 10))]);
  if (Math.abs(a.arc_angle) >= 6.28) {
    if (a.flatness === 1) {
      return horideicom$svg_jww$$circle(moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("cx", cx), horideicom$svg_jww$$attr_double("cy", cy), horideicom$svg_jww$$attr_double("r", _rx), horideicom$svg_jww$$fill_attr(color), horideicom$svg_jww$$stroke_none$46$tuple$47$1935], picker_attrs));
    } else {
      const base_attrs = moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("cx", cx), horideicom$svg_jww$$attr_double("cy", cy), horideicom$svg_jww$$attr_double("rx", _rx), horideicom$svg_jww$$attr_double("ry", _ry), horideicom$svg_jww$$fill_attr(color), horideicom$svg_jww$$stroke_none$46$tuple$47$1935], picker_attrs);
      const ellipse_attrs = a.tilt_angle !== 0 ? moonbitlang$core$builtin$$Add$add$37$(base_attrs, [horideicom$svg_jww$$attr("transform", `rotate(${moonbitlang$core$double$$Double$to_string(rotation)} ${moonbitlang$core$double$$Double$to_string(cx)} ${moonbitlang$core$double$$Double$to_string(cy)})`)]) : base_attrs;
      return horideicom$svg_jww$$ellipse(ellipse_attrs);
    }
  } else {
    const start_angle = a.start_angle;
    const end_angle = start_angle + a.arc_angle;
    const _bind$2 = horideicom$svg_jww$$ellipse_point(a.center_x, a.center_y, _rx, _ry, a.tilt_angle, start_angle);
    const _x1_raw = _bind$2._0;
    const _y1_raw = _bind$2._1;
    const _bind$3 = horideicom$svg_jww$$ellipse_point(a.center_x, a.center_y, _rx, _ry, a.tilt_angle, end_angle);
    const _x2_raw = _bind$3._0;
    const _y2_raw = _bind$3._1;
    const y1 = (opts.bounds_max_y - _y1_raw) * opts.scale + opts.offset_y + opts.padding;
    const y2 = (opts.bounds_max_y - _y2_raw) * opts.scale + opts.offset_y + opts.padding;
    const large_arc = Math.abs(a.arc_angle) > 3.14159 ? 1 : 0;
    const sweep = a.arc_angle > 0 ? 0 : 1;
    const path_d = `M ${moonbitlang$core$double$$Double$to_string(cx)} ${moonbitlang$core$double$$Double$to_string(cy)} L ${moonbitlang$core$double$$Double$to_string(_x1_raw)} ${moonbitlang$core$double$$Double$to_string(y1)} A ${moonbitlang$core$double$$Double$to_string(_rx)} ${moonbitlang$core$double$$Double$to_string(_ry)} ${moonbitlang$core$double$$Double$to_string(rotation)} ${moonbitlang$core$int$$Int$to_string$46$inner(large_arc, 10)} ${moonbitlang$core$int$$Int$to_string$46$inner(sweep, 10)} ${moonbitlang$core$double$$Double$to_string(_x2_raw)} ${moonbitlang$core$double$$Double$to_string(y2)} Z`;
    return horideicom$svg_jww$$path(moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr("d", path_d), horideicom$svg_jww$$fill_attr(color), horideicom$svg_jww$$stroke_none$46$tuple$47$1935], picker_attrs));
  }
}
function horideicom$svg_jww$$render_block_conv(b, entity_index, opts) {
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("block", entity_index, b.base), [horideicom$svg_jww$$attr_double("data-entity-ref-x", b.ref_x), horideicom$svg_jww$$attr_double("data-entity-ref-y", b.ref_y), horideicom$svg_jww$$attr_double("data-entity-scale-x", b.scale_x), horideicom$svg_jww$$attr_double("data-entity-scale-y", b.scale_y), horideicom$svg_jww$$attr_double("data-entity-rotation", b.rotation), horideicom$svg_jww$$attr("data-entity-def-number", moonbitlang$core$uint$$UInt$to_string$46$inner(b.def_number, 10))]);
  const _tmp = horideicom$svg_jww$$attr_double("x", b.ref_x);
  const _p = b.ref_y;
  return horideicom$svg_jww$$text_elem(moonbitlang$core$builtin$$Add$add$37$([_tmp, horideicom$svg_jww$$attr_double("y", (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding), horideicom$svg_jww$$attr("fill", "#999"), horideicom$svg_jww$$attr("font-size", "10"), horideicom$svg_jww$$style_attr("opacity: 0.5;")], picker_attrs), `[Block ${moonbitlang$core$uint$$UInt$to_string$46$inner(b.def_number, 10)}]`);
}
function horideicom$svg_jww$$render_image_conv(i, entity_index, opts) {
  const x = i.x;
  const _p = i.y;
  const y = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("image", entity_index, i.base), [horideicom$svg_jww$$attr_double("data-entity-x", i.x), horideicom$svg_jww$$attr_double("data-entity-y", i.y), horideicom$svg_jww$$attr_double("data-entity-width", i.width), horideicom$svg_jww$$attr_double("data-entity-height", i.height), horideicom$svg_jww$$attr_double("data-entity-rotation", i.rotation), horideicom$svg_jww$$attr("data-entity-image-path", i.image_path)]);
  const base_attrs = moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("x", x), horideicom$svg_jww$$attr_double("y", y), horideicom$svg_jww$$attr_double("width", i.width), horideicom$svg_jww$$attr_double("height", i.height), horideicom$svg_jww$$attr("href", i.image_path), horideicom$svg_jww$$attr("class", "jww-image"), horideicom$svg_jww$$attr("data-image-path", i.image_path), horideicom$svg_jww$$attr("data-status", "loading")], picker_attrs);
  const final_attrs = i.rotation !== 0 ? moonbitlang$core$builtin$$Add$add$37$(base_attrs, [horideicom$svg_jww$$attr("transform", `rotate(${moonbitlang$core$double$$Double$to_string(i.rotation)} ${moonbitlang$core$double$$Double$to_string(x)} ${moonbitlang$core$double$$Double$to_string(y)})`)]) : base_attrs;
  return horideicom$svg_jww$$image_elem(final_attrs);
}
function horideicom$svg_jww$$render_line_conv(l, entity_index, opts) {
  const stroke_w = horideicom$svg_jww$$stroke_width_min(l.base.pen_width);
  const line_type = horideicom$svg_jww$$pen_style_to_line_type(l.base.pen_style);
  const scale = stroke_w / 100;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("line", entity_index, l.base), [horideicom$svg_jww$$attr_double("data-entity-start-x", l.start_x), horideicom$svg_jww$$attr_double("data-entity-start-y", l.start_y), horideicom$svg_jww$$attr_double("data-entity-end-x", l.end_x), horideicom$svg_jww$$attr_double("data-entity-end-y", l.end_y)]);
  const _tmp = horideicom$svg_jww$$attr_double("x1", l.start_x);
  const _p = l.start_y;
  const _tmp$2 = horideicom$svg_jww$$attr_double("y1", (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding);
  const _tmp$3 = horideicom$svg_jww$$attr_double("x2", l.end_x);
  const _p$2 = l.end_y;
  const base_attrs = moonbitlang$core$builtin$$Add$add$37$([_tmp, _tmp$2, _tmp$3, horideicom$svg_jww$$attr_double("y2", (opts.bounds_max_y - _p$2) * opts.scale + opts.offset_y + opts.padding), horideicom$svg_jww$$stroke_attr(horideicom$svg_jww$$to_svg_color(l.base.pen_color)), horideicom$svg_jww$$stroke_width_double(scale), horideicom$svg_jww$$fill_none$46$tuple$47$1920], picker_attrs);
  const _bind = horideicom$svg_jww$$line_type_to_dasharray(line_type, scale);
  if (_bind === undefined) {
    return horideicom$svg_jww$$svg_line(base_attrs);
  } else {
    const _Some = _bind;
    const _dash_attr = _Some;
    return horideicom$svg_jww$$svg_line(moonbitlang$core$builtin$$Add$add$37$(base_attrs, [_dash_attr]));
  }
}
function horideicom$svg_jww$$render_point_conv(p, entity_index, opts) {
  const scale = p.scale > 0 ? p.scale : 1;
  const _p = 2 * scale;
  const size = _p * opts.scale;
  const radius = size / 2;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("point", entity_index, p.base), [horideicom$svg_jww$$attr_double("data-entity-x", p.x), horideicom$svg_jww$$attr_double("data-entity-y", p.y), horideicom$svg_jww$$attr("data-entity-code", moonbitlang$core$uint$$UInt$to_string$46$inner(p.code, 10)), horideicom$svg_jww$$attr_double("data-entity-angle", p.angle), horideicom$svg_jww$$attr_double("data-entity-scale", p.scale), horideicom$svg_jww$$attr("data-entity-is-temporary", p.is_temporary ? "true" : "false")]);
  const _tmp = horideicom$svg_jww$$attr_double("cx", p.x);
  const _p$2 = p.y;
  return horideicom$svg_jww$$circle(moonbitlang$core$builtin$$Add$add$37$([_tmp, horideicom$svg_jww$$attr_double("cy", (opts.bounds_max_y - _p$2) * opts.scale + opts.offset_y + opts.padding), horideicom$svg_jww$$attr_double("r", radius), horideicom$svg_jww$$fill_attr(horideicom$svg_jww$$to_svg_color(p.base.pen_color))], picker_attrs));
}
function horideicom$svg_jww$$render_solid_conv(s, entity_index, opts) {
  const fill_color = horideicom$svg_jww$$fill_color_from_pen(s.base.pen_color, s.color);
  const _tmp = moonbitlang$core$double$$Double$to_string(s.point1_x);
  const _p = s.point1_y;
  const _tmp$2 = moonbitlang$core$double$$Double$to_string((opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding);
  const _tmp$3 = moonbitlang$core$double$$Double$to_string(s.point4_x);
  const _p$2 = s.point4_y;
  const _tmp$4 = moonbitlang$core$double$$Double$to_string((opts.bounds_max_y - _p$2) * opts.scale + opts.offset_y + opts.padding);
  const _tmp$5 = moonbitlang$core$double$$Double$to_string(s.point2_x);
  const _p$3 = s.point2_y;
  const _tmp$6 = moonbitlang$core$double$$Double$to_string((opts.bounds_max_y - _p$3) * opts.scale + opts.offset_y + opts.padding);
  const _tmp$7 = moonbitlang$core$double$$Double$to_string(s.point3_x);
  const _p$4 = s.point3_y;
  const points = `${_tmp},${_tmp$2} ${_tmp$3},${_tmp$4} ${_tmp$5},${_tmp$6} ${_tmp$7},${moonbitlang$core$double$$Double$to_string((opts.bounds_max_y - _p$4) * opts.scale + opts.offset_y + opts.padding)}`;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("solid", entity_index, s.base), [horideicom$svg_jww$$attr_double("data-entity-point1-x", s.point1_x), horideicom$svg_jww$$attr_double("data-entity-point1-y", s.point1_y), horideicom$svg_jww$$attr_double("data-entity-point2-x", s.point2_x), horideicom$svg_jww$$attr_double("data-entity-point2-y", s.point2_y), horideicom$svg_jww$$attr_double("data-entity-point3-x", s.point3_x), horideicom$svg_jww$$attr_double("data-entity-point3-y", s.point3_y), horideicom$svg_jww$$attr_double("data-entity-point4-x", s.point4_x), horideicom$svg_jww$$attr_double("data-entity-point4-y", s.point4_y), horideicom$svg_jww$$attr("data-entity-color", moonbitlang$core$uint$$UInt$to_string$46$inner(s.color, 10))]);
  return horideicom$svg_jww$$polygon(moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr("points", points), horideicom$svg_jww$$fill_attr(fill_color), horideicom$svg_jww$$stroke_none$46$tuple$47$1935], picker_attrs));
}
function horideicom$svg_jww$$render_text_conv(t, entity_index, opts) {
  const x = t.start_x;
  const _p = t.start_y;
  const y = (opts.bounds_max_y - _p) * opts.scale + opts.offset_y + opts.padding;
  const font_size = Math.abs(t.size_y);
  const color = horideicom$svg_jww$$to_svg_color(t.base.pen_color);
  const angle = t.angle;
  const transform = `transform-origin: ${moonbitlang$core$double$$Double$to_string(x)}px ${moonbitlang$core$double$$Double$to_string(y)}px; transform: rotate(${moonbitlang$core$double$$Double$to_string(-angle)}deg);`;
  const picker_attrs = moonbitlang$core$builtin$$Add$add$37$(horideicom$svg_jww$$entity_picker_attrs("text", entity_index, t.base), [horideicom$svg_jww$$attr_double("data-entity-start-x", t.start_x), horideicom$svg_jww$$attr_double("data-entity-start-y", t.start_y), horideicom$svg_jww$$attr_double("data-entity-end-x", t.end_x), horideicom$svg_jww$$attr_double("data-entity-end-y", t.end_y), horideicom$svg_jww$$attr("data-entity-text-type", moonbitlang$core$uint$$UInt$to_string$46$inner(t.text_type, 10)), horideicom$svg_jww$$attr_double("data-entity-size-x", t.size_x), horideicom$svg_jww$$attr_double("data-entity-size-y", t.size_y), horideicom$svg_jww$$attr_double("data-entity-spacing", t.spacing), horideicom$svg_jww$$attr_double("data-entity-angle", t.angle), horideicom$svg_jww$$attr("data-entity-font-name", t.font_name), horideicom$svg_jww$$attr("data-entity-text", t.content)]);
  return horideicom$svg_jww$$text_elem(moonbitlang$core$builtin$$Add$add$37$([horideicom$svg_jww$$attr_double("x", x), horideicom$svg_jww$$attr_double("y", y), horideicom$svg_jww$$attr("fill", color), horideicom$svg_jww$$attr_double("font-size", font_size), horideicom$svg_jww$$attr("data-base-size", moonbitlang$core$double$$Double$to_string(font_size)), horideicom$svg_jww$$attr("font-family", "sans-serif"), horideicom$svg_jww$$attr("class", "jww-text"), horideicom$svg_jww$$style_attr(transform)], picker_attrs), t.content);
}
function horideicom$svg_jww$$render_entity_conv(entity, entity_index, opts) {
  switch (entity.$tag) {
    case 0: {
      const _Line = entity;
      const _l = _Line._0;
      return horideicom$svg_jww$$render_line_conv(_l, entity_index, opts);
    }
    case 1: {
      const _Arc = entity;
      const _a = _Arc._0;
      return horideicom$svg_jww$$render_arc_conv(_a, entity_index, opts);
    }
    case 2: {
      const _Point = entity;
      const _p = _Point._0;
      return horideicom$svg_jww$$render_point_conv(_p, entity_index, opts);
    }
    case 3: {
      const _Text = entity;
      const _t = _Text._0;
      return horideicom$svg_jww$$render_text_conv(_t, entity_index, opts);
    }
    case 4: {
      const _Solid = entity;
      const _s = _Solid._0;
      return horideicom$svg_jww$$render_solid_conv(_s, entity_index, opts);
    }
    case 6: {
      const _Block = entity;
      const _b = _Block._0;
      return horideicom$svg_jww$$render_block_conv(_b, entity_index, opts);
    }
    case 7: {
      const _Image = entity;
      const _i = _Image._0;
      return horideicom$svg_jww$$render_image_conv(_i, entity_index, opts);
    }
    default: {
      const _ArcSolid = entity;
      const _a$2 = _ArcSolid._0;
      return horideicom$svg_jww$$render_arc_solid_conv(_a$2, entity_index, opts);
    }
  }
}
function horideicom$svg_jww$$render_svg_conv(doc, opts, bounds, padding) {
  const _p = doc.layer_groups.length;
  const _p$2 = 16;
  const max_groups = _p < _p$2 ? _p : _p$2;
  let layer_elements = [];
  let _tmp = 0;
  while (true) {
    const g_idx = _tmp;
    if (g_idx < max_groups) {
      const lg = moonbitlang$core$array$$Array$at$18$(doc.layer_groups, g_idx);
      const _p$3 = lg.layers.length;
      const _p$4 = 16;
      const max_layers = _p$3 < _p$4 ? _p$3 : _p$4;
      let _tmp$2 = 0;
      while (true) {
        const l_idx = _tmp$2;
        if (l_idx < max_layers) {
          const layer_id = (Math.imul(g_idx, 16) | 0) + l_idx | 0;
          let entity_elems = [];
          const total_entities = doc.entities.length;
          let _tmp$3 = 0;
          while (true) {
            const i = _tmp$3;
            if (i < total_entities) {
              const entity = moonbitlang$core$array$$Array$at$22$(doc.entities, i);
              if (horideicom$svg_jww$$get_entity_layer_conv(entity) === layer_id) {
                const elem = horideicom$svg_jww$$render_entity_conv(entity, i, opts);
                entity_elems = moonbitlang$core$builtin$$Add$add$36$(entity_elems, [elem]);
              }
              _tmp$3 = i + 1 | 0;
              continue;
            } else {
              break;
            }
          }
          if (entity_elems.length > 0) {
            const g_elem = horideicom$svg_jww$$g([horideicom$svg_jww$$attr("id", `layer-${moonbitlang$core$int$$Int$to_string$46$inner(layer_id, 10)}`), horideicom$svg_jww$$attr("class", "jww-layer"), horideicom$svg_jww$$attr("data-layer", moonbitlang$core$int$$Int$to_string$46$inner(layer_id, 10))], entity_elems);
            layer_elements = moonbitlang$core$builtin$$Add$add$36$(layer_elements, [g_elem]);
          }
          _tmp$2 = l_idx + 1 | 0;
          continue;
        } else {
          break;
        }
      }
      _tmp = g_idx + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const bg_rect = horideicom$svg_jww$$rect([horideicom$svg_jww$$attr_double("x", bounds.min_x - padding), horideicom$svg_jww$$attr_double("y", 0), horideicom$svg_jww$$attr_double("width", opts.width), horideicom$svg_jww$$attr_double("height", opts.height), horideicom$svg_jww$$fill_attr("#000000")]);
  let children = [bg_rect];
  const _arr = layer_elements;
  const _len = _arr.length;
  let _tmp$2 = 0;
  while (true) {
    const _i = _tmp$2;
    if (_i < _len) {
      const elem = _arr[_i];
      children = moonbitlang$core$builtin$$Add$add$36$(children, [elem]);
      _tmp$2 = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  return horideicom$svg_jww$$svg([horideicom$svg_jww$$attr("xmlns", "http://www.w3.org/2000/svg"), horideicom$svg_jww$$attr("viewBox", `${moonbitlang$core$double$$Double$to_string(bounds.min_x - padding)} 0 ${moonbitlang$core$double$$Double$to_string(opts.width)} ${moonbitlang$core$double$$Double$to_string(opts.height)}`)], children);
}
function horideicom$svg_jww$$render_svg_conv_debug(doc, opts, bounds, padding, debug) {
  const base_svg = horideicom$svg_jww$$render_svg_conv(doc, opts, bounds, padding);
  const overlays = horideicom$svg_jww$$build_debug_overlays(doc, opts, bounds, padding, debug);
  if (overlays.length === 0) {
    return base_svg;
  } else {
    const overlay_group = horideicom$svg_jww$$g([horideicom$svg_jww$$class_attr("jww-debug-overlay"), horideicom$svg_jww$$style_attr("pointer-events: none;")], overlays);
    return horideicom$svg_jww$$append_svg_children(base_svg, [overlay_group]);
  }
}
function horideicom$svg_jww$$render_jww_document_with_debug(doc, debug) {
  let counts = horideicom$svg_jww$$render_jww_document_with_debug$46$record$47$2421;
  const _arr = doc.entities;
  const _len = _arr.length;
  let _tmp = 0;
  while (true) {
    const _i = _tmp;
    if (_i < _len) {
      const entity = _arr[_i];
      switch (entity.$tag) {
        case 0: {
          counts = { lines: counts.lines + 1 | 0, arcs: counts.arcs, texts: counts.texts, points: counts.points, solids: counts.solids, blocks: counts.blocks, images: counts.images };
          break;
        }
        case 1: {
          counts = { lines: counts.lines, arcs: counts.arcs + 1 | 0, texts: counts.texts, points: counts.points, solids: counts.solids, blocks: counts.blocks, images: counts.images };
          break;
        }
        case 3: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts + 1 | 0, points: counts.points, solids: counts.solids, blocks: counts.blocks, images: counts.images };
          break;
        }
        case 2: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts, points: counts.points + 1 | 0, solids: counts.solids, blocks: counts.blocks, images: counts.images };
          break;
        }
        case 4: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts, points: counts.points, solids: counts.solids + 1 | 0, blocks: counts.blocks, images: counts.images };
          break;
        }
        case 6: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts, points: counts.points, solids: counts.solids, blocks: counts.blocks + 1 | 0, images: counts.images };
          break;
        }
        case 7: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts, points: counts.points, solids: counts.solids, blocks: counts.blocks, images: counts.images + 1 | 0 };
          break;
        }
        default: {
          counts = { lines: counts.lines, arcs: counts.arcs, texts: counts.texts, points: counts.points, solids: counts.solids + 1 | 0, blocks: counts.blocks, images: counts.images };
        }
      }
      _tmp = _i + 1 | 0;
      continue;
    } else {
      break;
    }
  }
  const bounds = horideicom$svg_jww$$calculate_bounds(doc);
  const layers = horideicom$svg_jww$$build_layer_info(doc);
  const width = bounds.max_x - bounds.min_x + 40;
  const height = bounds.max_y - bounds.min_y + 40;
  const opts = horideicom$svg_jww$$RenderOptions$with_bounds(width, height, bounds.max_y, 20);
  const svg_elem = horideicom$svg_jww$$render_svg_conv_debug(doc, opts, bounds, 20, debug);
  return { _0: horideicom$svg_jww$$to_string(svg_elem), _1: bounds, _2: layers, _3: counts };
}
function horideicom$svg_jww$$render_jww_document(doc) {
  return horideicom$svg_jww$$render_jww_document_with_debug(doc, horideicom$svg_jww$$render_jww_document$46$debug$47$2436);
}
function horideicom$svg_jww$$jww_parse(data) {
  const doc = horideicom$jww_parser$core$$parse(data);
  const _bind = horideicom$svg_jww$$render_jww_document(doc);
  const _svg = _bind._0;
  const _bounds = _bind._1;
  const _layers = _bind._2;
  const _counts = _bind._3;
  return horideicom$svg_jww$$build_parsed_document(doc, _svg, _bounds, _layers, _counts);
}
function horideicom$svg_jww$$jww_to_svg(data) {
  return horideicom$svg_jww$$jww_parse(data).svg;
}
export { horideicom$svg_jww$$jww_parse as jww_parse, horideicom$svg_jww$$jww_to_svg as jww_to_svg }
